/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.12.7.0 (NJsonSchema v9.10.6.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { Http, Headers, ResponseContentType, Response } from '@angular/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    isTenantAvailable(input: IsTenantAvailableInput): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsTenantAvailable(response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>Observable.throw(response_);
        });
    }

    protected processIsTenantAvailable(response: Response): Observable<IsTenantAvailableOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IsTenantAvailableOutput.fromJS(resultData200) : new IsTenantAvailableOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IsTenantAvailableOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    register(input: RegisterInput): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegister(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegister(response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegisterOutput>><any>Observable.throw(response_);
        });
    }

    protected processRegister(response: Response): Observable<RegisterOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterOutput.fromJS(resultData200) : new RegisterOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RegisterOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendPasswordResetCode(input: SendPasswordResetCodeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendPasswordResetCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendPasswordResetCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resetPassword(input: ResetPasswordInput): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResetPassword(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResetPassword(response_);
                } catch (e) {
                    return <Observable<ResetPasswordOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ResetPasswordOutput>><any>Observable.throw(response_);
        });
    }

    protected processResetPassword(response: Response): Observable<ResetPasswordOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResetPasswordOutput.fromJS(resultData200) : new ResetPasswordOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ResetPasswordOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendEmailActivationLink(input: SendEmailActivationLinkInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendEmailActivationLink(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendEmailActivationLink(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    activateEmail(input: ActivateEmailInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processActivateEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processActivateEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processActivateEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    impersonate(input: ImpersonateInput): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImpersonate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImpersonate(response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>Observable.throw(response_);
        });
    }

    protected processImpersonate(response: Response): Observable<ImpersonateOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ImpersonateOutput>(<any>null);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBackToImpersonator(response_);
                } catch (e) {
                    return <Observable<ImpersonateOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ImpersonateOutput>><any>Observable.throw(response_);
        });
    }

    protected processBackToImpersonator(response: Response): Observable<ImpersonateOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ImpersonateOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    switchToLinkedAccount(input: SwitchToLinkedAccountInput): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSwitchToLinkedAccount(response_);
                } catch (e) {
                    return <Observable<SwitchToLinkedAccountOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<SwitchToLinkedAccountOutput>><any>Observable.throw(response_);
        });
    }

    protected processSwitchToLinkedAccount(response: Response): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SwitchToLinkedAccountOutput.fromJS(resultData200) : new SwitchToLinkedAccountOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SwitchToLinkedAccountOutput>(<any>null);
    }
}

@Injectable()
export class ActivityManagementServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getActivityListAsync(filter: string, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/GetActivityListAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityListAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActivityListAsync(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfActivityDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfActivityDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityListAsync(response: Response): Observable<PagedResultDtoOfActivityDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfActivityDto.fromJS(resultData200) : new PagedResultDtoOfActivityDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfActivityDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getActivityAsync(input: number): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/GetActivityAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActivityAsync(response_);
                } catch (e) {
                    return <Observable<ActivityDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ActivityDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityAsync(response: Response): Observable<ActivityDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ActivityDto.fromJS(resultData200) : new ActivityDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ActivityDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditActivityAsync(input: ActivityDto): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/CreateOrEditActivityAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditActivityAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrEditActivityAsync(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditActivityAsync(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    deleteActivityAsync(input: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/DeleteActivityAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteActivityAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteActivityAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteActivityAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getActivityLocationsAsync(input: number): Observable<ListResultDtoOfActivityLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/GetActivityLocationsAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityLocationsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActivityLocationsAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfActivityLocationDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfActivityLocationDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityLocationsAsync(response: Response): Observable<ListResultDtoOfActivityLocationDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfActivityLocationDto.fromJS(resultData200) : new ListResultDtoOfActivityLocationDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfActivityLocationDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditActivityLocationAsync(input: ActivityLocationDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/CreateOrEditActivityLocationAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditActivityLocationAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrEditActivityLocationAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditActivityLocationAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    deleteActivityLocationAsync(input: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/DeleteActivityLocationAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteActivityLocationAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteActivityLocationAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteActivityLocationAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @inputDay (optional) 
     * @return Success
     */
    getActivitySectionsAsync(input: number, inputDay: number): Observable<ListResultDtoOfActivitySectionDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/GetActivitySectionsAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        if (inputDay !== undefined)
            url_ += "inputDay=" + encodeURIComponent("" + inputDay) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActivitySectionsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActivitySectionsAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfActivitySectionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfActivitySectionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivitySectionsAsync(response: Response): Observable<ListResultDtoOfActivitySectionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfActivitySectionDto.fromJS(resultData200) : new ListResultDtoOfActivitySectionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfActivitySectionDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditActivitySectionAsync(input: ActivitySectionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/CreateOrEditActivitySectionAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditActivitySectionAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrEditActivitySectionAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditActivitySectionAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    deleteActivitySectionAsync(input: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/DeleteActivitySectionAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteActivitySectionAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteActivitySectionAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteActivitySectionAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getActivityManagersAsync(input: number): Observable<ListResultDtoOfActivityManagerDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/GetActivityManagersAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityManagersAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActivityManagersAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfActivityManagerDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfActivityManagerDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityManagersAsync(response: Response): Observable<ListResultDtoOfActivityManagerDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfActivityManagerDto.fromJS(resultData200) : new ListResultDtoOfActivityManagerDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfActivityManagerDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditActivityManagerAsync(input: ActivityManagerDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/CreateOrEditActivityManagerAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditActivityManagerAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrEditActivityManagerAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditActivityManagerAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    deleteActivityManagerAsync(input: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/DeleteActivityManagerAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteActivityManagerAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteActivityManagerAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteActivityManagerAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getActivitySpeakersAsync(input: number): Observable<ListResultDtoOfActivitySpeakerDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/GetActivitySpeakersAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActivitySpeakersAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActivitySpeakersAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfActivitySpeakerDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfActivitySpeakerDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivitySpeakersAsync(response: Response): Observable<ListResultDtoOfActivitySpeakerDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfActivitySpeakerDto.fromJS(resultData200) : new ListResultDtoOfActivitySpeakerDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfActivitySpeakerDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditActivitySpeakerAsync(input: ActivitySpeakerDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/CreateOrEditActivitySpeakerAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditActivitySpeakerAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrEditActivitySpeakerAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditActivitySpeakerAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    deleteActivitySpeakerAsync(input: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/DeleteActivitySpeakerAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteActivitySpeakerAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteActivitySpeakerAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteActivitySpeakerAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @activityId (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getActivityParticipantsAsync(filter: string, activityId: number, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfActivityParticipantDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/GetActivityParticipantsAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (activityId !== undefined)
            url_ += "ActivityId=" + encodeURIComponent("" + activityId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActivityParticipantsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActivityParticipantsAsync(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfActivityParticipantDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfActivityParticipantDto>><any>Observable.throw(response_);
        });
    }

    protected processGetActivityParticipantsAsync(response: Response): Observable<PagedResultDtoOfActivityParticipantDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfActivityParticipantDto.fromJS(resultData200) : new PagedResultDtoOfActivityParticipantDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfActivityParticipantDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditActivityParticipantAsync(input: ActivityParticipantDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/CreateOrEditActivityParticipantAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditActivityParticipantAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrEditActivityParticipantAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditActivityParticipantAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    deleteActivityParticipantAsync(input: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/DeleteActivityParticipantAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteActivityParticipantAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteActivityParticipantAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteActivityParticipantAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @activityId (optional) 
     * @locationId (optional) 
     * @return Success
     */
    getLocationParticipantsAsync(activityId: number, locationId: number): Observable<ListResultDtoOfActivityParticipantDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/GetLocationParticipantsAsync?";
        if (activityId !== undefined)
            url_ += "ActivityId=" + encodeURIComponent("" + activityId) + "&"; 
        if (locationId !== undefined)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLocationParticipantsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLocationParticipantsAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfActivityParticipantDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfActivityParticipantDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLocationParticipantsAsync(response: Response): Observable<ListResultDtoOfActivityParticipantDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfActivityParticipantDto.fromJS(resultData200) : new ListResultDtoOfActivityParticipantDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfActivityParticipantDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setParticipantSectionRandomAsync(input: ParticipantSectionRandomInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/SetParticipantSectionRandomAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetParticipantSectionRandomAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetParticipantSectionRandomAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetParticipantSectionRandomAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setParticipantSectionAsync(input: ParticipantSectionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/SetParticipantSectionAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetParticipantSectionAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetParticipantSectionAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetParticipantSectionAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAcceptedTitle(): Observable<ListResultDtoOfGetAcceptedTitleDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/GetAcceptedTitle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAcceptedTitle(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAcceptedTitle(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAcceptedTitleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAcceptedTitleDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAcceptedTitle(response: Response): Observable<ListResultDtoOfGetAcceptedTitleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAcceptedTitleDto.fromJS(resultData200) : new ListResultDtoOfGetAcceptedTitleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAcceptedTitleDto>(<any>null);
    }

    /**
     * @return Success
     */
    getTenants(): Observable<ListResultDtoOfActivityTenantDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/GetTenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenants(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfActivityTenantDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfActivityTenantDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenants(response: Response): Observable<ListResultDtoOfActivityTenantDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfActivityTenantDto.fromJS(resultData200) : new ListResultDtoOfActivityTenantDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfActivityTenantDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getApplicants(input: string): Observable<ListResultDtoOfActivityApplicantDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/GetApplicants?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetApplicants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetApplicants(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfActivityApplicantDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfActivityApplicantDto>><any>Observable.throw(response_);
        });
    }

    protected processGetApplicants(response: Response): Observable<ListResultDtoOfActivityApplicantDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfActivityApplicantDto.fromJS(resultData200) : new ListResultDtoOfActivityApplicantDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfActivityApplicantDto>(<any>null);
    }

    /**
     * @fileId (optional) 
     * @type (optional) 
     * @return Success
     */
    deleteActivityFileAsync(fileId: string, type: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/DeleteActivityFileAsync?";
        if (fileId !== undefined)
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&"; 
        if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteActivityFileAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteActivityFileAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteActivityFileAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getParticipantToExcelAsync(input: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityManagement/GetParticipantToExcelAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetParticipantToExcelAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetParticipantToExcelAsync(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetParticipantToExcelAsync(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class AnnouncementServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @isActive (optional) 
     * @language (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getAnnAnnouncement(filter: string, isActive: boolean, language: string, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfAnnAnnouncementOutput> {
        let url_ = this.baseUrl + "/api/services/app/Announcement/GetAnnAnnouncement?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (language !== undefined)
            url_ += "Language=" + encodeURIComponent("" + language) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAnnAnnouncement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAnnAnnouncement(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAnnAnnouncementOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfAnnAnnouncementOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAnnAnnouncement(response: Response): Observable<PagedResultDtoOfAnnAnnouncementOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfAnnAnnouncementOutput.fromJS(resultData200) : new PagedResultDtoOfAnnAnnouncementOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfAnnAnnouncementOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createAnnAnnouncement(input: CreateAnnAnnouncementInput): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Announcement/CreateAnnAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateAnnAnnouncement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateAnnAnnouncement(response_);
                } catch (e) {
                    return <Observable<number>><any>Observable.throw(e);
                }
            } else
                return <Observable<number>><any>Observable.throw(response_);
        });
    }

    protected processCreateAnnAnnouncement(response: Response): Observable<number> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<number>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createDetailAndImagesAnnAnnouncement(input: CreateAnnAnnouncementInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Announcement/CreateDetailAndImagesAnnAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateDetailAndImagesAnnAnnouncement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateDetailAndImagesAnnAnnouncement(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateDetailAndImagesAnnAnnouncement(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteAnnAnnouncement(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Announcement/DeleteAnnAnnouncement?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteAnnAnnouncement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteAnnAnnouncement(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteAnnAnnouncement(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getAnnAnnouncementForEdit(id: number): Observable<AnnAnnouncementEdit> {
        let url_ = this.baseUrl + "/api/services/app/Announcement/GetAnnAnnouncementForEdit?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAnnAnnouncementForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAnnAnnouncementForEdit(response_);
                } catch (e) {
                    return <Observable<AnnAnnouncementEdit>><any>Observable.throw(e);
                }
            } else
                return <Observable<AnnAnnouncementEdit>><any>Observable.throw(response_);
        });
    }

    protected processGetAnnAnnouncementForEdit(response: Response): Observable<AnnAnnouncementEdit> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AnnAnnouncementEdit.fromJS(resultData200) : new AnnAnnouncementEdit();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AnnAnnouncementEdit>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAnnAnnouncement(input: AnnAnnouncementEdit): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Announcement/UpdateAnnAnnouncement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateAnnAnnouncement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateAnnAnnouncement(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateAnnAnnouncement(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getAnnouncementImageFiles(id: number): Observable<UploadAnnouncementFileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Announcement/GetAnnouncementImageFiles?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAnnouncementImageFiles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAnnouncementImageFiles(response_);
                } catch (e) {
                    return <Observable<UploadAnnouncementFileDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UploadAnnouncementFileDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAnnouncementImageFiles(response: Response): Observable<UploadAnnouncementFileDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UploadAnnouncementFileDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UploadAnnouncementFileDto[]>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteFileOfAnnouncement(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Announcement/DeleteFileOfAnnouncement?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteFileOfAnnouncement(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteFileOfAnnouncement(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteFileOfAnnouncement(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ApplicantServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @vm (optional) 
     * @return Success
     */
    validateApplicantCredentials(vm: ApplicantLoginVm): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Applicant/ValidateApplicantCredentials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processValidateApplicantCredentials(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processValidateApplicantCredentials(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processValidateApplicantCredentials(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @vm (optional) 
     * @return Success
     */
    registerApplicantAsync(vm: ApplicantRegisterVm): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Applicant/RegisterApplicantAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegisterApplicantAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegisterApplicantAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processRegisterApplicantAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @tcNo (optional) 
     * @return Success
     */
    getApplicantUserAsync(tcNo: number): Observable<ApplicantDto> {
        let url_ = this.baseUrl + "/api/services/app/Applicant/GetApplicantUserAsync?";
        if (tcNo !== undefined)
            url_ += "tcNo=" + encodeURIComponent("" + tcNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetApplicantUserAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetApplicantUserAsync(response_);
                } catch (e) {
                    return <Observable<ApplicantDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ApplicantDto>><any>Observable.throw(response_);
        });
    }

    protected processGetApplicantUserAsync(response: Response): Observable<ApplicantDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ApplicantDto.fromJS(resultData200) : new ApplicantDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ApplicantDto>(<any>null);
    }

    /**
     * @tcNo (optional) 
     * @return Success
     */
    getApplicantWithApplications(tcNo: number): Observable<ApplicantDetailedDto> {
        let url_ = this.baseUrl + "/api/services/app/Applicant/GetApplicantWithApplications?";
        if (tcNo !== undefined)
            url_ += "tcNo=" + encodeURIComponent("" + tcNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetApplicantWithApplications(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetApplicantWithApplications(response_);
                } catch (e) {
                    return <Observable<ApplicantDetailedDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ApplicantDetailedDto>><any>Observable.throw(response_);
        });
    }

    protected processGetApplicantWithApplications(response: Response): Observable<ApplicantDetailedDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ApplicantDetailedDto.fromJS(resultData200) : new ApplicantDetailedDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ApplicantDetailedDto>(<any>null);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @userName (optional) 
     * @serviceName (optional) 
     * @methodName (optional) 
     * @browserInfo (optional) 
     * @hasException (optional) 
     * @minExecutionDuration (optional) 
     * @maxExecutionDuration (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getAuditLogs(startDate: moment.Moment, endDate: moment.Moment, userName: string, serviceName: string, methodName: string, browserInfo: string, hasException: boolean, minExecutionDuration: number, maxExecutionDuration: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&"; 
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&"; 
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&"; 
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&"; 
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAuditLogs(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAuditLogListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfAuditLogListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAuditLogs(response: Response): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfAuditLogListDto.fromJS(resultData200) : new PagedResultDtoOfAuditLogListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfAuditLogListDto>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @userName (optional) 
     * @serviceName (optional) 
     * @methodName (optional) 
     * @browserInfo (optional) 
     * @hasException (optional) 
     * @minExecutionDuration (optional) 
     * @maxExecutionDuration (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getAuditLogsToExcel(startDate: moment.Moment, endDate: moment.Moment, userName: string, serviceName: string, methodName: string, browserInfo: string, hasException: boolean, minExecutionDuration: number, maxExecutionDuration: number, sorting: string, maxResultCount: number, skipCount: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&"; 
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&"; 
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&"; 
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&"; 
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&"; 
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAuditLogsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAuditLogsToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllCaches(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCacheDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCacheDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCaches(response: Response): Observable<ListResultDtoOfCacheDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCacheDto.fromJS(resultData200) : new ListResultDtoOfCacheDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfCacheDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    clearCache(input: EntityDtoOfString): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processClearCache(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processClearCache(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearCache(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processClearAllCaches(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearAllCaches(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserChatFriendsWithSettings(response_);
                } catch (e) {
                    return <Observable<GetUserChatFriendsWithSettingsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserChatFriendsWithSettingsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserChatFriendsWithSettings(response: Response): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserChatFriendsWithSettingsOutput.fromJS(resultData200) : new GetUserChatFriendsWithSettingsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUserChatFriendsWithSettingsOutput>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @userId (optional) 
     * @minMessageId (optional) 
     * @return Success
     */
    getUserChatMessages(tenantId: number, userId: number, minMessageId: number): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserChatMessages(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfChatMessageDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfChatMessageDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUserChatMessages(response: Response): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfChatMessageDto.fromJS(resultData200) : new ListResultDtoOfChatMessageDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfChatMessageDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    markAllUnreadMessagesOfUserAsRead(input: MarkAllUnreadMessagesOfUserAsReadInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @onlyFreeItems (optional) 
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionsForCombobox(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionsForCombobox(response: Response): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200) : new ListResultDtoOfSubscribableEditionComboboxItemDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSubscribableEditionComboboxItemDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    findUsers(input: FindUsersInput): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processFindUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processFindUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(response_);
        });
    }

    protected processFindUsers(response: Response): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDefaultEditionName(response_);
                } catch (e) {
                    return <Observable<GetDefaultEditionNameOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDefaultEditionNameOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDefaultEditionName(response: Response): Observable<GetDefaultEditionNameOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDefaultEditionNameOutput.fromJS(resultData200) : new GetDefaultEditionNameOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDefaultEditionNameOutput>(<any>null);
    }
}

@Injectable()
export class DataKeyServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @categoryTypeId (optional) 
     * @culture (optional) 
     * @return Success
     */
    getDataKeysByCategoryAsync(categoryTypeId: number, culture: string): Observable<ListResultDtoOfGetDataTextsByCategoryOutput> {
        let url_ = this.baseUrl + "/api/services/app/DataKey/GetDataKeysByCategoryAsync?";
        if (categoryTypeId !== undefined)
            url_ += "CategoryTypeId=" + encodeURIComponent("" + categoryTypeId) + "&"; 
        if (culture !== undefined)
            url_ += "Culture=" + encodeURIComponent("" + culture) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataKeysByCategoryAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataKeysByCategoryAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetDataTextsByCategoryOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetDataTextsByCategoryOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDataKeysByCategoryAsync(response: Response): Observable<ListResultDtoOfGetDataTextsByCategoryOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetDataTextsByCategoryOutput.fromJS(resultData200) : new ListResultDtoOfGetDataTextsByCategoryOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetDataTextsByCategoryOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getValuesOfKeyByCultureAsync(culture: string, key: string): Observable<GetValueOfKeyByCultureOutput> {
        let url_ = this.baseUrl + "/api/services/app/DataKey/GetValuesOfKeyByCultureAsync?";
        if (culture === undefined || culture === null)
            throw new Error("The parameter 'culture' must be defined and cannot be null.");
        else
            url_ += "Culture=" + encodeURIComponent("" + culture) + "&"; 
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "Key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetValuesOfKeyByCultureAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetValuesOfKeyByCultureAsync(response_);
                } catch (e) {
                    return <Observable<GetValueOfKeyByCultureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetValueOfKeyByCultureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetValuesOfKeyByCultureAsync(response: Response): Observable<GetValueOfKeyByCultureOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetValueOfKeyByCultureOutput.fromJS(resultData200) : new GetValueOfKeyByCultureOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetValueOfKeyByCultureOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getValuesOfKeyAsync(key: string): Observable<ListResultDtoOfGetValuesOfKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/DataKey/GetValuesOfKeyAsync?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "Key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetValuesOfKeyAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetValuesOfKeyAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetValuesOfKeyOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetValuesOfKeyOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetValuesOfKeyAsync(response: Response): Observable<ListResultDtoOfGetValuesOfKeyOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetValuesOfKeyOutput.fromJS(resultData200) : new ListResultDtoOfGetValuesOfKeyOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetValuesOfKeyOutput>(<any>null);
    }

    /**
     * @categoryTypeValue (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @sorting (optional) 
     * @baseLanguageName (optional) 
     * @targetValueFilter (optional) 
     * @filterText (optional) 
     * @return Success
     */
    getDataKeysAsync(categoryTypeValue: number, maxResultCount: number, skipCount: number, sorting: string, sourceName: string, baseLanguageName: string, targetLanguageName: string, targetValueFilter: string, filterText: string): Observable<PagedResultDtoOfDataTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/DataKey/GetDataKeysAsync?";
        if (categoryTypeValue !== undefined)
            url_ += "CategoryTypeValue=" + encodeURIComponent("" + categoryTypeValue) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&"; 
        if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&"; 
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&"; 
        if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&"; 
        if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataKeysAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataKeysAsync(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfDataTextListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfDataTextListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetDataKeysAsync(response: Response): Observable<PagedResultDtoOfDataTextListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfDataTextListDto.fromJS(resultData200) : new PagedResultDtoOfDataTextListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfDataTextListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createNewDataKeyAsync(input: CreateDataTextInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DataKey/CreateNewDataKeyAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateNewDataKeyAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateNewDataKeyAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateNewDataKeyAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @categoryTypeValue (optional) 
     * @baseCulture (optional) 
     * @return Success
     */
    getDataKeyForEditAsync(dataKey: string, categoryTypeValue: number, baseCulture: string, targetCulture: string): Observable<GetDataTextForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/DataKey/GetDataKeyForEditAsync?";
        if (dataKey === undefined || dataKey === null)
            throw new Error("The parameter 'dataKey' must be defined and cannot be null.");
        else
            url_ += "DataKey=" + encodeURIComponent("" + dataKey) + "&"; 
        if (categoryTypeValue !== undefined)
            url_ += "CategoryTypeValue=" + encodeURIComponent("" + categoryTypeValue) + "&"; 
        if (baseCulture !== undefined)
            url_ += "BaseCulture=" + encodeURIComponent("" + baseCulture) + "&"; 
        if (targetCulture === undefined || targetCulture === null)
            throw new Error("The parameter 'targetCulture' must be defined and cannot be null.");
        else
            url_ += "TargetCulture=" + encodeURIComponent("" + targetCulture) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataKeyForEditAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataKeyForEditAsync(response_);
                } catch (e) {
                    return <Observable<GetDataTextForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDataTextForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDataKeyForEditAsync(response: Response): Observable<GetDataTextForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataTextForEditOutput.fromJS(resultData200) : new GetDataTextForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDataTextForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateDataKeyValue(input: UpdateDataTextInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DataKey/UpdateDataKeyValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDataKeyValue(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDataKeyValue(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDataKeyValue(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateDataKey(input: UpdateDataKeyInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DataKey/UpdateDataKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDataKey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDataKey(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDataKey(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    deleteDataKey(key: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DataKey/DeleteDataKey?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined and cannot be null.");
        else
            url_ += "Key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteDataKey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteDataKey(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteDataKey(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @value (optional) 
     * @return Success
     */
    getDataKeyOfValue(value: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DataKey/GetDataKeyOfValue?";
        if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDataKeyOfValue(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDataKeyOfValue(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetDataKeyOfValue(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @date (optional) 
     * @return Success
     */
    sendAndGetDate(date: moment.Moment): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetDate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetDate(response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetDate(response: Response): Observable<DateToStringOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DateToStringOutput>(<any>null);
    }

    /**
     * @date (optional) 
     * @return Success
     */
    sendAndGetDateTime(date: moment.Moment): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetDateTime(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetDateTime(response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetDateTime(response: Response): Observable<DateToStringOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DateToStringOutput>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    sendAndGetDateRange(startDate: moment.Moment, endDate: moment.Moment): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetDateRange(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetDateRange(response_);
                } catch (e) {
                    return <Observable<DateToStringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<DateToStringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetDateRange(response: Response): Observable<DateToStringOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<DateToStringOutput>(<any>null);
    }

    /**
     * @searchTerm (optional) 
     * @return Success
     */
    getCountries(searchTerm: string): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCountries(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCountries(response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>Observable.throw(response_);
        });
    }

    protected processGetCountries(response: Response): Observable<NameValueOfString[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NameValueOfString.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NameValueOfString[]>(<any>null);
    }

    /**
     * @selectedCountries (optional) 
     * @return Success
     */
    sendAndGetSelectedCountries(selectedCountries: NameValueOfString[]): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectedCountries);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetSelectedCountries(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetSelectedCountries(response_);
                } catch (e) {
                    return <Observable<NameValueOfString[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<NameValueOfString[]>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetSelectedCountries(response: Response): Observable<NameValueOfString[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(NameValueOfString.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<NameValueOfString[]>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendAndGetValue(input: string): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendAndGetValue(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendAndGetValue(response_);
                } catch (e) {
                    return <Observable<StringOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<StringOutput>><any>Observable.throw(response_);
        });
    }

    protected processSendAndGetValue(response: Response): Observable<StringOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? StringOutput.fromJS(resultData200) : new StringOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<StringOutput>(<any>null);
    }
}

@Injectable()
export class DistanceEducationEvaluationFeedbackServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    getDistanceEducationResult(tenantId: number): Observable<ListResultDtoOfDistanceEducationResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/DistanceEducationEvaluationFeedback/GetDistanceEducationResult?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDistanceEducationResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDistanceEducationResult(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDistanceEducationResultOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDistanceEducationResultOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDistanceEducationResult(response: Response): Observable<ListResultDtoOfDistanceEducationResultOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDistanceEducationResultOutput.fromJS(resultData200) : new ListResultDtoOfDistanceEducationResultOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfDistanceEducationResultOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setDistanceEducationFeedback(input: DistanceEducationResultOutput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DistanceEducationEvaluationFeedback/SetDistanceEducationFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetDistanceEducationFeedback(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetDistanceEducationFeedback(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetDistanceEducationFeedback(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getResultToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/DistanceEducationEvaluationFeedback/GetResultToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetResultToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetResultToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetResultToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditions(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEditionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEditionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEditions(response: Response): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEditionListDto.fromJS(resultData200) : new ListResultDtoOfEditionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEditionListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionForEdit(response_);
                } catch (e) {
                    return <Observable<GetEditionEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEditionEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionForEdit(response: Response): Observable<GetEditionEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEditionEditOutput.fromJS(resultData200) : new GetEditionEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetEditionEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateEdition(input: CreateOrUpdateEditionDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateOrUpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateEdition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateEdition(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteEdition(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteEdition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteEdition(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @selectedEditionId (optional) 
     * @addAllItem (optional) 
     * @onlyFreeItems (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number, addAllItem: boolean, onlyFreeItems: boolean): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&"; 
        if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&"; 
        if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionComboboxItems(response_);
                } catch (e) {
                    return <Observable<SubscribableEditionComboboxItemDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<SubscribableEditionComboboxItemDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionComboboxItems(response: Response): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SubscribableEditionComboboxItemDto[]>(<any>null);
    }
}

@Injectable()
export class EvaluatedUniversityServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getEvaluatedUniversities(id: number): Observable<ListResultDtoOfEvaluatedUniversityOutput> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatedUniversity/GetEvaluatedUniversities?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluatedUniversities(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluatedUniversities(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluatedUniversityOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluatedUniversityOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluatedUniversities(response: Response): Observable<ListResultDtoOfEvaluatedUniversityOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluatedUniversityOutput.fromJS(resultData200) : new ListResultDtoOfEvaluatedUniversityOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluatedUniversityOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createEvaluatedUniAsync(input: EvaluatedUniversityInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatedUniversity/CreateEvaluatedUniAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateEvaluatedUniAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateEvaluatedUniAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateEvaluatedUniAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @termId (optional) 
     * @return Success
     */
    deleteEvaluatedUniAsync(universityId: number, termId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatedUniversity/DeleteEvaluatedUniAsync?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteEvaluatedUniAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteEvaluatedUniAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteEvaluatedUniAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class EvaluationFormServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @parentId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getEvaluationFormsByParentId(parentId: number, termId: number): Observable<ListResultDtoOfEvaluationFormDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationForm/GetEvaluationFormsByParentId?";
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormsByParentId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormsByParentId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluationFormDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluationFormDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormsByParentId(response: Response): Observable<ListResultDtoOfEvaluationFormDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluationFormDto.fromJS(resultData200) : new ListResultDtoOfEvaluationFormDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluationFormDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @termId (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string, termId: number, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfEvaluationFormDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationForm/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEvaluationFormDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfEvaluationFormDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<PagedResultDtoOfEvaluationFormDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfEvaluationFormDto.fromJS(resultData200) : new PagedResultDtoOfEvaluationFormDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfEvaluationFormDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getEvaluationFormForUpdate(id: number): Observable<CreateOrUpdateEvaluationFormDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationForm/GetEvaluationFormForUpdate?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormForUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormForUpdate(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateEvaluationFormDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateEvaluationFormDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormForUpdate(response: Response): Observable<CreateOrUpdateEvaluationFormDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrUpdateEvaluationFormDto.fromJS(resultData200) : new CreateOrUpdateEvaluationFormDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrUpdateEvaluationFormDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createEvaluationForm(input: CreateOrUpdateEvaluationFormDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationForm/CreateEvaluationForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateEvaluationForm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateEvaluationForm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateEvaluationForm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateEvaluationForm(input: CreateOrUpdateEvaluationFormDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationForm/UpdateEvaluationForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateEvaluationForm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateEvaluationForm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateEvaluationForm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationForm/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getAllEvaluationCriterias(id: number): Observable<ListResultDtoOfEvaluationCriteriaDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationForm/GetAllEvaluationCriterias?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllEvaluationCriterias(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllEvaluationCriterias(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluationCriteriaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluationCriteriaDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllEvaluationCriterias(response: Response): Observable<ListResultDtoOfEvaluationCriteriaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluationCriteriaDto.fromJS(resultData200) : new ListResultDtoOfEvaluationCriteriaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluationCriteriaDto>(<any>null);
    }

    /**
     * @parentId (optional) 
     * @return Success
     */
    getEvaluationFormsSequenceZero(parentId: number): Observable<ListResultDtoOfEvaluationFormSequenceZeroDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationForm/GetEvaluationFormsSequenceZero?";
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormsSequenceZero(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormsSequenceZero(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluationFormSequenceZeroDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluationFormSequenceZeroDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormsSequenceZero(response: Response): Observable<ListResultDtoOfEvaluationFormSequenceZeroDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluationFormSequenceZeroDto.fromJS(resultData200) : new ListResultDtoOfEvaluationFormSequenceZeroDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluationFormSequenceZeroDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateEvaluationFormHelpAndProof(input: HelpAndProofDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationForm/CreateOrUpdateEvaluationFormHelpAndProof";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateEvaluationFormHelpAndProof(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateEvaluationFormHelpAndProof(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateEvaluationFormHelpAndProof(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class EvaluationFormAnswerServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @parentId (optional) 
     * @year (optional) 
     * @return Success
     */
    getEvaluationForms(parentId: number, year: number): Observable<ListResultDtoOfEvaluationFormDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/GetEvaluationForms?";
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationForms(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationForms(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluationFormDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluationFormDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationForms(response: Response): Observable<ListResultDtoOfEvaluationFormDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluationFormDto.fromJS(resultData200) : new ListResultDtoOfEvaluationFormDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluationFormDto>(<any>null);
    }

    /**
     * @evaluationFormId (optional) 
     * @year (optional) 
     * @return Success
     */
    getEvaluationFormWithAnswerAsync(evaluationFormId: number, year: number): Observable<ListResultDtoOfEvaluationFormWithAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/GetEvaluationFormWithAnswerAsync?";
        if (evaluationFormId !== undefined)
            url_ += "EvaluationFormId=" + encodeURIComponent("" + evaluationFormId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormWithAnswerAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormWithAnswerAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluationFormWithAnswerDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluationFormWithAnswerDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormWithAnswerAsync(response: Response): Observable<ListResultDtoOfEvaluationFormWithAnswerDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluationFormWithAnswerDto.fromJS(resultData200) : new ListResultDtoOfEvaluationFormWithAnswerDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluationFormWithAnswerDto>(<any>null);
    }

    /**
     * @evaluationFormId (optional) 
     * @year (optional) 
     * @return Success
     */
    getEvaluationFormWithAnswers(evaluationFormId: number, year: number): Observable<ListResultDtoOfEvaluationFormWithAllAnswersDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/GetEvaluationFormWithAnswers?";
        if (evaluationFormId !== undefined)
            url_ += "EvaluationFormId=" + encodeURIComponent("" + evaluationFormId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormWithAnswers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormWithAnswers(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluationFormWithAllAnswersDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluationFormWithAllAnswersDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormWithAnswers(response: Response): Observable<ListResultDtoOfEvaluationFormWithAllAnswersDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluationFormWithAllAnswersDto.fromJS(resultData200) : new ListResultDtoOfEvaluationFormWithAllAnswersDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluationFormWithAllAnswersDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getEvulationFormDataForEdit(id: number): Observable<CreateOrUpdateEvaluationFormAnswerInput> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/GetEvulationFormDataForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvulationFormDataForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvulationFormDataForEdit(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateEvaluationFormAnswerInput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateEvaluationFormAnswerInput>><any>Observable.throw(response_);
        });
    }

    protected processGetEvulationFormDataForEdit(response: Response): Observable<CreateOrUpdateEvaluationFormAnswerInput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrUpdateEvaluationFormAnswerInput.fromJS(resultData200) : new CreateOrUpdateEvaluationFormAnswerInput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrUpdateEvaluationFormAnswerInput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrUpdateEvaluationFormAnswerInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @year (optional) 
     * @formId (optional) 
     * @sequenceNo (optional) 
     * @return Success
     */
    getEvaluationFormAnswerOfTenantForYear(year: number, formId: number, sequenceNo: number): Observable<TenantEvalutionFormAnswerOfYearOutput> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/GetEvaluationFormAnswerOfTenantForYear?";
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        if (formId !== undefined)
            url_ += "FormId=" + encodeURIComponent("" + formId) + "&"; 
        if (sequenceNo !== undefined)
            url_ += "SequenceNo=" + encodeURIComponent("" + sequenceNo) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormAnswerOfTenantForYear(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormAnswerOfTenantForYear(response_);
                } catch (e) {
                    return <Observable<TenantEvalutionFormAnswerOfYearOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantEvalutionFormAnswerOfYearOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormAnswerOfTenantForYear(response: Response): Observable<TenantEvalutionFormAnswerOfYearOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantEvalutionFormAnswerOfYearOutput.fromJS(resultData200) : new TenantEvalutionFormAnswerOfYearOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantEvalutionFormAnswerOfYearOutput>(<any>null);
    }

    /**
     * @evaluationFormAnswerId (optional) 
     * @evlFormHelpAndProofType (optional) 
     * @return Success
     */
    getEvaluationFormAnswerProofFiles(evaluationFormAnswerId: number, evlFormHelpAndProofType: EvlFormHelpAndProofType): Observable<UploadProofFileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/GetEvaluationFormAnswerProofFiles?";
        if (evaluationFormAnswerId !== undefined)
            url_ += "evaluationFormAnswerId=" + encodeURIComponent("" + evaluationFormAnswerId) + "&"; 
        if (evlFormHelpAndProofType !== undefined)
            url_ += "evlFormHelpAndProofType=" + encodeURIComponent("" + evlFormHelpAndProofType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormAnswerProofFiles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormAnswerProofFiles(response_);
                } catch (e) {
                    return <Observable<UploadProofFileDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UploadProofFileDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormAnswerProofFiles(response: Response): Observable<UploadProofFileDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};

        if (status === 200) {
            const _responseText = response.text();

            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UploadProofFileDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UploadProofFileDto[]>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteFileOfAnswer(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/DeleteFileOfAnswer?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteFileOfAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteFileOfAnswer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteFileOfAnswer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @universtiyId (optional) 
     * @parentId (optional) 
     * @return Success
     */
    getExternalEvaluationAnswer(universtiyId: number, parentId: number): Observable<ListResultDtoOfExtEvlAnsw> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/GetExternalEvaluationAnswer?";
        if (universtiyId !== undefined)
            url_ += "universtiyId=" + encodeURIComponent("" + universtiyId) + "&"; 
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExternalEvaluationAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExternalEvaluationAnswer(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfExtEvlAnsw>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfExtEvlAnsw>><any>Observable.throw(response_);
        });
    }

    protected processGetExternalEvaluationAnswer(response: Response): Observable<ListResultDtoOfExtEvlAnsw> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfExtEvlAnsw.fromJS(resultData200) : new ListResultDtoOfExtEvlAnsw();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfExtEvlAnsw>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    evaluationFormCompleted(input: EvlFrmCompletedDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/EvaluationFormCompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEvaluationFormCompleted(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEvaluationFormCompleted(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEvaluationFormCompleted(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @termId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    getEvaluationFormIsCompleted(termId: number, tenantId: number): Observable<EvlFormCompletedOutput> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/GetEvaluationFormIsCompleted?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormIsCompleted(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormIsCompleted(response_);
                } catch (e) {
                    return <Observable<EvlFormCompletedOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<EvlFormCompletedOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormIsCompleted(response: Response): Observable<EvlFormCompletedOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EvlFormCompletedOutput.fromJS(resultData200) : new EvlFormCompletedOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EvlFormCompletedOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    deleteFileOfSelfEvaluation(input: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/DeleteFileOfSelfEvaluation?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteFileOfSelfEvaluation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteFileOfSelfEvaluation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteFileOfSelfEvaluation(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    evaluationFormIsCompleteable(input: GetEvlFrmIsCompletedDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/EvaluationFormIsCompleteable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEvaluationFormIsCompleteable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEvaluationFormIsCompleteable(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processEvaluationFormIsCompleteable(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @parentId (optional) 
     * @year (optional) 
     * @return Success
     */
    distanceGetEvaluationForms(parentId: number, year: number): Observable<ListResultDtoOfEvaluationFormDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/DistanceGetEvaluationForms?";
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDistanceGetEvaluationForms(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDistanceGetEvaluationForms(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluationFormDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluationFormDto>><any>Observable.throw(response_);
        });
    }

    protected processDistanceGetEvaluationForms(response: Response): Observable<ListResultDtoOfEvaluationFormDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluationFormDto.fromJS(resultData200) : new ListResultDtoOfEvaluationFormDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluationFormDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    distanceGetEvaluationFormWithAnswerAsync(input: GetEvaluationFormAnswersInput): Observable<ListResultDtoOfEvaluationFormWithAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/DistanceGetEvaluationFormWithAnswerAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDistanceGetEvaluationFormWithAnswerAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDistanceGetEvaluationFormWithAnswerAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluationFormWithAnswerDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluationFormWithAnswerDto>><any>Observable.throw(response_);
        });
    }

    protected processDistanceGetEvaluationFormWithAnswerAsync(response: Response): Observable<ListResultDtoOfEvaluationFormWithAnswerDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluationFormWithAnswerDto.fromJS(resultData200) : new ListResultDtoOfEvaluationFormWithAnswerDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluationFormWithAnswerDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    distanceCreateOrEdit(input: CreateOrUpdateEvaluationFormAnswerInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/DistanceCreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDistanceCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDistanceCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDistanceCreateOrEdit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @evaluationFormAnswerId (optional) 
     * @evlFormHelpAndProofType (optional) 
     * @return Success
     */
    distanceGetEvaluationFormAnswerProofFiles(evaluationFormAnswerId: number, evlFormHelpAndProofType: EvlFormHelpAndProofType2): Observable<UploadProofFileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormAnswer/DistanceGetEvaluationFormAnswerProofFiles?";
        if (evaluationFormAnswerId !== undefined)
            url_ += "evaluationFormAnswerId=" + encodeURIComponent("" + evaluationFormAnswerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(evlFormHelpAndProofType);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDistanceGetEvaluationFormAnswerProofFiles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDistanceGetEvaluationFormAnswerProofFiles(response_);
                } catch (e) {
                    return <Observable<UploadProofFileDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UploadProofFileDto[]>><any>Observable.throw(response_);
        });
    }

    protected processDistanceGetEvaluationFormAnswerProofFiles(response: Response): Observable<UploadProofFileDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UploadProofFileDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UploadProofFileDto[]>(<any>null);
    }
}

@Injectable()
export class EvaluationFormCompletionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @year (optional) 
     * @filter (optional) 
     * @return Success
     */
    getAllCompletions(year: number, filter: string): Observable<PagedResultDtoOfUniversityCompletionOutput> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormCompletion/GetAllCompletions?";
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCompletions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllCompletions(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUniversityCompletionOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfUniversityCompletionOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCompletions(response: Response): Observable<PagedResultDtoOfUniversityCompletionOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUniversityCompletionOutput.fromJS(resultData200) : new PagedResultDtoOfUniversityCompletionOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfUniversityCompletionOutput>(<any>null);
    }

    /**
     * @year (optional) 
     * @return Success
     */
    getAllCompletionsToExcel(year: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormCompletion/GetAllCompletionsToExcel?";
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllCompletionsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllCompletionsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllCompletionsToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class EvaluationFormMaturityLevelServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateMaturityLevel(input: CreateOrUpdateMaturityLevelDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMaturityLevel/CreateOrUpdateMaturityLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateMaturityLevel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateMaturityLevel(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateMaturityLevel(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMaturityLevel/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllEvaluationForm(): Observable<EvaluationFormDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMaturityLevel/GetAllEvaluationForm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllEvaluationForm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllEvaluationForm(response_);
                } catch (e) {
                    return <Observable<EvaluationFormDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<EvaluationFormDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllEvaluationForm(response: Response): Observable<EvaluationFormDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(EvaluationFormDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EvaluationFormDto[]>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getAllMaturityLevel(sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfMaturityLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMaturityLevel/GetAllMaturityLevel?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMaturityLevel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMaturityLevel(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfMaturityLevelDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfMaturityLevelDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMaturityLevel(response: Response): Observable<PagedResultDtoOfMaturityLevelDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfMaturityLevelDto.fromJS(resultData200) : new PagedResultDtoOfMaturityLevelDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfMaturityLevelDto>(<any>null);
    }
}

@Injectable()
export class EvaluationFormMentorServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @termId (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getAllMentors(termId: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfMentorDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMentor/GetAllMentors?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMentors(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMentors(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfMentorDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfMentorDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMentors(response: Response): Observable<PagedResultDtoOfMentorDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfMentorDto.fromJS(resultData200) : new PagedResultDtoOfMentorDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfMentorDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateMentor(input: CreateOrUpdateMentorDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMentor/CreateOrUpdateMentor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateMentor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateMentor(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateMentor(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMentor/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    getMentorSurveyList(termId: number): Observable<ListResultDtoOfMentorSurveyListDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMentor/GetMentorSurveyList?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMentorSurveyList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMentorSurveyList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMentorSurveyListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMentorSurveyListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetMentorSurveyList(response: Response): Observable<ListResultDtoOfMentorSurveyListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMentorSurveyListDto.fromJS(resultData200) : new ListResultDtoOfMentorSurveyListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMentorSurveyListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateMentorSurvey(input: CreateOrUpdateMentorSurveyDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMentor/CreateOrUpdateMentorSurvey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateMentorSurvey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateMentorSurvey(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateMentorSurvey(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @mentorSurveyId (optional) 
     * @return Success
     */
    getForUpdateMentorSurvey(mentorSurveyId: number): Observable<CreateOrUpdateMentorSurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMentor/GetForUpdateMentorSurvey?";
        if (mentorSurveyId !== undefined)
            url_ += "MentorSurveyId=" + encodeURIComponent("" + mentorSurveyId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetForUpdateMentorSurvey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetForUpdateMentorSurvey(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateMentorSurveyDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateMentorSurveyDto>><any>Observable.throw(response_);
        });
    }

    protected processGetForUpdateMentorSurvey(response: Response): Observable<CreateOrUpdateMentorSurveyDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrUpdateMentorSurveyDto.fromJS(resultData200) : new CreateOrUpdateMentorSurveyDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrUpdateMentorSurveyDto>(<any>null);
    }

    /**
     * @mentorSurveyId (optional) 
     * @return Success
     */
    deleteMentorSurvey(mentorSurveyId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMentor/DeleteMentorSurvey?";
        if (mentorSurveyId !== undefined)
            url_ += "MentorSurveyId=" + encodeURIComponent("" + mentorSurveyId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMentorSurvey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMentorSurvey(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMentorSurvey(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    getMentoringUniversities(termId: number): Observable<ListResultDtoOfMentoringUniversitysOutput> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMentor/GetMentoringUniversities?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMentoringUniversities(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMentoringUniversities(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMentoringUniversitysOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMentoringUniversitysOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetMentoringUniversities(response: Response): Observable<ListResultDtoOfMentoringUniversitysOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMentoringUniversitysOutput.fromJS(resultData200) : new ListResultDtoOfMentoringUniversitysOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMentoringUniversitysOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @tenantId (optional) 
     * @applicantId (optional) 
     * @return Success
     */
    getMentorSurveyDataAsync(termId: number, tenantId: number, applicantId: number): Observable<MentoringSurveyDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMentor/GetMentorSurveyDataAsync?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (applicantId !== undefined)
            url_ += "ApplicantId=" + encodeURIComponent("" + applicantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMentorSurveyDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMentorSurveyDataAsync(response_);
                } catch (e) {
                    return <Observable<MentoringSurveyDataOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<MentoringSurveyDataOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetMentorSurveyDataAsync(response: Response): Observable<MentoringSurveyDataOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MentoringSurveyDataOutput.fromJS(resultData200) : new MentoringSurveyDataOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MentoringSurveyDataOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    getAllMentorSurveyDataAsync(termId: number): Observable<ListResultDtoOfAllMentoringSurveyDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormMentor/GetAllMentorSurveyDataAsync?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMentorSurveyDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMentorSurveyDataAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfAllMentoringSurveyDataOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfAllMentoringSurveyDataOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMentorSurveyDataAsync(response: Response): Observable<ListResultDtoOfAllMentoringSurveyDataOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfAllMentoringSurveyDataOutput.fromJS(resultData200) : new ListResultDtoOfAllMentoringSurveyDataOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfAllMentoringSurveyDataOutput>(<any>null);
    }
}

@Injectable()
export class EvaluationFormReportsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @tenantIds (optional) 
     * @selectedYear (optional) 
     * @parentEvaluationFormId (optional) 
     * @childEvaluationFormId (optional) 
     * @return Success
     */
    getAnswersByTenantsAsync(tenantIds: number[], selectedYear: number, parentEvaluationFormId: number, childEvaluationFormId: number): Observable<ListResultDtoOfAnswersByTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormReports/GetAnswersByTenantsAsync?";
        if (tenantIds !== undefined)
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (selectedYear !== undefined)
            url_ += "SelectedYear=" + encodeURIComponent("" + selectedYear) + "&"; 
        if (parentEvaluationFormId !== undefined)
            url_ += "ParentEvaluationFormId=" + encodeURIComponent("" + parentEvaluationFormId) + "&"; 
        if (childEvaluationFormId !== undefined)
            url_ += "ChildEvaluationFormId=" + encodeURIComponent("" + childEvaluationFormId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAnswersByTenantsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAnswersByTenantsAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfAnswersByTenantsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfAnswersByTenantsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAnswersByTenantsAsync(response: Response): Observable<ListResultDtoOfAnswersByTenantsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfAnswersByTenantsOutput.fromJS(resultData200) : new ListResultDtoOfAnswersByTenantsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfAnswersByTenantsOutput>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @evaluationFormId (optional) 
     * @years (optional) 
     * @return Success
     */
    getAnswersByYearsAsync(tenantId: number, evaluationFormId: number, years: number[]): Observable<ListResultDtoOfAnswersByYearsOutput> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormReports/GetAnswersByYearsAsync?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (evaluationFormId !== undefined)
            url_ += "EvaluationFormId=" + encodeURIComponent("" + evaluationFormId) + "&"; 
        if (years !== undefined)
            years && years.forEach(item => { url_ += "Years=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAnswersByYearsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAnswersByYearsAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfAnswersByYearsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfAnswersByYearsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAnswersByYearsAsync(response: Response): Observable<ListResultDtoOfAnswersByYearsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfAnswersByYearsOutput.fromJS(resultData200) : new ListResultDtoOfAnswersByYearsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfAnswersByYearsOutput>(<any>null);
    }
}

@Injectable()
export class EvaluationFormUpdateServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    evaluationFormTermUpdate(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormUpdate/EvaluationFormTermUpdate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEvaluationFormTermUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEvaluationFormTermUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEvaluationFormTermUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    evaluationFormTermNew(termId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormUpdate/EvaluationFormTermNew?";
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEvaluationFormTermNew(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEvaluationFormTermNew(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEvaluationFormTermNew(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    evaluationFormAnswerUpdate(termId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormUpdate/EvaluationFormAnswerUpdate?";
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEvaluationFormAnswerUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEvaluationFormAnswerUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEvaluationFormAnswerUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    evaluationFormHelpAndProofUpdate(termId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormUpdate/EvaluationFormHelpAndProofUpdate?";
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEvaluationFormHelpAndProofUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEvaluationFormHelpAndProofUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEvaluationFormHelpAndProofUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    evaluationFormAnswerReverse(termId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationFormUpdate/EvaluationFormAnswerReverse?";
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEvaluationFormAnswerReverse(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEvaluationFormAnswerReverse(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEvaluationFormAnswerReverse(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class EvaluationTeamServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTeamsAsync(id: number): Observable<ListResultDtoOfEvaluationTeamOutput> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationTeam/GetTeamsAsync?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTeamsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTeamsAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluationTeamOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluationTeamOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTeamsAsync(response: Response): Observable<ListResultDtoOfEvaluationTeamOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluationTeamOutput.fromJS(resultData200) : new ListResultDtoOfEvaluationTeamOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluationTeamOutput>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTeamForEditAsync(id: number): Observable<EvaluationTeamOutput> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationTeam/GetTeamForEditAsync?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTeamForEditAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTeamForEditAsync(response_);
                } catch (e) {
                    return <Observable<EvaluationTeamOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<EvaluationTeamOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTeamForEditAsync(response: Response): Observable<EvaluationTeamOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EvaluationTeamOutput.fromJS(resultData200) : new EvaluationTeamOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EvaluationTeamOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createEvaluationTeam(input: CreateTeamInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationTeam/CreateEvaluationTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateEvaluationTeam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateEvaluationTeam(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateEvaluationTeam(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteEvaluationteam(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationTeam/DeleteEvaluationteam?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteEvaluationteam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteEvaluationteam(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteEvaluationteam(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateEvaluationteam(input: UpdateTeamInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationTeam/UpdateEvaluationteam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateEvaluationteam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateEvaluationteam(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateEvaluationteam(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @termId (optional) 
     * @evaluatorTask (optional) 
     * @return Success
     */
    getEvaluatorsAsync(termId: number, evaluatorTask: EvaluatorTask): Observable<ListResultDtoOfEvaluatorListDto> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationTeam/GetEvaluatorsAsync?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (evaluatorTask !== undefined)
            url_ += "EvaluatorTask=" + encodeURIComponent("" + evaluatorTask) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluatorsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluatorsAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluatorListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluatorListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluatorsAsync(response: Response): Observable<ListResultDtoOfEvaluatorListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluatorListDto.fromJS(resultData200) : new ListResultDtoOfEvaluatorListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluatorListDto>(<any>null);
    }

    /**
     * @termId (optional) 
     * @tenantId (optional) 
     * @teamId (optional) 
     * @return Success
     */
    getEvaluationUniversityAccreditationData(termId: number, tenantId: number, teamId: number): Observable<EvaluationUniversityAccDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationTeam/GetEvaluationUniversityAccreditationData?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationUniversityAccreditationData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationUniversityAccreditationData(response_);
                } catch (e) {
                    return <Observable<EvaluationUniversityAccDataOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<EvaluationUniversityAccDataOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationUniversityAccreditationData(response: Response): Observable<EvaluationUniversityAccDataOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EvaluationUniversityAccDataOutput.fromJS(resultData200) : new EvaluationUniversityAccDataOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EvaluationUniversityAccDataOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setEvaluationUniversityAccreditation(input: EvaluationUniversityAccDataOutput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluationTeam/SetEvaluationUniversityAccreditation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetEvaluationUniversityAccreditation(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetEvaluationUniversityAccreditation(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetEvaluationUniversityAccreditation(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class EvaluatorSystemAppSerivceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllEvaluatorsAsync(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetAllEvaluatorsAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllEvaluatorsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllEvaluatorsAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetAllEvaluatorsAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @return Success
     */
    getAllUsersAsync(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetAllUsersAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllUsersAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllUsersAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetAllUsersAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setEvaluatorSytemIdAsync(input: EvaluatorSystemIdListInput[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SetEvaluatorSytemIdAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetEvaluatorSytemIdAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetEvaluatorSytemIdAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetEvaluatorSytemIdAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @evlSysIdInput (optional) 
     * @evaluationTypeInput (optional) 
     * @termId (optional) 
     * @return Success
     */
    systemsApprovalsAsync(evlSysIdInput: number, evaluationTypeInput: number, termId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SystemsApprovalsAsync?";
        if (evlSysIdInput !== undefined)
            url_ += "evlSysIdInput=" + encodeURIComponent("" + evlSysIdInput) + "&"; 
        if (evaluationTypeInput !== undefined)
            url_ += "evaluationTypeInput=" + encodeURIComponent("" + evaluationTypeInput) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSystemsApprovalsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSystemsApprovalsAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processSystemsApprovalsAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @evlSysIdInput (optional) 
     * @termId (optional) 
     * @return Success
     */
    setSystemsApprovalsAsync(evlSysIdInput: number, termId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SetSystemsApprovalsAsync?";
        if (evlSysIdInput !== undefined)
            url_ += "evlSysIdInput=" + encodeURIComponent("" + evlSysIdInput) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetSystemsApprovalsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetSystemsApprovalsAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetSystemsApprovalsAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setTeamTaskDutyAsync(input: TeamTaskDutyInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SetTeamTaskDutyAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetTeamTaskDutyAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetTeamTaskDutyAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetTeamTaskDutyAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getTeamMembersAsync(teamId: number, termId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetTeamMembersAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTeamMembersAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTeamMembersAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetTeamMembersAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setWriteAuthAsync(input: MemberWriteAuth): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SetWriteAuthAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetWriteAuthAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetWriteAuthAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetWriteAuthAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @tenantId (optional) 
     * @applicantId (optional) 
     * @termId (optional) 
     * @cltr (optional) 
     * @return Success
     */
    teamUniversityDetail(teamId: number, tenantId: number, applicantId: number, termId: number, cltr: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/TeamUniversityDetail?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (applicantId !== undefined)
            url_ += "ApplicantId=" + encodeURIComponent("" + applicantId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (cltr !== undefined)
            url_ += "cltr=" + encodeURIComponent("" + cltr) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTeamUniversityDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTeamUniversityDetail(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processTeamUniversityDetail(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @tenantId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getUniversityFeedbackAsync(teamId: number, tenantId: number, termId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetUniversityFeedbackAsync?";
        if (teamId !== undefined)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUniversityFeedbackAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUniversityFeedbackAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetUniversityFeedbackAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @termId (optional) 
     * @cltr (optional) 
     * @return Success
     */
    getKidrDataAsync(tenantId: number, termId: number, cltr: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetKidrDataAsync?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (cltr !== undefined)
            url_ += "cltr=" + encodeURIComponent("" + cltr) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetKidrDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetKidrDataAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetKidrDataAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @tenantId (optional) 
     * @termId (optional) 
     * @cltr (optional) 
     * @return Success
     */
    getKgbrDataAsync(teamId: number, tenantId: number, termId: number, cltr: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetKgbrDataAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (cltr !== undefined)
            url_ += "cltr=" + encodeURIComponent("" + cltr) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetKgbrDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetKgbrDataAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetKgbrDataAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @cltr (optional) 
     * @return Success
     */
    getIndicatorsDataAsync(tenantId: number, cltr: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetIndicatorsDataAsync?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (cltr !== undefined)
            url_ += "cltr=" + encodeURIComponent("" + cltr) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIndicatorsDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIndicatorsDataAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetIndicatorsDataAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @tenantId (optional) 
     * @termId (optional) 
     * @cltr (optional) 
     * @return Success
     */
    getKarDataAsync(teamId: number, tenantId: number, termId: number, cltr: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetKarDataAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (cltr !== undefined)
            url_ += "cltr=" + encodeURIComponent("" + cltr) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetKarDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetKarDataAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetKarDataAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @tenantId (optional) 
     * @evlSysUserId (optional) 
     * @termId (optional) 
     * @return Success
     */
    sendDraftKarAsync(teamId: number, tenantId: number, evlSysUserId: number, termId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SendDraftKarAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (evlSysUserId !== undefined)
            url_ += "EvlSysUserId=" + encodeURIComponent("" + evlSysUserId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendDraftKarAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendDraftKarAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendDraftKarAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @tenantId (optional) 
     * @evlSysUserId (optional) 
     * @termId (optional) 
     * @return Success
     */
    sendDraftKgbrAsync(teamId: number, tenantId: number, evlSysUserId: number, termId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SendDraftKgbrAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (evlSysUserId !== undefined)
            url_ += "EvlSysUserId=" + encodeURIComponent("" + evlSysUserId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendDraftKgbrAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendDraftKgbrAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendDraftKgbrAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    sendCompleteKarAsync(teamId: number, tenantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SendCompleteKarAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendCompleteKarAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendCompleteKarAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendCompleteKarAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setSaveEvaluatorAnswerAsync(input: EvlSysEvaluatorAnswerDataInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SetSaveEvaluatorAnswerAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetSaveEvaluatorAnswerAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetSaveEvaluatorAnswerAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetSaveEvaluatorAnswerAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @uniEvlAnswId (optional) 
     * @return Success
     */
    getEvidencesAsync(uniEvlAnswId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetEvidencesAsync?";
        if (uniEvlAnswId !== undefined)
            url_ += "uniEvlAnswId=" + encodeURIComponent("" + uniEvlAnswId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvidencesAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvidencesAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetEvidencesAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @applicantId (optional) 
     * @return Success
     */
    getMeetingsAsync(teamId: number, applicantId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetMeetingsAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (applicantId !== undefined)
            url_ += "ApplicantId=" + encodeURIComponent("" + applicantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMeetingsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMeetingsAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetMeetingsAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @meetingId (optional) 
     * @return Success
     */
    getMeetingParticipantsAsync(teamId: number, meetingId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetMeetingParticipantsAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (meetingId !== undefined)
            url_ += "MeetingId=" + encodeURIComponent("" + meetingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMeetingParticipantsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMeetingParticipantsAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetMeetingParticipantsAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveMeetingParticipantsAsync(input: EvlSysMeetingParticipant): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SaveMeetingParticipantsAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveMeetingParticipantsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveMeetingParticipantsAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveMeetingParticipantsAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @pId (optional) 
     * @return Success
     */
    deleteMeetingParticipantsAsync(pId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/DeleteMeetingParticipantsAsync?";
        if (pId !== undefined)
            url_ += "pId=" + encodeURIComponent("" + pId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteMeetingParticipantsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteMeetingParticipantsAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteMeetingParticipantsAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @meetingId (optional) 
     * @participantIds (optional) 
     * @return Success
     */
    senEmailParticipantAsync(teamId: number, meetingId: number, participantIds: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SenEmailParticipantAsync?";
        if (teamId !== undefined)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (meetingId !== undefined)
            url_ += "meetingId=" + encodeURIComponent("" + meetingId) + "&"; 
        if (participantIds !== undefined)
            url_ += "participantIds=" + encodeURIComponent("" + participantIds) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSenEmailParticipantAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSenEmailParticipantAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSenEmailParticipantAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @meetingId (optional) 
     * @return Success
     */
    getMeetingcoeAsync(teamId: number, meetingId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetMeetingcoeAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (meetingId !== undefined)
            url_ += "MeetingId=" + encodeURIComponent("" + meetingId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMeetingcoeAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMeetingcoeAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetMeetingcoeAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setMeetingcoeAsync(input: EvlSysMeetingcoeData): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SetMeetingcoeAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetMeetingcoeAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetMeetingcoeAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetMeetingcoeAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @return Success
     */
    getAdditionalEvidenceAsync(teamId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetAdditionalEvidenceAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAdditionalEvidenceAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAdditionalEvidenceAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetAdditionalEvidenceAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @tenantId (optional) 
     * @applicantId (optional) 
     * @termId (optional) 
     * @cltr (optional) 
     * @return Success
     */
    getTeamUniversityDetailMonitoringAsync(teamId: number, tenantId: number, applicantId: number, termId: number, cltr: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetTeamUniversityDetailMonitoringAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (applicantId !== undefined)
            url_ += "ApplicantId=" + encodeURIComponent("" + applicantId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (cltr !== undefined)
            url_ += "cltr=" + encodeURIComponent("" + cltr) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTeamUniversityDetailMonitoringAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTeamUniversityDetailMonitoringAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetTeamUniversityDetailMonitoringAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setSaveEvaluatorAnswerMonitoringAsync(input: MonitoringAnswerData): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SetSaveEvaluatorAnswerMonitoringAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetSaveEvaluatorAnswerMonitoringAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetSaveEvaluatorAnswerMonitoringAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetSaveEvaluatorAnswerMonitoringAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @tenantId (optional) 
     * @cltr (optional) 
     * @return Success
     */
    getKirDataAsync(teamId: number, tenantId: number, cltr: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetKirDataAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (cltr !== undefined)
            url_ += "cltr=" + encodeURIComponent("" + cltr) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetKirDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetKirDataAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetKirDataAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @tenantId (optional) 
     * @evlSysUserId (optional) 
     * @termId (optional) 
     * @return Success
     */
    sendDraftMonitoringAsync(teamId: number, tenantId: number, evlSysUserId: number, termId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SendDraftMonitoringAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (evlSysUserId !== undefined)
            url_ += "EvlSysUserId=" + encodeURIComponent("" + evlSysUserId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendDraftMonitoringAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendDraftMonitoringAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendDraftMonitoringAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @teamId (optional) 
     * @return Success
     */
    getDistanceReportPdfDataAsync(tenantId: number, teamId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetDistanceReportPdfDataAsync?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDistanceReportPdfDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDistanceReportPdfDataAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetDistanceReportPdfDataAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setSaveDistanceEvaluationAnswerAsync(input: EvlSysDistanceAnswerData): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SetSaveDistanceEvaluationAnswerAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetSaveDistanceEvaluationAnswerAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetSaveDistanceEvaluationAnswerAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetSaveDistanceEvaluationAnswerAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @instAccAnswId (optional) 
     * @return Success
     */
    getInstAccAcceptedFileAsync(instAccAnswId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetInstAccAcceptedFileAsync?";
        if (instAccAnswId !== undefined)
            url_ += "InstAccAnswId=" + encodeURIComponent("" + instAccAnswId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInstAccAcceptedFileAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInstAccAcceptedFileAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetInstAccAcceptedFileAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @instAccAnswId (optional) 
     * @return Success
     */
    getExtEvlAcceptedFileAsync(instAccAnswId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetExtEvlAcceptedFileAsync?";
        if (instAccAnswId !== undefined)
            url_ += "InstAccAnswId=" + encodeURIComponent("" + instAccAnswId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExtEvlAcceptedFileAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExtEvlAcceptedFileAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetExtEvlAcceptedFileAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @evaluatorId (optional) 
     * @evaluatedId (optional) 
     * @teamId (optional) 
     * @tenantId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getSurveyDataAsync(from: From, to: To, evaluatorId: number, evaluatedId: number, teamId: number, tenantId: number, termId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetSurveyDataAsync?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent("" + to) + "&"; 
        if (evaluatorId !== undefined)
            url_ += "EvaluatorId=" + encodeURIComponent("" + evaluatorId) + "&"; 
        if (evaluatedId !== undefined)
            url_ += "EvaluatedId=" + encodeURIComponent("" + evaluatedId) + "&"; 
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSurveyDataAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyDataAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setSurveyAnswerAsync(input: EvlSysSurveyAnswerInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SetSurveyAnswerAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetSurveyAnswerAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetSurveyAnswerAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetSurveyAnswerAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setSurveyCompleteAsync(input: EvlSysSurveyCompleteInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SetSurveyCompleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetSurveyCompleteAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetSurveyCompleteAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetSurveyCompleteAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    allTermsListAsync(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/AllTermsListAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAllTermsListAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAllTermsListAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processAllTermsListAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @tenantId (optional) 
     * @applicantId (optional) 
     * @termId (optional) 
     * @cltr (optional) 
     * @return Success
     */
    teamUniversityInstituteDetail(teamId: number, tenantId: number, applicantId: number, termId: number, cltr: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/TeamUniversityInstituteDetail?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (applicantId !== undefined)
            url_ += "ApplicantId=" + encodeURIComponent("" + applicantId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (cltr !== undefined)
            url_ += "cltr=" + encodeURIComponent("" + cltr) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTeamUniversityInstituteDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTeamUniversityInstituteDetail(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processTeamUniversityInstituteDetail(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @termId (optional) 
     * @cltr (optional) 
     * @return Success
     */
    getEidrDataAsync(tenantId: number, termId: number, cltr: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetEidrDataAsync?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (cltr !== undefined)
            url_ += "cltr=" + encodeURIComponent("" + cltr) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEidrDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEidrDataAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetEidrDataAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @tenantId (optional) 
     * @termId (optional) 
     * @cltr (optional) 
     * @return Success
     */
    getEgbrDataAsync(teamId: number, tenantId: number, termId: number, cltr: string): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetEgbrDataAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (cltr !== undefined)
            url_ += "cltr=" + encodeURIComponent("" + cltr) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEgbrDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEgbrDataAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetEgbrDataAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @teamId (optional) 
     * @tenantId (optional) 
     * @evlSysUserId (optional) 
     * @termId (optional) 
     * @return Success
     */
    sendDraftEgbrAsync(teamId: number, tenantId: number, evlSysUserId: number, termId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/SendDraftEgbrAsync?";
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (evlSysUserId !== undefined)
            url_ += "EvlSysUserId=" + encodeURIComponent("" + evlSysUserId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendDraftEgbrAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendDraftEgbrAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendDraftEgbrAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @uniEvlAnswId (optional) 
     * @return Success
     */
    getEgbrEvidencesAsync(uniEvlAnswId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemAppSerivce/GetEgbrEvidencesAsync?";
        if (uniEvlAnswId !== undefined)
            url_ += "uniEvlAnswId=" + encodeURIComponent("" + uniEvlAnswId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEgbrEvidencesAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEgbrEvidencesAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetEgbrEvidencesAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }
}

@Injectable()
export class EvaluatorSystemConnectionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @applicantId (optional) 
     * @name (optional) 
     * @surname (optional) 
     * @emailAddress (optional) 
     * @userName (optional) 
     * @phoneNumber (optional) 
     * @password (optional) 
     * @return Success
     */
    getEvlsysAddUser(applicantId: number, name: string, surname: string, emailAddress: string, userName: string, phoneNumber: string, password: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemConnection/GetEvlsysAddUser?";
        if (applicantId !== undefined)
            url_ += "ApplicantId=" + encodeURIComponent("" + applicantId) + "&"; 
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (surname !== undefined)
            url_ += "Surname=" + encodeURIComponent("" + surname) + "&"; 
        if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&"; 
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&"; 
        if (phoneNumber !== undefined)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&"; 
        if (password !== undefined)
            url_ += "Password=" + encodeURIComponent("" + password) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvlsysAddUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvlsysAddUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processGetEvlsysAddUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class EvaluatorSystemMentorAppserviceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllMentorsAsync(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemMentorAppservice/GetAllMentorsAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllMentorsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllMentorsAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetAllMentorsAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setMentorEvaluatorSytemIdAsync(input: EvaluatorSystemIdListInput[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemMentorAppservice/SetMentorEvaluatorSytemIdAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetMentorEvaluatorSytemIdAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetMentorEvaluatorSytemIdAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetMentorEvaluatorSytemIdAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @evlSysId (optional) 
     * @return Success
     */
    mentorTasksAsync(evlSysId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemMentorAppservice/MentorTasksAsync?";
        if (evlSysId !== undefined)
            url_ += "EvlSysId=" + encodeURIComponent("" + evlSysId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMentorTasksAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMentorTasksAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processMentorTasksAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @applicantId (optional) 
     * @return Success
     */
    setMentorEthicsAsync(applicantId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemMentorAppservice/SetMentorEthicsAsync?";
        if (applicantId !== undefined)
            url_ += "ApplicantId=" + encodeURIComponent("" + applicantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetMentorEthicsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetMentorEthicsAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetMentorEthicsAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setMentorTaskDutyAsync(input: EvlSysMentorTaskDuty): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemMentorAppservice/SetMentorTaskDutyAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetMentorTaskDutyAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetMentorTaskDutyAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetMentorTaskDutyAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @applicantId (optional) 
     * @return Success
     */
    getUniversityDetailMentoringAsync(tenantId: number, applicantId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemMentorAppservice/GetUniversityDetailMentoringAsync?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (applicantId !== undefined)
            url_ += "ApplicantId=" + encodeURIComponent("" + applicantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUniversityDetailMentoringAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUniversityDetailMentoringAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetUniversityDetailMentoringAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setMentorReportAsync(input: EvlSysSaveReportAndSurvey): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemMentorAppservice/SetMentorReportAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetMentorReportAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetMentorReportAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetMentorReportAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setMentorSurveyAsync(input: SaveSurveyAnswer): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemMentorAppservice/SetMentorSurveyAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetMentorSurveyAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetMentorSurveyAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetMentorSurveyAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setMentorReportCompleteAsync(input: CompleteReport): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemMentorAppservice/SetMentorReportCompleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetMentorReportCompleteAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetMentorReportCompleteAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetMentorReportCompleteAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @applicantId (optional) 
     * @tenantId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getMentorDataAsync(applicantId: number, tenantId: number, termId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemMentorAppservice/GetMentorDataAsync?";
        if (applicantId !== undefined)
            url_ += "ApplicantId=" + encodeURIComponent("" + applicantId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMentorDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMentorDataAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetMentorDataAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @from (optional) 
     * @to (optional) 
     * @evaluatorId (optional) 
     * @evaluatedId (optional) 
     * @teamId (optional) 
     * @tenantId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getSurveyDataAsync(from: From2, to: To2, evaluatorId: number, evaluatedId: number, teamId: number, tenantId: number, termId: number): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemMentorAppservice/GetSurveyDataAsync?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent("" + to) + "&"; 
        if (evaluatorId !== undefined)
            url_ += "EvaluatorId=" + encodeURIComponent("" + evaluatorId) + "&"; 
        if (evaluatedId !== undefined)
            url_ += "EvaluatedId=" + encodeURIComponent("" + evaluatedId) + "&"; 
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSurveyDataAsync(response_);
                } catch (e) {
                    return <Observable<string>><any>Observable.throw(e);
                }
            } else
                return <Observable<string>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyDataAsync(response: Response): Observable<string> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<string>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setSurveyAnswerAsync(input: EvlSysSurveyAnswerInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemMentorAppservice/SetSurveyAnswerAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetSurveyAnswerAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetSurveyAnswerAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetSurveyAnswerAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setSurveyCompleteAsync(input: EvlSysSurveyCompleteInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EvaluatorSystemMentorAppservice/SetSurveyCompleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetSurveyCompleteAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetSurveyCompleteAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetSurveyCompleteAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ExternalEvaluationAnswerServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getLoggedUserTeamsForTerm(id: number): Observable<ListResultDtoOfEvaluationTeamOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationAnswer/GetLoggedUserTeamsForTerm?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLoggedUserTeamsForTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLoggedUserTeamsForTerm(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluationTeamOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluationTeamOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLoggedUserTeamsForTerm(response: Response): Observable<ListResultDtoOfEvaluationTeamOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluationTeamOutput.fromJS(resultData200) : new ListResultDtoOfEvaluationTeamOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluationTeamOutput>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @year (optional) 
     * @parentId (optional) 
     * @return Success
     */
    getAnswersWithEvaluations(universityId: number, year: number, parentId: number): Observable<ListResultDtoOfAnswersWithEvaluationOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationAnswer/GetAnswersWithEvaluations?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        if (parentId !== undefined)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAnswersWithEvaluations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAnswersWithEvaluations(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfAnswersWithEvaluationOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfAnswersWithEvaluationOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAnswersWithEvaluations(response: Response): Observable<ListResultDtoOfAnswersWithEvaluationOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfAnswersWithEvaluationOutput.fromJS(resultData200) : new ListResultDtoOfAnswersWithEvaluationOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfAnswersWithEvaluationOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateEvaluatorAnswer(input: EvaluatorAnswerInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationAnswer/CreateOrUpdateEvaluatorAnswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateEvaluatorAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateEvaluatorAnswer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateEvaluatorAnswer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @evaluationFormAnswerId (optional) 
     * @return Success
     */
    getEvaluationAnswerProofFiles(evaluationFormAnswerId: number): Observable<UploadProofFileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationAnswer/GetEvaluationAnswerProofFiles?";
        if (evaluationFormAnswerId !== undefined)
            url_ += "evaluationFormAnswerId=" + encodeURIComponent("" + evaluationFormAnswerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationAnswerProofFiles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationAnswerProofFiles(response_);
                } catch (e) {
                    return <Observable<UploadProofFileDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UploadProofFileDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationAnswerProofFiles(response: Response): Observable<UploadProofFileDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UploadProofFileDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UploadProofFileDto[]>(<any>null);
    }
}

@Injectable()
export class ExternalEvaluationStrengthsAndShortcomingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    strengthsAndShortcomingsAnswer(input: StrengthsAndShortcomingsInput): Observable<ListResultDtoOfStrengthsAndShortcomingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationStrengthsAndShortcomings/StrengthsAndShortcomingsAnswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processStrengthsAndShortcomingsAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processStrengthsAndShortcomingsAnswer(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfStrengthsAndShortcomingsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfStrengthsAndShortcomingsOutput>><any>Observable.throw(response_);
        });
    }

    protected processStrengthsAndShortcomingsAnswer(response: Response): Observable<ListResultDtoOfStrengthsAndShortcomingsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfStrengthsAndShortcomingsOutput.fromJS(resultData200) : new ListResultDtoOfStrengthsAndShortcomingsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfStrengthsAndShortcomingsOutput>(<any>null);
    }
}

@Injectable()
export class ExternalEvaluationSurveyServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @termId (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getEESurvey(filter: string, termId: number, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfEESurveyOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurvey/GetEESurvey?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEESurvey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEESurvey(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEESurveyOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfEESurveyOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEESurvey(response: Response): Observable<PagedResultDtoOfEESurveyOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfEESurveyOutput.fromJS(resultData200) : new PagedResultDtoOfEESurveyOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfEESurveyOutput>(<any>null);
    }

    /**
     * @filter (optional) 
     * @termId (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getEESurveyQuestion(filter: string, termId: number, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfEEQuestionForSurveyOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurvey/GetEESurveyQuestion?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEESurveyQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEESurveyQuestion(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEEQuestionForSurveyOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfEEQuestionForSurveyOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEESurveyQuestion(response: Response): Observable<PagedResultDtoOfEEQuestionForSurveyOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfEEQuestionForSurveyOutput.fromJS(resultData200) : new PagedResultDtoOfEEQuestionForSurveyOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfEEQuestionForSurveyOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createEESurvey(input: CreateEESurveyInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurvey/CreateEESurvey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateEESurvey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateEESurvey(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateEESurvey(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteEESurvey(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurvey/DeleteEESurvey?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteEESurvey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteEESurvey(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteEESurvey(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getEESurveyForEdit(id: number): Observable<EESurveyForEdit> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurvey/GetEESurveyForEdit?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEESurveyForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEESurveyForEdit(response_);
                } catch (e) {
                    return <Observable<EESurveyForEdit>><any>Observable.throw(e);
                }
            } else
                return <Observable<EESurveyForEdit>><any>Observable.throw(response_);
        });
    }

    protected processGetEESurveyForEdit(response: Response): Observable<EESurveyForEdit> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EESurveyForEdit.fromJS(resultData200) : new EESurveyForEdit();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EESurveyForEdit>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateEESurvey(input: EESurveyForEdit): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurvey/UpdateEESurvey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateEESurvey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateEESurvey(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateEESurvey(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ExternalEvaluationSurveyQuestionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getSurveyQuestionType(): Observable<ListResultDtoOfSurveyTypeOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurveyQuestion/GetSurveyQuestionType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyQuestionType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSurveyQuestionType(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSurveyTypeOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSurveyTypeOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyQuestionType(response: Response): Observable<ListResultDtoOfSurveyTypeOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSurveyTypeOutput.fromJS(resultData200) : new ListResultDtoOfSurveyTypeOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSurveyTypeOutput>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getEESurveyQuestions(filter: string, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfEESurveyQuestionOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurveyQuestion/GetEESurveyQuestions?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEESurveyQuestions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEESurveyQuestions(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEESurveyQuestionOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfEESurveyQuestionOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEESurveyQuestions(response: Response): Observable<PagedResultDtoOfEESurveyQuestionOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfEESurveyQuestionOutput.fromJS(resultData200) : new PagedResultDtoOfEESurveyQuestionOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfEESurveyQuestionOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createEESurveyQuestion(input: CreateEESurveyQuestionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurveyQuestion/CreateEESurveyQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateEESurveyQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateEESurveyQuestion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateEESurveyQuestion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteEESurveyQuestion(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurveyQuestion/DeleteEESurveyQuestion?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteEESurveyQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteEESurveyQuestion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteEESurveyQuestion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateEESurveyQuestion(input: EESurveyQuestionOutputForEdit): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurveyQuestion/UpdateEESurveyQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateEESurveyQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateEESurveyQuestion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateEESurveyQuestion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getEESurveyQuestionForEdit(id: number): Observable<EESurveyQuestionOutputForEdit> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurveyQuestion/GetEESurveyQuestionForEdit?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEESurveyQuestionForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEESurveyQuestionForEdit(response_);
                } catch (e) {
                    return <Observable<EESurveyQuestionOutputForEdit>><any>Observable.throw(e);
                }
            } else
                return <Observable<EESurveyQuestionOutputForEdit>><any>Observable.throw(response_);
        });
    }

    protected processGetEESurveyQuestionForEdit(response: Response): Observable<EESurveyQuestionOutputForEdit> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EESurveyQuestionOutputForEdit.fromJS(resultData200) : new EESurveyQuestionOutputForEdit();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EESurveyQuestionOutputForEdit>(<any>null);
    }
}

@Injectable()
export class ExternalEvaluationSurveyRectorServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @termId (optional) 
     * @universityId (optional) 
     * @return Success
     */
    getTeamMember(termId: number, universityId: number): Observable<ListResultDtoOfUniversityTeamMemberOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurveyRector/GetTeamMember?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTeamMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTeamMember(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUniversityTeamMemberOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUniversityTeamMemberOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTeamMember(response: Response): Observable<ListResultDtoOfUniversityTeamMemberOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUniversityTeamMemberOutput.fromJS(resultData200) : new ListResultDtoOfUniversityTeamMemberOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfUniversityTeamMemberOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @memberId (optional) 
     * @userId (optional) 
     * @teamId (optional) 
     * @return Success
     */
    getRectorSurveys(termId: number, from: From3, to: To3, memberId: number, userId: number, teamId: number): Observable<RectorSurveysOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurveyRector/GetRectorSurveys?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent("" + to) + "&"; 
        if (memberId !== undefined)
            url_ += "MemberId=" + encodeURIComponent("" + memberId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRectorSurveys(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRectorSurveys(response_);
                } catch (e) {
                    return <Observable<RectorSurveysOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<RectorSurveysOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetRectorSurveys(response: Response): Observable<RectorSurveysOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RectorSurveysOutput.fromJS(resultData200) : new RectorSurveysOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RectorSurveysOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveSurveyAnswer(input: RectorSurveyAnswerInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurveyRector/SaveSurveyAnswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveSurveyAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveSurveyAnswer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveSurveyAnswer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    surveyCompleteAsync(input: SurveyCompleteInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurveyRector/SurveyCompleteAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSurveyCompleteAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSurveyCompleteAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSurveyCompleteAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ExternalEvaluationSurveyResultsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTerms(): Observable<ListResultDtoOfTermOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurveyResults/GetTerms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTerms(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTerms(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTermOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTermOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTerms(response: Response): Observable<ListResultDtoOfTermOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTermOutput.fromJS(resultData200) : new ListResultDtoOfTermOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTermOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @from (optional) 
     * @to (optional) 
     * @return Success
     */
    getSurveyResults(termId: number, from: From4, to: To4): Observable<SurveyResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationSurveyResults/GetSurveyResults?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent("" + to) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSurveyResults(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSurveyResults(response_);
                } catch (e) {
                    return <Observable<SurveyResultOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<SurveyResultOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSurveyResults(response: Response): Observable<SurveyResultOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SurveyResultOutput.fromJS(resultData200) : new SurveyResultOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SurveyResultOutput>(<any>null);
    }
}

@Injectable()
export class ExternalEvaluationTeamMemberConfirmServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @universityId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getUniversityTeamMember(universityId: number, termId: number): Observable<ListResultDtoOfUnivTeamMemerConfirmOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationTeamMemberConfirm/GetUniversityTeamMember?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUniversityTeamMember(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUniversityTeamMember(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUnivTeamMemerConfirmOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUnivTeamMemerConfirmOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUniversityTeamMember(response: Response): Observable<ListResultDtoOfUnivTeamMemerConfirmOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUnivTeamMemerConfirmOutput.fromJS(resultData200) : new ListResultDtoOfUnivTeamMemerConfirmOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfUnivTeamMemerConfirmOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createorUpdateUniversityTeamMemberConfirm(input: UnivTeamMemerConfirmOutput[]): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvaluationTeamMemberConfirm/CreateorUpdateUniversityTeamMemberConfirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateorUpdateUniversityTeamMemberConfirm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateorUpdateUniversityTeamMemberConfirm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateorUpdateUniversityTeamMemberConfirm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ExternalEvalutationUniverstyFeedbackServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @universityId (optional) 
     * @return Success
     */
    getDraftReportListAsync(universityId: number): Observable<ListResultDtoOfDraftListOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvalutationUniverstyFeedback/GetDraftReportListAsync?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDraftReportListAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDraftReportListAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfDraftListOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfDraftListOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDraftReportListAsync(response: Response): Observable<ListResultDtoOfDraftListOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfDraftListOutput.fromJS(resultData200) : new ListResultDtoOfDraftListOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfDraftListOutput>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @termId (optional) 
     * @teamId (optional) 
     * @return Success
     */
    getTeamsExternalEvaluationDraftAsync(universityId: number, termId: number, teamId: number): Observable<ExternalEvaluationDraftOutput> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvalutationUniverstyFeedback/GetTeamsExternalEvaluationDraftAsync?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTeamsExternalEvaluationDraftAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTeamsExternalEvaluationDraftAsync(response_);
                } catch (e) {
                    return <Observable<ExternalEvaluationDraftOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExternalEvaluationDraftOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTeamsExternalEvaluationDraftAsync(response: Response): Observable<ExternalEvaluationDraftOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExternalEvaluationDraftOutput.fromJS(resultData200) : new ExternalEvaluationDraftOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExternalEvaluationDraftOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTeamsExternalEvaluationDraftAsync(input: ExternalEvaluationDraftOutput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvalutationUniverstyFeedback/UpdateTeamsExternalEvaluationDraftAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTeamsExternalEvaluationDraftAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTeamsExternalEvaluationDraftAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTeamsExternalEvaluationDraftAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @externalEvaluationDraftId (optional) 
     * @return Success
     */
    getExternalEvaluationDraftProofFiles(externalEvaluationDraftId: number): Observable<UploadExternalProofFileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvalutationUniverstyFeedback/GetExternalEvaluationDraftProofFiles?";
        if (externalEvaluationDraftId !== undefined)
            url_ += "externalEvaluationDraftId=" + encodeURIComponent("" + externalEvaluationDraftId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExternalEvaluationDraftProofFiles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExternalEvaluationDraftProofFiles(response_);
                } catch (e) {
                    return <Observable<UploadExternalProofFileDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UploadExternalProofFileDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetExternalEvaluationDraftProofFiles(response: Response): Observable<UploadExternalProofFileDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UploadExternalProofFileDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UploadExternalProofFileDto[]>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteFileOfExternalEvaluationDraft(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvalutationUniverstyFeedback/DeleteFileOfExternalEvaluationDraft?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteFileOfExternalEvaluationDraft(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteFileOfExternalEvaluationDraft(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteFileOfExternalEvaluationDraft(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateExternalEvaluationUniversySendTeam(input: ExternalEvaluationDraftOutput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ExternalEvalutationUniverstyFeedback/UpdateExternalEvaluationUniversySendTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateExternalEvaluationUniversySendTeam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateExternalEvaluationUniversySendTeam(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateExternalEvaluationUniversySendTeam(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createFriendshipRequest(input: CreateFriendshipRequestInput): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateFriendshipRequest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateFriendshipRequest(response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FriendDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateFriendshipRequest(response: Response): Observable<FriendDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FriendDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createFriendshipRequestByUserName(input: CreateFriendshipRequestByUserNameInput): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateFriendshipRequestByUserName(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateFriendshipRequestByUserName(response_);
                } catch (e) {
                    return <Observable<FriendDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FriendDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateFriendshipRequestByUserName(response: Response): Observable<FriendDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FriendDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    blockUser(input: BlockUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processBlockUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processBlockUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processBlockUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unblockUser(input: UnblockUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnblockUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnblockUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnblockUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    acceptFriendshipRequest(input: AcceptFriendshipRequestInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAcceptFriendshipRequest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAcceptFriendshipRequest(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAcceptFriendshipRequest(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @incomeStatisticsDateInterval (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getDashboardStatisticsData(incomeStatisticsDateInterval: IncomeStatisticsDateInterval, startDate: moment.Moment, endDate: moment.Moment): Observable<HostDashboardData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetDashboardStatisticsData?";
        if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&"; 
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDashboardStatisticsData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDashboardStatisticsData(response_);
                } catch (e) {
                    return <Observable<HostDashboardData>><any>Observable.throw(e);
                }
            } else
                return <Observable<HostDashboardData>><any>Observable.throw(response_);
        });
    }

    protected processGetDashboardStatisticsData(response: Response): Observable<HostDashboardData> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HostDashboardData.fromJS(resultData200) : new HostDashboardData();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HostDashboardData>(<any>null);
    }

    /**
     * @incomeStatisticsDateInterval (optional) 
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: IncomeStatisticsDateInterval2, startDate: moment.Moment, endDate: moment.Moment): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&"; 
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIncomeStatistics(response_);
                } catch (e) {
                    return <Observable<GetIncomeStatisticsDataOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetIncomeStatisticsDataOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetIncomeStatistics(response: Response): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetIncomeStatisticsDataOutput.fromJS(resultData200) : new GetIncomeStatisticsDataOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetIncomeStatisticsDataOutput>(<any>null);
    }

    /**
     * @startDate (optional) 
     * @endDate (optional) 
     * @return Success
     */
    getEditionTenantStatistics(startDate: moment.Moment, endDate: moment.Moment): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionTenantStatistics(response_);
                } catch (e) {
                    return <Observable<GetEditionTenantStatisticsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetEditionTenantStatisticsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionTenantStatistics(response: Response): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEditionTenantStatisticsOutput.fromJS(resultData200) : new GetEditionTenantStatisticsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetEditionTenantStatisticsOutput>(<any>null);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllSettings(response_);
                } catch (e) {
                    return <Observable<HostSettingsEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<HostSettingsEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSettings(response: Response): Observable<HostSettingsEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HostSettingsEditDto.fromJS(resultData200) : new HostSettingsEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HostSettingsEditDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAllSettings(input: HostSettingsEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateAllSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateAllSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendTestEmail(input: SendTestEmailInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendTestEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendTestEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class HSIEvaluationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllHSIEvlFrmList(): Observable<HSIEvaluationFormDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluation/GetAllHSIEvlFrmList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllHSIEvlFrmList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllHSIEvlFrmList(response_);
                } catch (e) {
                    return <Observable<HSIEvaluationFormDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<HSIEvaluationFormDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllHSIEvlFrmList(response: Response): Observable<HSIEvaluationFormDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(HSIEvaluationFormDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HSIEvaluationFormDto[]>(<any>null);
    }

    /**
     * @filter (optional) 
     * @termId (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getAllHSIEvlFrmPaged(filter: string, termId: number, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfHSIEvaluationFormDto> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluation/GetAllHSIEvlFrmPaged?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllHSIEvlFrmPaged(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllHSIEvlFrmPaged(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfHSIEvaluationFormDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfHSIEvaluationFormDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllHSIEvlFrmPaged(response: Response): Observable<PagedResultDtoOfHSIEvaluationFormDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfHSIEvaluationFormDto.fromJS(resultData200) : new PagedResultDtoOfHSIEvaluationFormDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfHSIEvaluationFormDto>(<any>null);
    }

    /**
     * @parentId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getHSIEvlFrmByParentId(parentId: number, termId: number): Observable<ListResultDtoOfHSIEvaluationFormDto> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluation/GetHSIEvlFrmByParentId?";
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHSIEvlFrmByParentId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHSIEvlFrmByParentId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfHSIEvaluationFormDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfHSIEvaluationFormDto>><any>Observable.throw(response_);
        });
    }

    protected processGetHSIEvlFrmByParentId(response: Response): Observable<ListResultDtoOfHSIEvaluationFormDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfHSIEvaluationFormDto.fromJS(resultData200) : new ListResultDtoOfHSIEvaluationFormDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfHSIEvaluationFormDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateHSIEvlFrm(input: CreateOrUpdateHSIEvaluationFormDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluation/CreateOrUpdateHSIEvlFrm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateHSIEvlFrm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateHSIEvlFrm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateHSIEvlFrm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteHSIEvlFrm(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluation/DeleteHSIEvlFrm?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteHSIEvlFrm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteHSIEvlFrm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteHSIEvlFrm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @criteriaId (optional) 
     * @return Success
     */
    getHSIEvaluationFormHelp(criteriaId: number): Observable<ListResultDtoOfHSIEvaluationFormHelpDto> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluation/GetHSIEvaluationFormHelp?";
        if (criteriaId !== undefined)
            url_ += "criteriaId=" + encodeURIComponent("" + criteriaId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHSIEvaluationFormHelp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHSIEvaluationFormHelp(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfHSIEvaluationFormHelpDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfHSIEvaluationFormHelpDto>><any>Observable.throw(response_);
        });
    }

    protected processGetHSIEvaluationFormHelp(response: Response): Observable<ListResultDtoOfHSIEvaluationFormHelpDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfHSIEvaluationFormHelpDto.fromJS(resultData200) : new ListResultDtoOfHSIEvaluationFormHelpDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfHSIEvaluationFormHelpDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateHSIEvaluationFormHelp(input: HSIEvaluationFormHelpAndProofDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluation/CreateOrUpdateHSIEvaluationFormHelp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateHSIEvaluationFormHelp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateHSIEvaluationFormHelp(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateHSIEvaluationFormHelp(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteHSIEvaluationFormHelp(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluation/DeleteHSIEvaluationFormHelp?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteHSIEvaluationFormHelp(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteHSIEvaluationFormHelp(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteHSIEvaluationFormHelp(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getAllHSIMaturityLevel(sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfHSIMaturityLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluation/GetAllHSIMaturityLevel?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllHSIMaturityLevel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllHSIMaturityLevel(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfHSIMaturityLevelDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfHSIMaturityLevelDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllHSIMaturityLevel(response: Response): Observable<PagedResultDtoOfHSIMaturityLevelDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfHSIMaturityLevelDto.fromJS(resultData200) : new PagedResultDtoOfHSIMaturityLevelDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfHSIMaturityLevelDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateHSIMaturityLevel(input: CreateOrUpdateHSIMaturityLevelDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluation/CreateOrUpdateHSIMaturityLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateHSIMaturityLevel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateHSIMaturityLevel(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateHSIMaturityLevel(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteHSIMaturityLevel(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluation/DeleteHSIMaturityLevel?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteHSIMaturityLevel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteHSIMaturityLevel(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteHSIMaturityLevel(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class HSIEvaluationAnswerServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @parentId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getHSIEvlFrmByParentId(parentId: number, termId: number): Observable<ListResultDtoOfHSIEvaluationFormDto> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluationAnswer/GetHSIEvlFrmByParentId?";
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHSIEvlFrmByParentId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHSIEvlFrmByParentId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfHSIEvaluationFormDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfHSIEvaluationFormDto>><any>Observable.throw(response_);
        });
    }

    protected processGetHSIEvlFrmByParentId(response: Response): Observable<ListResultDtoOfHSIEvaluationFormDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfHSIEvaluationFormDto.fromJS(resultData200) : new ListResultDtoOfHSIEvaluationFormDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfHSIEvaluationFormDto>(<any>null);
    }

    /**
     * @parentId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getHSIEvaluationFormAndAnswer(parentId: number, termId: number): Observable<ListResultDtoOfHSIEvaluationFormAndAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluationAnswer/GetHSIEvaluationFormAndAnswer?";
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHSIEvaluationFormAndAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHSIEvaluationFormAndAnswer(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfHSIEvaluationFormAndAnswerDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfHSIEvaluationFormAndAnswerDto>><any>Observable.throw(response_);
        });
    }

    protected processGetHSIEvaluationFormAndAnswer(response: Response): Observable<ListResultDtoOfHSIEvaluationFormAndAnswerDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfHSIEvaluationFormAndAnswerDto.fromJS(resultData200) : new ListResultDtoOfHSIEvaluationFormAndAnswerDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfHSIEvaluationFormAndAnswerDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveHSIEvaluationFormAnswer(input: HSIFormAnswerDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluationAnswer/SaveHSIEvaluationFormAnswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveHSIEvaluationFormAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveHSIEvaluationFormAnswer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveHSIEvaluationFormAnswer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @answerId (optional) 
     * @return Success
     */
    getHSIEvaluationFormAnswerProofFiles(answerId: number): Observable<UploadProofFileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluationAnswer/GetHSIEvaluationFormAnswerProofFiles?";
        if (answerId !== undefined)
            url_ += "answerId=" + encodeURIComponent("" + answerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHSIEvaluationFormAnswerProofFiles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHSIEvaluationFormAnswerProofFiles(response_);
                } catch (e) {
                    return <Observable<UploadProofFileDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UploadProofFileDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetHSIEvaluationFormAnswerProofFiles(response: Response): Observable<UploadProofFileDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UploadProofFileDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UploadProofFileDto[]>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteHSIFileOfAnswer(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluationAnswer/DeleteHSIFileOfAnswer?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteHSIFileOfAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteHSIFileOfAnswer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteHSIFileOfAnswer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    completeHSIEvaluationForm(input: HSIEvaluationFormCompletedDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluationAnswer/CompleteHSIEvaluationForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCompleteHSIEvaluationForm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCompleteHSIEvaluationForm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCompleteHSIEvaluationForm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @termId (optional) 
     * @tenantId (optional) 
     * @isCompleted (optional) 
     * @id (optional) 
     * @return Success
     */
    getHSIEvaluationFormIsCompleteable(termId: number, tenantId: number, isCompleted: boolean, id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluationAnswer/GetHSIEvaluationFormIsCompleteable?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&"; 
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHSIEvaluationFormIsCompleteable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHSIEvaluationFormIsCompleteable(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetHSIEvaluationFormIsCompleteable(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @termId (optional) 
     * @tenantId (optional) 
     * @isCompleted (optional) 
     * @id (optional) 
     * @return Success
     */
    getHSIEvaluationFormIsCompleted(termId: number, tenantId: number, isCompleted: boolean, id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/HSIEvaluationAnswer/GetHSIEvaluationFormIsCompleted?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (isCompleted !== undefined)
            url_ += "isCompleted=" + encodeURIComponent("" + isCompleted) + "&"; 
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHSIEvaluationFormIsCompleted(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHSIEvaluationFormIsCompleted(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetHSIEvaluationFormIsCompleted(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }
}

@Injectable()
export class IndicatorServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @parentId (optional) 
     * @isActive (optional) 
     * @return Success
     */
    getAllIndicatorsAsync(parentId: number, isActive: boolean): Observable<ListResultDtoOfIndicatorDto> {
        let url_ = this.baseUrl + "/api/services/app/Indicator/GetAllIndicatorsAsync?";
        if (parentId !== undefined)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllIndicatorsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllIndicatorsAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfIndicatorDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfIndicatorDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllIndicatorsAsync(response: Response): Observable<ListResultDtoOfIndicatorDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfIndicatorDto.fromJS(resultData200) : new ListResultDtoOfIndicatorDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfIndicatorDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getIndicatorAsync(id: number): Observable<IndicatorDto> {
        let url_ = this.baseUrl + "/api/services/app/Indicator/GetIndicatorAsync?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIndicatorAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIndicatorAsync(response_);
                } catch (e) {
                    return <Observable<IndicatorDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<IndicatorDto>><any>Observable.throw(response_);
        });
    }

    protected processGetIndicatorAsync(response: Response): Observable<IndicatorDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IndicatorDto.fromJS(resultData200) : new IndicatorDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IndicatorDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createIndicatorAsync(input: CreateIndicatorInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Indicator/CreateIndicatorAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateIndicatorAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateIndicatorAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateIndicatorAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteIndicator(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Indicator/DeleteIndicator?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteIndicator(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteIndicator(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteIndicator(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateIndicatorAsync(input: EditIndicatorModel): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Indicator/UpdateIndicatorAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateIndicatorAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateIndicatorAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateIndicatorAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getFormulaOfIndicatorAsync(id: number): Observable<IndicatorFormulaDto> {
        let url_ = this.baseUrl + "/api/services/app/Indicator/GetFormulaOfIndicatorAsync?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFormulaOfIndicatorAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFormulaOfIndicatorAsync(response_);
                } catch (e) {
                    return <Observable<IndicatorFormulaDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<IndicatorFormulaDto>><any>Observable.throw(response_);
        });
    }

    protected processGetFormulaOfIndicatorAsync(response: Response): Observable<IndicatorFormulaDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IndicatorFormulaDto.fromJS(resultData200) : new IndicatorFormulaDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IndicatorFormulaDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changeIndicatorActivity(input: ChangeIndicatorActivityInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Indicator/ChangeIndicatorActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangeIndicatorActivity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangeIndicatorActivity(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangeIndicatorActivity(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class IndicatorAnswerServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @years (optional) 
     * @parentId (optional) 
     * @return Success
     */
    getIndicatorsWithAnswersAsync(years: number[], parentId: number): Observable<ListResultDtoOfIndicatorsWithAnswersDto> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorAnswer/GetIndicatorsWithAnswersAsync?";
        if (years !== undefined)
            years && years.forEach(item => { url_ += "Years=" + encodeURIComponent("" + item) + "&"; });
        if (parentId !== undefined)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIndicatorsWithAnswersAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIndicatorsWithAnswersAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfIndicatorsWithAnswersDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfIndicatorsWithAnswersDto>><any>Observable.throw(response_);
        });
    }

    protected processGetIndicatorsWithAnswersAsync(response: Response): Observable<ListResultDtoOfIndicatorsWithAnswersDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfIndicatorsWithAnswersDto.fromJS(resultData200) : new ListResultDtoOfIndicatorsWithAnswersDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfIndicatorsWithAnswersDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: CreateOrUpdateIndicatorAnswerInput): Observable<CreateOrEditAnswerOutput> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorAnswer/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<CreateOrEditAnswerOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditAnswerOutput>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: Response): Observable<CreateOrEditAnswerOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditAnswerOutput.fromJS(resultData200) : new CreateOrEditAnswerOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrEditAnswerOutput>(<any>null);
    }

    /**
     * @years (optional) 
     * @id (optional) 
     * @return Success
     */
    getAnswerByIndicatorIdandYear(years: number[], id: number): Observable<ListResultDtoOfIndicatorAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorAnswer/GetAnswerByIndicatorIdandYear?";
        if (years !== undefined)
            years && years.forEach(item => { url_ += "Years=" + encodeURIComponent("" + item) + "&"; });
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAnswerByIndicatorIdandYear(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAnswerByIndicatorIdandYear(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfIndicatorAnswerDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfIndicatorAnswerDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAnswerByIndicatorIdandYear(response: Response): Observable<ListResultDtoOfIndicatorAnswerDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfIndicatorAnswerDto.fromJS(resultData200) : new ListResultDtoOfIndicatorAnswerDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfIndicatorAnswerDto>(<any>null);
    }

    /**
     * @indicatorAnswerId (optional) 
     * @return Success
     */
    getEvaluationFormAnswerProofFiles(indicatorAnswerId: number): Observable<UploadProofFileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorAnswer/GetEvaluationFormAnswerProofFiles?";
        if (indicatorAnswerId !== undefined)
            url_ += "indicatorAnswerId=" + encodeURIComponent("" + indicatorAnswerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormAnswerProofFiles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormAnswerProofFiles(response_);
                } catch (e) {
                    return <Observable<UploadProofFileDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<UploadProofFileDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormAnswerProofFiles(response: Response): Observable<UploadProofFileDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UploadProofFileDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UploadProofFileDto[]>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteFileOfAnswer(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorAnswer/DeleteFileOfAnswer?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteFileOfAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteFileOfAnswer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteFileOfAnswer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getIndicatorsCalculatedBatchAsync(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorAnswer/GetIndicatorsCalculatedBatchAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIndicatorsCalculatedBatchAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIndicatorsCalculatedBatchAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processGetIndicatorsCalculatedBatchAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @indicatorId (optional) 
     * @universityId (optional) 
     * @year (optional) 
     * @return Success
     */
    calculateRelatedIndicatorsByUniversityAndYear(indicatorId: number, universityId: number, year: number): Observable<IndicatorCalculationResult> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorAnswer/CalculateRelatedIndicatorsByUniversityAndYear?";
        if (indicatorId !== undefined)
            url_ += "indicatorId=" + encodeURIComponent("" + indicatorId) + "&"; 
        if (universityId !== undefined)
            url_ += "universityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCalculateRelatedIndicatorsByUniversityAndYear(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCalculateRelatedIndicatorsByUniversityAndYear(response_);
                } catch (e) {
                    return <Observable<IndicatorCalculationResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<IndicatorCalculationResult>><any>Observable.throw(response_);
        });
    }

    protected processCalculateRelatedIndicatorsByUniversityAndYear(response: Response): Observable<IndicatorCalculationResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IndicatorCalculationResult.fromJS(resultData200) : new IndicatorCalculationResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IndicatorCalculationResult>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    autoCalculatedIndicatorByYearsAndTenants(input: AutoCalculateInput): Observable<IndicatorCalculationResult> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorAnswer/AutoCalculatedIndicatorByYearsAndTenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAutoCalculatedIndicatorByYearsAndTenants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAutoCalculatedIndicatorByYearsAndTenants(response_);
                } catch (e) {
                    return <Observable<IndicatorCalculationResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<IndicatorCalculationResult>><any>Observable.throw(response_);
        });
    }

    protected processAutoCalculatedIndicatorByYearsAndTenants(response: Response): Observable<IndicatorCalculationResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IndicatorCalculationResult.fromJS(resultData200) : new IndicatorCalculationResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IndicatorCalculationResult>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @year (optional) 
     * @return Success
     */
    calculateUniversityIndicatorByYear(universityId: number, year: number): Observable<IndicatorCalculationResult> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorAnswer/CalculateUniversityIndicatorByYear?";
        if (universityId !== undefined)
            url_ += "universityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCalculateUniversityIndicatorByYear(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCalculateUniversityIndicatorByYear(response_);
                } catch (e) {
                    return <Observable<IndicatorCalculationResult>><any>Observable.throw(e);
                }
            } else
                return <Observable<IndicatorCalculationResult>><any>Observable.throw(response_);
        });
    }

    protected processCalculateUniversityIndicatorByYear(response: Response): Observable<IndicatorCalculationResult> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IndicatorCalculationResult.fromJS(resultData200) : new IndicatorCalculationResult();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IndicatorCalculationResult>(<any>null);
    }

    /**
     * @years (optional) 
     * @parentId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    getHostIndicatorsWithAnswersAsync(years: number[], parentId: number, tenantId: number): Observable<ListResultDtoOfIndicatorsWithAnswersDto> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorAnswer/GetHostIndicatorsWithAnswersAsync?";
        if (years !== undefined)
            years && years.forEach(item => { url_ += "Years=" + encodeURIComponent("" + item) + "&"; });
        if (parentId !== undefined)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHostIndicatorsWithAnswersAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHostIndicatorsWithAnswersAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfIndicatorsWithAnswersDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfIndicatorsWithAnswersDto>><any>Observable.throw(response_);
        });
    }

    protected processGetHostIndicatorsWithAnswersAsync(response: Response): Observable<ListResultDtoOfIndicatorsWithAnswersDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfIndicatorsWithAnswersDto.fromJS(resultData200) : new ListResultDtoOfIndicatorsWithAnswersDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfIndicatorsWithAnswersDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEditHost(input: CreateOrUpdateIndicatorAnswerHostInput): Observable<CreateOrEditAnswerOutput> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorAnswer/CreateOrEditHost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEditHost(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrEditHost(response_);
                } catch (e) {
                    return <Observable<CreateOrEditAnswerOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrEditAnswerOutput>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEditHost(response: Response): Observable<CreateOrEditAnswerOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrEditAnswerOutput.fromJS(resultData200) : new CreateOrEditAnswerOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrEditAnswerOutput>(<any>null);
    }
}

@Injectable()
export class IndicatorPerformanceReportServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getIndicators(): Observable<ListResultDtoOfGetIndicatorsDto> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorPerformanceReport/GetIndicators";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIndicators(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIndicators(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetIndicatorsDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetIndicatorsDto>><any>Observable.throw(response_);
        });
    }

    protected processGetIndicators(response: Response): Observable<ListResultDtoOfGetIndicatorsDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetIndicatorsDto.fromJS(resultData200) : new ListResultDtoOfGetIndicatorsDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetIndicatorsDto>(<any>null);
    }

    /**
     * @indicatorId (optional) 
     * @return Success
     */
    getIndicatorsById(indicatorId: number[]): Observable<ListResultDtoOfGetIndicatorByIdOutput> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorPerformanceReport/GetIndicatorsById?";
        if (indicatorId !== undefined)
            indicatorId && indicatorId.forEach(item => { url_ += "IndicatorId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIndicatorsById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIndicatorsById(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetIndicatorByIdOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetIndicatorByIdOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetIndicatorsById(response: Response): Observable<ListResultDtoOfGetIndicatorByIdOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetIndicatorByIdOutput.fromJS(resultData200) : new ListResultDtoOfGetIndicatorByIdOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetIndicatorByIdOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createIndicatorReportData(input: IndicatorPerformanceInput): Observable<ListResultDtoOfIndicatorsOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorPerformanceReport/CreateIndicatorReportData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateIndicatorReportData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateIndicatorReportData(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfIndicatorsOutputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfIndicatorsOutputDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateIndicatorReportData(response: Response): Observable<ListResultDtoOfIndicatorsOutputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfIndicatorsOutputDto.fromJS(resultData200) : new ListResultDtoOfIndicatorsOutputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfIndicatorsOutputDto>(<any>null);
    }

    /**
     * @answerableIndicatorId (optional) 
     * @return Success
     */
    getIndicatorValueReport(answerableIndicatorId: number): Observable<ListResultDtoOfIndicatorAnswerListOutput> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorPerformanceReport/GetIndicatorValueReport?";
        if (answerableIndicatorId !== undefined)
            url_ += "AnswerableIndicatorId=" + encodeURIComponent("" + answerableIndicatorId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIndicatorValueReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIndicatorValueReport(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfIndicatorAnswerListOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfIndicatorAnswerListOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetIndicatorValueReport(response: Response): Observable<ListResultDtoOfIndicatorAnswerListOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfIndicatorAnswerListOutput.fromJS(resultData200) : new ListResultDtoOfIndicatorAnswerListOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfIndicatorAnswerListOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getIndicatorForFilter(): Observable<ListResultDtoOfIndicatorForFilter> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorPerformanceReport/GetIndicatorForFilter";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIndicatorForFilter(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIndicatorForFilter(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfIndicatorForFilter>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfIndicatorForFilter>><any>Observable.throw(response_);
        });
    }

    protected processGetIndicatorForFilter(response: Response): Observable<ListResultDtoOfIndicatorForFilter> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfIndicatorForFilter.fromJS(resultData200) : new ListResultDtoOfIndicatorForFilter();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfIndicatorForFilter>(<any>null);
    }

    /**
     * @return Success
     */
    getRegion(): Observable<ListResultDtoOfRegionsOutput> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorPerformanceReport/GetRegion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRegion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRegion(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRegionsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRegionsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetRegion(response: Response): Observable<ListResultDtoOfRegionsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRegionsOutput.fromJS(resultData200) : new ListResultDtoOfRegionsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRegionsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getCountry(): Observable<ListResultDtoOfCountryOutput> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorPerformanceReport/GetCountry";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCountry(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCountry(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfCountryOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfCountryOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetCountry(response: Response): Observable<ListResultDtoOfCountryOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfCountryOutput.fromJS(resultData200) : new ListResultDtoOfCountryOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfCountryOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    indicatorValueByFilterReport(input: IndicatorFilterInput): Observable<ListResultDtoOfIndicatorFilterOutput> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorPerformanceReport/IndicatorValueByFilterReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIndicatorValueByFilterReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIndicatorValueByFilterReport(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfIndicatorFilterOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfIndicatorFilterOutput>><any>Observable.throw(response_);
        });
    }

    protected processIndicatorValueByFilterReport(response: Response): Observable<ListResultDtoOfIndicatorFilterOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfIndicatorFilterOutput.fromJS(resultData200) : new ListResultDtoOfIndicatorFilterOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfIndicatorFilterOutput>(<any>null);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setup(input: InstallDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetup(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAppSettingsJson(response_);
                } catch (e) {
                    return <Observable<AppSettingsJsonDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<AppSettingsJsonDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAppSettingsJson(response: Response): Observable<AppSettingsJsonDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AppSettingsJsonDto.fromJS(resultData200) : new AppSettingsJsonDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AppSettingsJsonDto>(<any>null);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckDatabase(response_);
                } catch (e) {
                    return <Observable<CheckDatabaseOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CheckDatabaseOutput>><any>Observable.throw(response_);
        });
    }

    protected processCheckDatabase(response: Response): Observable<CheckDatabaseOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckDatabaseOutput.fromJS(resultData200) : new CheckDatabaseOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CheckDatabaseOutput>(<any>null);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getInvoiceInfo(id: number): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInvoiceInfo(response_);
                } catch (e) {
                    return <Observable<InvoiceDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<InvoiceDto>><any>Observable.throw(response_);
        });
    }

    protected processGetInvoiceInfo(response: Response): Observable<InvoiceDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InvoiceDto.fromJS(resultData200) : new InvoiceDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<InvoiceDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createInvoice(input: CreateInvoiceDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateInvoice(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateInvoice(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class IserFeedbackFormServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createIserForm(input: CreateOrUpdateIserFormDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IserFeedbackForm/CreateIserForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateIserForm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateIserForm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateIserForm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IserFeedbackForm/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @termId (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string, termId: number, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfIserFormDto> {
        let url_ = this.baseUrl + "/api/services/app/IserFeedbackForm/GetAll?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAll(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAll(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfIserFormDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfIserFormDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAll(response: Response): Observable<PagedResultDtoOfIserFormDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfIserFormDto.fromJS(resultData200) : new PagedResultDtoOfIserFormDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfIserFormDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getIserFormForUpdate(id: number): Observable<CreateOrUpdateIserFormDto> {
        let url_ = this.baseUrl + "/api/services/app/IserFeedbackForm/GetIserFormForUpdate?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIserFormForUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIserFormForUpdate(response_);
                } catch (e) {
                    return <Observable<CreateOrUpdateIserFormDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateOrUpdateIserFormDto>><any>Observable.throw(response_);
        });
    }

    protected processGetIserFormForUpdate(response: Response): Observable<CreateOrUpdateIserFormDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateOrUpdateIserFormDto.fromJS(resultData200) : new CreateOrUpdateIserFormDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateOrUpdateIserFormDto>(<any>null);
    }

    /**
     * @parentId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getIserFormsByParentId(parentId: number, termId: number): Observable<ListResultDtoOfIserFormDto> {
        let url_ = this.baseUrl + "/api/services/app/IserFeedbackForm/GetIserFormsByParentId?";
        if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&"; 
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIserFormsByParentId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIserFormsByParentId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfIserFormDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfIserFormDto>><any>Observable.throw(response_);
        });
    }

    protected processGetIserFormsByParentId(response: Response): Observable<ListResultDtoOfIserFormDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfIserFormDto.fromJS(resultData200) : new ListResultDtoOfIserFormDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfIserFormDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateIserForm(input: CreateOrUpdateIserFormDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IserFeedbackForm/UpdateIserForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateIserForm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateIserForm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateIserForm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class IserFeedbackFormAnswerServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @universityId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getEvaluationFormWithAnswerAsync(universityId: number, termId: number): Observable<IserFeedbackFormCompletedAndAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/IserFeedbackFormAnswer/GetEvaluationFormWithAnswerAsync?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormWithAnswerAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormWithAnswerAsync(response_);
                } catch (e) {
                    return <Observable<IserFeedbackFormCompletedAndAnswerDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<IserFeedbackFormCompletedAndAnswerDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormWithAnswerAsync(response: Response): Observable<IserFeedbackFormCompletedAndAnswerDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IserFeedbackFormCompletedAndAnswerDto.fromJS(resultData200) : new IserFeedbackFormCompletedAndAnswerDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IserFeedbackFormCompletedAndAnswerDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    iserFeedbackAnswerCreateOrEdit(input: IserFeedbackAnswerCreateOrEdit): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IserFeedbackFormAnswer/IserFeedbackAnswerCreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIserFeedbackAnswerCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIserFeedbackAnswerCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processIserFeedbackAnswerCreateOrEdit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getIserFeedbackStatus(universityId: number, termId: number): Observable<GetIserFeedbackStatusOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/IserFeedbackFormAnswer/GetIserFeedbackStatus?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIserFeedbackStatus(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIserFeedbackStatus(response_);
                } catch (e) {
                    return <Observable<GetIserFeedbackStatusOutputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetIserFeedbackStatusOutputDto>><any>Observable.throw(response_);
        });
    }

    protected processGetIserFeedbackStatus(response: Response): Observable<GetIserFeedbackStatusOutputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetIserFeedbackStatusOutputDto.fromJS(resultData200) : new GetIserFeedbackStatusOutputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetIserFeedbackStatusOutputDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    iserFeedbackFormCompleted(input: IserFeedbackFormCompletedDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IserFeedbackFormAnswer/IserFeedbackFormCompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIserFeedbackFormCompleted(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIserFeedbackFormCompleted(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processIserFeedbackFormCompleted(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    iserFeedbackFormIsCompleteable(input: IserFeedbackFormCompletedDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/IserFeedbackFormAnswer/IserFeedbackFormIsCompleteable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIserFeedbackFormIsCompleteable(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIserFeedbackFormIsCompleteable(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processIserFeedbackFormIsCompleteable(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @termId (optional) 
     * @tenantId (optional) 
     * @evaluationFormId (optional) 
     * @return Success
     */
    getIserData(termId: number, tenantId: number, evaluationFormId: number): Observable<GetIserDataOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/IserFeedbackFormAnswer/GetIserData?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (evaluationFormId !== undefined)
            url_ += "EvaluationFormId=" + encodeURIComponent("" + evaluationFormId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIserData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIserData(response_);
                } catch (e) {
                    return <Observable<GetIserDataOutputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetIserDataOutputDto>><any>Observable.throw(response_);
        });
    }

    protected processGetIserData(response: Response): Observable<GetIserDataOutputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetIserDataOutputDto.fromJS(resultData200) : new GetIserDataOutputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetIserDataOutputDto>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    getIserFeedbackCompleted(termId: number): Observable<ListResultDtoOfGetIserFeedbackCompletedOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/IserFeedbackFormAnswer/GetIserFeedbackCompleted?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIserFeedbackCompleted(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIserFeedbackCompleted(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetIserFeedbackCompletedOutputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetIserFeedbackCompletedOutputDto>><any>Observable.throw(response_);
        });
    }

    protected processGetIserFeedbackCompleted(response: Response): Observable<ListResultDtoOfGetIserFeedbackCompletedOutputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetIserFeedbackCompletedOutputDto.fromJS(resultData200) : new ListResultDtoOfGetIserFeedbackCompletedOutputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetIserFeedbackCompletedOutputDto>(<any>null);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguages(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLanguages(response_);
                } catch (e) {
                    return <Observable<GetLanguagesOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLanguagesOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguages(response: Response): Observable<GetLanguagesOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLanguagesOutput.fromJS(resultData200) : new GetLanguagesOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLanguagesOutput>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLanguageForEdit(response_);
                } catch (e) {
                    return <Observable<GetLanguageForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLanguageForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguageForEdit(response: Response): Observable<GetLanguageForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLanguageForEditOutput.fromJS(resultData200) : new GetLanguageForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLanguageForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateLanguage(input: CreateOrUpdateLanguageInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateLanguage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteLanguage(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteLanguage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setDefaultLanguage(input: SetDefaultLanguageInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetDefaultLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetDefaultLanguage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @sorting (optional) 
     * @baseLanguageName (optional) 
     * @targetValueFilter (optional) 
     * @filterText (optional) 
     * @return Success
     */
    getLanguageTexts(maxResultCount: number, skipCount: number, sorting: string, sourceName: string, baseLanguageName: string, targetLanguageName: string, targetValueFilter: string, filterText: string): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&"; 
        if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&"; 
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&"; 
        if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&"; 
        if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLanguageTexts(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLanguageTextListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfLanguageTextListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLanguageTexts(response: Response): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLanguageTextListDto.fromJS(resultData200) : new PagedResultDtoOfLanguageTextListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfLanguageTextListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateLanguageText(input: UpdateLanguageTextInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateLanguageText(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateLanguageText(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class MatchEvaluationFormServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateMachEvaluationForm(input: CreateOrUpdateMachEvaluationFormDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MatchEvaluationForm/CreateOrUpdateMachEvaluationForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateMachEvaluationForm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateMachEvaluationForm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateMachEvaluationForm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MatchEvaluationForm/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDelete(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDelete(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDelete(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    getAllEvaluationForm(termId: number): Observable<EvaluationFormDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MatchEvaluationForm/GetAllEvaluationForm?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllEvaluationForm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllEvaluationForm(response_);
                } catch (e) {
                    return <Observable<EvaluationFormDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<EvaluationFormDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetAllEvaluationForm(response: Response): Observable<EvaluationFormDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(EvaluationFormDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EvaluationFormDto[]>(<any>null);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @state (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getUserNotifications(state: State, maxResultCount: number, skipCount: number): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserNotifications(response_);
                } catch (e) {
                    return <Observable<GetNotificationsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetNotificationsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserNotifications(response: Response): Observable<GetNotificationsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetNotificationsOutput.fromJS(resultData200) : new GetNotificationsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetNotificationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetAllNotificationsAsRead(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetAllNotificationsAsRead(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    setNotificationAsRead(input: EntityDtoOfGuid): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSetNotificationAsRead(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSetNotificationAsRead(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetNotificationSettings(response_);
                } catch (e) {
                    return <Observable<GetNotificationSettingsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetNotificationSettingsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetNotificationSettings(response: Response): Observable<GetNotificationSettingsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetNotificationSettingsOutput.fromJS(resultData200) : new GetNotificationSettingsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetNotificationSettingsOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateNotificationSettings(input: UpdateNotificationSettingsInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateNotificationSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateNotificationSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class OpinionSuggestionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addAsync(input: CreateOpinionSuggestionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OpinionSuggestion/AddAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteById(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OpinionSuggestion/DeleteById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteById(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteById(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    edit(input: EditOpinionSuggestionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OpinionSuggestion/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEdit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getOpinionSuggestionById(id: number): Observable<OpinionSuggestionDto> {
        let url_ = this.baseUrl + "/api/services/app/OpinionSuggestion/GetOpinionSuggestionById?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOpinionSuggestionById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOpinionSuggestionById(response_);
                } catch (e) {
                    return <Observable<OpinionSuggestionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OpinionSuggestionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOpinionSuggestionById(response: Response): Observable<OpinionSuggestionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OpinionSuggestionDto.fromJS(resultData200) : new OpinionSuggestionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OpinionSuggestionDto>(<any>null);
    }

    /**
     * @processDateId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    getCurrentOpinionSuggestionByTenantId(processDateId: number, tenantId: number): Observable<OpinionSuggestionDto> {
        let url_ = this.baseUrl + "/api/services/app/OpinionSuggestion/GetCurrentOpinionSuggestionByTenantId?";
        if (processDateId !== undefined)
            url_ += "processDateId=" + encodeURIComponent("" + processDateId) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentOpinionSuggestionByTenantId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentOpinionSuggestionByTenantId(response_);
                } catch (e) {
                    return <Observable<OpinionSuggestionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OpinionSuggestionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentOpinionSuggestionByTenantId(response: Response): Observable<OpinionSuggestionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OpinionSuggestionDto.fromJS(resultData200) : new OpinionSuggestionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OpinionSuggestionDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @return Success
     */
    getOpinionSuggestion(filter: string): Observable<OpinionSuggestionDto> {
        let url_ = this.baseUrl + "/api/services/app/OpinionSuggestion/GetOpinionSuggestion?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOpinionSuggestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOpinionSuggestion(response_);
                } catch (e) {
                    return <Observable<OpinionSuggestionDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OpinionSuggestionDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOpinionSuggestion(response: Response): Observable<OpinionSuggestionDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OpinionSuggestionDto.fromJS(resultData200) : new OpinionSuggestionDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OpinionSuggestionDto>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    getOpinionSuggestionListByTenantId(tenantId: number): Observable<ListResultDtoOfOpinionSuggestionListDto> {
        let url_ = this.baseUrl + "/api/services/app/OpinionSuggestion/GetOpinionSuggestionListByTenantId?";
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOpinionSuggestionListByTenantId(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOpinionSuggestionListByTenantId(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOpinionSuggestionListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfOpinionSuggestionListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOpinionSuggestionListByTenantId(response: Response): Observable<ListResultDtoOfOpinionSuggestionListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfOpinionSuggestionListDto.fromJS(resultData200) : new ListResultDtoOfOpinionSuggestionListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfOpinionSuggestionListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrentProcessDateOfOpSugAsync(): Observable<ProcessDateDto> {
        let url_ = this.baseUrl + "/api/services/app/OpinionSuggestion/GetCurrentProcessDateOfOpSugAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentProcessDateOfOpSugAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentProcessDateOfOpSugAsync(response_);
                } catch (e) {
                    return <Observable<ProcessDateDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProcessDateDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentProcessDateOfOpSugAsync(response: Response): Observable<ProcessDateDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProcessDateDto.fromJS(resultData200) : new ProcessDateDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProcessDateDto>(<any>null);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOrganizationUnits(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfOrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfOrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOrganizationUnits(response: Response): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfOrganizationUnitDto.fromJS(resultData200) : new ListResultDtoOfOrganizationUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfOrganizationUnitDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitUsers(id: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetOrganizationUnitUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfOrganizationUnitUserListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetOrganizationUnitUsers(response: Response): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationUnitUserListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfOrganizationUnitUserListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrganizationUnit(input: CreateOrganizationUnitInput): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrganizationUnit(response: Response): Observable<OrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OrganizationUnitDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateOrganizationUnit(input: UpdateOrganizationUnitInput): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processUpdateOrganizationUnit(response: Response): Observable<OrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OrganizationUnitDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    moveOrganizationUnit(input: MoveOrganizationUnitInput): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processMoveOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<OrganizationUnitDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<OrganizationUnitDto>><any>Observable.throw(response_);
        });
    }

    protected processMoveOrganizationUnit(response: Response): Observable<OrganizationUnitDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<OrganizationUnitDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteOrganizationUnit(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteOrganizationUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @userId (optional) 
     * @organizationUnitId (optional) 
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number, organizationUnitId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processRemoveUserFromOrganizationUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addUsersToOrganizationUnit(input: UsersToOrganizationUnitInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddUsersToOrganizationUnit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddUsersToOrganizationUnit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    findUsers(input: FindOrganizationUnitUsersInput): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processFindUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processFindUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameValueDto>><any>Observable.throw(response_);
        });
    }

    protected processFindUsers(response: Response): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfNameValueDto>(<any>null);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @upgradeEditionId (optional) 
     * @return Success
     */
    getPaymentInfo(upgradeEditionId: number): Observable<PaymentInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId !== undefined)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPaymentInfo(response_);
                } catch (e) {
                    return <Observable<PaymentInfoDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PaymentInfoDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentInfo(response: Response): Observable<PaymentInfoDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentInfoDto.fromJS(resultData200) : new PaymentInfoDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PaymentInfoDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPayment(input: CreatePaymentDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePayment(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processCreatePayment(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    executePayment(input: ExecutePaymentDto): Observable<any> {
        let url_ = this.baseUrl + "/api/services/app/Payment/ExecutePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExecutePayment(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExecutePayment(response_);
                } catch (e) {
                    return <Observable<any>><any>Observable.throw(e);
                }
            } else
                return <Observable<any>><any>Observable.throw(response_);
        });
    }

    protected processExecutePayment(response: Response): Observable<any> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {};
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        result200[key] = resultData200[key];
                }
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<any>(<any>null);
    }

    /**
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getPaymentHistory(sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPaymentHistory(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPaymentHistory(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfSubscriptionPaymentListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPaymentHistory(response: Response): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200) : new PagedResultDtoOfSubscriptionPaymentListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfSubscriptionPaymentListDto>(<any>null);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllPermissions(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfFlatPermissionWithLevelDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllPermissions(response: Response): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200) : new ListResultDtoOfFlatPermissionWithLevelDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfFlatPermissionWithLevelDto>(<any>null);
    }
}

@Injectable()
export class PreTrainingQuestionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPreTrainingQuestion(id: number): Observable<PtQuestionOutputForEdit> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingQuestion/GetPreTrainingQuestion?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPreTrainingQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPreTrainingQuestion(response_);
                } catch (e) {
                    return <Observable<PtQuestionOutputForEdit>><any>Observable.throw(e);
                }
            } else
                return <Observable<PtQuestionOutputForEdit>><any>Observable.throw(response_);
        });
    }

    protected processGetPreTrainingQuestion(response: Response): Observable<PtQuestionOutputForEdit> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PtQuestionOutputForEdit.fromJS(resultData200) : new PtQuestionOutputForEdit();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PtQuestionOutputForEdit>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPreTrainingQuestion(input: CreatePtQuestionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingQuestion/CreatePreTrainingQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePreTrainingQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePreTrainingQuestion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePreTrainingQuestion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deletePreTrainingQuestion(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingQuestion/DeletePreTrainingQuestion?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeletePreTrainingQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeletePreTrainingQuestion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePreTrainingQuestion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    checkTestsOfQuestion(id: number): Observable<TestSectionOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingQuestion/CheckTestsOfQuestion?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckTestsOfQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckTestsOfQuestion(response_);
                } catch (e) {
                    return <Observable<TestSectionOutput[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TestSectionOutput[]>><any>Observable.throw(response_);
        });
    }

    protected processCheckTestsOfQuestion(response: Response): Observable<TestSectionOutput[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TestSectionOutput.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TestSectionOutput[]>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getPreTrainingQuestions(filter: string, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfPtQuestionOutput> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingQuestion/GetPreTrainingQuestions?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPreTrainingQuestions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPreTrainingQuestions(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPtQuestionOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfPtQuestionOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPreTrainingQuestions(response: Response): Observable<PagedResultDtoOfPtQuestionOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfPtQuestionOutput.fromJS(resultData200) : new PagedResultDtoOfPtQuestionOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfPtQuestionOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updatePreTrainingQuestion(input: PtQuestionOutputForEdit): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingQuestion/UpdatePreTrainingQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdatePreTrainingQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdatePreTrainingQuestion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdatePreTrainingQuestion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @answerId (optional) 
     * @return Success
     */
    deleteAnswerOfQuestion(answerId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingQuestion/DeleteAnswerOfQuestion?";
        if (answerId !== undefined)
            url_ += "answerId=" + encodeURIComponent("" + answerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteAnswerOfQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteAnswerOfQuestion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteAnswerOfQuestion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PreTrainingTestServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createPreTrainingTests(input: CreatePreTrainingTestInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingTest/CreatePreTrainingTests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreatePreTrainingTests(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreatePreTrainingTests(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreatePreTrainingTests(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deletePreTrainingTests(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingTest/DeletePreTrainingTests?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeletePreTrainingTests(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeletePreTrainingTests(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePreTrainingTests(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getPreTestQuestions(filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfPreQuestionsOutput> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingTest/GetPreTestQuestions?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPreTestQuestions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPreTestQuestions(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPreQuestionsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfPreQuestionsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPreTestQuestions(response: Response): Observable<PagedResultDtoOfPreQuestionsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfPreQuestionsOutput.fromJS(resultData200) : new PagedResultDtoOfPreQuestionsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfPreQuestionsOutput>(<any>null);
    }

    /**
     * @testId (optional) 
     * @return Success
     */
    getPreTestEdit(testId: number): Observable<PretestEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingTest/GetPreTestEdit?";
        if (testId !== undefined)
            url_ += "TestId=" + encodeURIComponent("" + testId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPreTestEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPreTestEdit(response_);
                } catch (e) {
                    return <Observable<PretestEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PretestEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPreTestEdit(response: Response): Observable<PretestEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PretestEditOutput.fromJS(resultData200) : new PretestEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PretestEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    savePreTestEdit(input: PretestEditInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingTest/SavePreTestEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSavePreTestEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSavePreTestEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSavePreTestEdit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @termId (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getPreTrainingTests(termId: number, filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfPreTrainingTestOutput> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingTest/GetPreTrainingTests?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPreTrainingTests(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPreTrainingTests(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPreTrainingTestOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfPreTrainingTestOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPreTrainingTests(response: Response): Observable<PagedResultDtoOfPreTrainingTestOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfPreTrainingTestOutput.fromJS(resultData200) : new PagedResultDtoOfPreTrainingTestOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfPreTrainingTestOutput>(<any>null);
    }

    /**
     * @testId (optional) 
     * @return Success
     */
    isPreTestResolved(testId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PreTrainingTest/IsPreTestResolved?";
        if (testId !== undefined)
            url_ += "TestId=" + encodeURIComponent("" + testId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsPreTestResolved(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsPreTestResolved(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processIsPreTestResolved(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }
}

@Injectable()
export class PreviousExternalEvaluationAnswerServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    previousExternalEvaluationAnswer(input: PreviousExternalEvaluationAnswerInput): Observable<ListResultDtoOfPreviousExternalEvaluationAnswerOutput> {
        let url_ = this.baseUrl + "/api/services/app/PreviousExternalEvaluationAnswer/PreviousExternalEvaluationAnswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPreviousExternalEvaluationAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPreviousExternalEvaluationAnswer(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPreviousExternalEvaluationAnswerOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPreviousExternalEvaluationAnswerOutput>><any>Observable.throw(response_);
        });
    }

    protected processPreviousExternalEvaluationAnswer(response: Response): Observable<ListResultDtoOfPreviousExternalEvaluationAnswerOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPreviousExternalEvaluationAnswerOutput.fromJS(resultData200) : new ListResultDtoOfPreviousExternalEvaluationAnswerOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPreviousExternalEvaluationAnswerOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrEdit(input: PreviousExternalEvaluationAnswerOutput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PreviousExternalEvaluationAnswer/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrEdit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class PrgAccFeedbackServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    getFeedback(termId: number): Observable<ListResultDtoOfPrgAccFeedbackOutput> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccFeedback/GetFeedback?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFeedback(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFeedback(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPrgAccFeedbackOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPrgAccFeedbackOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetFeedback(response: Response): Observable<ListResultDtoOfPrgAccFeedbackOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPrgAccFeedbackOutput.fromJS(resultData200) : new ListResultDtoOfPrgAccFeedbackOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPrgAccFeedbackOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateFeedback(input: PrgAccFeedbackCreateInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccFeedback/CreateOrUpdateFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateFeedback(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateFeedback(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateFeedback(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteFeedback(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccFeedback/DeleteFeedback?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteFeedback(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteFeedback(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteFeedback(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getFeedbackForEdit(id: number): Observable<PrgAccFeedbackCreateInput> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccFeedback/GetFeedbackForEdit?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFeedbackForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFeedbackForEdit(response_);
                } catch (e) {
                    return <Observable<PrgAccFeedbackCreateInput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PrgAccFeedbackCreateInput>><any>Observable.throw(response_);
        });
    }

    protected processGetFeedbackForEdit(response: Response): Observable<PrgAccFeedbackCreateInput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PrgAccFeedbackCreateInput.fromJS(resultData200) : new PrgAccFeedbackCreateInput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PrgAccFeedbackCreateInput>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getFeedbackQuestions(filter: string, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfPrgAccQuestionOutput> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccFeedback/GetFeedbackQuestions?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFeedbackQuestions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFeedbackQuestions(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPrgAccQuestionOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfPrgAccQuestionOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetFeedbackQuestions(response: Response): Observable<PagedResultDtoOfPrgAccQuestionOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfPrgAccQuestionOutput.fromJS(resultData200) : new PagedResultDtoOfPrgAccQuestionOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfPrgAccQuestionOutput>(<any>null);
    }
}

@Injectable()
export class PrgAccFeedbackResultServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    prgAccResultGetPrograms(input: PrgAccResultProgramsInput): Observable<ListResultDtoOfPrgAccResultProgramsOutput> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccFeedbackResult/PrgAccResultGetPrograms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrgAccResultGetPrograms(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrgAccResultGetPrograms(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPrgAccResultProgramsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPrgAccResultProgramsOutput>><any>Observable.throw(response_);
        });
    }

    protected processPrgAccResultGetPrograms(response: Response): Observable<ListResultDtoOfPrgAccResultProgramsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPrgAccResultProgramsOutput.fromJS(resultData200) : new ListResultDtoOfPrgAccResultProgramsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPrgAccResultProgramsOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    prgAccGetProgramDetails(input: number): Observable<PrgAccProgramsDetailOutput> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccFeedbackResult/PrgAccGetProgramDetails?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrgAccGetProgramDetails(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrgAccGetProgramDetails(response_);
                } catch (e) {
                    return <Observable<PrgAccProgramsDetailOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PrgAccProgramsDetailOutput>><any>Observable.throw(response_);
        });
    }

    protected processPrgAccGetProgramDetails(response: Response): Observable<PrgAccProgramsDetailOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PrgAccProgramsDetailOutput.fromJS(resultData200) : new PrgAccProgramsDetailOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PrgAccProgramsDetailOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    prgAccGetAllresult(termId: number): Observable<ListResultDtoOfPrgAccAllResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccFeedbackResult/PrgAccGetAllresult?";
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processPrgAccGetAllresult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processPrgAccGetAllresult(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPrgAccAllResultOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPrgAccAllResultOutput>><any>Observable.throw(response_);
        });
    }

    protected processPrgAccGetAllresult(response: Response): Observable<ListResultDtoOfPrgAccAllResultOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPrgAccAllResultOutput.fromJS(resultData200) : new ListResultDtoOfPrgAccAllResultOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPrgAccAllResultOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    getResultToExcel(termId: number): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccFeedbackResult/GetResultToExcel?";
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetResultToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetResultToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetResultToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class PrgAccQuestionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getPrgAccQuestions(filter: string, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfPrgAccQuestionOutput> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccQuestion/GetPrgAccQuestions?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPrgAccQuestions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPrgAccQuestions(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPrgAccQuestionOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfPrgAccQuestionOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPrgAccQuestions(response: Response): Observable<PagedResultDtoOfPrgAccQuestionOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfPrgAccQuestionOutput.fromJS(resultData200) : new PagedResultDtoOfPrgAccQuestionOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfPrgAccQuestionOutput>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getPrgAccQuestionForUpdate(id: number): Observable<CreateorUpdatePrgAccQuestionInput> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccQuestion/GetPrgAccQuestionForUpdate?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPrgAccQuestionForUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPrgAccQuestionForUpdate(response_);
                } catch (e) {
                    return <Observable<CreateorUpdatePrgAccQuestionInput>><any>Observable.throw(e);
                }
            } else
                return <Observable<CreateorUpdatePrgAccQuestionInput>><any>Observable.throw(response_);
        });
    }

    protected processGetPrgAccQuestionForUpdate(response: Response): Observable<CreateorUpdatePrgAccQuestionInput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CreateorUpdatePrgAccQuestionInput.fromJS(resultData200) : new CreateorUpdatePrgAccQuestionInput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CreateorUpdatePrgAccQuestionInput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createorUpdatePrgAccQuestion(input: CreateorUpdatePrgAccQuestionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccQuestion/CreateorUpdatePrgAccQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateorUpdatePrgAccQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateorUpdatePrgAccQuestion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateorUpdatePrgAccQuestion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deletePrgAccQuestion(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccQuestion/DeletePrgAccQuestion?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeletePrgAccQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeletePrgAccQuestion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePrgAccQuestion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPrgAccQuestionsGroup(): Observable<ListResultDtoOfPrgAccQuestionGroupOutput> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccQuestion/GetPrgAccQuestionsGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPrgAccQuestionsGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPrgAccQuestionsGroup(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPrgAccQuestionGroupOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPrgAccQuestionGroupOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPrgAccQuestionsGroup(response: Response): Observable<ListResultDtoOfPrgAccQuestionGroupOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPrgAccQuestionGroupOutput.fromJS(resultData200) : new ListResultDtoOfPrgAccQuestionGroupOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPrgAccQuestionGroupOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createorUpdatePrgAccQuestionGroup(input: PrgAccQuestionGroupOutput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccQuestion/CreateorUpdatePrgAccQuestionGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateorUpdatePrgAccQuestionGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateorUpdatePrgAccQuestionGroup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateorUpdatePrgAccQuestionGroup(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deletePrgAccQuestionGroup(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccQuestion/DeletePrgAccQuestionGroup?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeletePrgAccQuestionGroup(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeletePrgAccQuestionGroup(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeletePrgAccQuestionGroup(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getQuestionType(): Observable<ListResultDtoOfPrgAccQuestionTypeOutput> {
        let url_ = this.baseUrl + "/api/services/app/PrgAccQuestion/GetQuestionType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetQuestionType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetQuestionType(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPrgAccQuestionTypeOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfPrgAccQuestionTypeOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetQuestionType(response: Response): Observable<ListResultDtoOfPrgAccQuestionTypeOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPrgAccQuestionTypeOutput.fromJS(resultData200) : new ListResultDtoOfPrgAccQuestionTypeOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfPrgAccQuestionTypeOutput>(<any>null);
    }
}

@Injectable()
export class ProcessServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    edit(input: EditProcessInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Process/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEdit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @processId (optional) 
     * @return Success
     */
    getProcessById(processId: number): Observable<ProcessDto> {
        let url_ = this.baseUrl + "/api/services/app/Process/GetProcessById?";
        if (processId !== undefined)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProcessById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProcessById(response_);
                } catch (e) {
                    return <Observable<ProcessDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProcessDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProcessById(response: Response): Observable<ProcessDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProcessDto.fromJS(resultData200) : new ProcessDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProcessDto>(<any>null);
    }

    /**
     * @processId (optional) 
     * @return Success
     */
    getProcessByIdForEdit(processId: number): Observable<EditProcessInput> {
        let url_ = this.baseUrl + "/api/services/app/Process/GetProcessByIdForEdit?";
        if (processId !== undefined)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProcessByIdForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProcessByIdForEdit(response_);
                } catch (e) {
                    return <Observable<EditProcessInput>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditProcessInput>><any>Observable.throw(response_);
        });
    }

    protected processGetProcessByIdForEdit(response: Response): Observable<EditProcessInput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditProcessInput.fromJS(resultData200) : new EditProcessInput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditProcessInput>(<any>null);
    }

    /**
     * @filter (optional) 
     * @return Success
     */
    getProcessesList(filter: string): Observable<ListResultDtoOfProcessListDto> {
        let url_ = this.baseUrl + "/api/services/app/Process/GetProcessesList?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProcessesList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProcessesList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProcessListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProcessListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProcessesList(response: Response): Observable<ListResultDtoOfProcessListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProcessListDto.fromJS(resultData200) : new ListResultDtoOfProcessListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProcessListDto>(<any>null);
    }
}

@Injectable()
export class ProcessDateServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    addAsync(input: CreateProcessDateInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProcessDate/AddAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAddAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAddAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAddAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    editAsync(input: EditProcessDateDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProcessDate/EditAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processEditAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processEditAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processEditAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getProcessDateByIdAsync(id: number): Observable<ProcessDateDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcessDate/GetProcessDateByIdAsync?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProcessDateByIdAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProcessDateByIdAsync(response_);
                } catch (e) {
                    return <Observable<ProcessDateDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProcessDateDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProcessDateByIdAsync(response: Response): Observable<ProcessDateDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProcessDateDto.fromJS(resultData200) : new ProcessDateDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProcessDateDto>(<any>null);
    }

    /**
     * @filter (optional) 
     * @return Success
     */
    getProcessDateListAsync(filter: string): Observable<ListResultDtoOfProcessDateListDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcessDate/GetProcessDateListAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProcessDateListAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProcessDateListAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProcessDateListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProcessDateListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProcessDateListAsync(response: Response): Observable<ListResultDtoOfProcessDateListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProcessDateListDto.fromJS(resultData200) : new ListResultDtoOfProcessDateListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProcessDateListDto>(<any>null);
    }

    /**
     * @processId (optional) 
     * @return Success
     */
    getProcessDateListByProcessIdAsync(processId: number): Observable<ListResultDtoOfProcessDateListDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcessDate/GetProcessDateListByProcessIdAsync?";
        if (processId !== undefined)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProcessDateListByProcessIdAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProcessDateListByProcessIdAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfProcessDateListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfProcessDateListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetProcessDateListByProcessIdAsync(response: Response): Observable<ListResultDtoOfProcessDateListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfProcessDateListDto.fromJS(resultData200) : new ListResultDtoOfProcessDateListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfProcessDateListDto>(<any>null);
    }

    /**
     * @processId (optional) 
     * @return Success
     */
    getCurrentProcessDateByProcessIdAsync(processId: number): Observable<ProcessDateDto> {
        let url_ = this.baseUrl + "/api/services/app/ProcessDate/GetCurrentProcessDateByProcessIdAsync?";
        if (processId !== undefined)
            url_ += "processId=" + encodeURIComponent("" + processId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentProcessDateByProcessIdAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentProcessDateByProcessIdAsync(response_);
                } catch (e) {
                    return <Observable<ProcessDateDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ProcessDateDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentProcessDateByProcessIdAsync(response: Response): Observable<ProcessDateDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProcessDateDto.fromJS(resultData200) : new ProcessDateDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ProcessDateDto>(<any>null);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentUserProfileForEdit(response_);
                } catch (e) {
                    return <Observable<CurrentUserProfileEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<CurrentUserProfileEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentUserProfileForEdit(response: Response): Observable<CurrentUserProfileEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CurrentUserProfileEditDto.fromJS(resultData200) : new CurrentUserProfileEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<CurrentUserProfileEditDto>(<any>null);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(response_);
                } catch (e) {
                    return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<UpdateGoogleAuthenticatorKeyOutput>><any>Observable.throw(response_);
        });
    }

    protected processUpdateGoogleAuthenticatorKey(response: Response): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200) : new UpdateGoogleAuthenticatorKeyOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UpdateGoogleAuthenticatorKeyOutput>(<any>null);
    }

    /**
     * @return Success
     */
    sendVerificationSms(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendVerificationSms(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendVerificationSms(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    verifySmsCode(input: VerifySmsCodeInputDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processVerifySmsCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processVerifySmsCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateCurrentUserProfile(input: CurrentUserProfileEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateCurrentUserProfile(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateCurrentUserProfile(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changePassword(input: ChangePasswordInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangePassword(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangePassword(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangePassword(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateProfilePicture(input: UpdateProfilePictureInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateProfilePicture(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateProfilePicture(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPasswordComplexitySetting(response_);
                } catch (e) {
                    return <Observable<GetPasswordComplexitySettingOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetPasswordComplexitySettingOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPasswordComplexitySetting(response: Response): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPasswordComplexitySettingOutput.fromJS(resultData200) : new GetPasswordComplexitySettingOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetPasswordComplexitySettingOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProfilePicture(response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProfilePicture(response: Response): Observable<GetProfilePictureOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @profilePictureId (optional) 
     * @userId (optional) 
     * @tenantId (optional) 
     * @return Success
     */
    getFriendProfilePictureById(profilePictureId: string, userId: number, tenantId: number): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "ProfilePictureId=" + encodeURIComponent("" + profilePictureId) + "&"; 
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFriendProfilePictureById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFriendProfilePictureById(response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetFriendProfilePictureById(response: Response): Observable<GetProfilePictureOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @profilePictureId (optional) 
     * @return Success
     */
    getProfilePictureById(profilePictureId: string): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProfilePictureById(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProfilePictureById(response_);
                } catch (e) {
                    return <Observable<GetProfilePictureOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetProfilePictureOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProfilePictureById(response: Response): Observable<GetProfilePictureOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    changeLanguage(input: ChangeUserLanguageDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processChangeLanguage(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processChangeLanguage(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class ReportsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @universityId (optional) 
     * @year (optional) 
     * @return Success
     */
    getInternalEvaluationReportData(universityId: number, year: number): Observable<InternalEvaluationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetInternalEvaluationReportData?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInternalEvaluationReportData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInternalEvaluationReportData(response_);
                } catch (e) {
                    return <Observable<InternalEvaluationOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<InternalEvaluationOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetInternalEvaluationReportData(response: Response): Observable<InternalEvaluationOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InternalEvaluationOutput.fromJS(resultData200) : new InternalEvaluationOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<InternalEvaluationOutput>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @years (optional) 
     * @isYokakKey (optional) 
     * @return Success
     */
    getIndicatorReportData(universityId: number, years: number[], isYokakKey: boolean): Observable<IndicatorReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetIndicatorReportData?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (years !== undefined)
            years && years.forEach(item => { url_ += "Years=" + encodeURIComponent("" + item) + "&"; });
        if (isYokakKey !== undefined)
            url_ += "IsYokakKey=" + encodeURIComponent("" + isYokakKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIndicatorReportData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIndicatorReportData(response_);
                } catch (e) {
                    return <Observable<IndicatorReportOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<IndicatorReportOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetIndicatorReportData(response: Response): Observable<IndicatorReportOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IndicatorReportOutput.fromJS(resultData200) : new IndicatorReportOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IndicatorReportOutput>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @return Success
     */
    getEvulationFormCriteria(universityId: number[]): Observable<ListResultDtoOfUniversityCriteriaListOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetEvulationFormCriteria?";
        if (universityId !== undefined)
            universityId && universityId.forEach(item => { url_ += "UniversityId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvulationFormCriteria(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvulationFormCriteria(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUniversityCriteriaListOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUniversityCriteriaListOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEvulationFormCriteria(response: Response): Observable<ListResultDtoOfUniversityCriteriaListOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUniversityCriteriaListOutput.fromJS(resultData200) : new ListResultDtoOfUniversityCriteriaListOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfUniversityCriteriaListOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    getEvaluationFormForCriteriaReport(termId: number): Observable<ListResultDtoOfEvlFormList> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetEvaluationFormForCriteriaReport?";
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormForCriteriaReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormForCriteriaReport(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvlFormList>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvlFormList>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormForCriteriaReport(response: Response): Observable<ListResultDtoOfEvlFormList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvlFormList.fromJS(resultData200) : new ListResultDtoOfEvlFormList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvlFormList>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @year (optional) 
     * @isAll (optional) 
     * @return Success
     */
    getSelfAndExternalEvaluationCriteria(universityId: number[], year: number, isAll: boolean): Observable<ListResultDtoOfSelfAndExternalEvaluationCriteriaListOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetSelfAndExternalEvaluationCriteria?";
        if (universityId !== undefined)
            universityId && universityId.forEach(item => { url_ += "UniversityId=" + encodeURIComponent("" + item) + "&"; });
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        if (isAll !== undefined)
            url_ += "IsAll=" + encodeURIComponent("" + isAll) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSelfAndExternalEvaluationCriteria(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSelfAndExternalEvaluationCriteria(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSelfAndExternalEvaluationCriteriaListOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSelfAndExternalEvaluationCriteriaListOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSelfAndExternalEvaluationCriteria(response: Response): Observable<ListResultDtoOfSelfAndExternalEvaluationCriteriaListOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSelfAndExternalEvaluationCriteriaListOutput.fromJS(resultData200) : new ListResultDtoOfSelfAndExternalEvaluationCriteriaListOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSelfAndExternalEvaluationCriteriaListOutput>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @year (optional) 
     * @return Success
     */
    getExternalEvaluationReportData(universityId: number, year: number): Observable<ExternalEvaluationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetExternalEvaluationReportData?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExternalEvaluationReportData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExternalEvaluationReportData(response_);
                } catch (e) {
                    return <Observable<ExternalEvaluationOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExternalEvaluationOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetExternalEvaluationReportData(response: Response): Observable<ExternalEvaluationOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExternalEvaluationOutput.fromJS(resultData200) : new ExternalEvaluationOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExternalEvaluationOutput>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @year (optional) 
     * @return Success
     */
    getExternalEvaluationFeedbackData(universityId: number, year: number): Observable<ListResultDtoOfExternalEvaluationFeedbackOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetExternalEvaluationFeedbackData?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExternalEvaluationFeedbackData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExternalEvaluationFeedbackData(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfExternalEvaluationFeedbackOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfExternalEvaluationFeedbackOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetExternalEvaluationFeedbackData(response: Response): Observable<ListResultDtoOfExternalEvaluationFeedbackOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfExternalEvaluationFeedbackOutput.fromJS(resultData200) : new ListResultDtoOfExternalEvaluationFeedbackOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfExternalEvaluationFeedbackOutput>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @year (optional) 
     * @return Success
     */
    getExternalEvaluationReportIsCompleted(universityId: number, year: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetExternalEvaluationReportIsCompleted?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExternalEvaluationReportIsCompleted(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExternalEvaluationReportIsCompleted(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetExternalEvaluationReportIsCompleted(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @year (optional) 
     * @return Success
     */
    getExternalEvaluationReportIsPublished(universityId: number, year: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetExternalEvaluationReportIsPublished?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExternalEvaluationReportIsPublished(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExternalEvaluationReportIsPublished(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetExternalEvaluationReportIsPublished(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @year (optional) 
     * @mainEvaluationForm (optional) 
     * @return Success
     */
    getEvaluationFormAllProofFiles(universityId: number, year: number, mainEvaluationForm: number): Observable<ListResultDtoOfEvaluationFormProofFileOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetEvaluationFormAllProofFiles?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        if (mainEvaluationForm !== undefined)
            url_ += "MainEvaluationForm=" + encodeURIComponent("" + mainEvaluationForm) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormAllProofFiles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormAllProofFiles(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluationFormProofFileOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluationFormProofFileOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormAllProofFiles(response: Response): Observable<ListResultDtoOfEvaluationFormProofFileOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluationFormProofFileOutput.fromJS(resultData200) : new ListResultDtoOfEvaluationFormProofFileOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluationFormProofFileOutput>(<any>null);
    }

    /**
     * @years (optional) 
     * @return Success
     */
    getEvaluationFormAllProofFilesCount(years: number[]): Observable<ListResultDtoOfEvaluationFormProofFileCountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetEvaluationFormAllProofFilesCount?";
        if (years !== undefined)
            years && years.forEach(item => { url_ += "Years=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormAllProofFilesCount(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormAllProofFilesCount(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluationFormProofFileCountOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluationFormProofFileCountOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormAllProofFilesCount(response: Response): Observable<ListResultDtoOfEvaluationFormProofFileCountOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluationFormProofFileCountOutput.fromJS(resultData200) : new ListResultDtoOfEvaluationFormProofFileCountOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluationFormProofFileCountOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    getInstAccUniversityList(termId: number): Observable<ListResultDtoOfInstAccUniversityListOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetInstAccUniversityList?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInstAccUniversityList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInstAccUniversityList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfInstAccUniversityListOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfInstAccUniversityListOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetInstAccUniversityList(response: Response): Observable<ListResultDtoOfInstAccUniversityListOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfInstAccUniversityListOutput.fromJS(resultData200) : new ListResultDtoOfInstAccUniversityListOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfInstAccUniversityListOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @teamId (optional) 
     * @universityId (optional) 
     * @return Success
     */
    getInstAccMatLevDetail(termId: number, teamId: number, universityId: number): Observable<ListResultDtoOfInstAccMaturityLevelDetailOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetInstAccMatLevDetail?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInstAccMatLevDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInstAccMatLevDetail(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfInstAccMaturityLevelDetailOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfInstAccMaturityLevelDetailOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetInstAccMatLevDetail(response: Response): Observable<ListResultDtoOfInstAccMaturityLevelDetailOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfInstAccMaturityLevelDetailOutput.fromJS(resultData200) : new ListResultDtoOfInstAccMaturityLevelDetailOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfInstAccMaturityLevelDetailOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @return Success
     */
    getEvaluationFormForMatLevReport(termId: number): Observable<ListResultDtoOfMatLevEvlFormList> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetEvaluationFormForMatLevReport?";
        if (termId !== undefined)
            url_ += "termId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluationFormForMatLevReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluationFormForMatLevReport(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfMatLevEvlFormList>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfMatLevEvlFormList>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluationFormForMatLevReport(response: Response): Observable<ListResultDtoOfMatLevEvlFormList> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfMatLevEvlFormList.fromJS(resultData200) : new ListResultDtoOfMatLevEvlFormList();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfMatLevEvlFormList>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @termId (optional) 
     * @isAll (optional) 
     * @return Success
     */
    getUniversitySelfEvaluationMatLev(universityId: number[], termId: number, isAll: boolean): Observable<ListResultDtoOfUniversitySelfEvaluationMatLevOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetUniversitySelfEvaluationMatLev?";
        if (universityId !== undefined)
            universityId && universityId.forEach(item => { url_ += "UniversityId=" + encodeURIComponent("" + item) + "&"; });
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (isAll !== undefined)
            url_ += "IsAll=" + encodeURIComponent("" + isAll) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUniversitySelfEvaluationMatLev(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUniversitySelfEvaluationMatLev(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUniversitySelfEvaluationMatLevOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUniversitySelfEvaluationMatLevOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUniversitySelfEvaluationMatLev(response: Response): Observable<ListResultDtoOfUniversitySelfEvaluationMatLevOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUniversitySelfEvaluationMatLevOutput.fromJS(resultData200) : new ListResultDtoOfUniversitySelfEvaluationMatLevOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfUniversitySelfEvaluationMatLevOutput>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getInstitutionalAccreditationReportData(universityId: number, termId: number): Observable<InstitutionalAccreditationReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetInstitutionalAccreditationReportData?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInstitutionalAccreditationReportData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInstitutionalAccreditationReportData(response_);
                } catch (e) {
                    return <Observable<InstitutionalAccreditationReportOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<InstitutionalAccreditationReportOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetInstitutionalAccreditationReportData(response: Response): Observable<InstitutionalAccreditationReportOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InstitutionalAccreditationReportOutput.fromJS(resultData200) : new InstitutionalAccreditationReportOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<InstitutionalAccreditationReportOutput>(<any>null);
    }
    //ARA DEĞERLENDİRME
    getAraReportData(universityId: number, termId: number): Observable<AraReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetAraReportData?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_: any) => {
            return this.processGetAraReportData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAraReportData(response_);
                } catch (e) {
                    return <Observable<AraReportOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<AraReportOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAraReportData(response: Response): Observable<AraReportOutput> {
        const status = response.status;

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AraReportOutput.fromJS(resultData200) : new AraReportOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AraReportOutput>(<any>null);
    }

    //ARA DEĞERLENDİRME
    /**
     * @universityId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getIserFeedbackStatusReport(universityId: number, termId: number): Observable<GetIserFeedbackStatusOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetIserFeedbackStatusReport?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIserFeedbackStatusReport(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIserFeedbackStatusReport(response_);
                } catch (e) {
                    return <Observable<GetIserFeedbackStatusOutputDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetIserFeedbackStatusOutputDto>><any>Observable.throw(response_);
        });
    }

    protected processGetIserFeedbackStatusReport(response: Response): Observable<GetIserFeedbackStatusOutputDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetIserFeedbackStatusOutputDto.fromJS(resultData200) : new GetIserFeedbackStatusOutputDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetIserFeedbackStatusOutputDto>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getIserFeedbackReportData(universityId: number, termId: number): Observable<IserFeedbackReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetIserFeedbackReportData?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetIserFeedbackReportData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetIserFeedbackReportData(response_);
                } catch (e) {
                    return <Observable<IserFeedbackReportOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<IserFeedbackReportOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetIserFeedbackReportData(response: Response): Observable<IserFeedbackReportOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IserFeedbackReportOutput.fromJS(resultData200) : new IserFeedbackReportOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<IserFeedbackReportOutput>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @year (optional) 
     * @return Success
     */
    getDistanceEvaluationReportData(universityId: number, year: number): Observable<InternalEvaluationOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetDistanceEvaluationReportData?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDistanceEvaluationReportData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDistanceEvaluationReportData(response_);
                } catch (e) {
                    return <Observable<InternalEvaluationOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<InternalEvaluationOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDistanceEvaluationReportData(response: Response): Observable<InternalEvaluationOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InternalEvaluationOutput.fromJS(resultData200) : new InternalEvaluationOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<InternalEvaluationOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @tenantId (optional) 
     * @applicantId (optional) 
     * @return Success
     */
    getMentorDataAsync(termId: number, tenantId: number, applicantId: number): Observable<MentoringReportDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetMentorDataAsync?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (applicantId !== undefined)
            url_ += "ApplicantId=" + encodeURIComponent("" + applicantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMentorDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMentorDataAsync(response_);
                } catch (e) {
                    return <Observable<MentoringReportDataOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<MentoringReportDataOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetMentorDataAsync(response: Response): Observable<MentoringReportDataOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MentoringReportDataOutput.fromJS(resultData200) : new MentoringReportDataOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<MentoringReportDataOutput>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @termId (optional) 
     * @return Success
     */
    getInstitutionalMonitoringReportDataAsync(tenantId: number, termId: number): Observable<InstitutionalMonitoringReportDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetInstitutionalMonitoringReportDataAsync?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetInstitutionalMonitoringReportDataAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetInstitutionalMonitoringReportDataAsync(response_);
                } catch (e) {
                    return <Observable<InstitutionalMonitoringReportDataOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<InstitutionalMonitoringReportDataOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetInstitutionalMonitoringReportDataAsync(response: Response): Observable<InstitutionalMonitoringReportDataOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? InstitutionalMonitoringReportDataOutput.fromJS(resultData200) : new InstitutionalMonitoringReportDataOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<InstitutionalMonitoringReportDataOutput>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @year (optional) 
     * @return Success
     */
    getHSISelfEvaluationReportData(universityId: number, year: number): Observable<HSISelfEvaluationReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Reports/GetHSISelfEvaluationReportData?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetHSISelfEvaluationReportData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetHSISelfEvaluationReportData(response_);
                } catch (e) {
                    return <Observable<HSISelfEvaluationReportOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<HSISelfEvaluationReportOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetHSISelfEvaluationReportData(response: Response): Observable<HSISelfEvaluationReportOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? HSISelfEvaluationReportOutput.fromJS(resultData200) : new HSISelfEvaluationReportOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<HSISelfEvaluationReportOutput>(<any>null);
    }
}

@Injectable()
export class ReviewServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAcceptedTitle(): Observable<ListResultDtoOfGetAcceptedTitleDto> {
        let url_ = this.baseUrl + "/api/services/app/Review/GetAcceptedTitle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAcceptedTitle(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAcceptedTitle(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAcceptedTitleDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAcceptedTitleDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAcceptedTitle(response: Response): Observable<ListResultDtoOfGetAcceptedTitleDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAcceptedTitleDto.fromJS(resultData200) : new ListResultDtoOfGetAcceptedTitleDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAcceptedTitleDto>(<any>null);
    }

    /**
     * @termId (optional) 
     * @status (optional) 
     * @titleId (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getEvaluators(termId: number, status: Status[], titleId: number, filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfEvaluatorsListDto> {
        let url_ = this.baseUrl + "/api/services/app/Review/GetEvaluators?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (status !== undefined)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (titleId !== undefined)
            url_ += "TitleId=" + encodeURIComponent("" + titleId) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluators(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluators(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEvaluatorsListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfEvaluatorsListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluators(response: Response): Observable<PagedResultDtoOfEvaluatorsListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfEvaluatorsListDto.fromJS(resultData200) : new PagedResultDtoOfEvaluatorsListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfEvaluatorsListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    update(input: UpdateEvalutarosInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Review/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @return Success
     */
    getEvaluatorsDetail(filter: number): Observable<EvaluatorsDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/Review/GetEvaluatorsDetail?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEvaluatorsDetail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEvaluatorsDetail(response_);
                } catch (e) {
                    return <Observable<EvaluatorsDetailDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EvaluatorsDetailDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEvaluatorsDetail(response: Response): Observable<EvaluatorsDetailDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EvaluatorsDetailDto.fromJS(resultData200) : new EvaluatorsDetailDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EvaluatorsDetailDto>(<any>null);
    }

    /**
     * @termId (optional) 
     * @status (optional) 
     * @titleId (optional) 
     * @filter (optional) 
     * @return Success
     */
    getReviewApplicationsToExcel(termId: number, status: Status2[], titleId: number, filter: string): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Review/GetReviewApplicationsToExcel?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (status !== undefined)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (titleId !== undefined)
            url_ += "TitleId=" + encodeURIComponent("" + titleId) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetReviewApplicationsToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetReviewApplicationsToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetReviewApplicationsToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @return Success
     */
    getApplicant(): Observable<ListResultDtoOfApplicantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Review/GetApplicant";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetApplicant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetApplicant(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfApplicantListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfApplicantListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetApplicant(response: Response): Observable<ListResultDtoOfApplicantListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfApplicantListDto.fromJS(resultData200) : new ListResultDtoOfApplicantListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfApplicantListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    reviewApplicationTransfertoNewTerm(input: GetEvaluatorsListForTransferInput): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Review/ReviewApplicationTransfertoNewTerm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processReviewApplicationTransfertoNewTerm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processReviewApplicationTransfertoNewTerm(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processReviewApplicationTransfertoNewTerm(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getApplicantForMentor(): Observable<ListResultDtoOfApplicantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Review/GetApplicantForMentor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetApplicantForMentor(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetApplicantForMentor(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfApplicantListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfApplicantListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetApplicantForMentor(response: Response): Observable<ListResultDtoOfApplicantListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfApplicantListDto.fromJS(resultData200) : new ListResultDtoOfApplicantListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfApplicantListDto>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @permission (optional) 
     * @return Success
     */
    getRoles(permission: string): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRoles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRoles(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRoles(response: Response): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRoleListDto.fromJS(resultData200) : new ListResultDtoOfRoleListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRoleListDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRoleForEdit(response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetRoleForEdit(response: Response): Observable<GetRoleForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRoleForEditOutput.fromJS(resultData200) : new GetRoleForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateRole(input: CreateOrUpdateRoleInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateRole(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateRole(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteRole(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteRole(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteRole(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteRole(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetCurrentLoginInformations(response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetCurrentLoginInformations(response: Response): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCurrentLoginInformationsOutput.fromJS(resultData200) : new GetCurrentLoginInformationsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetCurrentLoginInformationsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUserSignInToken(response_);
                } catch (e) {
                    return <Observable<UpdateUserSignInTokenOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<UpdateUserSignInTokenOutput>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUserSignInToken(response: Response): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UpdateUserSignInTokenOutput.fromJS(resultData200) : new UpdateUserSignInTokenOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UpdateUserSignInTokenOutput>(<any>null);
    }
}

@Injectable()
export class SourceServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @culture (optional) 
     * @return Success
     */
    getAllSourcesAsync(culture: string): Observable<ListResultDtoOfSourceDto> {
        let url_ = this.baseUrl + "/api/services/app/Source/GetAllSourcesAsync?";
        if (culture !== undefined)
            url_ += "Culture=" + encodeURIComponent("" + culture) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSourcesAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllSourcesAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSourceDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSourceDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSourcesAsync(response: Response): Observable<ListResultDtoOfSourceDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSourceDto.fromJS(resultData200) : new ListResultDtoOfSourceDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSourceDto>(<any>null);
    }

    /**
     * @nameKey (optional) 
     * @nameValue (optional) 
     * @sequenceNo (optional) 
     * @isActive (optional) 
     * @id (optional) 
     * @return Success
     */
    getSourceAsync(nameKey: string, nameValue: string, sequenceNo: number, isActive: boolean, id: number): Observable<SourceDto> {
        let url_ = this.baseUrl + "/api/services/app/Source/GetSourceAsync?";
        if (nameKey !== undefined)
            url_ += "NameKey=" + encodeURIComponent("" + nameKey) + "&"; 
        if (nameValue !== undefined)
            url_ += "NameValue=" + encodeURIComponent("" + nameValue) + "&"; 
        if (sequenceNo !== undefined)
            url_ += "SequenceNo=" + encodeURIComponent("" + sequenceNo) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSourceAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSourceAsync(response_);
                } catch (e) {
                    return <Observable<SourceDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<SourceDto>><any>Observable.throw(response_);
        });
    }

    protected processGetSourceAsync(response: Response): Observable<SourceDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SourceDto.fromJS(resultData200) : new SourceDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SourceDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createSourceAsync(input: CreateSourceInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Source/CreateSourceAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateSourceAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateSourceAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateSourceAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteSourceAsync(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Source/DeleteSourceAsync?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteSourceAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteSourceAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteSourceAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateSourceAsync(input: GetSourceForEditModel): Observable<GetSourceForEditModel> {
        let url_ = this.baseUrl + "/api/services/app/Source/UpdateSourceAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateSourceAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateSourceAsync(response_);
                } catch (e) {
                    return <Observable<GetSourceForEditModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSourceForEditModel>><any>Observable.throw(response_);
        });
    }

    protected processUpdateSourceAsync(response: Response): Observable<GetSourceForEditModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSourceForEditModel.fromJS(resultData200) : new GetSourceForEditModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetSourceForEditModel>(<any>null);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @upgradeEditionId (optional) 
     * @return Success
     */
    upgradeTenantToEquivalentEdition(upgradeEditionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/UpgradeTenantToEquivalentEdition?";
        if (upgradeEditionId !== undefined)
            url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpgradeTenantToEquivalentEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpgradeTenantToEquivalentEdition(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpgradeTenantToEquivalentEdition(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TeamEvaluatedUniversityServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTeamWithEvaluatedUnisAsync(id: number): Observable<ListResultDtoOfEvaluationTeamOutput> {
        let url_ = this.baseUrl + "/api/services/app/TeamEvaluatedUniversity/GetTeamWithEvaluatedUnisAsync?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTeamWithEvaluatedUnisAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTeamWithEvaluatedUnisAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluationTeamOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluationTeamOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTeamWithEvaluatedUnisAsync(response: Response): Observable<ListResultDtoOfEvaluationTeamOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluationTeamOutput.fromJS(resultData200) : new ListResultDtoOfEvaluationTeamOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluationTeamOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @teamId (optional) 
     * @return Success
     */
    getUnassignedUniversities(termId: number, teamId: number): Observable<ListResultDtoOfEvaluatedUniversityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TeamEvaluatedUniversity/GetUnassignedUniversities?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUnassignedUniversities(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUnassignedUniversities(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfEvaluatedUniversityOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfEvaluatedUniversityOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUnassignedUniversities(response: Response): Observable<ListResultDtoOfEvaluatedUniversityOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfEvaluatedUniversityOutput.fromJS(resultData200) : new ListResultDtoOfEvaluatedUniversityOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfEvaluatedUniversityOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    assignUniversityToTeam(input: AssignUniversityInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TeamEvaluatedUniversity/AssignUniversityToTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAssignUniversityToTeam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAssignUniversityToTeam(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processAssignUniversityToTeam(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @teamId (optional) 
     * @termId (optional) 
     * @evaluationBeginDate (optional) 
     * @evaluationEndDate (optional) 
     * @return Success
     */
    deleteAssignedUniversityFromTeam(universityId: number, teamId: number, termId: number, evaluationBeginDate: moment.Moment, evaluationEndDate: moment.Moment): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TeamEvaluatedUniversity/DeleteAssignedUniversityFromTeam?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&"; 
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (evaluationBeginDate !== undefined)
            url_ += "EvaluationBeginDate=" + encodeURIComponent(evaluationBeginDate ? "" + evaluationBeginDate.toJSON() : "") + "&"; 
        if (evaluationEndDate !== undefined)
            url_ += "EvaluationEndDate=" + encodeURIComponent(evaluationEndDate ? "" + evaluationEndDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteAssignedUniversityFromTeam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteAssignedUniversityFromTeam(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteAssignedUniversityFromTeam(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateEvaluationDates(input: AssignUniversityInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TeamEvaluatedUniversity/UpdateEvaluationDates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateEvaluationDates(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateEvaluationDates(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateEvaluationDates(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @subscriptionEndDateStart (optional) 
     * @subscriptionEndDateEnd (optional) 
     * @creationDateStart (optional) 
     * @creationDateEnd (optional) 
     * @editionId (optional) 
     * @editionIdSpecified (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getTenants(filter: string, subscriptionEndDateStart: moment.Moment, subscriptionEndDateEnd: moment.Moment, creationDateStart: moment.Moment, creationDateEnd: moment.Moment, editionId: number, editionIdSpecified: boolean, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toJSON() : "") + "&"; 
        if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toJSON() : "") + "&"; 
        if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&"; 
        if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&"; 
        if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&"; 
        if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenants(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenants(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTenantListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfTenantListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenants(response: Response): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTenantListDto.fromJS(resultData200) : new PagedResultDtoOfTenantListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfTenantListDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTenant(input: CreateTenantInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTenant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTenantForEdit(id: number): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantForEdit(response_);
                } catch (e) {
                    return <Observable<TenantEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantForEdit(response: Response): Observable<TenantEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantEditDto.fromJS(resultData200) : new TenantEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantEditDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTenant(input: TenantEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTenant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteTenant(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTenant(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTenant(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTenantFeaturesForEdit(id: number): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTenantFeaturesForEdit(response_);
                } catch (e) {
                    return <Observable<GetTenantFeaturesEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetTenantFeaturesEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTenantFeaturesForEdit(response: Response): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetTenantFeaturesEditOutput.fromJS(resultData200) : new GetTenantFeaturesEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetTenantFeaturesEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTenantFeatures(input: UpdateTenantFeaturesInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTenantFeatures(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTenantFeatures(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(input: EntityDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResetTenantSpecificFeatures(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processResetTenantSpecificFeatures(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unlockTenantAdmin(input: EntityDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnlockTenantAdmin(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnlockTenantAdmin(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetMemberActivity(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetMemberActivity(response_);
                } catch (e) {
                    return <Observable<GetMemberActivityOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetMemberActivityOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetMemberActivity(response: Response): Observable<GetMemberActivityOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetMemberActivityOutput.fromJS(resultData200) : new GetMemberActivityOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetMemberActivityOutput>(<any>null);
    }

    /**
     * @salesSummaryDatePeriod (optional) 
     * @return Success
     */
    getDashboardData(salesSummaryDatePeriod: SalesSummaryDatePeriod): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetDashboardData(response_);
                } catch (e) {
                    return <Observable<GetDashboardDataOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetDashboardDataOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetDashboardData(response: Response): Observable<GetDashboardDataOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDashboardDataOutput.fromJS(resultData200) : new GetDashboardDataOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetDashboardDataOutput>(<any>null);
    }

    /**
     * @salesSummaryDatePeriod (optional) 
     * @return Success
     */
    getSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod2): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetSalesSummary(response_);
                } catch (e) {
                    return <Observable<GetSalesSummaryOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetSalesSummaryOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetSalesSummary(response: Response): Observable<GetSalesSummaryOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetSalesSummaryOutput.fromJS(resultData200) : new GetSalesSummaryOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetSalesSummaryOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getWorldMap(input: any): Observable<GetWorldMapOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetWorldMap?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetWorldMap(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetWorldMap(response_);
                } catch (e) {
                    return <Observable<GetWorldMapOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetWorldMapOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetWorldMap(response: Response): Observable<GetWorldMapOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetWorldMapOutput.fromJS(resultData200) : new GetWorldMapOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetWorldMapOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getGeneralStats(input: any): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetGeneralStats(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetGeneralStats(response_);
                } catch (e) {
                    return <Observable<GetGeneralStatsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetGeneralStatsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetGeneralStats(response: Response): Observable<GetGeneralStatsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetGeneralStatsOutput.fromJS(resultData200) : new GetGeneralStatsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetGeneralStatsOutput>(<any>null);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    registerTenant(input: RegisterTenantInput): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processRegisterTenant(response_);
                } catch (e) {
                    return <Observable<RegisterTenantOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<RegisterTenantOutput>><any>Observable.throw(response_);
        });
    }

    protected processRegisterTenant(response: Response): Observable<RegisterTenantOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterTenantOutput.fromJS(resultData200) : new RegisterTenantOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<RegisterTenantOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEditionsForSelect(response_);
                } catch (e) {
                    return <Observable<EditionsSelectOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditionsSelectOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetEditionsForSelect(response: Response): Observable<EditionsSelectOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditionsSelectOutput.fromJS(resultData200) : new EditionsSelectOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditionsSelectOutput>(<any>null);
    }

    /**
     * @editionId (optional) 
     * @return Success
     */
    getEdition(editionId: number): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetEdition(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetEdition(response_);
                } catch (e) {
                    return <Observable<EditionSelectDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<EditionSelectDto>><any>Observable.throw(response_);
        });
    }

    protected processGetEdition(response: Response): Observable<EditionSelectDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EditionSelectDto.fromJS(resultData200) : new EditionSelectDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<EditionSelectDto>(<any>null);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllSettings(response_);
                } catch (e) {
                    return <Observable<TenantSettingsEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<TenantSettingsEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllSettings(response: Response): Observable<TenantSettingsEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantSettingsEditDto.fromJS(resultData200) : new TenantSettingsEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TenantSettingsEditDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateAllSettings(input: TenantSettingsEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateAllSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateAllSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processClearLogo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processClearLogo(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearLogo(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processClearCustomCss(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processClearCustomCss(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    sendTestEmail(input: SendTestEmailInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendTestEmail(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendTestEmail(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TermServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTermAsync(input: CreateTermInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Term/CreateTermAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTermAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTermAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTermAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteTermAsync(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Term/DeleteTermAsync?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTermAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTermAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTermAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getTermsAsync(filter: string, sorting: string): Observable<ListResultDtoOfTermOutput> {
        let url_ = this.baseUrl + "/api/services/app/Term/GetTermsAsync?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermsAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTermOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTermOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTermsAsync(response: Response): Observable<ListResultDtoOfTermOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTermOutput.fromJS(resultData200) : new ListResultDtoOfTermOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTermOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getActiveTermAsync(): Observable<TermOutput> {
        let url_ = this.baseUrl + "/api/services/app/Term/GetActiveTermAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActiveTermAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActiveTermAsync(response_);
                } catch (e) {
                    return <Observable<TermOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<TermOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetActiveTermAsync(response: Response): Observable<TermOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TermOutput.fromJS(resultData200) : new TermOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TermOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getAllTermsAsync(): Observable<ListResultDtoOfTermOutput> {
        let url_ = this.baseUrl + "/api/services/app/Term/GetAllTermsAsync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllTermsAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllTermsAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTermOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTermOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAllTermsAsync(response: Response): Observable<ListResultDtoOfTermOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTermOutput.fromJS(resultData200) : new ListResultDtoOfTermOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTermOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getTermByIdAsync(input: number): Observable<TermOutput> {
        let url_ = this.baseUrl + "/api/services/app/Term/GetTermByIdAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermByIdAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermByIdAsync(response_);
                } catch (e) {
                    return <Observable<TermOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<TermOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTermByIdAsync(response: Response): Observable<TermOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TermOutput.fromJS(resultData200) : new TermOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TermOutput>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTermAsync(id: number): Observable<TermOutput> {
        let url_ = this.baseUrl + "/api/services/app/Term/GetTermAsync?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTermAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTermAsync(response_);
                } catch (e) {
                    return <Observable<TermOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<TermOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTermAsync(response: Response): Observable<TermOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TermOutput.fromJS(resultData200) : new TermOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TermOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTermAsync(input: UpdateTermInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Term/UpdateTermAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTermAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTermAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTermAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createUniversityPermissionAsync(input: CreateUnivPermInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Term/CreateUniversityPermissionAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateUniversityPermissionAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateUniversityPermissionAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateUniversityPermissionAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUniversityPermissionAsync(input: UpdateUnivPermInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Term/UpdateUniversityPermissionAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUniversityPermissionAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUniversityPermissionAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUniversityPermissionAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteUniversityPermissionAsync(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Term/DeleteUniversityPermissionAsync?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteUniversityPermissionAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteUniversityPermissionAsync(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteUniversityPermissionAsync(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @year (optional) 
     * @return Success
     */
    getUniversityPermissionAsync(tenantId: number, year: number): Observable<ListResultDtoOfUnivPermOutput> {
        let url_ = this.baseUrl + "/api/services/app/Term/GetUniversityPermissionAsync?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUniversityPermissionAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUniversityPermissionAsync(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUnivPermOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUnivPermOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUniversityPermissionAsync(response: Response): Observable<ListResultDtoOfUnivPermOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUnivPermOutput.fromJS(resultData200) : new ListResultDtoOfUnivPermOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfUnivPermOutput>(<any>null);
    }

    /**
     * @processType (optional) 
     * @return Success
     */
    getProcessableAsync(processType: ProcessType): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Term/GetProcessableAsync?";
        if (processType !== undefined)
            url_ += "ProcessType=" + encodeURIComponent("" + processType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProcessableAsync(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProcessableAsync(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processGetProcessableAsync(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @defaultTimezoneScope (optional) 
     * @return Success
     */
    getTimezones(defaultTimezoneScope: DefaultTimezoneScope): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope !== undefined)
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTimezones(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTimezones(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfNameValueDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfNameValueDto>><any>Observable.throw(response_);
        });
    }

    protected processGetTimezones(response: Response): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfNameValueDto.fromJS(resultData200) : new ListResultDtoOfNameValueDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfNameValueDto>(<any>null);
    }

    /**
     * @selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTimezoneComboboxItems(response_);
                } catch (e) {
                    return <Observable<ComboboxItemDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ComboboxItemDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTimezoneComboboxItems(response: Response): Observable<ComboboxItemDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ComboboxItemDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ComboboxItemDto[]>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @model (optional) 
     * @return Success
     */
    authenticate(model: AuthenticateModel): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processAuthenticate(response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processAuthenticate(response: Response): Observable<AuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<AuthenticateResultModel>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    sendTwoFactorAuthCode(model: SendTwoFactorAuthCodeModel): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSendTwoFactorAuthCode(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSendTwoFactorAuthCode(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processImpersonatedAuthenticate(response_);
                } catch (e) {
                    return <Observable<ImpersonatedAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<ImpersonatedAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processImpersonatedAuthenticate(response: Response): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImpersonatedAuthenticateResultModel.fromJS(resultData200) : new ImpersonatedAuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ImpersonatedAuthenticateResultModel>(<any>null);
    }

    /**
     * @switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLinkedAccountAuthenticate(response_);
                } catch (e) {
                    return <Observable<SwitchedAccountAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<SwitchedAccountAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processLinkedAccountAuthenticate(response: Response): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SwitchedAccountAuthenticateResultModel.fromJS(resultData200) : new SwitchedAccountAuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<SwitchedAccountAuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>Observable.throw(response_);
        });
    }

    protected processGetExternalAuthenticationProviders(response: Response): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @model (optional) 
     * @return Success
     */
    externalAuthenticate(model: ExternalAuthenticateModel): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processExternalAuthenticate(response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>Observable.throw(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>Observable.throw(response_);
        });
    }

    protected processExternalAuthenticate(response: Response): Observable<ExternalAuthenticateResultModel> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExternalAuthenticateResultModel.fromJS(resultData200) : new ExternalAuthenticateResultModel();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ExternalAuthenticateResultModel>(<any>null);
    }

    /**
     * @message (optional) 
     * @severity (optional) 
     * @return Success
     */
    testNotification(message: string, severity: string): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&"; 
        if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processTestNotification(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processTestNotification(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processTestNotification(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TrainingFileServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getTrainingFiles(): Observable<TrainingFileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrainingFile/GetTrainingFiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTrainingFiles(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTrainingFiles(response_);
                } catch (e) {
                    return <Observable<TrainingFileDto[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrainingFileDto[]>><any>Observable.throw(response_);
        });
    }

    protected processGetTrainingFiles(response: Response): Observable<TrainingFileDto[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TrainingFileDto.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TrainingFileDto[]>(<any>null);
    }
}

@Injectable()
export class TrainingQuestionServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getTrainingQuestion(id: number): Observable<TQuestionOutputForEdit> {
        let url_ = this.baseUrl + "/api/services/app/TrainingQuestion/GetTrainingQuestion?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTrainingQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTrainingQuestion(response_);
                } catch (e) {
                    return <Observable<TQuestionOutputForEdit>><any>Observable.throw(e);
                }
            } else
                return <Observable<TQuestionOutputForEdit>><any>Observable.throw(response_);
        });
    }

    protected processGetTrainingQuestion(response: Response): Observable<TQuestionOutputForEdit> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TQuestionOutputForEdit.fromJS(resultData200) : new TQuestionOutputForEdit();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TQuestionOutputForEdit>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrainingQuestion(input: CreateTQuestionInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingQuestion/CreateTrainingQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrainingQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrainingQuestion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrainingQuestion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteTrainingQuestion(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingQuestion/DeleteTrainingQuestion?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTrainingQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTrainingQuestion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTrainingQuestion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getTrainingQuestions(filter: string, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfTQuestionOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrainingQuestion/GetTrainingQuestions?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTrainingQuestions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTrainingQuestions(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTQuestionOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfTQuestionOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTrainingQuestions(response: Response): Observable<PagedResultDtoOfTQuestionOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTQuestionOutput.fromJS(resultData200) : new PagedResultDtoOfTQuestionOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfTQuestionOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getActiveTrainingQuestions(): Observable<ListResultDtoOfSectionQuestionsInput> {
        let url_ = this.baseUrl + "/api/services/app/TrainingQuestion/GetActiveTrainingQuestions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetActiveTrainingQuestions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetActiveTrainingQuestions(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfSectionQuestionsInput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfSectionQuestionsInput>><any>Observable.throw(response_);
        });
    }

    protected processGetActiveTrainingQuestions(response: Response): Observable<ListResultDtoOfSectionQuestionsInput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfSectionQuestionsInput.fromJS(resultData200) : new ListResultDtoOfSectionQuestionsInput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfSectionQuestionsInput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateTrainingQuestion(input: TQuestionOutputForEdit): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingQuestion/UpdateTrainingQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTrainingQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTrainingQuestion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTrainingQuestion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    checkTestsOfQuestion(id: number): Observable<TestSectionOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/TrainingQuestion/CheckTestsOfQuestion?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCheckTestsOfQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCheckTestsOfQuestion(response_);
                } catch (e) {
                    return <Observable<TestSectionOutput[]>><any>Observable.throw(e);
                }
            } else
                return <Observable<TestSectionOutput[]>><any>Observable.throw(response_);
        });
    }

    protected processCheckTestsOfQuestion(response: Response): Observable<TestSectionOutput[]> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TestSectionOutput.fromJS(item));
            }
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TestSectionOutput[]>(<any>null);
    }

    /**
     * @answerId (optional) 
     * @return Success
     */
    deleteAnswerOfQuestion(answerId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingQuestion/DeleteAnswerOfQuestion?";
        if (answerId !== undefined)
            url_ += "answerId=" + encodeURIComponent("" + answerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteAnswerOfQuestion(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteAnswerOfQuestion(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteAnswerOfQuestion(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TrainingReportAppServicesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    getTestList(input: number): Observable<ListResultDtoOfTestListOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrainingReportAppServices/GetTestList?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTestList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTestList(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTestListOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTestListOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTestList(response: Response): Observable<ListResultDtoOfTestListOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTestListOutput.fromJS(resultData200) : new ListResultDtoOfTestListOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTestListOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @testId (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getTestResultList(termId: number, testId: number, filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfTestResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrainingReportAppServices/GetTestResultList?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (testId !== undefined)
            url_ += "TestId=" + encodeURIComponent("" + testId) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTestResultList(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTestResultList(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTestResultOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfTestResultOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTestResultList(response: Response): Observable<PagedResultDtoOfTestResultOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTestResultOutput.fromJS(resultData200) : new PagedResultDtoOfTestResultOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfTestResultOutput>(<any>null);
    }

    /**
     * @activeTerm (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getPreAndLastTestResult(activeTerm: number, filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfPreAndLastTestResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrainingReportAppServices/GetPreAndLastTestResult?";
        if (activeTerm !== undefined)
            url_ += "ActiveTerm=" + encodeURIComponent("" + activeTerm) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPreAndLastTestResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPreAndLastTestResult(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPreAndLastTestResultOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfPreAndLastTestResultOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetPreAndLastTestResult(response: Response): Observable<PagedResultDtoOfPreAndLastTestResultOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfPreAndLastTestResultOutput.fromJS(resultData200) : new PagedResultDtoOfPreAndLastTestResultOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfPreAndLastTestResultOutput>(<any>null);
    }

    /**
     * @activeTerm (optional) 
     * @filter (optional) 
     * @return Success
     */
    getPreAndLastTestResultToExcel(activeTerm: number, filter: string): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingReportAppServices/GetPreAndLastTestResultToExcel?";
        if (activeTerm !== undefined)
            url_ += "ActiveTerm=" + encodeURIComponent("" + activeTerm) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetPreAndLastTestResultToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetPreAndLastTestResultToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetPreAndLastTestResultToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @activeTerm (optional) 
     * @testId (optional) 
     * @filter (optional) 
     * @return Success
     */
    getQuestionBaseTestResult(activeTerm: number, testId: number, filter: string): Observable<ListResultDtoOfQuestionBaseTestResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrainingReportAppServices/GetQuestionBaseTestResult?";
        if (activeTerm !== undefined)
            url_ += "ActiveTerm=" + encodeURIComponent("" + activeTerm) + "&"; 
        if (testId !== undefined)
            url_ += "TestId=" + encodeURIComponent("" + testId) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetQuestionBaseTestResult(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetQuestionBaseTestResult(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfQuestionBaseTestResultOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfQuestionBaseTestResultOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetQuestionBaseTestResult(response: Response): Observable<ListResultDtoOfQuestionBaseTestResultOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfQuestionBaseTestResultOutput.fromJS(resultData200) : new ListResultDtoOfQuestionBaseTestResultOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfQuestionBaseTestResultOutput>(<any>null);
    }

    /**
     * @activeTerm (optional) 
     * @testId (optional) 
     * @filter (optional) 
     * @return Success
     */
    getQuestionBaseResultToExcel(activeTerm: number, testId: number, filter: string): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingReportAppServices/GetQuestionBaseResultToExcel?";
        if (activeTerm !== undefined)
            url_ += "ActiveTerm=" + encodeURIComponent("" + activeTerm) + "&"; 
        if (testId !== undefined)
            url_ += "TestId=" + encodeURIComponent("" + testId) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetQuestionBaseResultToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetQuestionBaseResultToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetQuestionBaseResultToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

@Injectable()
export class TrainingTestServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @sorting (optional) 
     * @skipCount (optional) 
     * @maxResultCount (optional) 
     * @return Success
     */
    getTestQuestions(filter: string, sorting: string, skipCount: number, maxResultCount: number): Observable<PagedResultDtoOfTQuestionOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrainingTest/GetTestQuestions?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTestQuestions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTestQuestions(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTQuestionOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfTQuestionOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTestQuestions(response: Response): Observable<PagedResultDtoOfTQuestionOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTQuestionOutput.fromJS(resultData200) : new PagedResultDtoOfTQuestionOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfTQuestionOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @filter (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getTrainingTests(termId: number, filter: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfTrainingTestListOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrainingTest/GetTrainingTests?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTrainingTests(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTrainingTests(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTrainingTestListOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfTrainingTestListOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTrainingTests(response: Response): Observable<PagedResultDtoOfTrainingTestListOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTrainingTestListOutput.fromJS(resultData200) : new PagedResultDtoOfTrainingTestListOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfTrainingTestListOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createTrainingTest(input: CreateTrainingTestInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingTest/CreateTrainingTest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateTrainingTest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateTrainingTest(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateTrainingTest(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @testId (optional) 
     * @return Success
     */
    getTestEdit(testId: number): Observable<TrainingTestEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/TrainingTest/GetTestEdit?";
        if (testId !== undefined)
            url_ += "TestId=" + encodeURIComponent("" + testId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTestEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTestEdit(response_);
                } catch (e) {
                    return <Observable<TrainingTestEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<TrainingTestEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTestEdit(response: Response): Observable<TrainingTestEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TrainingTestEditOutput.fromJS(resultData200) : new TrainingTestEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TrainingTestEditOutput>(<any>null);
    }

    /**
     * @testId (optional) 
     * @return Success
     */
    deleteTrainingTest(testId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingTest/DeleteTrainingTest?";
        if (testId !== undefined)
            url_ += "TestId=" + encodeURIComponent("" + testId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTrainingTest(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTrainingTest(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTrainingTest(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @testId (optional) 
     * @return Success
     */
    isTestResolved(testId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TrainingTest/IsTestResolved?";
        if (testId !== undefined)
            url_ += "TestId=" + encodeURIComponent("" + testId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processIsTestResolved(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processIsTestResolved(response_);
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response_);
        });
    }

    protected processIsTestResolved(response: Response): Observable<boolean> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<boolean>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveTestEdit(input: CreateTrainingTestInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingTest/SaveTestEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveTestEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveTestEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveTestEdit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class TransferTypeServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @culture (optional) 
     * @filter (optional) 
     * @return Success
     */
    getAllTransferTypes(culture: string, filter: string): Observable<ListResultDtoOfTransferTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TransferType/GetAllTransferTypes?";
        if (culture !== undefined)
            url_ += "Culture=" + encodeURIComponent("" + culture) + "&"; 
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAllTransferTypes(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAllTransferTypes(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfTransferTypeDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfTransferTypeDto>><any>Observable.throw(response_);
        });
    }

    protected processGetAllTransferTypes(response: Response): Observable<ListResultDtoOfTransferTypeDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfTransferTypeDto.fromJS(resultData200) : new ListResultDtoOfTransferTypeDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfTransferTypeDto>(<any>null);
    }

    /**
     * @culture (optional) 
     * @id (optional) 
     * @return Success
     */
    getTransferType(culture: string, id: number): Observable<TransferTypeOutput> {
        let url_ = this.baseUrl + "/api/services/app/TransferType/GetTransferType?";
        if (culture !== undefined)
            url_ += "Culture=" + encodeURIComponent("" + culture) + "&"; 
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetTransferType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetTransferType(response_);
                } catch (e) {
                    return <Observable<TransferTypeOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<TransferTypeOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetTransferType(response: Response): Observable<TransferTypeOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransferTypeOutput.fromJS(resultData200) : new TransferTypeOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TransferTypeOutput>(<any>null);
    }

    /**
     * @dto (optional) 
     * @return Success
     */
    saveTransferType(dto: CreateTransferTypeInput): Observable<TransferTypeOutput> {
        let url_ = this.baseUrl + "/api/services/app/TransferType/SaveTransferType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveTransferType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveTransferType(response_);
                } catch (e) {
                    return <Observable<TransferTypeOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<TransferTypeOutput>><any>Observable.throw(response_);
        });
    }

    protected processSaveTransferType(response: Response): Observable<TransferTypeOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransferTypeOutput.fromJS(resultData200) : new TransferTypeOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<TransferTypeOutput>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteTransferType(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransferType/DeleteTransferType?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteTransferType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteTransferType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteTransferType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @dto (optional) 
     * @return Success
     */
    updateTransferType(dto: UpdateTransferTypeInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransferType/UpdateTransferType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateTransferType(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateTransferType(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateTransferType(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<UiCustomizationSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUiManagementSettings(response_);
                } catch (e) {
                    return <Observable<UiCustomizationSettingsEditDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<UiCustomizationSettingsEditDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUiManagementSettings(response: Response): Observable<UiCustomizationSettingsEditDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UiCustomizationSettingsEditDto.fromJS(resultData200) : new UiCustomizationSettingsEditDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UiCustomizationSettingsEditDto>(<any>null);
    }

    /**
     * @settings (optional) 
     * @return Success
     */
    updateUiManagementSettings(settings: UiCustomizationSettingsEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUiManagementSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUiManagementSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @settings (optional) 
     * @return Success
     */
    updateDefaultUiManagementSettings(settings: UiCustomizationSettingsEditDto): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateDefaultUiManagementSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUseSystemDefaultSettings(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUseSystemDefaultSettings(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class UniversitiesInfoAppServicesServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRegionAndCountry(): Observable<ListResultDtoOfRegionAndCountryOutput> {
        let url_ = this.baseUrl + "/api/services/app/UniversitiesInfoAppServices/GetRegionAndCountry";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRegionAndCountry(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRegionAndCountry(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRegionAndCountryOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfRegionAndCountryOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetRegionAndCountry(response: Response): Observable<ListResultDtoOfRegionAndCountryOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRegionAndCountryOutput.fromJS(resultData200) : new ListResultDtoOfRegionAndCountryOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfRegionAndCountryOutput>(<any>null);
    }

    /**
     * @universityId (optional) 
     * @return Success
     */
    getUniversityInfo(universityId: number): Observable<UniversityInfoOutput> {
        let url_ = this.baseUrl + "/api/services/app/UniversitiesInfoAppServices/GetUniversityInfo?";
        if (universityId !== undefined)
            url_ += "UniversityId=" + encodeURIComponent("" + universityId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUniversityInfo(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUniversityInfo(response_);
                } catch (e) {
                    return <Observable<UniversityInfoOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<UniversityInfoOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUniversityInfo(response: Response): Observable<UniversityInfoOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UniversityInfoOutput.fromJS(resultData200) : new UniversityInfoOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<UniversityInfoOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    universityInfoCreateorEdit(input: UniversityInfoOutput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UniversitiesInfoAppServices/UniversityInfoCreateorEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUniversityInfoCreateorEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUniversityInfoCreateorEdit(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUniversityInfoCreateorEdit(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class UnivPrgAccServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAccreditationAgency(): Observable<ListResultDtoOfGetAccreditationOutput> {
        let url_ = this.baseUrl + "/api/services/app/UnivPrgAcc/GetAccreditationAgency";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetAccreditationAgency(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetAccreditationAgency(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetAccreditationOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetAccreditationOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetAccreditationAgency(response: Response): Observable<ListResultDtoOfGetAccreditationOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetAccreditationOutput.fromJS(resultData200) : new ListResultDtoOfGetAccreditationOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetAccreditationOutput>(<any>null);
    }

    /**
     * @tenantId (optional) 
     * @return Success
     */
    getFaculty(tenantId: number): Observable<GetFacultyOutput> {
        let url_ = this.baseUrl + "/api/services/app/UnivPrgAcc/GetFaculty?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFaculty(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFaculty(response_);
                } catch (e) {
                    return <Observable<GetFacultyOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetFacultyOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetFaculty(response: Response): Observable<GetFacultyOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetFacultyOutput.fromJS(resultData200) : new GetFacultyOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetFacultyOutput>(<any>null);
    }

    /**
     * @facultyId (optional) 
     * @return Success
     */
    getProgram(facultyId: number): Observable<ListResultDtoOfGetProgramOutput> {
        let url_ = this.baseUrl + "/api/services/app/UnivPrgAcc/GetProgram?";
        if (facultyId !== undefined)
            url_ += "FacultyId=" + encodeURIComponent("" + facultyId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetProgram(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetProgram(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfGetProgramOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfGetProgramOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetProgram(response: Response): Observable<ListResultDtoOfGetProgramOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfGetProgramOutput.fromJS(resultData200) : new ListResultDtoOfGetProgramOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfGetProgramOutput>(<any>null);
    }

    /**
     * @termId (optional) 
     * @tenantId (optional) 
     * @facultyId (optional) 
     * @programId (optional) 
     * @accreditationAgencyId (optional) 
     * @accreditationAgencyName (optional) 
     * @yoksisUniversityId (optional) 
     * @return Success
     */
    getFeedbackAccQuestions(termId: number, tenantId: number, facultyId: number, programId: number, accreditationAgencyId: number, accreditationAgencyName: string, yoksisUniversityId: number): Observable<GetFeedbackQuestionsOutput> {
        let url_ = this.baseUrl + "/api/services/app/UnivPrgAcc/GetFeedbackAccQuestions?";
        if (termId !== undefined)
            url_ += "TermId=" + encodeURIComponent("" + termId) + "&"; 
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (facultyId !== undefined)
            url_ += "FacultyId=" + encodeURIComponent("" + facultyId) + "&"; 
        if (programId !== undefined)
            url_ += "ProgramId=" + encodeURIComponent("" + programId) + "&"; 
        if (accreditationAgencyId !== undefined)
            url_ += "AccreditationAgencyId=" + encodeURIComponent("" + accreditationAgencyId) + "&"; 
        if (accreditationAgencyName !== undefined)
            url_ += "AccreditationAgencyName=" + encodeURIComponent("" + accreditationAgencyName) + "&"; 
        if (yoksisUniversityId !== undefined)
            url_ += "YoksisUniversityId=" + encodeURIComponent("" + yoksisUniversityId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetFeedbackAccQuestions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetFeedbackAccQuestions(response_);
                } catch (e) {
                    return <Observable<GetFeedbackQuestionsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetFeedbackQuestionsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetFeedbackAccQuestions(response: Response): Observable<GetFeedbackQuestionsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetFeedbackQuestionsOutput.fromJS(resultData200) : new GetFeedbackQuestionsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetFeedbackQuestionsOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveFeedbackAnswer(input: FeedbackQuestionAnswerInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UnivPrgAcc/SaveFeedbackAnswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveFeedbackAnswer(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveFeedbackAnswer(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveFeedbackAnswer(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveVisitDate(input: VisitDateInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UnivPrgAcc/SaveVisitDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveVisitDate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveVisitDate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveVisitDate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveAccreditedDate(input: AccreditedDateInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UnivPrgAcc/SaveAccreditedDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveAccreditedDate(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveAccreditedDate(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveAccreditedDate(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveFeedbackTeam(input: FeedbackTeamInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UnivPrgAcc/SaveFeedbackTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveFeedbackTeam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveFeedbackTeam(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveFeedbackTeam(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteFeedbackTeam(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UnivPrgAcc/DeleteFeedbackTeam?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteFeedbackTeam(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteFeedbackTeam(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteFeedbackTeam(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    saveCompleteFeedbackForm(input: CompleteFeedBackFormInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UnivPrgAcc/SaveCompleteFeedbackForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processSaveCompleteFeedbackForm(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processSaveCompleteFeedbackForm(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processSaveCompleteFeedbackForm(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @filter (optional) 
     * @permission (optional) 
     * @role (optional) 
     * @sorting (optional) 
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @return Success
     */
    getUsers(filter: string, permission: string, role: number, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&"; 
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserListDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserListDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUsers(response: Response): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserListDto.fromJS(resultData200) : new PagedResultDtoOfUserListDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfUserListDto>(<any>null);
    }

    /**
     * @return Success
     */
    getUsersToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUsersToExcel(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processGetUsersToExcel(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUserForEdit(id: number): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserForEdit(response_);
                } catch (e) {
                    return <Observable<GetUserForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserForEdit(response: Response): Observable<GetUserForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserForEditOutput.fromJS(resultData200) : new GetUserForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUserForEditOutput>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    getUserPermissionsForEdit(id: number): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetUserPermissionsForEdit(response_);
                } catch (e) {
                    return <Observable<GetUserPermissionsForEditOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetUserPermissionsForEditOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetUserPermissionsForEdit(response: Response): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetUserPermissionsForEditOutput.fromJS(resultData200) : new GetUserPermissionsForEditOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetUserPermissionsForEditOutput>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    resetUserSpecificPermissions(input: EntityDtoOfInt64): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processResetUserSpecificPermissions(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processResetUserSpecificPermissions(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    updateUserPermissions(input: UpdateUserPermissionsInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "put",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUpdateUserPermissions(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUpdateUserPermissions(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    createOrUpdateUser(input: CreateOrUpdateUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processCreateOrUpdateUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processCreateOrUpdateUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @id (optional) 
     * @return Success
     */
    deleteUser(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "delete",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDeleteUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDeleteUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processDeleteUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unlockUser(input: EntityDtoOfInt64): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnlockUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnlockUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnlockUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @input (optional) 
     * @return Success
     */
    linkToUser(input: LinkToUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processLinkToUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processLinkToUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processLinkToUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }

    /**
     * @maxResultCount (optional) 
     * @skipCount (optional) 
     * @sorting (optional) 
     * @return Success
     */
    getLinkedUsers(maxResultCount: number, skipCount: number, sorting: string): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLinkedUsers(response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLinkedUserDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<PagedResultDtoOfLinkedUserDto>><any>Observable.throw(response_);
        });
    }

    protected processGetLinkedUsers(response: Response): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLinkedUserDto.fromJS(resultData200) : new PagedResultDtoOfLinkedUserDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<PagedResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfLinkedUserDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfLinkedUserDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRecentlyUsedLinkedUsers(response: Response): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfLinkedUserDto.fromJS(resultData200) : new ListResultDtoOfLinkedUserDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfLinkedUserDto>(<any>null);
    }

    /**
     * @input (optional) 
     * @return Success
     */
    unlinkUser(input: UnlinkUserInput): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processUnlinkUser(response_);
                } catch (e) {
                    return <Observable<void>><any>Observable.throw(e);
                }
            } else
                return <Observable<void>><any>Observable.throw(response_);
        });
    }

    protected processUnlinkUser(response: Response): Observable<void> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            return Observable.of<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<void>(<any>null);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getRecentUserLoginAttempts(): Observable<ListResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetRecentUserLoginAttempts(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetRecentUserLoginAttempts(response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<ListResultDtoOfUserLoginAttemptDto>><any>Observable.throw(response_);
        });
    }

    protected processGetRecentUserLoginAttempts(response: Response): Observable<ListResultDtoOfUserLoginAttemptDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200) : new ListResultDtoOfUserLoginAttemptDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<ListResultDtoOfUserLoginAttemptDto>(<any>null);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: Http;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "get",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processGetLatestWebLogs(response_);
                } catch (e) {
                    return <Observable<GetLatestWebLogsOutput>><any>Observable.throw(e);
                }
            } else
                return <Observable<GetLatestWebLogsOutput>><any>Observable.throw(response_);
        });
    }

    protected processGetLatestWebLogs(response: Response): Observable<GetLatestWebLogsOutput> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLatestWebLogsOutput.fromJS(resultData200) : new GetLatestWebLogsOutput();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<GetLatestWebLogsOutput>(<any>null);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request(url_, options_).flatMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        }).catch((response_: any) => {
            if (response_ instanceof Response) {
                try {
                    return this.processDownloadWebLogs(response_);
                } catch (e) {
                    return <Observable<FileDto>><any>Observable.throw(e);
                }
            } else
                return <Observable<FileDto>><any>Observable.throw(response_);
        });
    }

    protected processDownloadWebLogs(response: Response): Observable<FileDto> {
        const status = response.status; 

        let _headers: any = response.headers ? response.headers.toJSON() : {};
        if (status === 200) {
            const _responseText = response.text();
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
            return Observable.of(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.text();
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Observable.of<FileDto>(<any>null);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState;
    tenantId: number;
    serverRootAddress: string;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"];
            this.tenantId = data["tenantId"];
            this.serverRootAddress = data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data; 
    }
}

export interface IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState;
    tenantId: number;
    serverRootAddress: string;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.password = data["password"];
            this.captchaResponse = data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data; 
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId: number;
    resetCode: string;
    password: string;
    returnUrl: string;
    singleSignIn: string;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.resetCode = data["resetCode"];
            this.password = data["password"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data; 
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string;
    password: string;
    returnUrl: string;
    singleSignIn: string;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin: boolean;
    userName: string;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId: number;
    confirmationCode: string;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.confirmationCode = data["confirmationCode"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        return data; 
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId: number;
    userId: number;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IImpersonateInput {
    tenantId: number;
    userId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken: string;
    tenancyName: string;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.impersonationToken = data["impersonationToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface IImpersonateOutput {
    impersonationToken: string;
    tenancyName: string;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId: number;
    targetUserId: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.targetTenantId = data["targetTenantId"];
            this.targetUserId = data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data; 
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken: string;
    tenancyName: string;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.switchAccountToken = data["switchAccountToken"];
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data; 
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string;
    tenancyName: string;
}

export class PagedResultDtoOfActivityDto implements IPagedResultDtoOfActivityDto {
    totalCount: number;
    items: ActivityDto[];

    constructor(data?: IPagedResultDtoOfActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfActivityDto {
        let result = new PagedResultDtoOfActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfActivityDto {
    totalCount: number;
    items: ActivityDto[];
}

export class ActivityDto implements IActivityDto {
    name: string;
    description: string;
    isActive: boolean;
    activityLocations: ActivityLocationDto[];
    activityFiles: ActivityFileDto[];
    activityPublicityImageFiles: ActivityFileDto[];
    activityParticipants: ActivityParticipantDto[];
    activityManagers: ActivityManagerDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            if (data["activityLocations"] && data["activityLocations"].constructor === Array) {
                this.activityLocations = [];
                for (let item of data["activityLocations"])
                    this.activityLocations.push(ActivityLocationDto.fromJS(item));
            }
            if (data["activityFiles"] && data["activityFiles"].constructor === Array) {
                this.activityFiles = [];
                for (let item of data["activityFiles"])
                    this.activityFiles.push(ActivityFileDto.fromJS(item));
            }
            if (data["activityPublicityImageFiles"] && data["activityPublicityImageFiles"].constructor === Array) {
                this.activityPublicityImageFiles = [];
                for (let item of data["activityPublicityImageFiles"])
                    this.activityPublicityImageFiles.push(ActivityFileDto.fromJS(item));
            }
            if (data["activityParticipants"] && data["activityParticipants"].constructor === Array) {
                this.activityParticipants = [];
                for (let item of data["activityParticipants"])
                    this.activityParticipants.push(ActivityParticipantDto.fromJS(item));
            }
            if (data["activityManagers"] && data["activityManagers"].constructor === Array) {
                this.activityManagers = [];
                for (let item of data["activityManagers"])
                    this.activityManagers.push(ActivityManagerDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityDto {
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (this.activityLocations && this.activityLocations.constructor === Array) {
            data["activityLocations"] = [];
            for (let item of this.activityLocations)
                data["activityLocations"].push(item.toJSON());
        }
        if (this.activityFiles && this.activityFiles.constructor === Array) {
            data["activityFiles"] = [];
            for (let item of this.activityFiles)
                data["activityFiles"].push(item.toJSON());
        }
        if (this.activityPublicityImageFiles && this.activityPublicityImageFiles.constructor === Array) {
            data["activityPublicityImageFiles"] = [];
            for (let item of this.activityPublicityImageFiles)
                data["activityPublicityImageFiles"].push(item.toJSON());
        }
        if (this.activityParticipants && this.activityParticipants.constructor === Array) {
            data["activityParticipants"] = [];
            for (let item of this.activityParticipants)
                data["activityParticipants"].push(item.toJSON());
        }
        if (this.activityManagers && this.activityManagers.constructor === Array) {
            data["activityManagers"] = [];
            for (let item of this.activityManagers)
                data["activityManagers"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityDto {
    name: string;
    description: string;
    isActive: boolean;
    activityLocations: ActivityLocationDto[];
    activityFiles: ActivityFileDto[];
    activityPublicityImageFiles: ActivityFileDto[];
    activityParticipants: ActivityParticipantDto[];
    activityManagers: ActivityManagerDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ActivityLocationDto implements IActivityLocationDto {
    name: string;
    quota: number;
    beginDate: moment.Moment;
    endDate: moment.Moment;
    mapLink: string;
    activityId: number;
    activityLocationFiles: ActivityFileDto[];
    activitySections: ActivitySectionDto[];
    id: number;

    constructor(data?: IActivityLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.quota = data["quota"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.mapLink = data["mapLink"];
            this.activityId = data["activityId"];
            if (data["activityLocationFiles"] && data["activityLocationFiles"].constructor === Array) {
                this.activityLocationFiles = [];
                for (let item of data["activityLocationFiles"])
                    this.activityLocationFiles.push(ActivityFileDto.fromJS(item));
            }
            if (data["activitySections"] && data["activitySections"].constructor === Array) {
                this.activitySections = [];
                for (let item of data["activitySections"])
                    this.activitySections.push(ActivitySectionDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityLocationDto {
        let result = new ActivityLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["quota"] = this.quota;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["mapLink"] = this.mapLink;
        data["activityId"] = this.activityId;
        if (this.activityLocationFiles && this.activityLocationFiles.constructor === Array) {
            data["activityLocationFiles"] = [];
            for (let item of this.activityLocationFiles)
                data["activityLocationFiles"].push(item.toJSON());
        }
        if (this.activitySections && this.activitySections.constructor === Array) {
            data["activitySections"] = [];
            for (let item of this.activitySections)
                data["activitySections"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityLocationDto {
    name: string;
    quota: number;
    beginDate: moment.Moment;
    endDate: moment.Moment;
    mapLink: string;
    activityId: number;
    activityLocationFiles: ActivityFileDto[];
    activitySections: ActivitySectionDto[];
    id: number;
}

export class ActivityFileDto implements IActivityFileDto {
    activityId: number;
    fileId: string;
    fileName: string;
    contentType: string;
    size: number;
    path: string;

    constructor(data?: IActivityFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityId = data["activityId"];
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.contentType = data["contentType"];
            this.size = data["size"];
            this.path = data["path"];
        }
    }

    static fromJS(data: any): ActivityFileDto {
        let result = new ActivityFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        data["path"] = this.path;
        return data; 
    }
}

export interface IActivityFileDto {
    activityId: number;
    fileId: string;
    fileName: string;
    contentType: string;
    size: number;
    path: string;
}

export class ActivityParticipantDto implements IActivityParticipantDto {
    tcNo: number;
    name: string;
    lastName: string;
    email: string;
    mobilePhone: string;
    isEvaluatorSystemRegistry: boolean;
    activityLocationName: string;
    applicantId: number;
    universityId: number;
    universityName: string;
    attendedInstitution: string;
    acceptedTitleId: number;
    acceptedTitleText: string;
    isAcceptKvkk: boolean;
    recordBy: string;
    attendedActivities: AttendedActivityDto[];
    id: number;

    constructor(data?: IActivityParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tcNo = data["tcNo"];
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.email = data["email"];
            this.mobilePhone = data["mobilePhone"];
            this.isEvaluatorSystemRegistry = data["isEvaluatorSystemRegistry"];
            this.activityLocationName = data["activityLocationName"];
            this.applicantId = data["applicantId"];
            this.universityId = data["universityId"];
            this.universityName = data["universityName"];
            this.attendedInstitution = data["attendedInstitution"];
            this.acceptedTitleId = data["acceptedTitleId"];
            this.acceptedTitleText = data["acceptedTitleText"];
            this.isAcceptKvkk = data["isAcceptKvkk"];
            this.recordBy = data["recordBy"];
            if (data["attendedActivities"] && data["attendedActivities"].constructor === Array) {
                this.attendedActivities = [];
                for (let item of data["attendedActivities"])
                    this.attendedActivities.push(AttendedActivityDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityParticipantDto {
        let result = new ActivityParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tcNo"] = this.tcNo;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["mobilePhone"] = this.mobilePhone;
        data["isEvaluatorSystemRegistry"] = this.isEvaluatorSystemRegistry;
        data["activityLocationName"] = this.activityLocationName;
        data["applicantId"] = this.applicantId;
        data["universityId"] = this.universityId;
        data["universityName"] = this.universityName;
        data["attendedInstitution"] = this.attendedInstitution;
        data["acceptedTitleId"] = this.acceptedTitleId;
        data["acceptedTitleText"] = this.acceptedTitleText;
        data["isAcceptKvkk"] = this.isAcceptKvkk;
        data["recordBy"] = this.recordBy;
        if (this.attendedActivities && this.attendedActivities.constructor === Array) {
            data["attendedActivities"] = [];
            for (let item of this.attendedActivities)
                data["attendedActivities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityParticipantDto {
    tcNo: number;
    name: string;
    lastName: string;
    email: string;
    mobilePhone: string;
    isEvaluatorSystemRegistry: boolean;
    activityLocationName: string;
    applicantId: number;
    universityId: number;
    universityName: string;
    attendedInstitution: string;
    acceptedTitleId: number;
    acceptedTitleText: string;
    isAcceptKvkk: boolean;
    recordBy: string;
    attendedActivities: AttendedActivityDto[];
    id: number;
}

export class ActivityManagerDto implements IActivityManagerDto {
    name: string;
    lastName: string;
    phone: string;
    email: string;
    activityId: number;
    id: number;

    constructor(data?: IActivityManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.activityId = data["activityId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityManagerDto {
        let result = new ActivityManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["activityId"] = this.activityId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityManagerDto {
    name: string;
    lastName: string;
    phone: string;
    email: string;
    activityId: number;
    id: number;
}

export class ActivitySectionDto implements IActivitySectionDto {
    name: string;
    description: string;
    beginTime: string;
    endTime: string;
    onlineJoinLink: string;
    hall: string;
    quota: number;
    isMainSection: boolean;
    activityLocationId: number;
    daySequence: number;
    speakers: ActivitySpeakerDto[];
    participants: ActivityParticipantDto[];
    id: number;

    constructor(data?: IActivitySectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.beginTime = data["beginTime"];
            this.endTime = data["endTime"];
            this.onlineJoinLink = data["onlineJoinLink"];
            this.hall = data["hall"];
            this.quota = data["quota"];
            this.isMainSection = data["isMainSection"];
            this.activityLocationId = data["activityLocationId"];
            this.daySequence = data["daySequence"];
            if (data["speakers"] && data["speakers"].constructor === Array) {
                this.speakers = [];
                for (let item of data["speakers"])
                    this.speakers.push(ActivitySpeakerDto.fromJS(item));
            }
            if (data["participants"] && data["participants"].constructor === Array) {
                this.participants = [];
                for (let item of data["participants"])
                    this.participants.push(ActivityParticipantDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivitySectionDto {
        let result = new ActivitySectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["beginTime"] = this.beginTime;
        data["endTime"] = this.endTime;
        data["onlineJoinLink"] = this.onlineJoinLink;
        data["hall"] = this.hall;
        data["quota"] = this.quota;
        data["isMainSection"] = this.isMainSection;
        data["activityLocationId"] = this.activityLocationId;
        data["daySequence"] = this.daySequence;
        if (this.speakers && this.speakers.constructor === Array) {
            data["speakers"] = [];
            for (let item of this.speakers)
                data["speakers"].push(item.toJSON());
        }
        if (this.participants && this.participants.constructor === Array) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivitySectionDto {
    name: string;
    description: string;
    beginTime: string;
    endTime: string;
    onlineJoinLink: string;
    hall: string;
    quota: number;
    isMainSection: boolean;
    activityLocationId: number;
    daySequence: number;
    speakers: ActivitySpeakerDto[];
    participants: ActivityParticipantDto[];
    id: number;
}

export class AttendedActivityDto implements IAttendedActivityDto {
    attendedActivityId: number;
    activityId: number;
    locationId: number;
    sections: ActivitySectionDto[];

    constructor(data?: IAttendedActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attendedActivityId = data["attendedActivityId"];
            this.activityId = data["activityId"];
            this.locationId = data["locationId"];
            if (data["sections"] && data["sections"].constructor === Array) {
                this.sections = [];
                for (let item of data["sections"])
                    this.sections.push(ActivitySectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttendedActivityDto {
        let result = new AttendedActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendedActivityId"] = this.attendedActivityId;
        data["activityId"] = this.activityId;
        data["locationId"] = this.locationId;
        if (this.sections && this.sections.constructor === Array) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAttendedActivityDto {
    attendedActivityId: number;
    activityId: number;
    locationId: number;
    sections: ActivitySectionDto[];
}

export class ActivitySpeakerDto implements IActivitySpeakerDto {
    acceptedTitleId: number;
    acceptedTitleText: string;
    name: string;
    lastName: string;
    profession: string;
    email: string;
    shortAbout: string;
    presentationTitle: string;
    isPublishSpeakerInfo: boolean;
    activityId: number;
    id: number;

    constructor(data?: IActivitySpeakerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.acceptedTitleId = data["acceptedTitleId"];
            this.acceptedTitleText = data["acceptedTitleText"];
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.profession = data["profession"];
            this.email = data["email"];
            this.shortAbout = data["shortAbout"];
            this.presentationTitle = data["presentationTitle"];
            this.isPublishSpeakerInfo = data["isPublishSpeakerInfo"];
            this.activityId = data["activityId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivitySpeakerDto {
        let result = new ActivitySpeakerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acceptedTitleId"] = this.acceptedTitleId;
        data["acceptedTitleText"] = this.acceptedTitleText;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["profession"] = this.profession;
        data["email"] = this.email;
        data["shortAbout"] = this.shortAbout;
        data["presentationTitle"] = this.presentationTitle;
        data["isPublishSpeakerInfo"] = this.isPublishSpeakerInfo;
        data["activityId"] = this.activityId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivitySpeakerDto {
    acceptedTitleId: number;
    acceptedTitleText: string;
    name: string;
    lastName: string;
    profession: string;
    email: string;
    shortAbout: string;
    presentationTitle: string;
    isPublishSpeakerInfo: boolean;
    activityId: number;
    id: number;
}

export class ListResultDtoOfActivityLocationDto implements IListResultDtoOfActivityLocationDto {
    items: ActivityLocationDto[];

    constructor(data?: IListResultDtoOfActivityLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ActivityLocationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfActivityLocationDto {
        let result = new ListResultDtoOfActivityLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfActivityLocationDto {
    items: ActivityLocationDto[];
}

export class ListResultDtoOfActivitySectionDto implements IListResultDtoOfActivitySectionDto {
    items: ActivitySectionDto[];

    constructor(data?: IListResultDtoOfActivitySectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ActivitySectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfActivitySectionDto {
        let result = new ListResultDtoOfActivitySectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfActivitySectionDto {
    items: ActivitySectionDto[];
}

export class ListResultDtoOfActivityManagerDto implements IListResultDtoOfActivityManagerDto {
    items: ActivityManagerDto[];

    constructor(data?: IListResultDtoOfActivityManagerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ActivityManagerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfActivityManagerDto {
        let result = new ListResultDtoOfActivityManagerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfActivityManagerDto {
    items: ActivityManagerDto[];
}

export class ListResultDtoOfActivitySpeakerDto implements IListResultDtoOfActivitySpeakerDto {
    items: ActivitySpeakerDto[];

    constructor(data?: IListResultDtoOfActivitySpeakerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ActivitySpeakerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfActivitySpeakerDto {
        let result = new ListResultDtoOfActivitySpeakerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfActivitySpeakerDto {
    items: ActivitySpeakerDto[];
}

export class PagedResultDtoOfActivityParticipantDto implements IPagedResultDtoOfActivityParticipantDto {
    totalCount: number;
    items: ActivityParticipantDto[];

    constructor(data?: IPagedResultDtoOfActivityParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ActivityParticipantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfActivityParticipantDto {
        let result = new PagedResultDtoOfActivityParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfActivityParticipantDto {
    totalCount: number;
    items: ActivityParticipantDto[];
}

export class ListResultDtoOfActivityParticipantDto implements IListResultDtoOfActivityParticipantDto {
    items: ActivityParticipantDto[];

    constructor(data?: IListResultDtoOfActivityParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ActivityParticipantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfActivityParticipantDto {
        let result = new ListResultDtoOfActivityParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfActivityParticipantDto {
    items: ActivityParticipantDto[];
}

export class ParticipantSectionRandomInput implements IParticipantSectionRandomInput {
    activityId: number;
    locationId: number;

    constructor(data?: IParticipantSectionRandomInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityId = data["activityId"];
            this.locationId = data["locationId"];
        }
    }

    static fromJS(data: any): ParticipantSectionRandomInput {
        let result = new ParticipantSectionRandomInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["locationId"] = this.locationId;
        return data; 
    }
}

export interface IParticipantSectionRandomInput {
    activityId: number;
    locationId: number;
}

export class ParticipantSectionInput implements IParticipantSectionInput {
    attendedActivityId: number;
    activityId: number;
    participantId: number;
    locationId: number;
    sectionId: number;
    addDrop: boolean;

    constructor(data?: IParticipantSectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attendedActivityId = data["attendedActivityId"];
            this.activityId = data["activityId"];
            this.participantId = data["participantId"];
            this.locationId = data["locationId"];
            this.sectionId = data["sectionId"];
            this.addDrop = data["addDrop"];
        }
    }

    static fromJS(data: any): ParticipantSectionInput {
        let result = new ParticipantSectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attendedActivityId"] = this.attendedActivityId;
        data["activityId"] = this.activityId;
        data["participantId"] = this.participantId;
        data["locationId"] = this.locationId;
        data["sectionId"] = this.sectionId;
        data["addDrop"] = this.addDrop;
        return data; 
    }
}

export interface IParticipantSectionInput {
    attendedActivityId: number;
    activityId: number;
    participantId: number;
    locationId: number;
    sectionId: number;
    addDrop: boolean;
}

export class ListResultDtoOfGetAcceptedTitleDto implements IListResultDtoOfGetAcceptedTitleDto {
    items: GetAcceptedTitleDto[];

    constructor(data?: IListResultDtoOfGetAcceptedTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAcceptedTitleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAcceptedTitleDto {
        let result = new ListResultDtoOfGetAcceptedTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAcceptedTitleDto {
    items: GetAcceptedTitleDto[];
}

export class GetAcceptedTitleDto implements IGetAcceptedTitleDto {
    title: string;
    type: GetAcceptedTitleDtoType;
    id: number;

    constructor(data?: IGetAcceptedTitleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetAcceptedTitleDto {
        let result = new GetAcceptedTitleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGetAcceptedTitleDto {
    title: string;
    type: GetAcceptedTitleDtoType;
    id: number;
}

export class ListResultDtoOfActivityTenantDto implements IListResultDtoOfActivityTenantDto {
    items: ActivityTenantDto[];

    constructor(data?: IListResultDtoOfActivityTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ActivityTenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfActivityTenantDto {
        let result = new ListResultDtoOfActivityTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfActivityTenantDto {
    items: ActivityTenantDto[];
}

export class ActivityTenantDto implements IActivityTenantDto {
    name: string;
    id: number;

    constructor(data?: IActivityTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityTenantDto {
        let result = new ActivityTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityTenantDto {
    name: string;
    id: number;
}

export class ListResultDtoOfActivityApplicantDto implements IListResultDtoOfActivityApplicantDto {
    items: ActivityApplicantDto[];

    constructor(data?: IListResultDtoOfActivityApplicantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ActivityApplicantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfActivityApplicantDto {
        let result = new ListResultDtoOfActivityApplicantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfActivityApplicantDto {
    items: ActivityApplicantDto[];
}

export class ActivityApplicantDto implements IActivityApplicantDto {
    title: number;
    titleText: string;
    name: string;
    lastName: string;
    activeEmail: string;
    tcNo: number;
    phone: string;
    id: number;

    constructor(data?: IActivityApplicantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.titleText = data["titleText"];
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.activeEmail = data["activeEmail"];
            this.tcNo = data["tcNo"];
            this.phone = data["phone"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ActivityApplicantDto {
        let result = new ActivityApplicantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["titleText"] = this.titleText;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["activeEmail"] = this.activeEmail;
        data["tcNo"] = this.tcNo;
        data["phone"] = this.phone;
        data["id"] = this.id;
        return data; 
    }
}

export interface IActivityApplicantDto {
    title: number;
    titleText: string;
    name: string;
    lastName: string;
    activeEmail: string;
    tcNo: number;
    phone: string;
    id: number;
}

export class FileDto implements IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data; 
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class PagedResultDtoOfAnnAnnouncementOutput implements IPagedResultDtoOfAnnAnnouncementOutput {
    totalCount: number;
    items: AnnAnnouncementOutput[];

    constructor(data?: IPagedResultDtoOfAnnAnnouncementOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(AnnAnnouncementOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAnnAnnouncementOutput {
        let result = new PagedResultDtoOfAnnAnnouncementOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAnnAnnouncementOutput {
    totalCount: number;
    items: AnnAnnouncementOutput[];
}

export class AnnAnnouncementOutput implements IAnnAnnouncementOutput {
    publishDate: moment.Moment;
    publishEndDate: moment.Moment;
    isActive: boolean;
    annType: string;
    annHeading: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IAnnAnnouncementOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.publishDate = data["publishDate"] ? moment(data["publishDate"].toString()) : <any>undefined;
            this.publishEndDate = data["publishEndDate"] ? moment(data["publishEndDate"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.annType = data["annType"];
            this.annHeading = data["annHeading"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnAnnouncementOutput {
        let result = new AnnAnnouncementOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["publishEndDate"] = this.publishEndDate ? this.publishEndDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["annType"] = this.annType;
        data["annHeading"] = this.annHeading;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAnnAnnouncementOutput {
    publishDate: moment.Moment;
    publishEndDate: moment.Moment;
    isActive: boolean;
    annType: string;
    annHeading: string;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CreateAnnAnnouncementInput implements ICreateAnnAnnouncementInput {
    publishDate: moment.Moment;
    publishEndDate: moment.Moment;
    isActive: boolean;
    annType: CreateAnnAnnouncementInputAnnType;
    announcementImageFiles: UploadAnnouncementFileDto[];
    announcementDetails: AnnouncementDetailInput[];
    id: number;

    constructor(data?: ICreateAnnAnnouncementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.publishDate = data["publishDate"] ? moment(data["publishDate"].toString()) : <any>undefined;
            this.publishEndDate = data["publishEndDate"] ? moment(data["publishEndDate"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.annType = data["annType"];
            if (data["announcementImageFiles"] && data["announcementImageFiles"].constructor === Array) {
                this.announcementImageFiles = [];
                for (let item of data["announcementImageFiles"])
                    this.announcementImageFiles.push(UploadAnnouncementFileDto.fromJS(item));
            }
            if (data["announcementDetails"] && data["announcementDetails"].constructor === Array) {
                this.announcementDetails = [];
                for (let item of data["announcementDetails"])
                    this.announcementDetails.push(AnnouncementDetailInput.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateAnnAnnouncementInput {
        let result = new CreateAnnAnnouncementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["publishEndDate"] = this.publishEndDate ? this.publishEndDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["annType"] = this.annType;
        if (this.announcementImageFiles && this.announcementImageFiles.constructor === Array) {
            data["announcementImageFiles"] = [];
            for (let item of this.announcementImageFiles)
                data["announcementImageFiles"].push(item.toJSON());
        }
        if (this.announcementDetails && this.announcementDetails.constructor === Array) {
            data["announcementDetails"] = [];
            for (let item of this.announcementDetails)
                data["announcementDetails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateAnnAnnouncementInput {
    publishDate: moment.Moment;
    publishEndDate: moment.Moment;
    isActive: boolean;
    annType: CreateAnnAnnouncementInputAnnType;
    announcementImageFiles: UploadAnnouncementFileDto[];
    announcementDetails: AnnouncementDetailInput[];
    id: number;
}

export class UploadAnnouncementFileDto implements IUploadAnnouncementFileDto {
    announcementId: number;
    fileId: string;
    fileName: string;
    contentType: string;
    size: number;
    path: string;

    constructor(data?: IUploadAnnouncementFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.announcementId = data["announcementId"];
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.contentType = data["contentType"];
            this.size = data["size"];
            this.path = data["path"];
        }
    }

    static fromJS(data: any): UploadAnnouncementFileDto {
        let result = new UploadAnnouncementFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["announcementId"] = this.announcementId;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        data["path"] = this.path;
        return data; 
    }
}

export interface IUploadAnnouncementFileDto {
    announcementId: number;
    fileId: string;
    fileName: string;
    contentType: string;
    size: number;
    path: string;
}

export class AnnouncementDetailInput implements IAnnouncementDetailInput {
    annHeading: string;
    annContent: string;
    language: string;
    announcementId: number;
    id: number;

    constructor(data?: IAnnouncementDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annHeading = data["annHeading"];
            this.annContent = data["annContent"];
            this.language = data["language"];
            this.announcementId = data["announcementId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnouncementDetailInput {
        let result = new AnnouncementDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annHeading"] = this.annHeading;
        data["annContent"] = this.annContent;
        data["language"] = this.language;
        data["announcementId"] = this.announcementId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAnnouncementDetailInput {
    annHeading: string;
    annContent: string;
    language: string;
    announcementId: number;
    id: number;
}

export class AnnAnnouncementEdit implements IAnnAnnouncementEdit {
    publishDate: moment.Moment;
    publishEndDate: moment.Moment;
    isActive: boolean;
    annType: AnnAnnouncementEditAnnType;
    announcementImageFiles: UploadAnnouncementFileDto[];
    announcementDetails: AnnouncementDetailInput[];
    id: number;

    constructor(data?: IAnnAnnouncementEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.publishDate = data["publishDate"] ? moment(data["publishDate"].toString()) : <any>undefined;
            this.publishEndDate = data["publishEndDate"] ? moment(data["publishEndDate"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.annType = data["annType"];
            if (data["announcementImageFiles"] && data["announcementImageFiles"].constructor === Array) {
                this.announcementImageFiles = [];
                for (let item of data["announcementImageFiles"])
                    this.announcementImageFiles.push(UploadAnnouncementFileDto.fromJS(item));
            }
            if (data["announcementDetails"] && data["announcementDetails"].constructor === Array) {
                this.announcementDetails = [];
                for (let item of data["announcementDetails"])
                    this.announcementDetails.push(AnnouncementDetailInput.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnAnnouncementEdit {
        let result = new AnnAnnouncementEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishDate"] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
        data["publishEndDate"] = this.publishEndDate ? this.publishEndDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["annType"] = this.annType;
        if (this.announcementImageFiles && this.announcementImageFiles.constructor === Array) {
            data["announcementImageFiles"] = [];
            for (let item of this.announcementImageFiles)
                data["announcementImageFiles"].push(item.toJSON());
        }
        if (this.announcementDetails && this.announcementDetails.constructor === Array) {
            data["announcementDetails"] = [];
            for (let item of this.announcementDetails)
                data["announcementDetails"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IAnnAnnouncementEdit {
    publishDate: moment.Moment;
    publishEndDate: moment.Moment;
    isActive: boolean;
    annType: AnnAnnouncementEditAnnType;
    announcementImageFiles: UploadAnnouncementFileDto[];
    announcementDetails: AnnouncementDetailInput[];
    id: number;
}

export class ApplicantLoginVm implements IApplicantLoginVm {
    email: string;
    password: string;
    rememberMe: boolean;

    constructor(data?: IApplicantLoginVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"];
            this.password = data["password"];
            this.rememberMe = data["rememberMe"];
        }
    }

    static fromJS(data: any): ApplicantLoginVm {
        let result = new ApplicantLoginVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["rememberMe"] = this.rememberMe;
        return data; 
    }
}

export interface IApplicantLoginVm {
    email: string;
    password: string;
    rememberMe: boolean;
}

export class ApplicantRegisterVm implements IApplicantRegisterVm {
    tcNo: number;
    email: string;
    password: string;
    confirmPassword: string;
    name: string;
    lastName: string;
    phoneNumber: string;

    constructor(data?: IApplicantRegisterVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tcNo = data["tcNo"];
            this.email = data["email"];
            this.password = data["password"];
            this.confirmPassword = data["confirmPassword"];
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.phoneNumber = data["phoneNumber"];
        }
    }

    static fromJS(data: any): ApplicantRegisterVm {
        let result = new ApplicantRegisterVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tcNo"] = this.tcNo;
        data["email"] = this.email;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }
}

export interface IApplicantRegisterVm {
    tcNo: number;
    email: string;
    password: string;
    confirmPassword: string;
    name: string;
    lastName: string;
    phoneNumber: string;
}

export class ApplicantDto implements IApplicantDto {
    name: string;
    lastName: string;
    activeEmail: string;
    tcNo: number;
    gender: string;
    phone: string;
    secret: string;
    id: number;

    constructor(data?: IApplicantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.activeEmail = data["activeEmail"];
            this.tcNo = data["tcNo"];
            this.gender = data["gender"];
            this.phone = data["phone"];
            this.secret = data["secret"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ApplicantDto {
        let result = new ApplicantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["activeEmail"] = this.activeEmail;
        data["tcNo"] = this.tcNo;
        data["gender"] = this.gender;
        data["phone"] = this.phone;
        data["secret"] = this.secret;
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplicantDto {
    name: string;
    lastName: string;
    activeEmail: string;
    tcNo: number;
    gender: string;
    phone: string;
    secret: string;
    id: number;
}

export class ApplicantDetailedDto implements IApplicantDetailedDto {
    name: string;
    lastName: string;
    tcNo: number;
    gender: string;
    phone: string;
    reviewApplication: ReviewApplicationDto;
    id: number;

    constructor(data?: IApplicantDetailedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.tcNo = data["tcNo"];
            this.gender = data["gender"];
            this.phone = data["phone"];
            this.reviewApplication = data["reviewApplication"] ? ReviewApplicationDto.fromJS(data["reviewApplication"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ApplicantDetailedDto {
        let result = new ApplicantDetailedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["tcNo"] = this.tcNo;
        data["gender"] = this.gender;
        data["phone"] = this.phone;
        data["reviewApplication"] = this.reviewApplication ? this.reviewApplication.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplicantDetailedDto {
    name: string;
    lastName: string;
    tcNo: number;
    gender: string;
    phone: string;
    reviewApplication: ReviewApplicationDto;
    id: number;
}

export class ReviewApplicationDto implements IReviewApplicationDto {
    applicationStatus: ReviewApplicationDtoApplicationStatus;
    titleId: number;
    titleName: string;
    termId: number;
    termName: string;
    id: number;

    constructor(data?: IReviewApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicationStatus = data["applicationStatus"];
            this.titleId = data["titleId"];
            this.titleName = data["titleName"];
            this.termId = data["termId"];
            this.termName = data["termName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReviewApplicationDto {
        let result = new ReviewApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationStatus"] = this.applicationStatus;
        data["titleId"] = this.titleId;
        data["titleName"] = this.titleName;
        data["termId"] = this.termId;
        data["termName"] = this.termName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IReviewApplicationDto {
    applicationStatus: ReviewApplicationDtoApplicationStatus;
    titleId: number;
    titleName: string;
    termId: number;
    termName: string;
    id: number;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[];

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[];
}

export class AuditLogListDto implements IAuditLogListDto {
    userId: number;
    userName: string;
    impersonatorTenantId: number;
    impersonatorUserId: number;
    serviceName: string;
    methodName: string;
    parameters: string;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string;
    clientName: string;
    browserInfo: string;
    exception: string;
    customData: string;
    id: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.impersonatorTenantId = data["impersonatorTenantId"];
            this.impersonatorUserId = data["impersonatorUserId"];
            this.serviceName = data["serviceName"];
            this.methodName = data["methodName"];
            this.parameters = data["parameters"];
            this.executionTime = data["executionTime"] ? moment(data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = data["executionDuration"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.exception = data["exception"];
            this.customData = data["customData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAuditLogListDto {
    userId: number;
    userName: string;
    impersonatorTenantId: number;
    impersonatorUserId: number;
    serviceName: string;
    methodName: string;
    parameters: string;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string;
    clientName: string;
    browserInfo: string;
    exception: string;
    customData: string;
    id: number;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items: CacheDto[];

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[];
}

export class CacheDto implements ICacheDto {
    name: string;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ICacheDto {
    name: string;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id: string;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfString {
    id: string;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment;
    friends: FriendDto[];

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serverTime = data["serverTime"] ? moment(data["serverTime"].toString()) : <any>undefined;
            if (data["friends"] && data["friends"].constructor === Array) {
                this.friends = [];
                for (let item of data["friends"])
                    this.friends.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : <any>undefined;
        if (this.friends && this.friends.constructor === Array) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment;
    friends: FriendDto[];
}

export class FriendDto implements IFriendDto {
    friendUserId: number;
    friendTenantId: number;
    friendUserName: string;
    friendTenancyName: string;
    friendProfilePictureId: string;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendDtoState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.friendUserId = data["friendUserId"];
            this.friendTenantId = data["friendTenantId"];
            this.friendUserName = data["friendUserName"];
            this.friendTenancyName = data["friendTenancyName"];
            this.friendProfilePictureId = data["friendProfilePictureId"];
            this.unreadMessageCount = data["unreadMessageCount"];
            this.isOnline = data["isOnline"];
            this.state = data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data; 
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number;
    friendUserName: string;
    friendTenancyName: string;
    friendProfilePictureId: string;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendDtoState;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[];

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[];
}

export class ChatMessageDto implements IChatMessageDto {
    userId: number;
    tenantId: number;
    targetUserId: number;
    targetTenantId: number;
    side: ChatMessageDtoSide;
    readState: ChatMessageDtoReadState;
    receiverReadState: ChatMessageDtoReceiverReadState;
    message: string;
    creationTime: moment.Moment;
    sharedMessageId: string;
    id: number;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.targetUserId = data["targetUserId"];
            this.targetTenantId = data["targetTenantId"];
            this.side = data["side"];
            this.readState = data["readState"];
            this.receiverReadState = data["receiverReadState"];
            this.message = data["message"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.sharedMessageId = data["sharedMessageId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IChatMessageDto {
    userId: number;
    tenantId: number;
    targetUserId: number;
    targetTenantId: number;
    side: ChatMessageDtoSide;
    readState: ChatMessageDtoReadState;
    receiverReadState: ChatMessageDtoReceiverReadState;
    message: string;
    creationTime: moment.Moment;
    sharedMessageId: string;
    id: number;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number;
    userId: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number;
    userId: number;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[];

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[];
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree: boolean;
    value: string;
    displayText: string;
    isSelected: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isFree = data["isFree"];
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean;
    value: string;
    displayText: string;
    isSelected: boolean;
}

export class FindUsersInput implements IFindUsersInput {
    tenantId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindUsersInput {
    tenantId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[];

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[];
}

export class NameValueDto implements INameValueDto {
    name: string;
    value: string;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueDto {
    name: string;
    value: string;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name: string;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string;
}

export class ListResultDtoOfGetDataTextsByCategoryOutput implements IListResultDtoOfGetDataTextsByCategoryOutput {
    items: GetDataTextsByCategoryOutput[];

    constructor(data?: IListResultDtoOfGetDataTextsByCategoryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetDataTextsByCategoryOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetDataTextsByCategoryOutput {
        let result = new ListResultDtoOfGetDataTextsByCategoryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetDataTextsByCategoryOutput {
    items: GetDataTextsByCategoryOutput[];
}

export class GetDataTextsByCategoryOutput implements IGetDataTextsByCategoryOutput {
    key: string;
    value: string;
    id: number;

    constructor(data?: IGetDataTextsByCategoryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetDataTextsByCategoryOutput {
        let result = new GetDataTextsByCategoryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGetDataTextsByCategoryOutput {
    key: string;
    value: string;
    id: number;
}

export class GetValueOfKeyByCultureOutput implements IGetValueOfKeyByCultureOutput {
    value: string;

    constructor(data?: IGetValueOfKeyByCultureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
        }
    }

    static fromJS(data: any): GetValueOfKeyByCultureOutput {
        let result = new GetValueOfKeyByCultureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data; 
    }
}

export interface IGetValueOfKeyByCultureOutput {
    value: string;
}

export class ListResultDtoOfGetValuesOfKeyOutput implements IListResultDtoOfGetValuesOfKeyOutput {
    items: GetValuesOfKeyOutput[];

    constructor(data?: IListResultDtoOfGetValuesOfKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetValuesOfKeyOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetValuesOfKeyOutput {
        let result = new ListResultDtoOfGetValuesOfKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetValuesOfKeyOutput {
    items: GetValuesOfKeyOutput[];
}

export class GetValuesOfKeyOutput implements IGetValuesOfKeyOutput {
    culture: string;
    value: string;
    id: number;

    constructor(data?: IGetValuesOfKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.culture = data["culture"];
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetValuesOfKeyOutput {
        let result = new GetValuesOfKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["culture"] = this.culture;
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGetValuesOfKeyOutput {
    culture: string;
    value: string;
    id: number;
}

export class PagedResultDtoOfDataTextListDto implements IPagedResultDtoOfDataTextListDto {
    totalCount: number;
    items: DataTextListDto[];

    constructor(data?: IPagedResultDtoOfDataTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(DataTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDataTextListDto {
        let result = new PagedResultDtoOfDataTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfDataTextListDto {
    totalCount: number;
    items: DataTextListDto[];
}

export class DataTextListDto implements IDataTextListDto {
    categoryType: DataTextListDtoCategoryType;
    categoryTypeStr: string;
    key: string;
    baseValue: string;
    targetValue: string;

    constructor(data?: IDataTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryType = data["categoryType"];
            this.categoryTypeStr = data["categoryTypeStr"];
            this.key = data["key"];
            this.baseValue = data["baseValue"];
            this.targetValue = data["targetValue"];
        }
    }

    static fromJS(data: any): DataTextListDto {
        let result = new DataTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryType"] = this.categoryType;
        data["categoryTypeStr"] = this.categoryTypeStr;
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data; 
    }
}

export interface IDataTextListDto {
    categoryType: DataTextListDtoCategoryType;
    categoryTypeStr: string;
    key: string;
    baseValue: string;
    targetValue: string;
}

export class CreateDataTextInput implements ICreateDataTextInput {
    culture: string;
    key: string;
    value: string;
    categoryTypeValue: number;

    constructor(data?: ICreateDataTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.culture = data["culture"];
            this.key = data["key"];
            this.value = data["value"];
            this.categoryTypeValue = data["categoryTypeValue"];
        }
    }

    static fromJS(data: any): CreateDataTextInput {
        let result = new CreateDataTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["culture"] = this.culture;
        data["key"] = this.key;
        data["value"] = this.value;
        data["categoryTypeValue"] = this.categoryTypeValue;
        return data; 
    }
}

export interface ICreateDataTextInput {
    culture: string;
    key: string;
    value: string;
    categoryTypeValue: number;
}

export class GetDataTextForEditOutput implements IGetDataTextForEditOutput {
    dataKey: string;
    baseValue: string;
    targetValue: string;
    categoryTypeValue: number;

    constructor(data?: IGetDataTextForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataKey = data["dataKey"];
            this.baseValue = data["baseValue"];
            this.targetValue = data["targetValue"];
            this.categoryTypeValue = data["categoryTypeValue"];
        }
    }

    static fromJS(data: any): GetDataTextForEditOutput {
        let result = new GetDataTextForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataKey"] = this.dataKey;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        data["categoryTypeValue"] = this.categoryTypeValue;
        return data; 
    }
}

export interface IGetDataTextForEditOutput {
    dataKey: string;
    baseValue: string;
    targetValue: string;
    categoryTypeValue: number;
}

export class UpdateDataTextInput implements IUpdateDataTextInput {
    categoryTypeValue: number;
    languageName: string;
    sourceName: string;
    key: string;
    value: string;

    constructor(data?: IUpdateDataTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.categoryTypeValue = data["categoryTypeValue"];
            this.languageName = data["languageName"];
            this.sourceName = data["sourceName"];
            this.key = data["key"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): UpdateDataTextInput {
        let result = new UpdateDataTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryTypeValue"] = this.categoryTypeValue;
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }
}

export interface IUpdateDataTextInput {
    categoryTypeValue: number;
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class UpdateDataKeyInput implements IUpdateDataKeyInput {
    key: string;
    categoryTypeValue: number;

    constructor(data?: IUpdateDataKeyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.categoryTypeValue = data["categoryTypeValue"];
        }
    }

    static fromJS(data: any): UpdateDataKeyInput {
        let result = new UpdateDataKeyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["categoryTypeValue"] = this.categoryTypeValue;
        return data; 
    }
}

export interface IUpdateDataKeyInput {
    key: string;
    categoryTypeValue: number;
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString: string;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateString = data["dateString"];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data; 
    }
}

export interface IDateToStringOutput {
    dateString: string;
}

export class NameValueOfString implements INameValueOfString {
    name: string;
    value: string;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValueOfString {
    name: string;
    value: string;
}

export class StringOutput implements IStringOutput {
    output: string;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.output = data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data; 
    }
}

export interface IStringOutput {
    output: string;
}

export class ListResultDtoOfDistanceEducationResultOutput implements IListResultDtoOfDistanceEducationResultOutput {
    items: DistanceEducationResultOutput[];

    constructor(data?: IListResultDtoOfDistanceEducationResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(DistanceEducationResultOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDistanceEducationResultOutput {
        let result = new ListResultDtoOfDistanceEducationResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfDistanceEducationResultOutput {
    items: DistanceEducationResultOutput[];
}

export class DistanceEducationResultOutput implements IDistanceEducationResultOutput {
    criteriaId: number;
    criteria: string;
    subCriteriaId: number;
    subCriteria: string;
    universityAnswerId: number;
    universityAnswer: string;
    universityMaturityLevelId: number;
    universityMaturityLevelSequence: number;
    universityMaturityLevel: string;
    feedbackAnswerId: number;
    feedbackAnswer: string;
    feedbackMaturityLevelId: number;
    feedbackMaturityLevelSequence: number;
    feedbackMaturityLevel: string;
    proofFiles: string;
    maturityLevels: MaturityLevelDto[];

    constructor(data?: IDistanceEducationResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.criteriaId = data["criteriaId"];
            this.criteria = data["criteria"];
            this.subCriteriaId = data["subCriteriaId"];
            this.subCriteria = data["subCriteria"];
            this.universityAnswerId = data["universityAnswerId"];
            this.universityAnswer = data["universityAnswer"];
            this.universityMaturityLevelId = data["universityMaturityLevelId"];
            this.universityMaturityLevelSequence = data["universityMaturityLevelSequence"];
            this.universityMaturityLevel = data["universityMaturityLevel"];
            this.feedbackAnswerId = data["feedbackAnswerId"];
            this.feedbackAnswer = data["feedbackAnswer"];
            this.feedbackMaturityLevelId = data["feedbackMaturityLevelId"];
            this.feedbackMaturityLevelSequence = data["feedbackMaturityLevelSequence"];
            this.feedbackMaturityLevel = data["feedbackMaturityLevel"];
            this.proofFiles = data["proofFiles"];
            if (data["maturityLevels"] && data["maturityLevels"].constructor === Array) {
                this.maturityLevels = [];
                for (let item of data["maturityLevels"])
                    this.maturityLevels.push(MaturityLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DistanceEducationResultOutput {
        let result = new DistanceEducationResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criteriaId"] = this.criteriaId;
        data["criteria"] = this.criteria;
        data["subCriteriaId"] = this.subCriteriaId;
        data["subCriteria"] = this.subCriteria;
        data["universityAnswerId"] = this.universityAnswerId;
        data["universityAnswer"] = this.universityAnswer;
        data["universityMaturityLevelId"] = this.universityMaturityLevelId;
        data["universityMaturityLevelSequence"] = this.universityMaturityLevelSequence;
        data["universityMaturityLevel"] = this.universityMaturityLevel;
        data["feedbackAnswerId"] = this.feedbackAnswerId;
        data["feedbackAnswer"] = this.feedbackAnswer;
        data["feedbackMaturityLevelId"] = this.feedbackMaturityLevelId;
        data["feedbackMaturityLevelSequence"] = this.feedbackMaturityLevelSequence;
        data["feedbackMaturityLevel"] = this.feedbackMaturityLevel;
        data["proofFiles"] = this.proofFiles;
        if (this.maturityLevels && this.maturityLevels.constructor === Array) {
            data["maturityLevels"] = [];
            for (let item of this.maturityLevels)
                data["maturityLevels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDistanceEducationResultOutput {
    criteriaId: number;
    criteria: string;
    subCriteriaId: number;
    subCriteria: string;
    universityAnswerId: number;
    universityAnswer: string;
    universityMaturityLevelId: number;
    universityMaturityLevelSequence: number;
    universityMaturityLevel: string;
    feedbackAnswerId: number;
    feedbackAnswer: string;
    feedbackMaturityLevelId: number;
    feedbackMaturityLevelSequence: number;
    feedbackMaturityLevel: string;
    proofFiles: string;
    maturityLevels: MaturityLevelDto[];
}

export class MaturityLevelDto implements IMaturityLevelDto {
    name: string;
    sequenceNo: number;
    nameKey: string;
    evaluationFormId: number;
    evaluationFormName: string;
    weight: number;
    isDistanceEducation: boolean;
    id: number;

    constructor(data?: IMaturityLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.sequenceNo = data["sequenceNo"];
            this.nameKey = data["nameKey"];
            this.evaluationFormId = data["evaluationFormId"];
            this.evaluationFormName = data["evaluationFormName"];
            this.weight = data["weight"];
            this.isDistanceEducation = data["isDistanceEducation"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MaturityLevelDto {
        let result = new MaturityLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sequenceNo"] = this.sequenceNo;
        data["nameKey"] = this.nameKey;
        data["evaluationFormId"] = this.evaluationFormId;
        data["evaluationFormName"] = this.evaluationFormName;
        data["weight"] = this.weight;
        data["isDistanceEducation"] = this.isDistanceEducation;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMaturityLevelDto {
    name: string;
    sequenceNo: number;
    nameKey: string;
    evaluationFormId: number;
    evaluationFormName: string;
    weight: number;
    isDistanceEducation: boolean;
    id: number;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items: EditionListDto[];

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[];
}

export class EditionListDto implements IEditionListDto {
    name: string;
    displayName: string;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditionListDto {
    name: string;
    displayName: string;
    creationTime: moment.Moment;
    id: number;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
    features: FlatFeatureDto[];

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : <any>undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (let item of data["features"])
                    this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
    features: FlatFeatureDto[];
}

export class EditionEditDto implements IEditionEditDto {
    id: number;
    displayName: string;
    monthlyPrice: number;
    annualPrice: number;
    trialDayCount: number;
    waitingDayAfterExpire: number;
    expiringEditionId: number;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data; 
    }
}

export interface IEditionEditDto {
    id: number;
    displayName: string;
    monthlyPrice: number;
    annualPrice: number;
    trialDayCount: number;
    waitingDayAfterExpire: number;
    expiringEditionId: number;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    defaultValue: string;
    inputType: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? FeatureInputTypeDto.fromJS(data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFlatFeatureDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    defaultValue: string;
    inputType: FeatureInputTypeDto;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name: string;
    attributes: { [key: string] : any; };
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
            this.itemSource = data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFeatureInputTypeDto {
    name: string;
    attributes: { [key: string] : any; };
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export class IValueValidator implements IIValueValidator {
    name: string;
    attributes: { [key: string] : any; };

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        return data; 
    }
}

export interface IIValueValidator {
    name: string;
    attributes: { [key: string] : any; };
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[];

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[];
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value: string;
    displayText: string;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data; 
    }
}

export interface ILocalizableComboboxItemDto {
    value: string;
    displayText: string;
}

export class CreateOrUpdateEditionDto implements ICreateOrUpdateEditionDto {
    edition: EditionEditDto = new EditionEditDto();
    featureValues: NameValueDto[] = [];

    constructor(data?: ICreateOrUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : new EditionEditDto();
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEditionDto {
        let result = new CreateOrUpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateOrUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class ListResultDtoOfEvaluatedUniversityOutput implements IListResultDtoOfEvaluatedUniversityOutput {
    items: EvaluatedUniversityOutput[];

    constructor(data?: IListResultDtoOfEvaluatedUniversityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EvaluatedUniversityOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEvaluatedUniversityOutput {
        let result = new ListResultDtoOfEvaluatedUniversityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEvaluatedUniversityOutput {
    items: EvaluatedUniversityOutput[];
}

export class EvaluatedUniversityOutput implements IEvaluatedUniversityOutput {
    universityId: number;
    universityName: string;
    universityCode: string;
    termId: number;
    teamId: number;
    evaluationBeginDate: moment.Moment;
    evaluationEndDate: moment.Moment;
    fieldVisitDate: moment.Moment;
    fieldVisitEndDate: moment.Moment;
    preFieldVisitDate: moment.Moment;
    isDraftSent: boolean;

    constructor(data?: IEvaluatedUniversityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.universityId = data["universityId"];
            this.universityName = data["universityName"];
            this.universityCode = data["universityCode"];
            this.termId = data["termId"];
            this.teamId = data["teamId"];
            this.evaluationBeginDate = data["evaluationBeginDate"] ? moment(data["evaluationBeginDate"].toString()) : <any>undefined;
            this.evaluationEndDate = data["evaluationEndDate"] ? moment(data["evaluationEndDate"].toString()) : <any>undefined;
            this.fieldVisitDate = data["fieldVisitDate"] ? moment(data["fieldVisitDate"].toString()) : <any>undefined;
            this.fieldVisitEndDate = data["fieldVisitEndDate"] ? moment(data["fieldVisitEndDate"].toString()) : <any>undefined;
            this.preFieldVisitDate = data["preFieldVisitDate"] ? moment(data["preFieldVisitDate"].toString()) : <any>undefined;
            this.isDraftSent = data["isDraftSent"];
        }
    }

    static fromJS(data: any): EvaluatedUniversityOutput {
        let result = new EvaluatedUniversityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityId"] = this.universityId;
        data["universityName"] = this.universityName;
        data["universityCode"] = this.universityCode;
        data["termId"] = this.termId;
        data["teamId"] = this.teamId;
        data["evaluationBeginDate"] = this.evaluationBeginDate ? this.evaluationBeginDate.toISOString() : <any>undefined;
        data["evaluationEndDate"] = this.evaluationEndDate ? this.evaluationEndDate.toISOString() : <any>undefined;
        data["fieldVisitDate"] = this.fieldVisitDate ? this.fieldVisitDate.toISOString() : <any>undefined;
        data["fieldVisitEndDate"] = this.fieldVisitEndDate ? this.fieldVisitEndDate.toISOString() : <any>undefined;
        data["preFieldVisitDate"] = this.preFieldVisitDate ? this.preFieldVisitDate.toISOString() : <any>undefined;
        data["isDraftSent"] = this.isDraftSent;
        return data; 
    }
}

export interface IEvaluatedUniversityOutput {
    universityId: number;
    universityName: string;
    universityCode: string;
    termId: number;
    teamId: number;
    evaluationBeginDate: moment.Moment;
    evaluationEndDate: moment.Moment;
    fieldVisitDate: moment.Moment;
    fieldVisitEndDate: moment.Moment;
    preFieldVisitDate: moment.Moment;
    isDraftSent: boolean;
}

export class EvaluatedUniversityInput implements IEvaluatedUniversityInput {
    universityId: number;
    termId: number;

    constructor(data?: IEvaluatedUniversityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.universityId = data["universityId"];
            this.termId = data["termId"];
        }
    }

    static fromJS(data: any): EvaluatedUniversityInput {
        let result = new EvaluatedUniversityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityId"] = this.universityId;
        data["termId"] = this.termId;
        return data; 
    }
}

export interface IEvaluatedUniversityInput {
    universityId: number;
    termId: number;
}

export class ListResultDtoOfEvaluationFormDto implements IListResultDtoOfEvaluationFormDto {
    items: EvaluationFormDto[];

    constructor(data?: IListResultDtoOfEvaluationFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EvaluationFormDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEvaluationFormDto {
        let result = new ListResultDtoOfEvaluationFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEvaluationFormDto {
    items: EvaluationFormDto[];
}

export class EvaluationFormDto implements IEvaluationFormDto {
    parentId: number;
    grandParentId: number;
    title: string;
    isEditor: boolean;
    isActive: boolean;
    help: string;
    sequenceNo: number;
    depth: number;
    termId: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    matchEvaluationFormId: number;
    isDistanceEducationReport: boolean;
    thirdLevelForm: EvaluationFormWithAnswerDto[];
    id: number;

    constructor(data?: IEvaluationFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.grandParentId = data["grandParentId"];
            this.title = data["title"];
            this.isEditor = data["isEditor"];
            this.isActive = data["isActive"];
            this.help = data["help"];
            this.sequenceNo = data["sequenceNo"];
            this.depth = data["depth"];
            this.termId = data["termId"];
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            this.matchEvaluationFormId = data["matchEvaluationFormId"];
            this.isDistanceEducationReport = data["isDistanceEducationReport"];
            if (data["thirdLevelForm"] && data["thirdLevelForm"].constructor === Array) {
                this.thirdLevelForm = [];
                for (let item of data["thirdLevelForm"])
                    this.thirdLevelForm.push(EvaluationFormWithAnswerDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvaluationFormDto {
        let result = new EvaluationFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["grandParentId"] = this.grandParentId;
        data["title"] = this.title;
        data["isEditor"] = this.isEditor;
        data["isActive"] = this.isActive;
        data["help"] = this.help;
        data["sequenceNo"] = this.sequenceNo;
        data["depth"] = this.depth;
        data["termId"] = this.termId;
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        data["matchEvaluationFormId"] = this.matchEvaluationFormId;
        data["isDistanceEducationReport"] = this.isDistanceEducationReport;
        if (this.thirdLevelForm && this.thirdLevelForm.constructor === Array) {
            data["thirdLevelForm"] = [];
            for (let item of this.thirdLevelForm)
                data["thirdLevelForm"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvaluationFormDto {
    parentId: number;
    grandParentId: number;
    title: string;
    isEditor: boolean;
    isActive: boolean;
    help: string;
    sequenceNo: number;
    depth: number;
    termId: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    matchEvaluationFormId: number;
    isDistanceEducationReport: boolean;
    thirdLevelForm: EvaluationFormWithAnswerDto[];
    id: number;
}

export class EvaluationFormWithAnswerDto implements IEvaluationFormWithAnswerDto {
    parentId: number;
    title: string;
    isEditor: boolean;
    isActive: boolean;
    help_Help: string;
    help_EvidenceExamples: string;
    insitutionalProof: string;
    improvementProof: string;
    sequenceNo: number;
    matchEvaluationFormId: number;
    answer: FormAnswerDto;
    isIntroduction: boolean;
    isConclusion: boolean;
    maturityLevels: MaturityLevelDto[];
    id: number;

    constructor(data?: IEvaluationFormWithAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.isEditor = data["isEditor"];
            this.isActive = data["isActive"];
            this.help_Help = data["help_Help"];
            this.help_EvidenceExamples = data["help_EvidenceExamples"];
            this.insitutionalProof = data["insitutionalProof"];
            this.improvementProof = data["improvementProof"];
            this.sequenceNo = data["sequenceNo"];
            this.matchEvaluationFormId = data["matchEvaluationFormId"];
            this.answer = data["answer"] ? FormAnswerDto.fromJS(data["answer"]) : <any>undefined;
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            if (data["maturityLevels"] && data["maturityLevels"].constructor === Array) {
                this.maturityLevels = [];
                for (let item of data["maturityLevels"])
                    this.maturityLevels.push(MaturityLevelDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvaluationFormWithAnswerDto {
        let result = new EvaluationFormWithAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["isEditor"] = this.isEditor;
        data["isActive"] = this.isActive;
        data["help_Help"] = this.help_Help;
        data["help_EvidenceExamples"] = this.help_EvidenceExamples;
        data["insitutionalProof"] = this.insitutionalProof;
        data["improvementProof"] = this.improvementProof;
        data["sequenceNo"] = this.sequenceNo;
        data["matchEvaluationFormId"] = this.matchEvaluationFormId;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        if (this.maturityLevels && this.maturityLevels.constructor === Array) {
            data["maturityLevels"] = [];
            for (let item of this.maturityLevels)
                data["maturityLevels"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvaluationFormWithAnswerDto {
    parentId: number;
    title: string;
    isEditor: boolean;
    isActive: boolean;
    help_Help: string;
    help_EvidenceExamples: string;
    insitutionalProof: string;
    improvementProof: string;
    sequenceNo: number;
    matchEvaluationFormId: number;
    answer: FormAnswerDto;
    isIntroduction: boolean;
    isConclusion: boolean;
    maturityLevels: MaturityLevelDto[];
    id: number;
}

export class FormAnswerDto implements IFormAnswerDto {
    evaluationFormId: number;
    year: number;
    isSummary: boolean;
    body: string;
    criteriaId: number;
    maturityLevelId: number;
    maturityLevelText: string;
    extra: string;
    hasActiveEditor: boolean;
    proofFilesCount: number;
    insitutionalProofFilesCount: number;
    improvementProofFilesCount: number;
    id: number;

    constructor(data?: IFormAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evaluationFormId = data["evaluationFormId"];
            this.year = data["year"];
            this.isSummary = data["isSummary"];
            this.body = data["body"];
            this.criteriaId = data["criteriaId"];
            this.maturityLevelId = data["maturityLevelId"];
            this.maturityLevelText = data["maturityLevelText"];
            this.extra = data["extra"];
            this.hasActiveEditor = data["hasActiveEditor"];
            this.proofFilesCount = data["proofFilesCount"];
            this.insitutionalProofFilesCount = data["insitutionalProofFilesCount"];
            this.improvementProofFilesCount = data["improvementProofFilesCount"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FormAnswerDto {
        let result = new FormAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationFormId"] = this.evaluationFormId;
        data["year"] = this.year;
        data["isSummary"] = this.isSummary;
        data["body"] = this.body;
        data["criteriaId"] = this.criteriaId;
        data["maturityLevelId"] = this.maturityLevelId;
        data["maturityLevelText"] = this.maturityLevelText;
        data["extra"] = this.extra;
        data["hasActiveEditor"] = this.hasActiveEditor;
        data["proofFilesCount"] = this.proofFilesCount;
        data["insitutionalProofFilesCount"] = this.insitutionalProofFilesCount;
        data["improvementProofFilesCount"] = this.improvementProofFilesCount;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFormAnswerDto {
    evaluationFormId: number;
    year: number;
    isSummary: boolean;
    body: string;
    criteriaId: number;
    maturityLevelId: number;
    maturityLevelText: string;
    extra: string;
    hasActiveEditor: boolean;
    proofFilesCount: number;
    insitutionalProofFilesCount: number;
    improvementProofFilesCount: number;
    id: number;
}

export class PagedResultDtoOfEvaluationFormDto implements IPagedResultDtoOfEvaluationFormDto {
    totalCount: number;
    items: EvaluationFormDto[];

    constructor(data?: IPagedResultDtoOfEvaluationFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EvaluationFormDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEvaluationFormDto {
        let result = new PagedResultDtoOfEvaluationFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfEvaluationFormDto {
    totalCount: number;
    items: EvaluationFormDto[];
}

export class CreateOrUpdateEvaluationFormDto implements ICreateOrUpdateEvaluationFormDto {
    parentId: number;
    title: string;
    nameKey: string;
    isEditor: boolean;
    isActive: boolean;
    help: string;
    sequenceNo: number;
    termId: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    isDistanceEducationReport: boolean;
    id: number;

    constructor(data?: ICreateOrUpdateEvaluationFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.nameKey = data["nameKey"];
            this.isEditor = data["isEditor"];
            this.isActive = data["isActive"];
            this.help = data["help"];
            this.sequenceNo = data["sequenceNo"];
            this.termId = data["termId"];
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            this.isDistanceEducationReport = data["isDistanceEducationReport"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateEvaluationFormDto {
        let result = new CreateOrUpdateEvaluationFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["nameKey"] = this.nameKey;
        data["isEditor"] = this.isEditor;
        data["isActive"] = this.isActive;
        data["help"] = this.help;
        data["sequenceNo"] = this.sequenceNo;
        data["termId"] = this.termId;
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        data["isDistanceEducationReport"] = this.isDistanceEducationReport;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrUpdateEvaluationFormDto {
    parentId: number;
    title: string;
    nameKey: string;
    isEditor: boolean;
    isActive: boolean;
    help: string;
    sequenceNo: number;
    termId: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    isDistanceEducationReport: boolean;
    id: number;
}

export class ListResultDtoOfEvaluationCriteriaDto implements IListResultDtoOfEvaluationCriteriaDto {
    items: EvaluationCriteriaDto[];

    constructor(data?: IListResultDtoOfEvaluationCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EvaluationCriteriaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEvaluationCriteriaDto {
        let result = new ListResultDtoOfEvaluationCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEvaluationCriteriaDto {
    items: EvaluationCriteriaDto[];
}

export class EvaluationCriteriaDto implements IEvaluationCriteriaDto {
    description: string;
    id: number;

    constructor(data?: IEvaluationCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvaluationCriteriaDto {
        let result = new EvaluationCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvaluationCriteriaDto {
    description: string;
    id: number;
}

export class ListResultDtoOfEvaluationFormSequenceZeroDto implements IListResultDtoOfEvaluationFormSequenceZeroDto {
    items: EvaluationFormSequenceZeroDto[];

    constructor(data?: IListResultDtoOfEvaluationFormSequenceZeroDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EvaluationFormSequenceZeroDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEvaluationFormSequenceZeroDto {
        let result = new ListResultDtoOfEvaluationFormSequenceZeroDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEvaluationFormSequenceZeroDto {
    items: EvaluationFormSequenceZeroDto[];
}

export class EvaluationFormSequenceZeroDto implements IEvaluationFormSequenceZeroDto {
    title: string;
    sequenceNo: number;
    helpAndProof: HelpAndProofDto[];
    id: number;

    constructor(data?: IEvaluationFormSequenceZeroDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.sequenceNo = data["sequenceNo"];
            if (data["helpAndProof"] && data["helpAndProof"].constructor === Array) {
                this.helpAndProof = [];
                for (let item of data["helpAndProof"])
                    this.helpAndProof.push(HelpAndProofDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvaluationFormSequenceZeroDto {
        let result = new EvaluationFormSequenceZeroDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["sequenceNo"] = this.sequenceNo;
        if (this.helpAndProof && this.helpAndProof.constructor === Array) {
            data["helpAndProof"] = [];
            for (let item of this.helpAndProof)
                data["helpAndProof"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvaluationFormSequenceZeroDto {
    title: string;
    sequenceNo: number;
    helpAndProof: HelpAndProofDto[];
    id: number;
}

export class HelpAndProofDto implements IHelpAndProofDto {
    nameKey: string;
    description: string;
    evlFormHelpAndProofType: HelpAndProofDtoEvlFormHelpAndProofType;
    evlFormHelpAndProofTypeText: string;
    evaluationFormId: number;
    id: number;

    constructor(data?: IHelpAndProofDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nameKey = data["nameKey"];
            this.description = data["description"];
            this.evlFormHelpAndProofType = data["evlFormHelpAndProofType"];
            this.evlFormHelpAndProofTypeText = data["evlFormHelpAndProofTypeText"];
            this.evaluationFormId = data["evaluationFormId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HelpAndProofDto {
        let result = new HelpAndProofDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameKey"] = this.nameKey;
        data["description"] = this.description;
        data["evlFormHelpAndProofType"] = this.evlFormHelpAndProofType;
        data["evlFormHelpAndProofTypeText"] = this.evlFormHelpAndProofTypeText;
        data["evaluationFormId"] = this.evaluationFormId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHelpAndProofDto {
    nameKey: string;
    description: string;
    evlFormHelpAndProofType: HelpAndProofDtoEvlFormHelpAndProofType;
    evlFormHelpAndProofTypeText: string;
    evaluationFormId: number;
    id: number;
}

export class ListResultDtoOfEvaluationFormWithAnswerDto implements IListResultDtoOfEvaluationFormWithAnswerDto {
    items: EvaluationFormWithAnswerDto[];

    constructor(data?: IListResultDtoOfEvaluationFormWithAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EvaluationFormWithAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEvaluationFormWithAnswerDto {
        let result = new ListResultDtoOfEvaluationFormWithAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEvaluationFormWithAnswerDto {
    items: EvaluationFormWithAnswerDto[];
}

export class ListResultDtoOfEvaluationFormWithAllAnswersDto implements IListResultDtoOfEvaluationFormWithAllAnswersDto {
    items: EvaluationFormWithAllAnswersDto[];

    constructor(data?: IListResultDtoOfEvaluationFormWithAllAnswersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EvaluationFormWithAllAnswersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEvaluationFormWithAllAnswersDto {
        let result = new ListResultDtoOfEvaluationFormWithAllAnswersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEvaluationFormWithAllAnswersDto {
    items: EvaluationFormWithAllAnswersDto[];
}

export class EvaluationFormWithAllAnswersDto implements IEvaluationFormWithAllAnswersDto {
    parentId: number;
    title: string;
    isEditor: boolean;
    isActive: boolean;
    help: string;
    insitutionalProof: string;
    improvementProof: string;
    sequenceNo: number;
    answers: FormAnswerDto[];
    id: number;

    constructor(data?: IEvaluationFormWithAllAnswersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.isEditor = data["isEditor"];
            this.isActive = data["isActive"];
            this.help = data["help"];
            this.insitutionalProof = data["insitutionalProof"];
            this.improvementProof = data["improvementProof"];
            this.sequenceNo = data["sequenceNo"];
            if (data["answers"] && data["answers"].constructor === Array) {
                this.answers = [];
                for (let item of data["answers"])
                    this.answers.push(FormAnswerDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvaluationFormWithAllAnswersDto {
        let result = new EvaluationFormWithAllAnswersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["isEditor"] = this.isEditor;
        data["isActive"] = this.isActive;
        data["help"] = this.help;
        data["insitutionalProof"] = this.insitutionalProof;
        data["improvementProof"] = this.improvementProof;
        data["sequenceNo"] = this.sequenceNo;
        if (this.answers && this.answers.constructor === Array) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvaluationFormWithAllAnswersDto {
    parentId: number;
    title: string;
    isEditor: boolean;
    isActive: boolean;
    help: string;
    insitutionalProof: string;
    improvementProof: string;
    sequenceNo: number;
    answers: FormAnswerDto[];
    id: number;
}

export class CreateOrUpdateEvaluationFormAnswerInput implements ICreateOrUpdateEvaluationFormAnswerInput {
    evaluationFormId: number;
    year: number;
    body: string;
    extra: string;
    criteriaId: number;
    maturityLevelId: number;
    id: number;

    constructor(data?: ICreateOrUpdateEvaluationFormAnswerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evaluationFormId = data["evaluationFormId"];
            this.year = data["year"];
            this.body = data["body"];
            this.extra = data["extra"];
            this.criteriaId = data["criteriaId"];
            this.maturityLevelId = data["maturityLevelId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateEvaluationFormAnswerInput {
        let result = new CreateOrUpdateEvaluationFormAnswerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationFormId"] = this.evaluationFormId;
        data["year"] = this.year;
        data["body"] = this.body;
        data["extra"] = this.extra;
        data["criteriaId"] = this.criteriaId;
        data["maturityLevelId"] = this.maturityLevelId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrUpdateEvaluationFormAnswerInput {
    evaluationFormId: number;
    year: number;
    body: string;
    extra: string;
    criteriaId: number;
    maturityLevelId: number;
    id: number;
}

export class TenantEvalutionFormAnswerOfYearOutput implements ITenantEvalutionFormAnswerOfYearOutput {
    answerBody: string;

    constructor(data?: ITenantEvalutionFormAnswerOfYearOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answerBody = data["answerBody"];
        }
    }

    static fromJS(data: any): TenantEvalutionFormAnswerOfYearOutput {
        let result = new TenantEvalutionFormAnswerOfYearOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerBody"] = this.answerBody;
        return data; 
    }
}

export interface ITenantEvalutionFormAnswerOfYearOutput {
    answerBody: string;
}

export class UploadProofFileDto implements IUploadProofFileDto {
    answerId: number;
    fileId: string;
    fileName: string;
    contentType: string;
    size: number;
    path: string;
    evlFormHelpAndProofType: UploadProofFileDtoEvlFormHelpAndProofType;

    constructor(data?: IUploadProofFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answerId = data["answerId"];
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.contentType = data["contentType"];
            this.size = data["size"];
            this.path = data["path"];
            this.evlFormHelpAndProofType = data["evlFormHelpAndProofType"];
        }
    }

    static fromJS(data: any): UploadProofFileDto {
        let result = new UploadProofFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerId"] = this.answerId;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        data["path"] = this.path;
        data["evlFormHelpAndProofType"] = this.evlFormHelpAndProofType;
        return data; 
    }
}

export interface IUploadProofFileDto {
    answerId: number;
    fileId: string;
    fileName: string;
    contentType: string;
    size: number;
    path: string;
    evlFormHelpAndProofType: UploadProofFileDtoEvlFormHelpAndProofType;
}

export class ListResultDtoOfExtEvlAnsw implements IListResultDtoOfExtEvlAnsw {
    items: ExtEvlAnsw[];

    constructor(data?: IListResultDtoOfExtEvlAnsw) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ExtEvlAnsw.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfExtEvlAnsw {
        let result = new ListResultDtoOfExtEvlAnsw();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfExtEvlAnsw {
    items: ExtEvlAnsw[];
}

export class ExtEvlAnsw implements IExtEvlAnsw {
    year: number;
    answerBody: string;

    constructor(data?: IExtEvlAnsw) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.answerBody = data["answerBody"];
        }
    }

    static fromJS(data: any): ExtEvlAnsw {
        let result = new ExtEvlAnsw();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["answerBody"] = this.answerBody;
        return data; 
    }
}

export interface IExtEvlAnsw {
    year: number;
    answerBody: string;
}

export class EvlFrmCompletedDto implements IEvlFrmCompletedDto {
    termId: number;
    tenantId: number;
    isCompleted: boolean;
    id: number;

    constructor(data?: IEvlFrmCompletedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.tenantId = data["tenantId"];
            this.isCompleted = data["isCompleted"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvlFrmCompletedDto {
        let result = new EvlFrmCompletedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["tenantId"] = this.tenantId;
        data["isCompleted"] = this.isCompleted;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvlFrmCompletedDto {
    termId: number;
    tenantId: number;
    isCompleted: boolean;
    id: number;
}

export class EvlFormCompletedOutput implements IEvlFormCompletedOutput {
    termId: number;
    tenantId: number;
    isCompleted: boolean;
    engFileName: string;
    engPath: string;
    engAbsolutePath: string;
    id: number;

    constructor(data?: IEvlFormCompletedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.tenantId = data["tenantId"];
            this.isCompleted = data["isCompleted"];
            this.engFileName = data["engFileName"];
            this.engPath = data["engPath"];
            this.engAbsolutePath = data["engAbsolutePath"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvlFormCompletedOutput {
        let result = new EvlFormCompletedOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["tenantId"] = this.tenantId;
        data["isCompleted"] = this.isCompleted;
        data["engFileName"] = this.engFileName;
        data["engPath"] = this.engPath;
        data["engAbsolutePath"] = this.engAbsolutePath;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvlFormCompletedOutput {
    termId: number;
    tenantId: number;
    isCompleted: boolean;
    engFileName: string;
    engPath: string;
    engAbsolutePath: string;
    id: number;
}

export class GetEvlFrmIsCompletedDto implements IGetEvlFrmIsCompletedDto {
    termId: number;
    tenantId: number;

    constructor(data?: IGetEvlFrmIsCompletedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): GetEvlFrmIsCompletedDto {
        let result = new GetEvlFrmIsCompletedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IGetEvlFrmIsCompletedDto {
    termId: number;
    tenantId: number;
}

export class GetEvaluationFormAnswersInput implements IGetEvaluationFormAnswersInput {
    evaluationFormId: number;
    year: number;

    constructor(data?: IGetEvaluationFormAnswersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evaluationFormId = data["evaluationFormId"];
            this.year = data["year"];
        }
    }

    static fromJS(data: any): GetEvaluationFormAnswersInput {
        let result = new GetEvaluationFormAnswersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationFormId"] = this.evaluationFormId;
        data["year"] = this.year;
        return data; 
    }
}

export interface IGetEvaluationFormAnswersInput {
    evaluationFormId: number;
    year: number;
}

export class PagedResultDtoOfUniversityCompletionOutput implements IPagedResultDtoOfUniversityCompletionOutput {
    totalCount: number;
    items: UniversityCompletionOutput[];

    constructor(data?: IPagedResultDtoOfUniversityCompletionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UniversityCompletionOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUniversityCompletionOutput {
        let result = new PagedResultDtoOfUniversityCompletionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfUniversityCompletionOutput {
    totalCount: number;
    items: UniversityCompletionOutput[];
}

export class UniversityCompletionOutput implements IUniversityCompletionOutput {
    universityId: number;
    universityName: string;
    answeredFormCount: number;
    totalFormCount: number;
    percentage: number;
    isCompleted: boolean;

    constructor(data?: IUniversityCompletionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.universityId = data["universityId"];
            this.universityName = data["universityName"];
            this.answeredFormCount = data["answeredFormCount"];
            this.totalFormCount = data["totalFormCount"];
            this.percentage = data["percentage"];
            this.isCompleted = data["isCompleted"];
        }
    }

    static fromJS(data: any): UniversityCompletionOutput {
        let result = new UniversityCompletionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityId"] = this.universityId;
        data["universityName"] = this.universityName;
        data["answeredFormCount"] = this.answeredFormCount;
        data["totalFormCount"] = this.totalFormCount;
        data["percentage"] = this.percentage;
        data["isCompleted"] = this.isCompleted;
        return data; 
    }
}

export interface IUniversityCompletionOutput {
    universityId: number;
    universityName: string;
    answeredFormCount: number;
    totalFormCount: number;
    percentage: number;
    isCompleted: boolean;
}

export class CreateOrUpdateMaturityLevelDto implements ICreateOrUpdateMaturityLevelDto {
    name: string;
    sequenceNo: number;
    nameKey: string;
    weight: number;
    evaluationFormId: number;
    isDistanceEducation: boolean;
    id: number;

    constructor(data?: ICreateOrUpdateMaturityLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.sequenceNo = data["sequenceNo"];
            this.nameKey = data["nameKey"];
            this.weight = data["weight"];
            this.evaluationFormId = data["evaluationFormId"];
            this.isDistanceEducation = data["isDistanceEducation"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMaturityLevelDto {
        let result = new CreateOrUpdateMaturityLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sequenceNo"] = this.sequenceNo;
        data["nameKey"] = this.nameKey;
        data["weight"] = this.weight;
        data["evaluationFormId"] = this.evaluationFormId;
        data["isDistanceEducation"] = this.isDistanceEducation;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrUpdateMaturityLevelDto {
    name: string;
    sequenceNo: number;
    nameKey: string;
    weight: number;
    evaluationFormId: number;
    isDistanceEducation: boolean;
    id: number;
}

export class PagedResultDtoOfMaturityLevelDto implements IPagedResultDtoOfMaturityLevelDto {
    totalCount: number;
    items: MaturityLevelDto[];

    constructor(data?: IPagedResultDtoOfMaturityLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MaturityLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMaturityLevelDto {
        let result = new PagedResultDtoOfMaturityLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfMaturityLevelDto {
    totalCount: number;
    items: MaturityLevelDto[];
}

export class PagedResultDtoOfMentorDto implements IPagedResultDtoOfMentorDto {
    totalCount: number;
    items: MentorDto[];

    constructor(data?: IPagedResultDtoOfMentorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MentorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfMentorDto {
        let result = new PagedResultDtoOfMentorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfMentorDto {
    totalCount: number;
    items: MentorDto[];
}

export class MentorDto implements IMentorDto {
    termId: number;
    applicantId: number;
    applicantName: string;
    tenantId: number;
    tenantName: string;
    id: number;

    constructor(data?: IMentorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.applicantId = data["applicantId"];
            this.applicantName = data["applicantName"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MentorDto {
        let result = new MentorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["applicantId"] = this.applicantId;
        data["applicantName"] = this.applicantName;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMentorDto {
    termId: number;
    applicantId: number;
    applicantName: string;
    tenantId: number;
    tenantName: string;
    id: number;
}

export class CreateOrUpdateMentorDto implements ICreateOrUpdateMentorDto {
    termId: number;
    applicantId: number;
    tenantId: number;
    id: number;

    constructor(data?: ICreateOrUpdateMentorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.applicantId = data["applicantId"];
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMentorDto {
        let result = new CreateOrUpdateMentorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["applicantId"] = this.applicantId;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrUpdateMentorDto {
    termId: number;
    applicantId: number;
    tenantId: number;
    id: number;
}

export class ListResultDtoOfMentorSurveyListDto implements IListResultDtoOfMentorSurveyListDto {
    items: MentorSurveyListDto[];

    constructor(data?: IListResultDtoOfMentorSurveyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MentorSurveyListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMentorSurveyListDto {
        let result = new ListResultDtoOfMentorSurveyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfMentorSurveyListDto {
    items: MentorSurveyListDto[];
}

export class MentorSurveyListDto implements IMentorSurveyListDto {
    name: string;
    description: string;
    isActive: boolean;
    termId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IMentorSurveyListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.termId = data["termId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MentorSurveyListDto {
        let result = new MentorSurveyListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["termId"] = this.termId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IMentorSurveyListDto {
    name: string;
    description: string;
    isActive: boolean;
    termId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CreateOrUpdateMentorSurveyDto implements ICreateOrUpdateMentorSurveyDto {
    name: string;
    description: string;
    isActive: boolean;
    termId: number;
    teamSurveyQuestions: TeamSurveyQuestionDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICreateOrUpdateMentorSurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.termId = data["termId"];
            if (data["teamSurveyQuestions"] && data["teamSurveyQuestions"].constructor === Array) {
                this.teamSurveyQuestions = [];
                for (let item of data["teamSurveyQuestions"])
                    this.teamSurveyQuestions.push(TeamSurveyQuestionDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMentorSurveyDto {
        let result = new CreateOrUpdateMentorSurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["termId"] = this.termId;
        if (this.teamSurveyQuestions && this.teamSurveyQuestions.constructor === Array) {
            data["teamSurveyQuestions"] = [];
            for (let item of this.teamSurveyQuestions)
                data["teamSurveyQuestions"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrUpdateMentorSurveyDto {
    name: string;
    description: string;
    isActive: boolean;
    termId: number;
    teamSurveyQuestions: TeamSurveyQuestionDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TeamSurveyQuestionDto implements ITeamSurveyQuestionDto {
    teamSurveyId: number;
    surveyQuestionId: number;
    description: string;
    surveyQuestionTypeText: string;

    constructor(data?: ITeamSurveyQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.teamSurveyId = data["teamSurveyId"];
            this.surveyQuestionId = data["surveyQuestionId"];
            this.description = data["description"];
            this.surveyQuestionTypeText = data["surveyQuestionTypeText"];
        }
    }

    static fromJS(data: any): TeamSurveyQuestionDto {
        let result = new TeamSurveyQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamSurveyId"] = this.teamSurveyId;
        data["surveyQuestionId"] = this.surveyQuestionId;
        data["description"] = this.description;
        data["surveyQuestionTypeText"] = this.surveyQuestionTypeText;
        return data; 
    }
}

export interface ITeamSurveyQuestionDto {
    teamSurveyId: number;
    surveyQuestionId: number;
    description: string;
    surveyQuestionTypeText: string;
}

export class ListResultDtoOfMentoringUniversitysOutput implements IListResultDtoOfMentoringUniversitysOutput {
    items: MentoringUniversitysOutput[];

    constructor(data?: IListResultDtoOfMentoringUniversitysOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MentoringUniversitysOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMentoringUniversitysOutput {
        let result = new ListResultDtoOfMentoringUniversitysOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfMentoringUniversitysOutput {
    items: MentoringUniversitysOutput[];
}

export class MentoringUniversitysOutput implements IMentoringUniversitysOutput {
    tenantId: number;
    tenantName: string;
    applicantId: number;

    constructor(data?: IMentoringUniversitysOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
            this.applicantId = data["applicantId"];
        }
    }

    static fromJS(data: any): MentoringUniversitysOutput {
        let result = new MentoringUniversitysOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["applicantId"] = this.applicantId;
        return data; 
    }
}

export interface IMentoringUniversitysOutput {
    tenantId: number;
    tenantName: string;
    applicantId: number;
}

export class MentoringSurveyDataOutput implements IMentoringSurveyDataOutput {
    name: string;
    description: string;
    surveyQuestions: SQsDto[];
    id: number;

    constructor(data?: IMentoringSurveyDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            if (data["surveyQuestions"] && data["surveyQuestions"].constructor === Array) {
                this.surveyQuestions = [];
                for (let item of data["surveyQuestions"])
                    this.surveyQuestions.push(SQsDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MentoringSurveyDataOutput {
        let result = new MentoringSurveyDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (this.surveyQuestions && this.surveyQuestions.constructor === Array) {
            data["surveyQuestions"] = [];
            for (let item of this.surveyQuestions)
                data["surveyQuestions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IMentoringSurveyDataOutput {
    name: string;
    description: string;
    surveyQuestions: SQsDto[];
    id: number;
}

export class SQsDto implements ISQsDto {
    name: string;
    description: string;
    surveyQuestionTypeId: number;
    questionAnswerId: number;
    questionAnswerText: string;
    qCsId: number;
    qCsDescription: string;
    id: number;

    constructor(data?: ISQsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.surveyQuestionTypeId = data["surveyQuestionTypeId"];
            this.questionAnswerId = data["questionAnswerId"];
            this.questionAnswerText = data["questionAnswerText"];
            this.qCsId = data["qCsId"];
            this.qCsDescription = data["qCsDescription"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SQsDto {
        let result = new SQsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["surveyQuestionTypeId"] = this.surveyQuestionTypeId;
        data["questionAnswerId"] = this.questionAnswerId;
        data["questionAnswerText"] = this.questionAnswerText;
        data["qCsId"] = this.qCsId;
        data["qCsDescription"] = this.qCsDescription;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISQsDto {
    name: string;
    description: string;
    surveyQuestionTypeId: number;
    questionAnswerId: number;
    questionAnswerText: string;
    qCsId: number;
    qCsDescription: string;
    id: number;
}

export class ListResultDtoOfAllMentoringSurveyDataOutput implements IListResultDtoOfAllMentoringSurveyDataOutput {
    items: AllMentoringSurveyDataOutput[];

    constructor(data?: IListResultDtoOfAllMentoringSurveyDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(AllMentoringSurveyDataOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfAllMentoringSurveyDataOutput {
        let result = new ListResultDtoOfAllMentoringSurveyDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfAllMentoringSurveyDataOutput {
    items: AllMentoringSurveyDataOutput[];
}

export class AllMentoringSurveyDataOutput implements IAllMentoringSurveyDataOutput {
    name: string;
    description: string;
    tenantId: number;
    tenantName: string;
    applicantId: number;
    applicantName: string;
    surveyQuestions: SQsDto[];
    id: number;

    constructor(data?: IAllMentoringSurveyDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
            this.applicantId = data["applicantId"];
            this.applicantName = data["applicantName"];
            if (data["surveyQuestions"] && data["surveyQuestions"].constructor === Array) {
                this.surveyQuestions = [];
                for (let item of data["surveyQuestions"])
                    this.surveyQuestions.push(SQsDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AllMentoringSurveyDataOutput {
        let result = new AllMentoringSurveyDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["applicantId"] = this.applicantId;
        data["applicantName"] = this.applicantName;
        if (this.surveyQuestions && this.surveyQuestions.constructor === Array) {
            data["surveyQuestions"] = [];
            for (let item of this.surveyQuestions)
                data["surveyQuestions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IAllMentoringSurveyDataOutput {
    name: string;
    description: string;
    tenantId: number;
    tenantName: string;
    applicantId: number;
    applicantName: string;
    surveyQuestions: SQsDto[];
    id: number;
}

export class ListResultDtoOfAnswersByTenantsOutput implements IListResultDtoOfAnswersByTenantsOutput {
    items: AnswersByTenantsOutput[];

    constructor(data?: IListResultDtoOfAnswersByTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(AnswersByTenantsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfAnswersByTenantsOutput {
        let result = new ListResultDtoOfAnswersByTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfAnswersByTenantsOutput {
    items: AnswersByTenantsOutput[];
}

export class AnswersByTenantsOutput implements IAnswersByTenantsOutput {
    answer: string;
    avgPoints: number;
    universityId: number;
    universityName: string;

    constructor(data?: IAnswersByTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answer = data["answer"];
            this.avgPoints = data["avgPoints"];
            this.universityId = data["universityId"];
            this.universityName = data["universityName"];
        }
    }

    static fromJS(data: any): AnswersByTenantsOutput {
        let result = new AnswersByTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer;
        data["avgPoints"] = this.avgPoints;
        data["universityId"] = this.universityId;
        data["universityName"] = this.universityName;
        return data; 
    }
}

export interface IAnswersByTenantsOutput {
    answer: string;
    avgPoints: number;
    universityId: number;
    universityName: string;
}

export class ListResultDtoOfAnswersByYearsOutput implements IListResultDtoOfAnswersByYearsOutput {
    items: AnswersByYearsOutput[];

    constructor(data?: IListResultDtoOfAnswersByYearsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(AnswersByYearsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfAnswersByYearsOutput {
        let result = new ListResultDtoOfAnswersByYearsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfAnswersByYearsOutput {
    items: AnswersByYearsOutput[];
}

export class AnswersByYearsOutput implements IAnswersByYearsOutput {
    subEvaluationSequenceNo: number;
    subEvaluationTitle: string;
    evaluationSequenceNo: number;
    evaluationTitle: string;
    subEvulationId: number;
    evulationId: number;
    tenantId: number;
    mainMatchKey: string;
    subMatchKey: string;
    answersForYear: YearAnswersDto[];

    constructor(data?: IAnswersByYearsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subEvaluationSequenceNo = data["subEvaluationSequenceNo"];
            this.subEvaluationTitle = data["subEvaluationTitle"];
            this.evaluationSequenceNo = data["evaluationSequenceNo"];
            this.evaluationTitle = data["evaluationTitle"];
            this.subEvulationId = data["subEvulationId"];
            this.evulationId = data["evulationId"];
            this.tenantId = data["tenantId"];
            this.mainMatchKey = data["mainMatchKey"];
            this.subMatchKey = data["subMatchKey"];
            if (data["answersForYear"] && data["answersForYear"].constructor === Array) {
                this.answersForYear = [];
                for (let item of data["answersForYear"])
                    this.answersForYear.push(YearAnswersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnswersByYearsOutput {
        let result = new AnswersByYearsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subEvaluationSequenceNo"] = this.subEvaluationSequenceNo;
        data["subEvaluationTitle"] = this.subEvaluationTitle;
        data["evaluationSequenceNo"] = this.evaluationSequenceNo;
        data["evaluationTitle"] = this.evaluationTitle;
        data["subEvulationId"] = this.subEvulationId;
        data["evulationId"] = this.evulationId;
        data["tenantId"] = this.tenantId;
        data["mainMatchKey"] = this.mainMatchKey;
        data["subMatchKey"] = this.subMatchKey;
        if (this.answersForYear && this.answersForYear.constructor === Array) {
            data["answersForYear"] = [];
            for (let item of this.answersForYear)
                data["answersForYear"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAnswersByYearsOutput {
    subEvaluationSequenceNo: number;
    subEvaluationTitle: string;
    evaluationSequenceNo: number;
    evaluationTitle: string;
    subEvulationId: number;
    evulationId: number;
    tenantId: number;
    mainMatchKey: string;
    subMatchKey: string;
    answersForYear: YearAnswersDto[];
}

export class YearAnswersDto implements IYearAnswersDto {
    year: number;
    nestedAnswer: string;
    avaregeScore: number;

    constructor(data?: IYearAnswersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.nestedAnswer = data["nestedAnswer"];
            this.avaregeScore = data["avaregeScore"];
        }
    }

    static fromJS(data: any): YearAnswersDto {
        let result = new YearAnswersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["nestedAnswer"] = this.nestedAnswer;
        data["avaregeScore"] = this.avaregeScore;
        return data; 
    }
}

export interface IYearAnswersDto {
    year: number;
    nestedAnswer: string;
    avaregeScore: number;
}

export class ListResultDtoOfEvaluationTeamOutput implements IListResultDtoOfEvaluationTeamOutput {
    items: EvaluationTeamOutput[];

    constructor(data?: IListResultDtoOfEvaluationTeamOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EvaluationTeamOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEvaluationTeamOutput {
        let result = new ListResultDtoOfEvaluationTeamOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEvaluationTeamOutput {
    items: EvaluationTeamOutput[];
}

export class EvaluationTeamOutput implements IEvaluationTeamOutput {
    name: string;
    termId: number;
    isApplicantTeamLeader: boolean;
    isReportSent: boolean;
    isReportCompleted: boolean;
    evaluationType: EvaluationTeamOutputEvaluationType;
    meetingUserName: string;
    meetingUserPassword: string;
    teamMembers: TeamMemberOutput[];
    evaluatedUniversities: EvaluatedUniversityOutput[];
    teamMembersAuth: TeamMemberAuthOutput[];
    id: number;

    constructor(data?: IEvaluationTeamOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.termId = data["termId"];
            this.isApplicantTeamLeader = data["isApplicantTeamLeader"];
            this.isReportSent = data["isReportSent"];
            this.isReportCompleted = data["isReportCompleted"];
            this.evaluationType = data["evaluationType"];
            this.meetingUserName = data["meetingUserName"];
            this.meetingUserPassword = data["meetingUserPassword"];
            if (data["teamMembers"] && data["teamMembers"].constructor === Array) {
                this.teamMembers = [];
                for (let item of data["teamMembers"])
                    this.teamMembers.push(TeamMemberOutput.fromJS(item));
            }
            if (data["evaluatedUniversities"] && data["evaluatedUniversities"].constructor === Array) {
                this.evaluatedUniversities = [];
                for (let item of data["evaluatedUniversities"])
                    this.evaluatedUniversities.push(EvaluatedUniversityOutput.fromJS(item));
            }
            if (data["teamMembersAuth"] && data["teamMembersAuth"].constructor === Array) {
                this.teamMembersAuth = [];
                for (let item of data["teamMembersAuth"])
                    this.teamMembersAuth.push(TeamMemberAuthOutput.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvaluationTeamOutput {
        let result = new EvaluationTeamOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["termId"] = this.termId;
        data["isApplicantTeamLeader"] = this.isApplicantTeamLeader;
        data["isReportSent"] = this.isReportSent;
        data["isReportCompleted"] = this.isReportCompleted;
        data["evaluationType"] = this.evaluationType;
        data["meetingUserName"] = this.meetingUserName;
        data["meetingUserPassword"] = this.meetingUserPassword;
        if (this.teamMembers && this.teamMembers.constructor === Array) {
            data["teamMembers"] = [];
            for (let item of this.teamMembers)
                data["teamMembers"].push(item.toJSON());
        }
        if (this.evaluatedUniversities && this.evaluatedUniversities.constructor === Array) {
            data["evaluatedUniversities"] = [];
            for (let item of this.evaluatedUniversities)
                data["evaluatedUniversities"].push(item.toJSON());
        }
        if (this.teamMembersAuth && this.teamMembersAuth.constructor === Array) {
            data["teamMembersAuth"] = [];
            for (let item of this.teamMembersAuth)
                data["teamMembersAuth"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvaluationTeamOutput {
    name: string;
    termId: number;
    isApplicantTeamLeader: boolean;
    isReportSent: boolean;
    isReportCompleted: boolean;
    evaluationType: EvaluationTeamOutputEvaluationType;
    meetingUserName: string;
    meetingUserPassword: string;
    teamMembers: TeamMemberOutput[];
    evaluatedUniversities: EvaluatedUniversityOutput[];
    teamMembersAuth: TeamMemberAuthOutput[];
    id: number;
}

export class TeamMemberOutput implements ITeamMemberOutput {
    teamTaskStr: string;
    teamId: number;
    teamTask: TeamMemberOutputTeamTask;
    isEthicFormAccepted: boolean;
    isDutyAccepted: TeamMemberOutputIsDutyAccepted;
    isUnivConfirm: TeamMemberOutputIsUnivConfirm;
    description: string;
    applicantDescription: string;
    applicantId: number;
    userName: string;
    name: string;
    lastName: string;
    email: string;
    isAuth: boolean;

    constructor(data?: ITeamMemberOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.teamTaskStr = data["teamTaskStr"];
            this.teamId = data["teamId"];
            this.teamTask = data["teamTask"];
            this.isEthicFormAccepted = data["isEthicFormAccepted"];
            this.isDutyAccepted = data["isDutyAccepted"];
            this.isUnivConfirm = data["isUnivConfirm"];
            this.description = data["description"];
            this.applicantDescription = data["applicantDescription"];
            this.applicantId = data["applicantId"];
            this.userName = data["userName"];
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.email = data["email"];
            this.isAuth = data["isAuth"];
        }
    }

    static fromJS(data: any): TeamMemberOutput {
        let result = new TeamMemberOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamTaskStr"] = this.teamTaskStr;
        data["teamId"] = this.teamId;
        data["teamTask"] = this.teamTask;
        data["isEthicFormAccepted"] = this.isEthicFormAccepted;
        data["isDutyAccepted"] = this.isDutyAccepted;
        data["isUnivConfirm"] = this.isUnivConfirm;
        data["description"] = this.description;
        data["applicantDescription"] = this.applicantDescription;
        data["applicantId"] = this.applicantId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["isAuth"] = this.isAuth;
        return data; 
    }
}

export interface ITeamMemberOutput {
    teamTaskStr: string;
    teamId: number;
    teamTask: TeamMemberOutputTeamTask;
    isEthicFormAccepted: boolean;
    isDutyAccepted: TeamMemberOutputIsDutyAccepted;
    isUnivConfirm: TeamMemberOutputIsUnivConfirm;
    description: string;
    applicantDescription: string;
    applicantId: number;
    userName: string;
    name: string;
    lastName: string;
    email: string;
    isAuth: boolean;
}

export class TeamMemberAuthOutput implements ITeamMemberAuthOutput {
    applicantId: number;
    userName: string;
    name: string;
    lastName: string;
    email: string;
    universityId: number;
    gsm: string;
    teamTask: TeamMemberAuthOutputTeamTask;
    isAuth: boolean;
    id: number;

    constructor(data?: ITeamMemberAuthOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicantId = data["applicantId"];
            this.userName = data["userName"];
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.email = data["email"];
            this.universityId = data["universityId"];
            this.gsm = data["gsm"];
            this.teamTask = data["teamTask"];
            this.isAuth = data["isAuth"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TeamMemberAuthOutput {
        let result = new TeamMemberAuthOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["universityId"] = this.universityId;
        data["gsm"] = this.gsm;
        data["teamTask"] = this.teamTask;
        data["isAuth"] = this.isAuth;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITeamMemberAuthOutput {
    applicantId: number;
    userName: string;
    name: string;
    lastName: string;
    email: string;
    universityId: number;
    gsm: string;
    teamTask: TeamMemberAuthOutputTeamTask;
    isAuth: boolean;
    id: number;
}

export class CreateTeamInput implements ICreateTeamInput {
    termId: number;
    name: string;
    evaluationType: CreateTeamInputEvaluationType;
    meetingUserName: string;
    meetingUserPassword: string;
    teamMemberList: TeamMemberInput[];

    constructor(data?: ICreateTeamInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.name = data["name"];
            this.evaluationType = data["evaluationType"];
            this.meetingUserName = data["meetingUserName"];
            this.meetingUserPassword = data["meetingUserPassword"];
            if (data["teamMemberList"] && data["teamMemberList"].constructor === Array) {
                this.teamMemberList = [];
                for (let item of data["teamMemberList"])
                    this.teamMemberList.push(TeamMemberInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTeamInput {
        let result = new CreateTeamInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["name"] = this.name;
        data["evaluationType"] = this.evaluationType;
        data["meetingUserName"] = this.meetingUserName;
        data["meetingUserPassword"] = this.meetingUserPassword;
        if (this.teamMemberList && this.teamMemberList.constructor === Array) {
            data["teamMemberList"] = [];
            for (let item of this.teamMemberList)
                data["teamMemberList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateTeamInput {
    termId: number;
    name: string;
    evaluationType: CreateTeamInputEvaluationType;
    meetingUserName: string;
    meetingUserPassword: string;
    teamMemberList: TeamMemberInput[];
}

export class TeamMemberInput implements ITeamMemberInput {
    applicantId: number;
    task: TeamMemberInputTask;

    constructor(data?: ITeamMemberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicantId = data["applicantId"];
            this.task = data["task"];
        }
    }

    static fromJS(data: any): TeamMemberInput {
        let result = new TeamMemberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["task"] = this.task;
        return data; 
    }
}

export interface ITeamMemberInput {
    applicantId: number;
    task: TeamMemberInputTask;
}

export class UpdateTeamInput implements IUpdateTeamInput {
    termId: number;
    name: string;
    evaluationType: UpdateTeamInputEvaluationType;
    meetingUserName: string;
    meetingUserPassword: string;
    teamMemberList: TeamMemberInput[];
    id: number;

    constructor(data?: IUpdateTeamInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.name = data["name"];
            this.evaluationType = data["evaluationType"];
            this.meetingUserName = data["meetingUserName"];
            this.meetingUserPassword = data["meetingUserPassword"];
            if (data["teamMemberList"] && data["teamMemberList"].constructor === Array) {
                this.teamMemberList = [];
                for (let item of data["teamMemberList"])
                    this.teamMemberList.push(TeamMemberInput.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateTeamInput {
        let result = new UpdateTeamInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["name"] = this.name;
        data["evaluationType"] = this.evaluationType;
        data["meetingUserName"] = this.meetingUserName;
        data["meetingUserPassword"] = this.meetingUserPassword;
        if (this.teamMemberList && this.teamMemberList.constructor === Array) {
            data["teamMemberList"] = [];
            for (let item of this.teamMemberList)
                data["teamMemberList"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IUpdateTeamInput {
    termId: number;
    name: string;
    evaluationType: UpdateTeamInputEvaluationType;
    meetingUserName: string;
    meetingUserPassword: string;
    teamMemberList: TeamMemberInput[];
    id: number;
}

export class ListResultDtoOfEvaluatorListDto implements IListResultDtoOfEvaluatorListDto {
    items: EvaluatorListDto[];

    constructor(data?: IListResultDtoOfEvaluatorListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EvaluatorListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEvaluatorListDto {
        let result = new ListResultDtoOfEvaluatorListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEvaluatorListDto {
    items: EvaluatorListDto[];
}

export class EvaluatorListDto implements IEvaluatorListDto {
    applicantId: number;
    userName: string;
    name: string;
    lastName: string;
    email: string;
    isAuth: boolean;

    constructor(data?: IEvaluatorListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicantId = data["applicantId"];
            this.userName = data["userName"];
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.email = data["email"];
            this.isAuth = data["isAuth"];
        }
    }

    static fromJS(data: any): EvaluatorListDto {
        let result = new EvaluatorListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["isAuth"] = this.isAuth;
        return data; 
    }
}

export interface IEvaluatorListDto {
    applicantId: number;
    userName: string;
    name: string;
    lastName: string;
    email: string;
    isAuth: boolean;
}

export class EvaluationUniversityAccDataOutput implements IEvaluationUniversityAccDataOutput {
    termId: number;
    tenantId: number;
    teamId: number;
    accBeginDate: moment.Moment;
    accEndDate: moment.Moment;
    accType: EvaluationUniversityAccDataOutputAccType;
    accDecision: string;
    isPublished: boolean;

    constructor(data?: IEvaluationUniversityAccDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.tenantId = data["tenantId"];
            this.teamId = data["teamId"];
            this.accBeginDate = data["accBeginDate"] ? moment(data["accBeginDate"].toString()) : <any>undefined;
            this.accEndDate = data["accEndDate"] ? moment(data["accEndDate"].toString()) : <any>undefined;
            this.accType = data["accType"];
            this.accDecision = data["accDecision"];
            this.isPublished = data["isPublished"];
        }
    }

    static fromJS(data: any): EvaluationUniversityAccDataOutput {
        let result = new EvaluationUniversityAccDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["tenantId"] = this.tenantId;
        data["teamId"] = this.teamId;
        data["accBeginDate"] = this.accBeginDate ? this.accBeginDate.toISOString() : <any>undefined;
        data["accEndDate"] = this.accEndDate ? this.accEndDate.toISOString() : <any>undefined;
        data["accType"] = this.accType;
        data["accDecision"] = this.accDecision;
        data["isPublished"] = this.isPublished;
        return data; 
    }
}

export interface IEvaluationUniversityAccDataOutput {
    termId: number;
    tenantId: number;
    teamId: number;
    accBeginDate: moment.Moment;
    accEndDate: moment.Moment;
    accType: EvaluationUniversityAccDataOutputAccType;
    accDecision: string;
    isPublished: boolean;
}

export class EvaluatorSystemIdListInput implements IEvaluatorSystemIdListInput {
    applicantId: number;
    evaluatorSystemId: number;

    constructor(data?: IEvaluatorSystemIdListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicantId = data["applicantId"];
            this.evaluatorSystemId = data["evaluatorSystemId"];
        }
    }

    static fromJS(data: any): EvaluatorSystemIdListInput {
        let result = new EvaluatorSystemIdListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["evaluatorSystemId"] = this.evaluatorSystemId;
        return data; 
    }
}

export interface IEvaluatorSystemIdListInput {
    applicantId: number;
    evaluatorSystemId: number;
}

export class TeamTaskDutyInput implements ITeamTaskDutyInput {
    teamId: number;
    tenantId: number;
    isAcceptDuty: boolean;
    notAcceptingReason: string;
    evlSysId: number;

    constructor(data?: ITeamTaskDutyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.teamId = data["teamId"];
            this.tenantId = data["tenantId"];
            this.isAcceptDuty = data["isAcceptDuty"];
            this.notAcceptingReason = data["notAcceptingReason"];
            this.evlSysId = data["evlSysId"];
        }
    }

    static fromJS(data: any): TeamTaskDutyInput {
        let result = new TeamTaskDutyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["tenantId"] = this.tenantId;
        data["isAcceptDuty"] = this.isAcceptDuty;
        data["notAcceptingReason"] = this.notAcceptingReason;
        data["evlSysId"] = this.evlSysId;
        return data; 
    }
}

export interface ITeamTaskDutyInput {
    teamId: number;
    tenantId: number;
    isAcceptDuty: boolean;
    notAcceptingReason: string;
    evlSysId: number;
}

export class MemberWriteAuth implements IMemberWriteAuth {
    teamId: number;
    applicantId: number;
    writeAuth: boolean;

    constructor(data?: IMemberWriteAuth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.teamId = data["teamId"];
            this.applicantId = data["applicantId"];
            this.writeAuth = data["writeAuth"];
        }
    }

    static fromJS(data: any): MemberWriteAuth {
        let result = new MemberWriteAuth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["applicantId"] = this.applicantId;
        data["writeAuth"] = this.writeAuth;
        return data; 
    }
}

export interface IMemberWriteAuth {
    teamId: number;
    applicantId: number;
    writeAuth: boolean;
}

export class EvlSysEvaluatorAnswerDataInput implements IEvlSysEvaluatorAnswerDataInput {
    evaluationAnswerId: number;
    evaluatorAnswerBody: string;
    evaluatorSuggestionBody: string;
    evaluatorMaturityLevelId: number;
    evaluationType: number;

    constructor(data?: IEvlSysEvaluatorAnswerDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evaluationAnswerId = data["evaluationAnswerId"];
            this.evaluatorAnswerBody = data["evaluatorAnswerBody"];
            this.evaluatorSuggestionBody = data["evaluatorSuggestionBody"];
            this.evaluatorMaturityLevelId = data["evaluatorMaturityLevelId"];
            this.evaluationType = data["evaluationType"];
        }
    }

    static fromJS(data: any): EvlSysEvaluatorAnswerDataInput {
        let result = new EvlSysEvaluatorAnswerDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationAnswerId"] = this.evaluationAnswerId;
        data["evaluatorAnswerBody"] = this.evaluatorAnswerBody;
        data["evaluatorSuggestionBody"] = this.evaluatorSuggestionBody;
        data["evaluatorMaturityLevelId"] = this.evaluatorMaturityLevelId;
        data["evaluationType"] = this.evaluationType;
        return data; 
    }
}

export interface IEvlSysEvaluatorAnswerDataInput {
    evaluationAnswerId: number;
    evaluatorAnswerBody: string;
    evaluatorSuggestionBody: string;
    evaluatorMaturityLevelId: number;
    evaluationType: number;
}

export class EvlSysMeetingParticipant implements IEvlSysMeetingParticipant {
    name: string;
    lastName: string;
    email: string;
    teamMeetingId: number;
    id: number;

    constructor(data?: IEvlSysMeetingParticipant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.email = data["email"];
            this.teamMeetingId = data["teamMeetingId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvlSysMeetingParticipant {
        let result = new EvlSysMeetingParticipant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["teamMeetingId"] = this.teamMeetingId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvlSysMeetingParticipant {
    name: string;
    lastName: string;
    email: string;
    teamMeetingId: number;
    id: number;
}

export class EvlSysMeetingcoeData implements IEvlSysMeetingcoeData {
    id: number;
    meetingType: EvlSysMeetingcoeDataMeetingType;
    name: string;
    description: string;
    beginDate: string;
    endDate: string;
    link: string;
    meetingId: string;
    teamId: number;
    applicantId: number;
    tenantId: number;
    meetingUserName: string;
    meetingUserPassword: string;
    meetingAction: number;

    constructor(data?: IEvlSysMeetingcoeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.meetingType = data["meetingType"];
            this.name = data["name"];
            this.description = data["description"];
            this.beginDate = data["beginDate"];
            this.endDate = data["endDate"];
            this.link = data["link"];
            this.meetingId = data["meetingId"];
            this.teamId = data["teamId"];
            this.applicantId = data["applicantId"];
            this.tenantId = data["tenantId"];
            this.meetingUserName = data["meetingUserName"];
            this.meetingUserPassword = data["meetingUserPassword"];
            this.meetingAction = data["meetingAction"];
        }
    }

    static fromJS(data: any): EvlSysMeetingcoeData {
        let result = new EvlSysMeetingcoeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meetingType"] = this.meetingType;
        data["name"] = this.name;
        data["description"] = this.description;
        data["beginDate"] = this.beginDate;
        data["endDate"] = this.endDate;
        data["link"] = this.link;
        data["meetingId"] = this.meetingId;
        data["teamId"] = this.teamId;
        data["applicantId"] = this.applicantId;
        data["tenantId"] = this.tenantId;
        data["meetingUserName"] = this.meetingUserName;
        data["meetingUserPassword"] = this.meetingUserPassword;
        data["meetingAction"] = this.meetingAction;
        return data; 
    }
}

export interface IEvlSysMeetingcoeData {
    id: number;
    meetingType: EvlSysMeetingcoeDataMeetingType;
    name: string;
    description: string;
    beginDate: string;
    endDate: string;
    link: string;
    meetingId: string;
    teamId: number;
    applicantId: number;
    tenantId: number;
    meetingUserName: string;
    meetingUserPassword: string;
    meetingAction: number;
}

export class MonitoringAnswerData implements IMonitoringAnswerData {
    evaluationFormId: number;
    monitoringAnswer: string;
    evaluationType: number;
    tenantId: number;
    termId: number;

    constructor(data?: IMonitoringAnswerData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evaluationFormId = data["evaluationFormId"];
            this.monitoringAnswer = data["monitoringAnswer"];
            this.evaluationType = data["evaluationType"];
            this.tenantId = data["tenantId"];
            this.termId = data["termId"];
        }
    }

    static fromJS(data: any): MonitoringAnswerData {
        let result = new MonitoringAnswerData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationFormId"] = this.evaluationFormId;
        data["monitoringAnswer"] = this.monitoringAnswer;
        data["evaluationType"] = this.evaluationType;
        data["tenantId"] = this.tenantId;
        data["termId"] = this.termId;
        return data; 
    }
}

export interface IMonitoringAnswerData {
    evaluationFormId: number;
    monitoringAnswer: string;
    evaluationType: number;
    tenantId: number;
    termId: number;
}

export class EvlSysDistanceAnswerData implements IEvlSysDistanceAnswerData {
    teamId: number;
    tenantId: number;
    distanceAnswerId: number;
    body: string;

    constructor(data?: IEvlSysDistanceAnswerData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.teamId = data["teamId"];
            this.tenantId = data["tenantId"];
            this.distanceAnswerId = data["distanceAnswerId"];
            this.body = data["body"];
        }
    }

    static fromJS(data: any): EvlSysDistanceAnswerData {
        let result = new EvlSysDistanceAnswerData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["tenantId"] = this.tenantId;
        data["distanceAnswerId"] = this.distanceAnswerId;
        data["body"] = this.body;
        return data; 
    }
}

export interface IEvlSysDistanceAnswerData {
    teamId: number;
    tenantId: number;
    distanceAnswerId: number;
    body: string;
}

export class EvlSysSurveyAnswerInput implements IEvlSysSurveyAnswerInput {
    surveyId: number;
    teamId: number;
    evaluatorId: number;
    evaluatedId: number;
    questionId: number;
    choiceId: number;
    questionText: string;
    tenantId: number;

    constructor(data?: IEvlSysSurveyAnswerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyId = data["surveyId"];
            this.teamId = data["teamId"];
            this.evaluatorId = data["evaluatorId"];
            this.evaluatedId = data["evaluatedId"];
            this.questionId = data["questionId"];
            this.choiceId = data["choiceId"];
            this.questionText = data["questionText"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): EvlSysSurveyAnswerInput {
        let result = new EvlSysSurveyAnswerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["teamId"] = this.teamId;
        data["evaluatorId"] = this.evaluatorId;
        data["evaluatedId"] = this.evaluatedId;
        data["questionId"] = this.questionId;
        data["choiceId"] = this.choiceId;
        data["questionText"] = this.questionText;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IEvlSysSurveyAnswerInput {
    surveyId: number;
    teamId: number;
    evaluatorId: number;
    evaluatedId: number;
    questionId: number;
    choiceId: number;
    questionText: string;
    tenantId: number;
}

export class EvlSysSurveyCompleteInput implements IEvlSysSurveyCompleteInput {
    surveyId: number;
    evaluatorId: number;
    evaluatedId: number;
    teamId: number;
    isCompleted: boolean;
    tenantId: number;

    constructor(data?: IEvlSysSurveyCompleteInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyId = data["surveyId"];
            this.evaluatorId = data["evaluatorId"];
            this.evaluatedId = data["evaluatedId"];
            this.teamId = data["teamId"];
            this.isCompleted = data["isCompleted"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): EvlSysSurveyCompleteInput {
        let result = new EvlSysSurveyCompleteInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["evaluatorId"] = this.evaluatorId;
        data["evaluatedId"] = this.evaluatedId;
        data["teamId"] = this.teamId;
        data["isCompleted"] = this.isCompleted;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IEvlSysSurveyCompleteInput {
    surveyId: number;
    evaluatorId: number;
    evaluatedId: number;
    teamId: number;
    isCompleted: boolean;
    tenantId: number;
}

export class EvlSysMentorTaskDuty implements IEvlSysMentorTaskDuty {
    tenantId: number;
    isAcceptDuty: boolean;
    notAcceptingReason: string;
    applicantId: number;

    constructor(data?: IEvlSysMentorTaskDuty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.isAcceptDuty = data["isAcceptDuty"];
            this.notAcceptingReason = data["notAcceptingReason"];
            this.applicantId = data["applicantId"];
        }
    }

    static fromJS(data: any): EvlSysMentorTaskDuty {
        let result = new EvlSysMentorTaskDuty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["isAcceptDuty"] = this.isAcceptDuty;
        data["notAcceptingReason"] = this.notAcceptingReason;
        data["applicantId"] = this.applicantId;
        return data; 
    }
}

export interface IEvlSysMentorTaskDuty {
    tenantId: number;
    isAcceptDuty: boolean;
    notAcceptingReason: string;
    applicantId: number;
}

export class EvlSysSaveReportAndSurvey implements IEvlSysSaveReportAndSurvey {
    answerId: number;
    mentoringAnswer: string;
    applicantId: number;
    tenantId: number;
    termId: number;

    constructor(data?: IEvlSysSaveReportAndSurvey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answerId = data["answerId"];
            this.mentoringAnswer = data["mentoringAnswer"];
            this.applicantId = data["applicantId"];
            this.tenantId = data["tenantId"];
            this.termId = data["termId"];
        }
    }

    static fromJS(data: any): EvlSysSaveReportAndSurvey {
        let result = new EvlSysSaveReportAndSurvey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerId"] = this.answerId;
        data["mentoringAnswer"] = this.mentoringAnswer;
        data["applicantId"] = this.applicantId;
        data["tenantId"] = this.tenantId;
        data["termId"] = this.termId;
        return data; 
    }
}

export interface IEvlSysSaveReportAndSurvey {
    answerId: number;
    mentoringAnswer: string;
    applicantId: number;
    tenantId: number;
    termId: number;
}

export class SaveSurveyAnswer implements ISaveSurveyAnswer {
    surveyId: number;
    questionId: number;
    choiceId: number;
    answerId: number;
    answerText: string;
    applicantId: number;
    tenantId: number;
    termId: number;

    constructor(data?: ISaveSurveyAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyId = data["surveyId"];
            this.questionId = data["questionId"];
            this.choiceId = data["choiceId"];
            this.answerId = data["answerId"];
            this.answerText = data["answerText"];
            this.applicantId = data["applicantId"];
            this.tenantId = data["tenantId"];
            this.termId = data["termId"];
        }
    }

    static fromJS(data: any): SaveSurveyAnswer {
        let result = new SaveSurveyAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["questionId"] = this.questionId;
        data["choiceId"] = this.choiceId;
        data["answerId"] = this.answerId;
        data["answerText"] = this.answerText;
        data["applicantId"] = this.applicantId;
        data["tenantId"] = this.tenantId;
        data["termId"] = this.termId;
        return data; 
    }
}

export interface ISaveSurveyAnswer {
    surveyId: number;
    questionId: number;
    choiceId: number;
    answerId: number;
    answerText: string;
    applicantId: number;
    tenantId: number;
    termId: number;
}

export class CompleteReport implements ICompleteReport {
    applicantId: number;
    tenantId: number;
    termId: number;

    constructor(data?: ICompleteReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicantId = data["applicantId"];
            this.tenantId = data["tenantId"];
            this.termId = data["termId"];
        }
    }

    static fromJS(data: any): CompleteReport {
        let result = new CompleteReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["tenantId"] = this.tenantId;
        data["termId"] = this.termId;
        return data; 
    }
}

export interface ICompleteReport {
    applicantId: number;
    tenantId: number;
    termId: number;
}

export class ListResultDtoOfAnswersWithEvaluationOutput implements IListResultDtoOfAnswersWithEvaluationOutput {
    items: AnswersWithEvaluationOutput[];

    constructor(data?: IListResultDtoOfAnswersWithEvaluationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(AnswersWithEvaluationOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfAnswersWithEvaluationOutput {
        let result = new ListResultDtoOfAnswersWithEvaluationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfAnswersWithEvaluationOutput {
    items: AnswersWithEvaluationOutput[];
}

export class AnswersWithEvaluationOutput implements IAnswersWithEvaluationOutput {
    evaluationWithAnswer: EvaluationFormWithAnswerDto;
    evaluatorAnswer: EvaluatorAnswer;
    anwswerFor6: string;
    maturityLevels: MaturityLevelDto[];

    constructor(data?: IAnswersWithEvaluationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evaluationWithAnswer = data["evaluationWithAnswer"] ? EvaluationFormWithAnswerDto.fromJS(data["evaluationWithAnswer"]) : <any>undefined;
            this.evaluatorAnswer = data["evaluatorAnswer"] ? EvaluatorAnswer.fromJS(data["evaluatorAnswer"]) : <any>undefined;
            this.anwswerFor6 = data["anwswerFor6"];
            if (data["maturityLevels"] && data["maturityLevels"].constructor === Array) {
                this.maturityLevels = [];
                for (let item of data["maturityLevels"])
                    this.maturityLevels.push(MaturityLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnswersWithEvaluationOutput {
        let result = new AnswersWithEvaluationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationWithAnswer"] = this.evaluationWithAnswer ? this.evaluationWithAnswer.toJSON() : <any>undefined;
        data["evaluatorAnswer"] = this.evaluatorAnswer ? this.evaluatorAnswer.toJSON() : <any>undefined;
        data["anwswerFor6"] = this.anwswerFor6;
        if (this.maturityLevels && this.maturityLevels.constructor === Array) {
            data["maturityLevels"] = [];
            for (let item of this.maturityLevels)
                data["maturityLevels"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAnswersWithEvaluationOutput {
    evaluationWithAnswer: EvaluationFormWithAnswerDto;
    evaluatorAnswer: EvaluatorAnswer;
    anwswerFor6: string;
    maturityLevels: MaturityLevelDto[];
}

export class EvaluatorAnswer implements IEvaluatorAnswer {
    body: string;
    suggestion: string;
    criteriaId: number;
    maturityLevelId: number;
    id: number;

    constructor(data?: IEvaluatorAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.body = data["body"];
            this.suggestion = data["suggestion"];
            this.criteriaId = data["criteriaId"];
            this.maturityLevelId = data["maturityLevelId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvaluatorAnswer {
        let result = new EvaluatorAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        data["suggestion"] = this.suggestion;
        data["criteriaId"] = this.criteriaId;
        data["maturityLevelId"] = this.maturityLevelId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvaluatorAnswer {
    body: string;
    suggestion: string;
    criteriaId: number;
    maturityLevelId: number;
    id: number;
}

export class EvaluatorAnswerInput implements IEvaluatorAnswerInput {
    evaluationAnswerId: number;
    evaluatorAnswerId: number;
    evaluatorAnswerBody: string;
    evaluatorAnswerCriteriaId: number;
    evaluatorMaturityLevelId: number;
    mainSequence: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    evaluatorSuggestionBody: string;

    constructor(data?: IEvaluatorAnswerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evaluationAnswerId = data["evaluationAnswerId"];
            this.evaluatorAnswerId = data["evaluatorAnswerId"];
            this.evaluatorAnswerBody = data["evaluatorAnswerBody"];
            this.evaluatorAnswerCriteriaId = data["evaluatorAnswerCriteriaId"];
            this.evaluatorMaturityLevelId = data["evaluatorMaturityLevelId"];
            this.mainSequence = data["mainSequence"];
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            this.evaluatorSuggestionBody = data["evaluatorSuggestionBody"];
        }
    }

    static fromJS(data: any): EvaluatorAnswerInput {
        let result = new EvaluatorAnswerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationAnswerId"] = this.evaluationAnswerId;
        data["evaluatorAnswerId"] = this.evaluatorAnswerId;
        data["evaluatorAnswerBody"] = this.evaluatorAnswerBody;
        data["evaluatorAnswerCriteriaId"] = this.evaluatorAnswerCriteriaId;
        data["evaluatorMaturityLevelId"] = this.evaluatorMaturityLevelId;
        data["mainSequence"] = this.mainSequence;
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        data["evaluatorSuggestionBody"] = this.evaluatorSuggestionBody;
        return data; 
    }
}

export interface IEvaluatorAnswerInput {
    evaluationAnswerId: number;
    evaluatorAnswerId: number;
    evaluatorAnswerBody: string;
    evaluatorAnswerCriteriaId: number;
    evaluatorMaturityLevelId: number;
    mainSequence: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    evaluatorSuggestionBody: string;
}

export class StrengthsAndShortcomingsInput implements IStrengthsAndShortcomingsInput {
    universities: number[];
    strengthsOrShortcomings: number;

    constructor(data?: IStrengthsAndShortcomingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["universities"] && data["universities"].constructor === Array) {
                this.universities = [];
                for (let item of data["universities"])
                    this.universities.push(item);
            }
            this.strengthsOrShortcomings = data["strengthsOrShortcomings"];
        }
    }

    static fromJS(data: any): StrengthsAndShortcomingsInput {
        let result = new StrengthsAndShortcomingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.universities && this.universities.constructor === Array) {
            data["universities"] = [];
            for (let item of this.universities)
                data["universities"].push(item);
        }
        data["strengthsOrShortcomings"] = this.strengthsOrShortcomings;
        return data; 
    }
}

export interface IStrengthsAndShortcomingsInput {
    universities: number[];
    strengthsOrShortcomings: number;
}

export class ListResultDtoOfStrengthsAndShortcomingsOutput implements IListResultDtoOfStrengthsAndShortcomingsOutput {
    items: StrengthsAndShortcomingsOutput[];

    constructor(data?: IListResultDtoOfStrengthsAndShortcomingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(StrengthsAndShortcomingsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfStrengthsAndShortcomingsOutput {
        let result = new ListResultDtoOfStrengthsAndShortcomingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfStrengthsAndShortcomingsOutput {
    items: StrengthsAndShortcomingsOutput[];
}

export class StrengthsAndShortcomingsOutput implements IStrengthsAndShortcomingsOutput {
    universityId: number;
    universityName: string;
    extEvlForms: ExtEvlForms[];
    extEvlYears: ExtEvlYears[];

    constructor(data?: IStrengthsAndShortcomingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.universityId = data["universityId"];
            this.universityName = data["universityName"];
            if (data["extEvlForms"] && data["extEvlForms"].constructor === Array) {
                this.extEvlForms = [];
                for (let item of data["extEvlForms"])
                    this.extEvlForms.push(ExtEvlForms.fromJS(item));
            }
            if (data["extEvlYears"] && data["extEvlYears"].constructor === Array) {
                this.extEvlYears = [];
                for (let item of data["extEvlYears"])
                    this.extEvlYears.push(ExtEvlYears.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StrengthsAndShortcomingsOutput {
        let result = new StrengthsAndShortcomingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityId"] = this.universityId;
        data["universityName"] = this.universityName;
        if (this.extEvlForms && this.extEvlForms.constructor === Array) {
            data["extEvlForms"] = [];
            for (let item of this.extEvlForms)
                data["extEvlForms"].push(item.toJSON());
        }
        if (this.extEvlYears && this.extEvlYears.constructor === Array) {
            data["extEvlYears"] = [];
            for (let item of this.extEvlYears)
                data["extEvlYears"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStrengthsAndShortcomingsOutput {
    universityId: number;
    universityName: string;
    extEvlForms: ExtEvlForms[];
    extEvlYears: ExtEvlYears[];
}

export class ExtEvlForms implements IExtEvlForms {
    evlFormId: number;
    evlFormText: string;

    constructor(data?: IExtEvlForms) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evlFormId = data["evlFormId"];
            this.evlFormText = data["evlFormText"];
        }
    }

    static fromJS(data: any): ExtEvlForms {
        let result = new ExtEvlForms();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evlFormId"] = this.evlFormId;
        data["evlFormText"] = this.evlFormText;
        return data; 
    }
}

export interface IExtEvlForms {
    evlFormId: number;
    evlFormText: string;
}

export class ExtEvlYears implements IExtEvlYears {
    year: number;
    extEvlStrengthsOrShortcomingsAnswers: ExtEvlStrengthsOrShortcomingsAnswers[];

    constructor(data?: IExtEvlYears) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            if (data["extEvlStrengthsOrShortcomingsAnswers"] && data["extEvlStrengthsOrShortcomingsAnswers"].constructor === Array) {
                this.extEvlStrengthsOrShortcomingsAnswers = [];
                for (let item of data["extEvlStrengthsOrShortcomingsAnswers"])
                    this.extEvlStrengthsOrShortcomingsAnswers.push(ExtEvlStrengthsOrShortcomingsAnswers.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtEvlYears {
        let result = new ExtEvlYears();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        if (this.extEvlStrengthsOrShortcomingsAnswers && this.extEvlStrengthsOrShortcomingsAnswers.constructor === Array) {
            data["extEvlStrengthsOrShortcomingsAnswers"] = [];
            for (let item of this.extEvlStrengthsOrShortcomingsAnswers)
                data["extEvlStrengthsOrShortcomingsAnswers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IExtEvlYears {
    year: number;
    extEvlStrengthsOrShortcomingsAnswers: ExtEvlStrengthsOrShortcomingsAnswers[];
}

export class ExtEvlStrengthsOrShortcomingsAnswers implements IExtEvlStrengthsOrShortcomingsAnswers {
    evlFormId: number;
    evlFormName: string;
    answer: string;

    constructor(data?: IExtEvlStrengthsOrShortcomingsAnswers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evlFormId = data["evlFormId"];
            this.evlFormName = data["evlFormName"];
            this.answer = data["answer"];
        }
    }

    static fromJS(data: any): ExtEvlStrengthsOrShortcomingsAnswers {
        let result = new ExtEvlStrengthsOrShortcomingsAnswers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evlFormId"] = this.evlFormId;
        data["evlFormName"] = this.evlFormName;
        data["answer"] = this.answer;
        return data; 
    }
}

export interface IExtEvlStrengthsOrShortcomingsAnswers {
    evlFormId: number;
    evlFormName: string;
    answer: string;
}

export class PagedResultDtoOfEESurveyOutput implements IPagedResultDtoOfEESurveyOutput {
    totalCount: number;
    items: EESurveyOutput[];

    constructor(data?: IPagedResultDtoOfEESurveyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EESurveyOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEESurveyOutput {
        let result = new PagedResultDtoOfEESurveyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfEESurveyOutput {
    totalCount: number;
    items: EESurveyOutput[];
}

export class EESurveyOutput implements IEESurveyOutput {
    name: string;
    description: string;
    isActive: boolean;
    from: string;
    to: string;
    termId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IEESurveyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.from = data["from"];
            this.to = data["to"];
            this.termId = data["termId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EESurveyOutput {
        let result = new EESurveyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["from"] = this.from;
        data["to"] = this.to;
        data["termId"] = this.termId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEESurveyOutput {
    name: string;
    description: string;
    isActive: boolean;
    from: string;
    to: string;
    termId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PagedResultDtoOfEEQuestionForSurveyOutput implements IPagedResultDtoOfEEQuestionForSurveyOutput {
    totalCount: number;
    items: EEQuestionForSurveyOutput[];

    constructor(data?: IPagedResultDtoOfEEQuestionForSurveyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EEQuestionForSurveyOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEEQuestionForSurveyOutput {
        let result = new PagedResultDtoOfEEQuestionForSurveyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfEEQuestionForSurveyOutput {
    totalCount: number;
    items: EEQuestionForSurveyOutput[];
}

export class EEQuestionForSurveyOutput implements IEEQuestionForSurveyOutput {
    description: string;
    surveyQuestionTypeText: string;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IEEQuestionForSurveyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.surveyQuestionTypeText = data["surveyQuestionTypeText"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EEQuestionForSurveyOutput {
        let result = new EEQuestionForSurveyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["surveyQuestionTypeText"] = this.surveyQuestionTypeText;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEEQuestionForSurveyOutput {
    description: string;
    surveyQuestionTypeText: string;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CreateEESurveyInput implements ICreateEESurveyInput {
    name: string;
    description: string;
    isActive: boolean;
    from: CreateEESurveyInputFrom;
    to: CreateEESurveyInputTo;
    termId: number;
    teamSurveyQuestions: TeamSurveyQuestionDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICreateEESurveyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.from = data["from"];
            this.to = data["to"];
            this.termId = data["termId"];
            if (data["teamSurveyQuestions"] && data["teamSurveyQuestions"].constructor === Array) {
                this.teamSurveyQuestions = [];
                for (let item of data["teamSurveyQuestions"])
                    this.teamSurveyQuestions.push(TeamSurveyQuestionDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateEESurveyInput {
        let result = new CreateEESurveyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["from"] = this.from;
        data["to"] = this.to;
        data["termId"] = this.termId;
        if (this.teamSurveyQuestions && this.teamSurveyQuestions.constructor === Array) {
            data["teamSurveyQuestions"] = [];
            for (let item of this.teamSurveyQuestions)
                data["teamSurveyQuestions"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateEESurveyInput {
    name: string;
    description: string;
    isActive: boolean;
    from: CreateEESurveyInputFrom;
    to: CreateEESurveyInputTo;
    termId: number;
    teamSurveyQuestions: TeamSurveyQuestionDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class EESurveyForEdit implements IEESurveyForEdit {
    name: string;
    description: string;
    isActive: boolean;
    from: EESurveyForEditFrom;
    to: EESurveyForEditTo;
    termId: number;
    teamSurveyQuestions: TeamSurveyQuestionDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IEESurveyForEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.from = data["from"];
            this.to = data["to"];
            this.termId = data["termId"];
            if (data["teamSurveyQuestions"] && data["teamSurveyQuestions"].constructor === Array) {
                this.teamSurveyQuestions = [];
                for (let item of data["teamSurveyQuestions"])
                    this.teamSurveyQuestions.push(TeamSurveyQuestionDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EESurveyForEdit {
        let result = new EESurveyForEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["from"] = this.from;
        data["to"] = this.to;
        data["termId"] = this.termId;
        if (this.teamSurveyQuestions && this.teamSurveyQuestions.constructor === Array) {
            data["teamSurveyQuestions"] = [];
            for (let item of this.teamSurveyQuestions)
                data["teamSurveyQuestions"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEESurveyForEdit {
    name: string;
    description: string;
    isActive: boolean;
    from: EESurveyForEditFrom;
    to: EESurveyForEditTo;
    termId: number;
    teamSurveyQuestions: TeamSurveyQuestionDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ListResultDtoOfSurveyTypeOutput implements IListResultDtoOfSurveyTypeOutput {
    items: SurveyTypeOutput[];

    constructor(data?: IListResultDtoOfSurveyTypeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SurveyTypeOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSurveyTypeOutput {
        let result = new ListResultDtoOfSurveyTypeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSurveyTypeOutput {
    items: SurveyTypeOutput[];
}

export class SurveyTypeOutput implements ISurveyTypeOutput {
    name: string;
    id: number;

    constructor(data?: ISurveyTypeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyTypeOutput {
        let result = new SurveyTypeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISurveyTypeOutput {
    name: string;
    id: number;
}

export class PagedResultDtoOfEESurveyQuestionOutput implements IPagedResultDtoOfEESurveyQuestionOutput {
    totalCount: number;
    items: EESurveyQuestionOutput[];

    constructor(data?: IPagedResultDtoOfEESurveyQuestionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EESurveyQuestionOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEESurveyQuestionOutput {
        let result = new PagedResultDtoOfEESurveyQuestionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfEESurveyQuestionOutput {
    totalCount: number;
    items: EESurveyQuestionOutput[];
}

export class EESurveyQuestionOutput implements IEESurveyQuestionOutput {
    description: string;
    surveyQuestionType: number;
    surveyQuestionTypeText: string;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IEESurveyQuestionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.surveyQuestionType = data["surveyQuestionType"];
            this.surveyQuestionTypeText = data["surveyQuestionTypeText"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EESurveyQuestionOutput {
        let result = new EESurveyQuestionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["surveyQuestionType"] = this.surveyQuestionType;
        data["surveyQuestionTypeText"] = this.surveyQuestionTypeText;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEESurveyQuestionOutput {
    description: string;
    surveyQuestionType: number;
    surveyQuestionTypeText: string;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CreateEESurveyQuestionInput implements ICreateEESurveyQuestionInput {
    description: string;
    surveyQuestionType: number;
    choices: SurveyQuestionChoiceInput[];
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICreateEESurveyQuestionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.surveyQuestionType = data["surveyQuestionType"];
            if (data["choices"] && data["choices"].constructor === Array) {
                this.choices = [];
                for (let item of data["choices"])
                    this.choices.push(SurveyQuestionChoiceInput.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateEESurveyQuestionInput {
        let result = new CreateEESurveyQuestionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["surveyQuestionType"] = this.surveyQuestionType;
        if (this.choices && this.choices.constructor === Array) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateEESurveyQuestionInput {
    description: string;
    surveyQuestionType: number;
    choices: SurveyQuestionChoiceInput[];
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SurveyQuestionChoiceInput implements ISurveyQuestionChoiceInput {
    description: string;
    value: number;
    id: number;

    constructor(data?: ISurveyQuestionChoiceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyQuestionChoiceInput {
        let result = new SurveyQuestionChoiceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISurveyQuestionChoiceInput {
    description: string;
    value: number;
    id: number;
}

export class EESurveyQuestionOutputForEdit implements IEESurveyQuestionOutputForEdit {
    description: string;
    surveyQuestionType: number;
    choices: SurveyQuestionChoiceInput[];
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IEESurveyQuestionOutputForEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.surveyQuestionType = data["surveyQuestionType"];
            if (data["choices"] && data["choices"].constructor === Array) {
                this.choices = [];
                for (let item of data["choices"])
                    this.choices.push(SurveyQuestionChoiceInput.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EESurveyQuestionOutputForEdit {
        let result = new EESurveyQuestionOutputForEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["surveyQuestionType"] = this.surveyQuestionType;
        if (this.choices && this.choices.constructor === Array) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEESurveyQuestionOutputForEdit {
    description: string;
    surveyQuestionType: number;
    choices: SurveyQuestionChoiceInput[];
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ListResultDtoOfUniversityTeamMemberOutput implements IListResultDtoOfUniversityTeamMemberOutput {
    items: UniversityTeamMemberOutput[];

    constructor(data?: IListResultDtoOfUniversityTeamMemberOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UniversityTeamMemberOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUniversityTeamMemberOutput {
        let result = new ListResultDtoOfUniversityTeamMemberOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUniversityTeamMemberOutput {
    items: UniversityTeamMemberOutput[];
}

export class UniversityTeamMemberOutput implements IUniversityTeamMemberOutput {
    teamId: number;
    teamName: string;
    memberId: number;
    memberTitle: string;
    memberName: string;
    memberSurname: string;
    memberUniversity: string;
    memberTeamTask: string;
    memberTeamTaskId: UniversityTeamMemberOutputMemberTeamTaskId;

    constructor(data?: IUniversityTeamMemberOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.teamId = data["teamId"];
            this.teamName = data["teamName"];
            this.memberId = data["memberId"];
            this.memberTitle = data["memberTitle"];
            this.memberName = data["memberName"];
            this.memberSurname = data["memberSurname"];
            this.memberUniversity = data["memberUniversity"];
            this.memberTeamTask = data["memberTeamTask"];
            this.memberTeamTaskId = data["memberTeamTaskId"];
        }
    }

    static fromJS(data: any): UniversityTeamMemberOutput {
        let result = new UniversityTeamMemberOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["teamName"] = this.teamName;
        data["memberId"] = this.memberId;
        data["memberTitle"] = this.memberTitle;
        data["memberName"] = this.memberName;
        data["memberSurname"] = this.memberSurname;
        data["memberUniversity"] = this.memberUniversity;
        data["memberTeamTask"] = this.memberTeamTask;
        data["memberTeamTaskId"] = this.memberTeamTaskId;
        return data; 
    }
}

export interface IUniversityTeamMemberOutput {
    teamId: number;
    teamName: string;
    memberId: number;
    memberTitle: string;
    memberName: string;
    memberSurname: string;
    memberUniversity: string;
    memberTeamTask: string;
    memberTeamTaskId: UniversityTeamMemberOutputMemberTeamTaskId;
}

export class RectorSurveysOutput implements IRectorSurveysOutput {
    name: string;
    description: string;
    isCompleted: boolean;
    rectorSurveyQuestions: RectorSurveyQuestion[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRectorSurveysOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.isCompleted = data["isCompleted"];
            if (data["rectorSurveyQuestions"] && data["rectorSurveyQuestions"].constructor === Array) {
                this.rectorSurveyQuestions = [];
                for (let item of data["rectorSurveyQuestions"])
                    this.rectorSurveyQuestions.push(RectorSurveyQuestion.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RectorSurveysOutput {
        let result = new RectorSurveysOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isCompleted"] = this.isCompleted;
        if (this.rectorSurveyQuestions && this.rectorSurveyQuestions.constructor === Array) {
            data["rectorSurveyQuestions"] = [];
            for (let item of this.rectorSurveyQuestions)
                data["rectorSurveyQuestions"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRectorSurveysOutput {
    name: string;
    description: string;
    isCompleted: boolean;
    rectorSurveyQuestions: RectorSurveyQuestion[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RectorSurveyQuestion implements IRectorSurveyQuestion {
    description: string;
    surveyQuestionTypeId: number;
    surveyQuestionAnswerText: string;
    rectorSurveyQuestionChoices: RectorSurveyQuestionChoice[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IRectorSurveyQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.surveyQuestionTypeId = data["surveyQuestionTypeId"];
            this.surveyQuestionAnswerText = data["surveyQuestionAnswerText"];
            if (data["rectorSurveyQuestionChoices"] && data["rectorSurveyQuestionChoices"].constructor === Array) {
                this.rectorSurveyQuestionChoices = [];
                for (let item of data["rectorSurveyQuestionChoices"])
                    this.rectorSurveyQuestionChoices.push(RectorSurveyQuestionChoice.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RectorSurveyQuestion {
        let result = new RectorSurveyQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["surveyQuestionTypeId"] = this.surveyQuestionTypeId;
        data["surveyQuestionAnswerText"] = this.surveyQuestionAnswerText;
        if (this.rectorSurveyQuestionChoices && this.rectorSurveyQuestionChoices.constructor === Array) {
            data["rectorSurveyQuestionChoices"] = [];
            for (let item of this.rectorSurveyQuestionChoices)
                data["rectorSurveyQuestionChoices"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRectorSurveyQuestion {
    description: string;
    surveyQuestionTypeId: number;
    surveyQuestionAnswerText: string;
    rectorSurveyQuestionChoices: RectorSurveyQuestionChoice[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class RectorSurveyQuestionChoice implements IRectorSurveyQuestionChoice {
    description: string;
    isSelected: boolean;
    id: number;

    constructor(data?: IRectorSurveyQuestionChoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isSelected = data["isSelected"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RectorSurveyQuestionChoice {
        let result = new RectorSurveyQuestionChoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isSelected"] = this.isSelected;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRectorSurveyQuestionChoice {
    description: string;
    isSelected: boolean;
    id: number;
}

export class RectorSurveyAnswerInput implements IRectorSurveyAnswerInput {
    applicantId: number;
    userId: number;
    surveyQuestionId: number;
    teamSurveyId: number;
    surveyQuestionChoiceId: number;
    questionAnswerText: string;
    evaluatedApplicantId: number;
    evaluationTeamId: number;
    id: number;

    constructor(data?: IRectorSurveyAnswerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicantId = data["applicantId"];
            this.userId = data["userId"];
            this.surveyQuestionId = data["surveyQuestionId"];
            this.teamSurveyId = data["teamSurveyId"];
            this.surveyQuestionChoiceId = data["surveyQuestionChoiceId"];
            this.questionAnswerText = data["questionAnswerText"];
            this.evaluatedApplicantId = data["evaluatedApplicantId"];
            this.evaluationTeamId = data["evaluationTeamId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RectorSurveyAnswerInput {
        let result = new RectorSurveyAnswerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["userId"] = this.userId;
        data["surveyQuestionId"] = this.surveyQuestionId;
        data["teamSurveyId"] = this.teamSurveyId;
        data["surveyQuestionChoiceId"] = this.surveyQuestionChoiceId;
        data["questionAnswerText"] = this.questionAnswerText;
        data["evaluatedApplicantId"] = this.evaluatedApplicantId;
        data["evaluationTeamId"] = this.evaluationTeamId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRectorSurveyAnswerInput {
    applicantId: number;
    userId: number;
    surveyQuestionId: number;
    teamSurveyId: number;
    surveyQuestionChoiceId: number;
    questionAnswerText: string;
    evaluatedApplicantId: number;
    evaluationTeamId: number;
    id: number;
}

export class SurveyCompleteInput implements ISurveyCompleteInput {
    teamSurveyId: number;
    evaluatorId: number;
    evaluatedApplicantId: number;
    evaluationTeamId: number;
    isCompleted: boolean;

    constructor(data?: ISurveyCompleteInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.teamSurveyId = data["teamSurveyId"];
            this.evaluatorId = data["evaluatorId"];
            this.evaluatedApplicantId = data["evaluatedApplicantId"];
            this.evaluationTeamId = data["evaluationTeamId"];
            this.isCompleted = data["isCompleted"];
        }
    }

    static fromJS(data: any): SurveyCompleteInput {
        let result = new SurveyCompleteInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamSurveyId"] = this.teamSurveyId;
        data["evaluatorId"] = this.evaluatorId;
        data["evaluatedApplicantId"] = this.evaluatedApplicantId;
        data["evaluationTeamId"] = this.evaluationTeamId;
        data["isCompleted"] = this.isCompleted;
        return data; 
    }
}

export interface ISurveyCompleteInput {
    teamSurveyId: number;
    evaluatorId: number;
    evaluatedApplicantId: number;
    evaluationTeamId: number;
    isCompleted: boolean;
}

export class ListResultDtoOfTermOutput implements IListResultDtoOfTermOutput {
    items: TermOutput[];

    constructor(data?: IListResultDtoOfTermOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TermOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTermOutput {
        let result = new ListResultDtoOfTermOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfTermOutput {
    items: TermOutput[];
}

export class TermOutput implements ITermOutput {
    announcementBeginDate: moment.Moment;
    announcementEndDate: moment.Moment;
    assignmentBeginDate: moment.Moment;
    assignmentEndDate: moment.Moment;
    trainingBeginDate: moment.Moment;
    trainingEndDate: moment.Moment;
    name: string;
    year: number;
    isActive: boolean;
    isEvaluationTerm: boolean;
    id: number;

    constructor(data?: ITermOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.announcementBeginDate = data["announcementBeginDate"] ? moment(data["announcementBeginDate"].toString()) : <any>undefined;
            this.announcementEndDate = data["announcementEndDate"] ? moment(data["announcementEndDate"].toString()) : <any>undefined;
            this.assignmentBeginDate = data["assignmentBeginDate"] ? moment(data["assignmentBeginDate"].toString()) : <any>undefined;
            this.assignmentEndDate = data["assignmentEndDate"] ? moment(data["assignmentEndDate"].toString()) : <any>undefined;
            this.trainingBeginDate = data["trainingBeginDate"] ? moment(data["trainingBeginDate"].toString()) : <any>undefined;
            this.trainingEndDate = data["trainingEndDate"] ? moment(data["trainingEndDate"].toString()) : <any>undefined;
            this.name = data["name"];
            this.year = data["year"];
            this.isActive = data["isActive"];
            this.isEvaluationTerm = data["isEvaluationTerm"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TermOutput {
        let result = new TermOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["announcementBeginDate"] = this.announcementBeginDate ? this.announcementBeginDate.toISOString() : <any>undefined;
        data["announcementEndDate"] = this.announcementEndDate ? this.announcementEndDate.toISOString() : <any>undefined;
        data["assignmentBeginDate"] = this.assignmentBeginDate ? this.assignmentBeginDate.toISOString() : <any>undefined;
        data["assignmentEndDate"] = this.assignmentEndDate ? this.assignmentEndDate.toISOString() : <any>undefined;
        data["trainingBeginDate"] = this.trainingBeginDate ? this.trainingBeginDate.toISOString() : <any>undefined;
        data["trainingEndDate"] = this.trainingEndDate ? this.trainingEndDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["year"] = this.year;
        data["isActive"] = this.isActive;
        data["isEvaluationTerm"] = this.isEvaluationTerm;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITermOutput {
    announcementBeginDate: moment.Moment;
    announcementEndDate: moment.Moment;
    assignmentBeginDate: moment.Moment;
    assignmentEndDate: moment.Moment;
    trainingBeginDate: moment.Moment;
    trainingEndDate: moment.Moment;
    name: string;
    year: number;
    isActive: boolean;
    isEvaluationTerm: boolean;
    id: number;
}

export class SurveyResultOutput implements ISurveyResultOutput {
    surveyName: string;
    surveyDescription: string;
    surveyEvaluator: SurveyEvaluator[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISurveyResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.surveyName = data["surveyName"];
            this.surveyDescription = data["surveyDescription"];
            if (data["surveyEvaluator"] && data["surveyEvaluator"].constructor === Array) {
                this.surveyEvaluator = [];
                for (let item of data["surveyEvaluator"])
                    this.surveyEvaluator.push(SurveyEvaluator.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyResultOutput {
        let result = new SurveyResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyName"] = this.surveyName;
        data["surveyDescription"] = this.surveyDescription;
        if (this.surveyEvaluator && this.surveyEvaluator.constructor === Array) {
            data["surveyEvaluator"] = [];
            for (let item of this.surveyEvaluator)
                data["surveyEvaluator"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISurveyResultOutput {
    surveyName: string;
    surveyDescription: string;
    surveyEvaluator: SurveyEvaluator[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SurveyEvaluator implements ISurveyEvaluator {
    fromTitle: string;
    fromName: string;
    fromSurname: string;
    fromTeam: string;
    fromTask: string;
    surveyEvaluated: SurveyEvaluated[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISurveyEvaluator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fromTitle = data["fromTitle"];
            this.fromName = data["fromName"];
            this.fromSurname = data["fromSurname"];
            this.fromTeam = data["fromTeam"];
            this.fromTask = data["fromTask"];
            if (data["surveyEvaluated"] && data["surveyEvaluated"].constructor === Array) {
                this.surveyEvaluated = [];
                for (let item of data["surveyEvaluated"])
                    this.surveyEvaluated.push(SurveyEvaluated.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyEvaluator {
        let result = new SurveyEvaluator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromTitle"] = this.fromTitle;
        data["fromName"] = this.fromName;
        data["fromSurname"] = this.fromSurname;
        data["fromTeam"] = this.fromTeam;
        data["fromTask"] = this.fromTask;
        if (this.surveyEvaluated && this.surveyEvaluated.constructor === Array) {
            data["surveyEvaluated"] = [];
            for (let item of this.surveyEvaluated)
                data["surveyEvaluated"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISurveyEvaluator {
    fromTitle: string;
    fromName: string;
    fromSurname: string;
    fromTeam: string;
    fromTask: string;
    surveyEvaluated: SurveyEvaluated[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SurveyEvaluated implements ISurveyEvaluated {
    toTitle: string;
    toName: string;
    toSurname: string;
    toTeam: string;
    toTask: string;
    surveyQuestionAnswers: SurveyQuestionAnswer[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISurveyEvaluated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.toTitle = data["toTitle"];
            this.toName = data["toName"];
            this.toSurname = data["toSurname"];
            this.toTeam = data["toTeam"];
            this.toTask = data["toTask"];
            if (data["surveyQuestionAnswers"] && data["surveyQuestionAnswers"].constructor === Array) {
                this.surveyQuestionAnswers = [];
                for (let item of data["surveyQuestionAnswers"])
                    this.surveyQuestionAnswers.push(SurveyQuestionAnswer.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyEvaluated {
        let result = new SurveyEvaluated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toTitle"] = this.toTitle;
        data["toName"] = this.toName;
        data["toSurname"] = this.toSurname;
        data["toTeam"] = this.toTeam;
        data["toTask"] = this.toTask;
        if (this.surveyQuestionAnswers && this.surveyQuestionAnswers.constructor === Array) {
            data["surveyQuestionAnswers"] = [];
            for (let item of this.surveyQuestionAnswers)
                data["surveyQuestionAnswers"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISurveyEvaluated {
    toTitle: string;
    toName: string;
    toSurname: string;
    toTeam: string;
    toTask: string;
    surveyQuestionAnswers: SurveyQuestionAnswer[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class SurveyQuestionAnswer implements ISurveyQuestionAnswer {
    description: string;
    surveyQuestionTypeId: number;
    answerText: string;
    answerDescription: string;
    answerWeight: number;
    choiceId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISurveyQuestionAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.surveyQuestionTypeId = data["surveyQuestionTypeId"];
            this.answerText = data["answerText"];
            this.answerDescription = data["answerDescription"];
            this.answerWeight = data["answerWeight"];
            this.choiceId = data["choiceId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SurveyQuestionAnswer {
        let result = new SurveyQuestionAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["surveyQuestionTypeId"] = this.surveyQuestionTypeId;
        data["answerText"] = this.answerText;
        data["answerDescription"] = this.answerDescription;
        data["answerWeight"] = this.answerWeight;
        data["choiceId"] = this.choiceId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISurveyQuestionAnswer {
    description: string;
    surveyQuestionTypeId: number;
    answerText: string;
    answerDescription: string;
    answerWeight: number;
    choiceId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ListResultDtoOfUnivTeamMemerConfirmOutput implements IListResultDtoOfUnivTeamMemerConfirmOutput {
    items: UnivTeamMemerConfirmOutput[];

    constructor(data?: IListResultDtoOfUnivTeamMemerConfirmOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UnivTeamMemerConfirmOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUnivTeamMemerConfirmOutput {
        let result = new ListResultDtoOfUnivTeamMemerConfirmOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUnivTeamMemerConfirmOutput {
    items: UnivTeamMemerConfirmOutput[];
}

export class UnivTeamMemerConfirmOutput implements IUnivTeamMemerConfirmOutput {
    teamId: number;
    teamName: string;
    memberId: number;
    memberTitle: string;
    memberName: string;
    memberSurname: string;
    memberUniversity: string;
    memberTeamTask: string;
    memberEmail: string;
    memberPhone: string;
    universityId: number;
    termId: number;
    isUnivConfirm: UnivTeamMemerConfirmOutputIsUnivConfirm;
    description: string;

    constructor(data?: IUnivTeamMemerConfirmOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.teamId = data["teamId"];
            this.teamName = data["teamName"];
            this.memberId = data["memberId"];
            this.memberTitle = data["memberTitle"];
            this.memberName = data["memberName"];
            this.memberSurname = data["memberSurname"];
            this.memberUniversity = data["memberUniversity"];
            this.memberTeamTask = data["memberTeamTask"];
            this.memberEmail = data["memberEmail"];
            this.memberPhone = data["memberPhone"];
            this.universityId = data["universityId"];
            this.termId = data["termId"];
            this.isUnivConfirm = data["isUnivConfirm"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): UnivTeamMemerConfirmOutput {
        let result = new UnivTeamMemerConfirmOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["teamName"] = this.teamName;
        data["memberId"] = this.memberId;
        data["memberTitle"] = this.memberTitle;
        data["memberName"] = this.memberName;
        data["memberSurname"] = this.memberSurname;
        data["memberUniversity"] = this.memberUniversity;
        data["memberTeamTask"] = this.memberTeamTask;
        data["memberEmail"] = this.memberEmail;
        data["memberPhone"] = this.memberPhone;
        data["universityId"] = this.universityId;
        data["termId"] = this.termId;
        data["isUnivConfirm"] = this.isUnivConfirm;
        data["description"] = this.description;
        return data; 
    }
}

export interface IUnivTeamMemerConfirmOutput {
    teamId: number;
    teamName: string;
    memberId: number;
    memberTitle: string;
    memberName: string;
    memberSurname: string;
    memberUniversity: string;
    memberTeamTask: string;
    memberEmail: string;
    memberPhone: string;
    universityId: number;
    termId: number;
    isUnivConfirm: UnivTeamMemerConfirmOutputIsUnivConfirm;
    description: string;
}

export class ListResultDtoOfDraftListOutput implements IListResultDtoOfDraftListOutput {
    items: DraftListOutput[];

    constructor(data?: IListResultDtoOfDraftListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(DraftListOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDraftListOutput {
        let result = new ListResultDtoOfDraftListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfDraftListOutput {
    items: DraftListOutput[];
}

export class DraftListOutput implements IDraftListOutput {
    termId: number;
    termName: string;
    termYear: number;
    teamId: number;
    teamName: string;
    universityId: number;
    universityName: string;
    creationTime: moment.Moment;

    constructor(data?: IDraftListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.termName = data["termName"];
            this.termYear = data["termYear"];
            this.teamId = data["teamId"];
            this.teamName = data["teamName"];
            this.universityId = data["universityId"];
            this.universityName = data["universityName"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DraftListOutput {
        let result = new DraftListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["termName"] = this.termName;
        data["termYear"] = this.termYear;
        data["teamId"] = this.teamId;
        data["teamName"] = this.teamName;
        data["universityId"] = this.universityId;
        data["universityName"] = this.universityName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDraftListOutput {
    termId: number;
    termName: string;
    termYear: number;
    teamId: number;
    teamName: string;
    universityId: number;
    universityName: string;
    creationTime: moment.Moment;
}

export class ExternalEvaluationDraftOutput implements IExternalEvaluationDraftOutput {
    termId: number;
    teamId: number;
    universityId: number;
    externalEvaluationReport: string;
    externalEvaluationReportUniAnswer: string;
    creationTime: moment.Moment;
    lastModifiedTime: moment.Moment;
    sendUniversityUserId: number;
    externalFeedbackProofFilesCount: number;
    isReportSent: boolean;
    id: number;

    constructor(data?: IExternalEvaluationDraftOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.teamId = data["teamId"];
            this.universityId = data["universityId"];
            this.externalEvaluationReport = data["externalEvaluationReport"];
            this.externalEvaluationReportUniAnswer = data["externalEvaluationReportUniAnswer"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifiedTime = data["lastModifiedTime"] ? moment(data["lastModifiedTime"].toString()) : <any>undefined;
            this.sendUniversityUserId = data["sendUniversityUserId"];
            this.externalFeedbackProofFilesCount = data["externalFeedbackProofFilesCount"];
            this.isReportSent = data["isReportSent"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ExternalEvaluationDraftOutput {
        let result = new ExternalEvaluationDraftOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["teamId"] = this.teamId;
        data["universityId"] = this.universityId;
        data["externalEvaluationReport"] = this.externalEvaluationReport;
        data["externalEvaluationReportUniAnswer"] = this.externalEvaluationReportUniAnswer;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifiedTime"] = this.lastModifiedTime ? this.lastModifiedTime.toISOString() : <any>undefined;
        data["sendUniversityUserId"] = this.sendUniversityUserId;
        data["externalFeedbackProofFilesCount"] = this.externalFeedbackProofFilesCount;
        data["isReportSent"] = this.isReportSent;
        data["id"] = this.id;
        return data; 
    }
}

export interface IExternalEvaluationDraftOutput {
    termId: number;
    teamId: number;
    universityId: number;
    externalEvaluationReport: string;
    externalEvaluationReportUniAnswer: string;
    creationTime: moment.Moment;
    lastModifiedTime: moment.Moment;
    sendUniversityUserId: number;
    externalFeedbackProofFilesCount: number;
    isReportSent: boolean;
    id: number;
}

export class UploadExternalProofFileDto implements IUploadExternalProofFileDto {
    externalDraftId: number;
    fileId: string;
    fileName: string;
    contentType: string;
    size: number;
    path: string;

    constructor(data?: IUploadExternalProofFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.externalDraftId = data["externalDraftId"];
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.contentType = data["contentType"];
            this.size = data["size"];
            this.path = data["path"];
        }
    }

    static fromJS(data: any): UploadExternalProofFileDto {
        let result = new UploadExternalProofFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalDraftId"] = this.externalDraftId;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        data["path"] = this.path;
        return data; 
    }
}

export interface IUploadExternalProofFileDto {
    externalDraftId: number;
    fileId: string;
    fileName: string;
    contentType: string;
    size: number;
    path: string;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number;
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string;
}

export class BlockUserInput implements IBlockUserInput {
    userId: number;
    tenantId: number;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId: number;
    tenantId: number;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number;
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number;
}

export class HostDashboardData implements IHostDashboardData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
    incomeStatistics: IncomeStastistic[];
    editionStatistics: TenantEdition[];
    expiringTenants: ExpiringTenant[];
    recentTenants: RecentTenant[];
    maxExpiringTenantsShownCount: number;
    maxRecentTenantsShownCount: number;
    subscriptionEndAlertDayCount: number;
    recentTenantsDayCount: number;
    subscriptionEndDateStart: moment.Moment;
    subscriptionEndDateEnd: moment.Moment;
    tenantCreationStartDate: moment.Moment;

    constructor(data?: IHostDashboardData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.newTenantsCount = data["newTenantsCount"];
            this.newSubscriptionAmount = data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = data["dashboardPlaceholder2"];
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                for (let item of data["incomeStatistics"])
                    this.incomeStatistics.push(IncomeStastistic.fromJS(item));
            }
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                for (let item of data["editionStatistics"])
                    this.editionStatistics.push(TenantEdition.fromJS(item));
            }
            if (data["expiringTenants"] && data["expiringTenants"].constructor === Array) {
                this.expiringTenants = [];
                for (let item of data["expiringTenants"])
                    this.expiringTenants.push(ExpiringTenant.fromJS(item));
            }
            if (data["recentTenants"] && data["recentTenants"].constructor === Array) {
                this.recentTenants = [];
                for (let item of data["recentTenants"])
                    this.recentTenants.push(RecentTenant.fromJS(item));
            }
            this.maxExpiringTenantsShownCount = data["maxExpiringTenantsShownCount"];
            this.maxRecentTenantsShownCount = data["maxRecentTenantsShownCount"];
            this.subscriptionEndAlertDayCount = data["subscriptionEndAlertDayCount"];
            this.recentTenantsDayCount = data["recentTenantsDayCount"];
            this.subscriptionEndDateStart = data["subscriptionEndDateStart"] ? moment(data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = data["subscriptionEndDateEnd"] ? moment(data["subscriptionEndDateEnd"].toString()) : <any>undefined;
            this.tenantCreationStartDate = data["tenantCreationStartDate"] ? moment(data["tenantCreationStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HostDashboardData {
        let result = new HostDashboardData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        if (this.expiringTenants && this.expiringTenants.constructor === Array) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        if (this.recentTenants && this.recentTenants.constructor === Array) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toISOString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toISOString() : <any>undefined;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IHostDashboardData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
    incomeStatistics: IncomeStastistic[];
    editionStatistics: TenantEdition[];
    expiringTenants: ExpiringTenant[];
    recentTenants: RecentTenant[];
    maxExpiringTenantsShownCount: number;
    maxRecentTenantsShownCount: number;
    subscriptionEndAlertDayCount: number;
    recentTenantsDayCount: number;
    subscriptionEndDateStart: moment.Moment;
    subscriptionEndDateEnd: moment.Moment;
    tenantCreationStartDate: moment.Moment;
}

export class IncomeStastistic implements IIncomeStastistic {
    label: string;
    date: moment.Moment;
    amount: number;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.date = data["date"] ? moment(data["date"].toString()) : <any>undefined;
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        return data; 
    }
}

export interface IIncomeStastistic {
    label: string;
    date: moment.Moment;
    amount: number;
}

export class TenantEdition implements ITenantEdition {
    label: string;
    value: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.label = data["label"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data; 
    }
}

export interface ITenantEdition {
    label: string;
    value: number;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName: string;
    remainingDayCount: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.remainingDayCount = data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data; 
    }
}

export interface IExpiringTenant {
    tenantName: string;
    remainingDayCount: number;
}

export class RecentTenant implements IRecentTenant {
    id: number;
    name: string;
    creationTime: moment.Moment;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IRecentTenant {
    id: number;
    name: string;
    creationTime: moment.Moment;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[];

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                for (let item of data["incomeStatistics"])
                    this.incomeStatistics.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[];
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[];

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                for (let item of data["editionStatistics"])
                    this.editionStatistics.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[];
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general: GeneralSettingsEditDto = new GeneralSettingsEditDto();
    userManagement: HostUserManagementSettingsEditDto = new HostUserManagementSettingsEditDto();
    email: EmailSettingsEditDto = new EmailSettingsEditDto();
    tenantManagement: TenantManagementSettingsEditDto = new TenantManagementSettingsEditDto();
    security: SecuritySettingsEditDto = new SecuritySettingsEditDto();
    billing: HostBillingSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? HostBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone: string;
    timezoneForComparison: string;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timezone = data["timezone"];
            this.timezoneForComparison = data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data; 
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string;
    timezoneForComparison: string;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = data["smsVerificationEnabled"];
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        return data; 
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress: string;
    defaultFromDisplayName: string;
    smtpHost: string;
    smtpPort: number;
    smtpUserName: string;
    smtpPassword: string;
    smtpDomain: string;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultFromAddress = data["defaultFromAddress"];
            this.defaultFromDisplayName = data["defaultFromDisplayName"];
            this.smtpHost = data["smtpHost"];
            this.smtpPort = data["smtpPort"];
            this.smtpUserName = data["smtpUserName"];
            this.smtpPassword = data["smtpPassword"];
            this.smtpDomain = data["smtpDomain"];
            this.smtpEnableSsl = data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data; 
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string;
    defaultFromDisplayName: string;
    smtpHost: string;
    smtpPort: number;
    smtpUserName: string;
    smtpPassword: string;
    smtpDomain: string;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.defaultEditionId = data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data; 
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.useDefaultPasswordComplexitySettings = data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName: string;
    address: string;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data; 
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string;
    address: string;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requireDigit = data["requireDigit"];
            this.requireLowercase = data["requireLowercase"];
            this.requireNonAlphanumeric = data["requireNonAlphanumeric"];
            this.requireUppercase = data["requireUppercase"];
            this.requiredLength = data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data; 
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data; 
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isEnabledForApplication = data["isEnabledForApplication"];
            this.isEnabled = data["isEnabled"];
            this.isEmailProviderEnabled = data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class HSIEvaluationFormDto implements IHSIEvaluationFormDto {
    parentId: number;
    title: string;
    nameKey: string;
    isEditor: boolean;
    isActive: boolean;
    sequenceNo: number;
    termId: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    depth: number;
    help: string;
    id: number;

    constructor(data?: IHSIEvaluationFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.nameKey = data["nameKey"];
            this.isEditor = data["isEditor"];
            this.isActive = data["isActive"];
            this.sequenceNo = data["sequenceNo"];
            this.termId = data["termId"];
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            this.depth = data["depth"];
            this.help = data["help"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HSIEvaluationFormDto {
        let result = new HSIEvaluationFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["nameKey"] = this.nameKey;
        data["isEditor"] = this.isEditor;
        data["isActive"] = this.isActive;
        data["sequenceNo"] = this.sequenceNo;
        data["termId"] = this.termId;
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        data["depth"] = this.depth;
        data["help"] = this.help;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHSIEvaluationFormDto {
    parentId: number;
    title: string;
    nameKey: string;
    isEditor: boolean;
    isActive: boolean;
    sequenceNo: number;
    termId: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    depth: number;
    help: string;
    id: number;
}

export class PagedResultDtoOfHSIEvaluationFormDto implements IPagedResultDtoOfHSIEvaluationFormDto {
    totalCount: number;
    items: HSIEvaluationFormDto[];

    constructor(data?: IPagedResultDtoOfHSIEvaluationFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(HSIEvaluationFormDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfHSIEvaluationFormDto {
        let result = new PagedResultDtoOfHSIEvaluationFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfHSIEvaluationFormDto {
    totalCount: number;
    items: HSIEvaluationFormDto[];
}

export class ListResultDtoOfHSIEvaluationFormDto implements IListResultDtoOfHSIEvaluationFormDto {
    items: HSIEvaluationFormDto[];

    constructor(data?: IListResultDtoOfHSIEvaluationFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(HSIEvaluationFormDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfHSIEvaluationFormDto {
        let result = new ListResultDtoOfHSIEvaluationFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfHSIEvaluationFormDto {
    items: HSIEvaluationFormDto[];
}

export class CreateOrUpdateHSIEvaluationFormDto implements ICreateOrUpdateHSIEvaluationFormDto {
    parentId: number;
    title: string;
    nameKey: string;
    isEditor: boolean;
    isActive: boolean;
    sequenceNo: number;
    termId: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    depth: number;
    id: number;

    constructor(data?: ICreateOrUpdateHSIEvaluationFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.nameKey = data["nameKey"];
            this.isEditor = data["isEditor"];
            this.isActive = data["isActive"];
            this.sequenceNo = data["sequenceNo"];
            this.termId = data["termId"];
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            this.depth = data["depth"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateHSIEvaluationFormDto {
        let result = new CreateOrUpdateHSIEvaluationFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["nameKey"] = this.nameKey;
        data["isEditor"] = this.isEditor;
        data["isActive"] = this.isActive;
        data["sequenceNo"] = this.sequenceNo;
        data["termId"] = this.termId;
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        data["depth"] = this.depth;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrUpdateHSIEvaluationFormDto {
    parentId: number;
    title: string;
    nameKey: string;
    isEditor: boolean;
    isActive: boolean;
    sequenceNo: number;
    termId: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    depth: number;
    id: number;
}

export class ListResultDtoOfHSIEvaluationFormHelpDto implements IListResultDtoOfHSIEvaluationFormHelpDto {
    items: HSIEvaluationFormHelpDto[];

    constructor(data?: IListResultDtoOfHSIEvaluationFormHelpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(HSIEvaluationFormHelpDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfHSIEvaluationFormHelpDto {
        let result = new ListResultDtoOfHSIEvaluationFormHelpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfHSIEvaluationFormHelpDto {
    items: HSIEvaluationFormHelpDto[];
}

export class HSIEvaluationFormHelpDto implements IHSIEvaluationFormHelpDto {
    title: string;
    sequenceNo: number;
    hsiHelpDto: HSIHelpDto[];
    id: number;

    constructor(data?: IHSIEvaluationFormHelpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.sequenceNo = data["sequenceNo"];
            if (data["hsiHelpDto"] && data["hsiHelpDto"].constructor === Array) {
                this.hsiHelpDto = [];
                for (let item of data["hsiHelpDto"])
                    this.hsiHelpDto.push(HSIHelpDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HSIEvaluationFormHelpDto {
        let result = new HSIEvaluationFormHelpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["sequenceNo"] = this.sequenceNo;
        if (this.hsiHelpDto && this.hsiHelpDto.constructor === Array) {
            data["hsiHelpDto"] = [];
            for (let item of this.hsiHelpDto)
                data["hsiHelpDto"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IHSIEvaluationFormHelpDto {
    title: string;
    sequenceNo: number;
    hsiHelpDto: HSIHelpDto[];
    id: number;
}

export class HSIHelpDto implements IHSIHelpDto {
    nameKey: string;
    description: string;
    evlFormHelpAndProofType: HSIHelpDtoEvlFormHelpAndProofType;
    evlFormHelpAndProofTypeText: string;
    hsiEvaluationFormId: number;
    id: number;

    constructor(data?: IHSIHelpDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nameKey = data["nameKey"];
            this.description = data["description"];
            this.evlFormHelpAndProofType = data["evlFormHelpAndProofType"];
            this.evlFormHelpAndProofTypeText = data["evlFormHelpAndProofTypeText"];
            this.hsiEvaluationFormId = data["hsiEvaluationFormId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HSIHelpDto {
        let result = new HSIHelpDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameKey"] = this.nameKey;
        data["description"] = this.description;
        data["evlFormHelpAndProofType"] = this.evlFormHelpAndProofType;
        data["evlFormHelpAndProofTypeText"] = this.evlFormHelpAndProofTypeText;
        data["hsiEvaluationFormId"] = this.hsiEvaluationFormId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHSIHelpDto {
    nameKey: string;
    description: string;
    evlFormHelpAndProofType: HSIHelpDtoEvlFormHelpAndProofType;
    evlFormHelpAndProofTypeText: string;
    hsiEvaluationFormId: number;
    id: number;
}

export class HSIEvaluationFormHelpAndProofDto implements IHSIEvaluationFormHelpAndProofDto {
    nameKey: string;
    description: string;
    evlFormHelpAndProofType: HSIEvaluationFormHelpAndProofDtoEvlFormHelpAndProofType;
    evlFormHelpAndProofTypeText: string;
    hsiEvaluationFormId: number;
    id: number;

    constructor(data?: IHSIEvaluationFormHelpAndProofDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nameKey = data["nameKey"];
            this.description = data["description"];
            this.evlFormHelpAndProofType = data["evlFormHelpAndProofType"];
            this.evlFormHelpAndProofTypeText = data["evlFormHelpAndProofTypeText"];
            this.hsiEvaluationFormId = data["hsiEvaluationFormId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HSIEvaluationFormHelpAndProofDto {
        let result = new HSIEvaluationFormHelpAndProofDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameKey"] = this.nameKey;
        data["description"] = this.description;
        data["evlFormHelpAndProofType"] = this.evlFormHelpAndProofType;
        data["evlFormHelpAndProofTypeText"] = this.evlFormHelpAndProofTypeText;
        data["hsiEvaluationFormId"] = this.hsiEvaluationFormId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHSIEvaluationFormHelpAndProofDto {
    nameKey: string;
    description: string;
    evlFormHelpAndProofType: HSIEvaluationFormHelpAndProofDtoEvlFormHelpAndProofType;
    evlFormHelpAndProofTypeText: string;
    hsiEvaluationFormId: number;
    id: number;
}

export class PagedResultDtoOfHSIMaturityLevelDto implements IPagedResultDtoOfHSIMaturityLevelDto {
    totalCount: number;
    items: HSIMaturityLevelDto[];

    constructor(data?: IPagedResultDtoOfHSIMaturityLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(HSIMaturityLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfHSIMaturityLevelDto {
        let result = new PagedResultDtoOfHSIMaturityLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfHSIMaturityLevelDto {
    totalCount: number;
    items: HSIMaturityLevelDto[];
}

export class HSIMaturityLevelDto implements IHSIMaturityLevelDto {
    name: string;
    sequenceNo: number;
    nameKey: string;
    hsiEvaluationFormId: number;
    hsiEvaluationFormName: string;
    weight: number;
    type: HSIMaturityLevelDtoType;
    id: number;

    constructor(data?: IHSIMaturityLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.sequenceNo = data["sequenceNo"];
            this.nameKey = data["nameKey"];
            this.hsiEvaluationFormId = data["hsiEvaluationFormId"];
            this.hsiEvaluationFormName = data["hsiEvaluationFormName"];
            this.weight = data["weight"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HSIMaturityLevelDto {
        let result = new HSIMaturityLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sequenceNo"] = this.sequenceNo;
        data["nameKey"] = this.nameKey;
        data["hsiEvaluationFormId"] = this.hsiEvaluationFormId;
        data["hsiEvaluationFormName"] = this.hsiEvaluationFormName;
        data["weight"] = this.weight;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHSIMaturityLevelDto {
    name: string;
    sequenceNo: number;
    nameKey: string;
    hsiEvaluationFormId: number;
    hsiEvaluationFormName: string;
    weight: number;
    type: HSIMaturityLevelDtoType;
    id: number;
}

export class CreateOrUpdateHSIMaturityLevelDto implements ICreateOrUpdateHSIMaturityLevelDto {
    name: string;
    sequenceNo: number;
    nameKey: string;
    hsiEvaluationFormId: number;
    weight: number;
    type: CreateOrUpdateHSIMaturityLevelDtoType;
    id: number;

    constructor(data?: ICreateOrUpdateHSIMaturityLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.sequenceNo = data["sequenceNo"];
            this.nameKey = data["nameKey"];
            this.hsiEvaluationFormId = data["hsiEvaluationFormId"];
            this.weight = data["weight"];
            this.type = data["type"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateHSIMaturityLevelDto {
        let result = new CreateOrUpdateHSIMaturityLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sequenceNo"] = this.sequenceNo;
        data["nameKey"] = this.nameKey;
        data["hsiEvaluationFormId"] = this.hsiEvaluationFormId;
        data["weight"] = this.weight;
        data["type"] = this.type;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrUpdateHSIMaturityLevelDto {
    name: string;
    sequenceNo: number;
    nameKey: string;
    hsiEvaluationFormId: number;
    weight: number;
    type: CreateOrUpdateHSIMaturityLevelDtoType;
    id: number;
}

export class ListResultDtoOfHSIEvaluationFormAndAnswerDto implements IListResultDtoOfHSIEvaluationFormAndAnswerDto {
    items: HSIEvaluationFormAndAnswerDto[];

    constructor(data?: IListResultDtoOfHSIEvaluationFormAndAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(HSIEvaluationFormAndAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfHSIEvaluationFormAndAnswerDto {
        let result = new ListResultDtoOfHSIEvaluationFormAndAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfHSIEvaluationFormAndAnswerDto {
    items: HSIEvaluationFormAndAnswerDto[];
}

export class HSIEvaluationFormAndAnswerDto implements IHSIEvaluationFormAndAnswerDto {
    parentId: number;
    title: string;
    isEditor: boolean;
    isActive: boolean;
    help: string;
    sequenceNo: number;
    depth: number;
    termId: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    help_Help: string;
    help_Proof: string;
    answer: HSIFormAnswerDto;
    maturityLevels: HSIMaturityLevelDto[];
    subForm: HSIEvaluationFormAndAnswerDto[];
    id: number;

    constructor(data?: IHSIEvaluationFormAndAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.isEditor = data["isEditor"];
            this.isActive = data["isActive"];
            this.help = data["help"];
            this.sequenceNo = data["sequenceNo"];
            this.depth = data["depth"];
            this.termId = data["termId"];
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            this.help_Help = data["help_Help"];
            this.help_Proof = data["help_Proof"];
            this.answer = data["answer"] ? HSIFormAnswerDto.fromJS(data["answer"]) : <any>undefined;
            if (data["maturityLevels"] && data["maturityLevels"].constructor === Array) {
                this.maturityLevels = [];
                for (let item of data["maturityLevels"])
                    this.maturityLevels.push(HSIMaturityLevelDto.fromJS(item));
            }
            if (data["subForm"] && data["subForm"].constructor === Array) {
                this.subForm = [];
                for (let item of data["subForm"])
                    this.subForm.push(HSIEvaluationFormAndAnswerDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HSIEvaluationFormAndAnswerDto {
        let result = new HSIEvaluationFormAndAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["isEditor"] = this.isEditor;
        data["isActive"] = this.isActive;
        data["help"] = this.help;
        data["sequenceNo"] = this.sequenceNo;
        data["depth"] = this.depth;
        data["termId"] = this.termId;
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        data["help_Help"] = this.help_Help;
        data["help_Proof"] = this.help_Proof;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        if (this.maturityLevels && this.maturityLevels.constructor === Array) {
            data["maturityLevels"] = [];
            for (let item of this.maturityLevels)
                data["maturityLevels"].push(item.toJSON());
        }
        if (this.subForm && this.subForm.constructor === Array) {
            data["subForm"] = [];
            for (let item of this.subForm)
                data["subForm"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IHSIEvaluationFormAndAnswerDto {
    parentId: number;
    title: string;
    isEditor: boolean;
    isActive: boolean;
    help: string;
    sequenceNo: number;
    depth: number;
    termId: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    help_Help: string;
    help_Proof: string;
    answer: HSIFormAnswerDto;
    maturityLevels: HSIMaturityLevelDto[];
    subForm: HSIEvaluationFormAndAnswerDto[];
    id: number;
}

export class HSIFormAnswerDto implements IHSIFormAnswerDto {
    hsiEvaluationFormId: number;
    year: number;
    body: string;
    hsiMaturityLevelId: number;
    hsiMaturityLevelText: string;
    extra: string;
    hasActiveEditor: boolean;
    proofFilesCount: number;
    insitutionalProofFilesCount: number;
    improvementProofFilesCount: number;
    id: number;

    constructor(data?: IHSIFormAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.hsiEvaluationFormId = data["hsiEvaluationFormId"];
            this.year = data["year"];
            this.body = data["body"];
            this.hsiMaturityLevelId = data["hsiMaturityLevelId"];
            this.hsiMaturityLevelText = data["hsiMaturityLevelText"];
            this.extra = data["extra"];
            this.hasActiveEditor = data["hasActiveEditor"];
            this.proofFilesCount = data["proofFilesCount"];
            this.insitutionalProofFilesCount = data["insitutionalProofFilesCount"];
            this.improvementProofFilesCount = data["improvementProofFilesCount"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HSIFormAnswerDto {
        let result = new HSIFormAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hsiEvaluationFormId"] = this.hsiEvaluationFormId;
        data["year"] = this.year;
        data["body"] = this.body;
        data["hsiMaturityLevelId"] = this.hsiMaturityLevelId;
        data["hsiMaturityLevelText"] = this.hsiMaturityLevelText;
        data["extra"] = this.extra;
        data["hasActiveEditor"] = this.hasActiveEditor;
        data["proofFilesCount"] = this.proofFilesCount;
        data["insitutionalProofFilesCount"] = this.insitutionalProofFilesCount;
        data["improvementProofFilesCount"] = this.improvementProofFilesCount;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHSIFormAnswerDto {
    hsiEvaluationFormId: number;
    year: number;
    body: string;
    hsiMaturityLevelId: number;
    hsiMaturityLevelText: string;
    extra: string;
    hasActiveEditor: boolean;
    proofFilesCount: number;
    insitutionalProofFilesCount: number;
    improvementProofFilesCount: number;
    id: number;
}

export class HSIEvaluationFormCompletedDto implements IHSIEvaluationFormCompletedDto {
    termId: number;
    tenantId: number;
    isCompleted: boolean;
    id: number;

    constructor(data?: IHSIEvaluationFormCompletedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.tenantId = data["tenantId"];
            this.isCompleted = data["isCompleted"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): HSIEvaluationFormCompletedDto {
        let result = new HSIEvaluationFormCompletedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["tenantId"] = this.tenantId;
        data["isCompleted"] = this.isCompleted;
        data["id"] = this.id;
        return data; 
    }
}

export interface IHSIEvaluationFormCompletedDto {
    termId: number;
    tenantId: number;
    isCompleted: boolean;
    id: number;
}

export class ListResultDtoOfIndicatorDto implements IListResultDtoOfIndicatorDto {
    items: IndicatorDto[];

    constructor(data?: IListResultDtoOfIndicatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(IndicatorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfIndicatorDto {
        let result = new ListResultDtoOfIndicatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfIndicatorDto {
    items: IndicatorDto[];
}

export class IndicatorDto implements IIndicatorDto {
    nameKey: string;
    nameValue: string;
    sequenceNo: number;
    isActive: boolean;
    isCalculated: boolean;
    isYokakKey: boolean;
    parentId: number;
    formula: IndicatorFormulaDto;
    sources: SourceDto[];
    transferTypes: TransferTypeDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IIndicatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nameKey = data["nameKey"];
            this.nameValue = data["nameValue"];
            this.sequenceNo = data["sequenceNo"];
            this.isActive = data["isActive"];
            this.isCalculated = data["isCalculated"];
            this.isYokakKey = data["isYokakKey"];
            this.parentId = data["parentId"];
            this.formula = data["formula"] ? IndicatorFormulaDto.fromJS(data["formula"]) : <any>undefined;
            if (data["sources"] && data["sources"].constructor === Array) {
                this.sources = [];
                for (let item of data["sources"])
                    this.sources.push(SourceDto.fromJS(item));
            }
            if (data["transferTypes"] && data["transferTypes"].constructor === Array) {
                this.transferTypes = [];
                for (let item of data["transferTypes"])
                    this.transferTypes.push(TransferTypeDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IndicatorDto {
        let result = new IndicatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameKey"] = this.nameKey;
        data["nameValue"] = this.nameValue;
        data["sequenceNo"] = this.sequenceNo;
        data["isActive"] = this.isActive;
        data["isCalculated"] = this.isCalculated;
        data["isYokakKey"] = this.isYokakKey;
        data["parentId"] = this.parentId;
        data["formula"] = this.formula ? this.formula.toJSON() : <any>undefined;
        if (this.sources && this.sources.constructor === Array) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item.toJSON());
        }
        if (this.transferTypes && this.transferTypes.constructor === Array) {
            data["transferTypes"] = [];
            for (let item of this.transferTypes)
                data["transferTypes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IIndicatorDto {
    nameKey: string;
    nameValue: string;
    sequenceNo: number;
    isActive: boolean;
    isCalculated: boolean;
    isYokakKey: boolean;
    parentId: number;
    formula: IndicatorFormulaDto;
    sources: SourceDto[];
    transferTypes: TransferTypeDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class IndicatorFormulaDto implements IIndicatorFormulaDto {
    formula: string;
    id: number;

    constructor(data?: IIndicatorFormulaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formula = data["formula"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IndicatorFormulaDto {
        let result = new IndicatorFormulaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formula"] = this.formula;
        data["id"] = this.id;
        return data; 
    }
}

export interface IIndicatorFormulaDto {
    formula: string;
    id: number;
}

export class SourceDto implements ISourceDto {
    nameKey: string;
    nameValue: string;
    sequenceNo: number;
    isActive: boolean;
    id: number;

    constructor(data?: ISourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nameKey = data["nameKey"];
            this.nameValue = data["nameValue"];
            this.sequenceNo = data["sequenceNo"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SourceDto {
        let result = new SourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameKey"] = this.nameKey;
        data["nameValue"] = this.nameValue;
        data["sequenceNo"] = this.sequenceNo;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISourceDto {
    nameKey: string;
    nameValue: string;
    sequenceNo: number;
    isActive: boolean;
    id: number;
}

export class TransferTypeDto implements ITransferTypeDto {
    isActive: boolean;
    nameKey: string;
    sequenceNo: number;
    nameValue: string;
    id: number;

    constructor(data?: ITransferTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.nameKey = data["nameKey"];
            this.sequenceNo = data["sequenceNo"];
            this.nameValue = data["nameValue"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransferTypeDto {
        let result = new TransferTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["nameKey"] = this.nameKey;
        data["sequenceNo"] = this.sequenceNo;
        data["nameValue"] = this.nameValue;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITransferTypeDto {
    isActive: boolean;
    nameKey: string;
    sequenceNo: number;
    nameValue: string;
    id: number;
}

export class CreateIndicatorInput implements ICreateIndicatorInput {
    nameKey: string;
    sequenceNo: number;
    isActive: boolean;
    parentId: number;
    isCalculated: boolean;
    isYokakKey: boolean;
    formula: IndicatorFormulaDto;
    sourceList: number[];
    transferTypeList: number[];

    constructor(data?: ICreateIndicatorInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nameKey = data["nameKey"];
            this.sequenceNo = data["sequenceNo"];
            this.isActive = data["isActive"];
            this.parentId = data["parentId"];
            this.isCalculated = data["isCalculated"];
            this.isYokakKey = data["isYokakKey"];
            this.formula = data["formula"] ? IndicatorFormulaDto.fromJS(data["formula"]) : <any>undefined;
            if (data["sourceList"] && data["sourceList"].constructor === Array) {
                this.sourceList = [];
                for (let item of data["sourceList"])
                    this.sourceList.push(item);
            }
            if (data["transferTypeList"] && data["transferTypeList"].constructor === Array) {
                this.transferTypeList = [];
                for (let item of data["transferTypeList"])
                    this.transferTypeList.push(item);
            }
        }
    }

    static fromJS(data: any): CreateIndicatorInput {
        let result = new CreateIndicatorInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameKey"] = this.nameKey;
        data["sequenceNo"] = this.sequenceNo;
        data["isActive"] = this.isActive;
        data["parentId"] = this.parentId;
        data["isCalculated"] = this.isCalculated;
        data["isYokakKey"] = this.isYokakKey;
        data["formula"] = this.formula ? this.formula.toJSON() : <any>undefined;
        if (this.sourceList && this.sourceList.constructor === Array) {
            data["sourceList"] = [];
            for (let item of this.sourceList)
                data["sourceList"].push(item);
        }
        if (this.transferTypeList && this.transferTypeList.constructor === Array) {
            data["transferTypeList"] = [];
            for (let item of this.transferTypeList)
                data["transferTypeList"].push(item);
        }
        return data; 
    }
}

export interface ICreateIndicatorInput {
    nameKey: string;
    sequenceNo: number;
    isActive: boolean;
    parentId: number;
    isCalculated: boolean;
    isYokakKey: boolean;
    formula: IndicatorFormulaDto;
    sourceList: number[];
    transferTypeList: number[];
}

export class EditIndicatorModel implements IEditIndicatorModel {
    nameKey: string;
    sequenceNo: number;
    isActive: boolean;
    parentId: number;
    isCalculated: boolean;
    isYokakKey: boolean;
    sourceList: number[];
    transferTypeList: number[];
    formula: IndicatorFormulaDto;
    id: number;

    constructor(data?: IEditIndicatorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nameKey = data["nameKey"];
            this.sequenceNo = data["sequenceNo"];
            this.isActive = data["isActive"];
            this.parentId = data["parentId"];
            this.isCalculated = data["isCalculated"];
            this.isYokakKey = data["isYokakKey"];
            if (data["sourceList"] && data["sourceList"].constructor === Array) {
                this.sourceList = [];
                for (let item of data["sourceList"])
                    this.sourceList.push(item);
            }
            if (data["transferTypeList"] && data["transferTypeList"].constructor === Array) {
                this.transferTypeList = [];
                for (let item of data["transferTypeList"])
                    this.transferTypeList.push(item);
            }
            this.formula = data["formula"] ? IndicatorFormulaDto.fromJS(data["formula"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditIndicatorModel {
        let result = new EditIndicatorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameKey"] = this.nameKey;
        data["sequenceNo"] = this.sequenceNo;
        data["isActive"] = this.isActive;
        data["parentId"] = this.parentId;
        data["isCalculated"] = this.isCalculated;
        data["isYokakKey"] = this.isYokakKey;
        if (this.sourceList && this.sourceList.constructor === Array) {
            data["sourceList"] = [];
            for (let item of this.sourceList)
                data["sourceList"].push(item);
        }
        if (this.transferTypeList && this.transferTypeList.constructor === Array) {
            data["transferTypeList"] = [];
            for (let item of this.transferTypeList)
                data["transferTypeList"].push(item);
        }
        data["formula"] = this.formula ? this.formula.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditIndicatorModel {
    nameKey: string;
    sequenceNo: number;
    isActive: boolean;
    parentId: number;
    isCalculated: boolean;
    isYokakKey: boolean;
    sourceList: number[];
    transferTypeList: number[];
    formula: IndicatorFormulaDto;
    id: number;
}

export class ChangeIndicatorActivityInput implements IChangeIndicatorActivityInput {
    isActive: boolean;
    id: number;

    constructor(data?: IChangeIndicatorActivityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChangeIndicatorActivityInput {
        let result = new ChangeIndicatorActivityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface IChangeIndicatorActivityInput {
    isActive: boolean;
    id: number;
}

export class ListResultDtoOfIndicatorsWithAnswersDto implements IListResultDtoOfIndicatorsWithAnswersDto {
    items: IndicatorsWithAnswersDto[];

    constructor(data?: IListResultDtoOfIndicatorsWithAnswersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(IndicatorsWithAnswersDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfIndicatorsWithAnswersDto {
        let result = new ListResultDtoOfIndicatorsWithAnswersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfIndicatorsWithAnswersDto {
    items: IndicatorsWithAnswersDto[];
}

export class IndicatorsWithAnswersDto implements IIndicatorsWithAnswersDto {
    nameKey: string;
    nameValue: string;
    sequenceNo: number;
    isActive: boolean;
    parentId: number;
    isCalculated: boolean;
    formula: string;
    isYokak: boolean;
    answers: IndicatorAnswerDto[];
    subIndicators: IndicatorsWithAnswersDto[];
    id: number;

    constructor(data?: IIndicatorsWithAnswersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nameKey = data["nameKey"];
            this.nameValue = data["nameValue"];
            this.sequenceNo = data["sequenceNo"];
            this.isActive = data["isActive"];
            this.parentId = data["parentId"];
            this.isCalculated = data["isCalculated"];
            this.formula = data["formula"];
            this.isYokak = data["isYokak"];
            if (data["answers"] && data["answers"].constructor === Array) {
                this.answers = [];
                for (let item of data["answers"])
                    this.answers.push(IndicatorAnswerDto.fromJS(item));
            }
            if (data["subIndicators"] && data["subIndicators"].constructor === Array) {
                this.subIndicators = [];
                for (let item of data["subIndicators"])
                    this.subIndicators.push(IndicatorsWithAnswersDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IndicatorsWithAnswersDto {
        let result = new IndicatorsWithAnswersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameKey"] = this.nameKey;
        data["nameValue"] = this.nameValue;
        data["sequenceNo"] = this.sequenceNo;
        data["isActive"] = this.isActive;
        data["parentId"] = this.parentId;
        data["isCalculated"] = this.isCalculated;
        data["formula"] = this.formula;
        data["isYokak"] = this.isYokak;
        if (this.answers && this.answers.constructor === Array) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        if (this.subIndicators && this.subIndicators.constructor === Array) {
            data["subIndicators"] = [];
            for (let item of this.subIndicators)
                data["subIndicators"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IIndicatorsWithAnswersDto {
    nameKey: string;
    nameValue: string;
    sequenceNo: number;
    isActive: boolean;
    parentId: number;
    isCalculated: boolean;
    formula: string;
    isYokak: boolean;
    answers: IndicatorAnswerDto[];
    subIndicators: IndicatorsWithAnswersDto[];
    id: number;
}

export class IndicatorAnswerDto implements IIndicatorAnswerDto {
    indicatorId: number;
    year: number;
    body: number;
    extra: string;
    proofFilesCount: number;
    id: number;

    constructor(data?: IIndicatorAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.indicatorId = data["indicatorId"];
            this.year = data["year"];
            this.body = data["body"];
            this.extra = data["extra"];
            this.proofFilesCount = data["proofFilesCount"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IndicatorAnswerDto {
        let result = new IndicatorAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicatorId"] = this.indicatorId;
        data["year"] = this.year;
        data["body"] = this.body;
        data["extra"] = this.extra;
        data["proofFilesCount"] = this.proofFilesCount;
        data["id"] = this.id;
        return data; 
    }
}

export interface IIndicatorAnswerDto {
    indicatorId: number;
    year: number;
    body: number;
    extra: string;
    proofFilesCount: number;
    id: number;
}

export class CreateOrUpdateIndicatorAnswerInput implements ICreateOrUpdateIndicatorAnswerInput {
    year: number;
    body: number;
    indicatorId: number;
    autoCalculateFormulas: boolean;
    id: number;

    constructor(data?: ICreateOrUpdateIndicatorAnswerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.body = data["body"];
            this.indicatorId = data["indicatorId"];
            this.autoCalculateFormulas = data["autoCalculateFormulas"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateIndicatorAnswerInput {
        let result = new CreateOrUpdateIndicatorAnswerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["body"] = this.body;
        data["indicatorId"] = this.indicatorId;
        data["autoCalculateFormulas"] = this.autoCalculateFormulas;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrUpdateIndicatorAnswerInput {
    year: number;
    body: number;
    indicatorId: number;
    autoCalculateFormulas: boolean;
    id: number;
}

export class CreateOrEditAnswerOutput implements ICreateOrEditAnswerOutput {
    answer: IndicatorAnswerDto;
    calculationResult: IndicatorCalculationResult;

    constructor(data?: ICreateOrEditAnswerOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.answer = data["answer"] ? IndicatorAnswerDto.fromJS(data["answer"]) : <any>undefined;
            this.calculationResult = data["calculationResult"] ? IndicatorCalculationResult.fromJS(data["calculationResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditAnswerOutput {
        let result = new CreateOrEditAnswerOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["calculationResult"] = this.calculationResult ? this.calculationResult.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrEditAnswerOutput {
    answer: IndicatorAnswerDto;
    calculationResult: IndicatorCalculationResult;
}

export class IndicatorCalculationResult implements IIndicatorCalculationResult {
    messages: CalculationMessage[];

    constructor(data?: IIndicatorCalculationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["messages"] && data["messages"].constructor === Array) {
                this.messages = [];
                for (let item of data["messages"])
                    this.messages.push(CalculationMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IndicatorCalculationResult {
        let result = new IndicatorCalculationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.messages && this.messages.constructor === Array) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIndicatorCalculationResult {
    messages: CalculationMessage[];
}

export class CalculationMessage implements ICalculationMessage {
    message: string;
    universityId: number;
    formula: string;
    type: CalculationMessageType;
    year: number;

    constructor(data?: ICalculationMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            this.universityId = data["universityId"];
            this.formula = data["formula"];
            this.type = data["type"];
            this.year = data["year"];
        }
    }

    static fromJS(data: any): CalculationMessage {
        let result = new CalculationMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["universityId"] = this.universityId;
        data["formula"] = this.formula;
        data["type"] = this.type;
        data["year"] = this.year;
        return data; 
    }
}

export interface ICalculationMessage {
    message: string;
    universityId: number;
    formula: string;
    type: CalculationMessageType;
    year: number;
}

export class ListResultDtoOfIndicatorAnswerDto implements IListResultDtoOfIndicatorAnswerDto {
    items: IndicatorAnswerDto[];

    constructor(data?: IListResultDtoOfIndicatorAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(IndicatorAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfIndicatorAnswerDto {
        let result = new ListResultDtoOfIndicatorAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfIndicatorAnswerDto {
    items: IndicatorAnswerDto[];
}

export class AutoCalculateInput implements IAutoCalculateInput {
    indicatorId: number;
    years: number[];
    universities: number[];

    constructor(data?: IAutoCalculateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.indicatorId = data["indicatorId"];
            if (data["years"] && data["years"].constructor === Array) {
                this.years = [];
                for (let item of data["years"])
                    this.years.push(item);
            }
            if (data["universities"] && data["universities"].constructor === Array) {
                this.universities = [];
                for (let item of data["universities"])
                    this.universities.push(item);
            }
        }
    }

    static fromJS(data: any): AutoCalculateInput {
        let result = new AutoCalculateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicatorId"] = this.indicatorId;
        if (this.years && this.years.constructor === Array) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item);
        }
        if (this.universities && this.universities.constructor === Array) {
            data["universities"] = [];
            for (let item of this.universities)
                data["universities"].push(item);
        }
        return data; 
    }
}

export interface IAutoCalculateInput {
    indicatorId: number;
    years: number[];
    universities: number[];
}

export class CreateOrUpdateIndicatorAnswerHostInput implements ICreateOrUpdateIndicatorAnswerHostInput {
    year: number;
    tenantId: number;
    body: number;
    indicatorId: number;
    autoCalculateFormulas: boolean;
    id: number;

    constructor(data?: ICreateOrUpdateIndicatorAnswerHostInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.tenantId = data["tenantId"];
            this.body = data["body"];
            this.indicatorId = data["indicatorId"];
            this.autoCalculateFormulas = data["autoCalculateFormulas"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateIndicatorAnswerHostInput {
        let result = new CreateOrUpdateIndicatorAnswerHostInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["tenantId"] = this.tenantId;
        data["body"] = this.body;
        data["indicatorId"] = this.indicatorId;
        data["autoCalculateFormulas"] = this.autoCalculateFormulas;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrUpdateIndicatorAnswerHostInput {
    year: number;
    tenantId: number;
    body: number;
    indicatorId: number;
    autoCalculateFormulas: boolean;
    id: number;
}

export class ListResultDtoOfGetIndicatorsDto implements IListResultDtoOfGetIndicatorsDto {
    items: GetIndicatorsDto[];

    constructor(data?: IListResultDtoOfGetIndicatorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetIndicatorsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetIndicatorsDto {
        let result = new ListResultDtoOfGetIndicatorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetIndicatorsDto {
    items: GetIndicatorsDto[];
}

export class GetIndicatorsDto implements IGetIndicatorsDto {
    id: number;
    indicator: string;
    parentId: number;
    sequenceNoStr: string;
    sequenceNo: number;
    isYokakKey: boolean;
    children: GetIndicatorsDto[];

    constructor(data?: IGetIndicatorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.indicator = data["indicator"];
            this.parentId = data["parentId"];
            this.sequenceNoStr = data["sequenceNoStr"];
            this.sequenceNo = data["sequenceNo"];
            this.isYokakKey = data["isYokakKey"];
            if (data["children"] && data["children"].constructor === Array) {
                this.children = [];
                for (let item of data["children"])
                    this.children.push(GetIndicatorsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIndicatorsDto {
        let result = new GetIndicatorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["indicator"] = this.indicator;
        data["parentId"] = this.parentId;
        data["sequenceNoStr"] = this.sequenceNoStr;
        data["sequenceNo"] = this.sequenceNo;
        data["isYokakKey"] = this.isYokakKey;
        if (this.children && this.children.constructor === Array) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetIndicatorsDto {
    id: number;
    indicator: string;
    parentId: number;
    sequenceNoStr: string;
    sequenceNo: number;
    isYokakKey: boolean;
    children: GetIndicatorsDto[];
}

export class ListResultDtoOfGetIndicatorByIdOutput implements IListResultDtoOfGetIndicatorByIdOutput {
    items: GetIndicatorByIdOutput[];

    constructor(data?: IListResultDtoOfGetIndicatorByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetIndicatorByIdOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetIndicatorByIdOutput {
        let result = new ListResultDtoOfGetIndicatorByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetIndicatorByIdOutput {
    items: GetIndicatorByIdOutput[];
}

export class GetIndicatorByIdOutput implements IGetIndicatorByIdOutput {
    id: number;
    indicator: string;
    parentId: number;
    sequenceNoStr: string;
    additiveEffect: number;

    constructor(data?: IGetIndicatorByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.indicator = data["indicator"];
            this.parentId = data["parentId"];
            this.sequenceNoStr = data["sequenceNoStr"];
            this.additiveEffect = data["additiveEffect"];
        }
    }

    static fromJS(data: any): GetIndicatorByIdOutput {
        let result = new GetIndicatorByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["indicator"] = this.indicator;
        data["parentId"] = this.parentId;
        data["sequenceNoStr"] = this.sequenceNoStr;
        data["additiveEffect"] = this.additiveEffect;
        return data; 
    }
}

export interface IGetIndicatorByIdOutput {
    id: number;
    indicator: string;
    parentId: number;
    sequenceNoStr: string;
    additiveEffect: number;
}

export class IndicatorPerformanceInput implements IIndicatorPerformanceInput {
    indicatorPerformansList: IndicatorPerformansDto[];
    year: number[];

    constructor(data?: IIndicatorPerformanceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["indicatorPerformansList"] && data["indicatorPerformansList"].constructor === Array) {
                this.indicatorPerformansList = [];
                for (let item of data["indicatorPerformansList"])
                    this.indicatorPerformansList.push(IndicatorPerformansDto.fromJS(item));
            }
            if (data["year"] && data["year"].constructor === Array) {
                this.year = [];
                for (let item of data["year"])
                    this.year.push(item);
            }
        }
    }

    static fromJS(data: any): IndicatorPerformanceInput {
        let result = new IndicatorPerformanceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.indicatorPerformansList && this.indicatorPerformansList.constructor === Array) {
            data["indicatorPerformansList"] = [];
            for (let item of this.indicatorPerformansList)
                data["indicatorPerformansList"].push(item.toJSON());
        }
        if (this.year && this.year.constructor === Array) {
            data["year"] = [];
            for (let item of this.year)
                data["year"].push(item);
        }
        return data; 
    }
}

export interface IIndicatorPerformanceInput {
    indicatorPerformansList: IndicatorPerformansDto[];
    year: number[];
}

export class IndicatorPerformansDto implements IIndicatorPerformansDto {
    indicatorId: number;
    additiveEffect: number;

    constructor(data?: IIndicatorPerformansDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.indicatorId = data["indicatorId"];
            this.additiveEffect = data["additiveEffect"];
        }
    }

    static fromJS(data: any): IndicatorPerformansDto {
        let result = new IndicatorPerformansDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicatorId"] = this.indicatorId;
        data["additiveEffect"] = this.additiveEffect;
        return data; 
    }
}

export interface IIndicatorPerformansDto {
    indicatorId: number;
    additiveEffect: number;
}

export class ListResultDtoOfIndicatorsOutputDto implements IListResultDtoOfIndicatorsOutputDto {
    items: IndicatorsOutputDto[];

    constructor(data?: IListResultDtoOfIndicatorsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(IndicatorsOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfIndicatorsOutputDto {
        let result = new ListResultDtoOfIndicatorsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfIndicatorsOutputDto {
    items: IndicatorsOutputDto[];
}

export class IndicatorsOutputDto implements IIndicatorsOutputDto {
    id: number;
    university: string;
    yearPerformanceList: YearPerformance[];

    constructor(data?: IIndicatorsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.university = data["university"];
            if (data["yearPerformanceList"] && data["yearPerformanceList"].constructor === Array) {
                this.yearPerformanceList = [];
                for (let item of data["yearPerformanceList"])
                    this.yearPerformanceList.push(YearPerformance.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IndicatorsOutputDto {
        let result = new IndicatorsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["university"] = this.university;
        if (this.yearPerformanceList && this.yearPerformanceList.constructor === Array) {
            data["yearPerformanceList"] = [];
            for (let item of this.yearPerformanceList)
                data["yearPerformanceList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIndicatorsOutputDto {
    id: number;
    university: string;
    yearPerformanceList: YearPerformance[];
}

export class YearPerformance implements IYearPerformance {
    year: number;
    performance: number;

    constructor(data?: IYearPerformance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.performance = data["performance"];
        }
    }

    static fromJS(data: any): YearPerformance {
        let result = new YearPerformance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["performance"] = this.performance;
        return data; 
    }
}

export interface IYearPerformance {
    year: number;
    performance: number;
}

export class ListResultDtoOfIndicatorAnswerListOutput implements IListResultDtoOfIndicatorAnswerListOutput {
    items: IndicatorAnswerListOutput[];

    constructor(data?: IListResultDtoOfIndicatorAnswerListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(IndicatorAnswerListOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfIndicatorAnswerListOutput {
        let result = new ListResultDtoOfIndicatorAnswerListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfIndicatorAnswerListOutput {
    items: IndicatorAnswerListOutput[];
}

export class IndicatorAnswerListOutput implements IIndicatorAnswerListOutput {
    id: number;
    university: string;
    yearIndicatorAnswerList: YearIndicatorAnswer[];

    constructor(data?: IIndicatorAnswerListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.university = data["university"];
            if (data["yearIndicatorAnswerList"] && data["yearIndicatorAnswerList"].constructor === Array) {
                this.yearIndicatorAnswerList = [];
                for (let item of data["yearIndicatorAnswerList"])
                    this.yearIndicatorAnswerList.push(YearIndicatorAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IndicatorAnswerListOutput {
        let result = new IndicatorAnswerListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["university"] = this.university;
        if (this.yearIndicatorAnswerList && this.yearIndicatorAnswerList.constructor === Array) {
            data["yearIndicatorAnswerList"] = [];
            for (let item of this.yearIndicatorAnswerList)
                data["yearIndicatorAnswerList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIndicatorAnswerListOutput {
    id: number;
    university: string;
    yearIndicatorAnswerList: YearIndicatorAnswer[];
}

export class YearIndicatorAnswer implements IYearIndicatorAnswer {
    year: number;
    answer: number;

    constructor(data?: IYearIndicatorAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.answer = data["answer"];
        }
    }

    static fromJS(data: any): YearIndicatorAnswer {
        let result = new YearIndicatorAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["answer"] = this.answer;
        return data; 
    }
}

export interface IYearIndicatorAnswer {
    year: number;
    answer: number;
}

export class ListResultDtoOfIndicatorForFilter implements IListResultDtoOfIndicatorForFilter {
    items: IndicatorForFilter[];

    constructor(data?: IListResultDtoOfIndicatorForFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(IndicatorForFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfIndicatorForFilter {
        let result = new ListResultDtoOfIndicatorForFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfIndicatorForFilter {
    items: IndicatorForFilter[];
}

export class IndicatorForFilter implements IIndicatorForFilter {
    id: number;
    name: string;
    sequenceNoStr: string;
    sequenceNo: number;
    isYokakKey: boolean;
    depth: number;

    constructor(data?: IIndicatorForFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.sequenceNoStr = data["sequenceNoStr"];
            this.sequenceNo = data["sequenceNo"];
            this.isYokakKey = data["isYokakKey"];
            this.depth = data["depth"];
        }
    }

    static fromJS(data: any): IndicatorForFilter {
        let result = new IndicatorForFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequenceNoStr"] = this.sequenceNoStr;
        data["sequenceNo"] = this.sequenceNo;
        data["isYokakKey"] = this.isYokakKey;
        data["depth"] = this.depth;
        return data; 
    }
}

export interface IIndicatorForFilter {
    id: number;
    name: string;
    sequenceNoStr: string;
    sequenceNo: number;
    isYokakKey: boolean;
    depth: number;
}

export class ListResultDtoOfRegionsOutput implements IListResultDtoOfRegionsOutput {
    items: RegionsOutput[];

    constructor(data?: IListResultDtoOfRegionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RegionsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRegionsOutput {
        let result = new ListResultDtoOfRegionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfRegionsOutput {
    items: RegionsOutput[];
}

export class RegionsOutput implements IRegionsOutput {
    regionId: string;
    regionName: string;

    constructor(data?: IRegionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.regionId = data["regionId"];
            this.regionName = data["regionName"];
        }
    }

    static fromJS(data: any): RegionsOutput {
        let result = new RegionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        return data; 
    }
}

export interface IRegionsOutput {
    regionId: string;
    regionName: string;
}

export class ListResultDtoOfCountryOutput implements IListResultDtoOfCountryOutput {
    items: CountryOutput[];

    constructor(data?: IListResultDtoOfCountryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CountryOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCountryOutput {
        let result = new ListResultDtoOfCountryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfCountryOutput {
    items: CountryOutput[];
}

export class CountryOutput implements ICountryOutput {
    countryId: string;
    countryName: string;

    constructor(data?: ICountryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countryId = data["countryId"];
            this.countryName = data["countryName"];
        }
    }

    static fromJS(data: any): CountryOutput {
        let result = new CountryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        return data; 
    }
}

export interface ICountryOutput {
    countryId: string;
    countryName: string;
}

export class IndicatorFilterInput implements IIndicatorFilterInput {
    univType: IndicatorFilterInputUnivType;
    missionOriented: IndicatorFilterInputMissionOriented;
    establishmentYear: number;
    isTecnicalUniversity: boolean;
    isHaveMedicalSchool: boolean;
    regionId: string;
    countryId: string;
    years: number[];
    indicatorIds: number[];
    filters: IndicatorFilter[];

    constructor(data?: IIndicatorFilterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.univType = data["univType"];
            this.missionOriented = data["missionOriented"];
            this.establishmentYear = data["establishmentYear"];
            this.isTecnicalUniversity = data["isTecnicalUniversity"];
            this.isHaveMedicalSchool = data["isHaveMedicalSchool"];
            this.regionId = data["regionId"];
            this.countryId = data["countryId"];
            if (data["years"] && data["years"].constructor === Array) {
                this.years = [];
                for (let item of data["years"])
                    this.years.push(item);
            }
            if (data["indicatorIds"] && data["indicatorIds"].constructor === Array) {
                this.indicatorIds = [];
                for (let item of data["indicatorIds"])
                    this.indicatorIds.push(item);
            }
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [];
                for (let item of data["filters"])
                    this.filters.push(IndicatorFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IndicatorFilterInput {
        let result = new IndicatorFilterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["univType"] = this.univType;
        data["missionOriented"] = this.missionOriented;
        data["establishmentYear"] = this.establishmentYear;
        data["isTecnicalUniversity"] = this.isTecnicalUniversity;
        data["isHaveMedicalSchool"] = this.isHaveMedicalSchool;
        data["regionId"] = this.regionId;
        data["countryId"] = this.countryId;
        if (this.years && this.years.constructor === Array) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item);
        }
        if (this.indicatorIds && this.indicatorIds.constructor === Array) {
            data["indicatorIds"] = [];
            for (let item of this.indicatorIds)
                data["indicatorIds"].push(item);
        }
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIndicatorFilterInput {
    univType: IndicatorFilterInputUnivType;
    missionOriented: IndicatorFilterInputMissionOriented;
    establishmentYear: number;
    isTecnicalUniversity: boolean;
    isHaveMedicalSchool: boolean;
    regionId: string;
    countryId: string;
    years: number[];
    indicatorIds: number[];
    filters: IndicatorFilter[];
}

export class IndicatorFilter implements IIndicatorFilter {
    indicatorId: number;
    indicatorName: string;
    minValue: number;
    maxValue: number;

    constructor(data?: IIndicatorFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.indicatorId = data["indicatorId"];
            this.indicatorName = data["indicatorName"];
            this.minValue = data["minValue"];
            this.maxValue = data["maxValue"];
        }
    }

    static fromJS(data: any): IndicatorFilter {
        let result = new IndicatorFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indicatorId"] = this.indicatorId;
        data["indicatorName"] = this.indicatorName;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        return data; 
    }
}

export interface IIndicatorFilter {
    indicatorId: number;
    indicatorName: string;
    minValue: number;
    maxValue: number;
}

export class ListResultDtoOfIndicatorFilterOutput implements IListResultDtoOfIndicatorFilterOutput {
    items: IndicatorFilterOutput[];

    constructor(data?: IListResultDtoOfIndicatorFilterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(IndicatorFilterOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfIndicatorFilterOutput {
        let result = new ListResultDtoOfIndicatorFilterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfIndicatorFilterOutput {
    items: IndicatorFilterOutput[];
}

export class IndicatorFilterOutput implements IIndicatorFilterOutput {
    id: number;
    university: string;
    filteredIndicators: FilteredIndicator[];

    constructor(data?: IIndicatorFilterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.university = data["university"];
            if (data["filteredIndicators"] && data["filteredIndicators"].constructor === Array) {
                this.filteredIndicators = [];
                for (let item of data["filteredIndicators"])
                    this.filteredIndicators.push(FilteredIndicator.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IndicatorFilterOutput {
        let result = new IndicatorFilterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["university"] = this.university;
        if (this.filteredIndicators && this.filteredIndicators.constructor === Array) {
            data["filteredIndicators"] = [];
            for (let item of this.filteredIndicators)
                data["filteredIndicators"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IIndicatorFilterOutput {
    id: number;
    university: string;
    filteredIndicators: FilteredIndicator[];
}

export class FilteredIndicator implements IFilteredIndicator {
    id: number;
    name: string;
    yearAnswer: YearAnswer[];

    constructor(data?: IFilteredIndicator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            if (data["yearAnswer"] && data["yearAnswer"].constructor === Array) {
                this.yearAnswer = [];
                for (let item of data["yearAnswer"])
                    this.yearAnswer.push(YearAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilteredIndicator {
        let result = new FilteredIndicator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (this.yearAnswer && this.yearAnswer.constructor === Array) {
            data["yearAnswer"] = [];
            for (let item of this.yearAnswer)
                data["yearAnswer"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IFilteredIndicator {
    id: number;
    name: string;
    yearAnswer: YearAnswer[];
}

export class YearAnswer implements IYearAnswer {
    year: number;
    answer: number;

    constructor(data?: IYearAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.answer = data["answer"];
        }
    }

    static fromJS(data: any): YearAnswer {
        let result = new YearAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["answer"] = this.answer;
        return data; 
    }
}

export interface IYearAnswer {
    year: number;
    answer: number;
}

export class InstallDto implements IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectionString = data["connectionString"];
            this.adminPassword = data["adminPassword"];
            this.webSiteUrl = data["webSiteUrl"];
            this.serverUrl = data["serverUrl"];
            this.defaultLanguage = data["defaultLanguage"];
            this.smtpSettings = data["smtpSettings"] ? EmailSettingsEditDto.fromJS(data["smtpSettings"]) : <any>undefined;
            this.billInfo = data["billInfo"] ? HostBillingSettingsEditDto.fromJS(data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl: string;
    serverSiteUrl: string;
    languages: NameValue[];

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.webSiteUrl = data["webSiteUrl"];
            this.serverSiteUrl = data["serverSiteUrl"];
            if (data["languages"] && data["languages"].constructor === Array) {
                this.languages = [];
                for (let item of data["languages"])
                    this.languages.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (this.languages && this.languages.constructor === Array) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string;
    serverSiteUrl: string;
    languages: NameValue[];
}

export class NameValue implements INameValue {
    name: string;
    value: string;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface INameValue {
    name: string;
    value: string;
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isDatabaseExist = data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data; 
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class InvoiceDto implements IInvoiceDto {
    amount: number;
    editionDisplayName: string;
    invoiceNo: string;
    invoiceDate: moment.Moment;
    tenantLegalName: string;
    tenantAddress: string[];
    tenantTaxNo: string;
    hostLegalName: string;
    hostAddress: string[];

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amount = data["amount"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.invoiceDate = data["invoiceDate"] ? moment(data["invoiceDate"].toString()) : <any>undefined;
            this.tenantLegalName = data["tenantLegalName"];
            if (data["tenantAddress"] && data["tenantAddress"].constructor === Array) {
                this.tenantAddress = [];
                for (let item of data["tenantAddress"])
                    this.tenantAddress.push(item);
            }
            this.tenantTaxNo = data["tenantTaxNo"];
            this.hostLegalName = data["hostLegalName"];
            if (data["hostAddress"] && data["hostAddress"].constructor === Array) {
                this.hostAddress = [];
                for (let item of data["hostAddress"])
                    this.hostAddress.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (this.tenantAddress && this.tenantAddress.constructor === Array) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (this.hostAddress && this.hostAddress.constructor === Array) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data; 
    }
}

export interface IInvoiceDto {
    amount: number;
    editionDisplayName: string;
    invoiceNo: string;
    invoiceDate: moment.Moment;
    tenantLegalName: string;
    tenantAddress: string[];
    tenantTaxNo: string;
    hostLegalName: string;
    hostAddress: string[];
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subscriptionPaymentId = data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data; 
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class CreateOrUpdateIserFormDto implements ICreateOrUpdateIserFormDto {
    parentId: number;
    title: string;
    nameKey: string;
    isEditor: boolean;
    isActive: boolean;
    sequenceNo: number;
    termId: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    id: number;

    constructor(data?: ICreateOrUpdateIserFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.nameKey = data["nameKey"];
            this.isEditor = data["isEditor"];
            this.isActive = data["isActive"];
            this.sequenceNo = data["sequenceNo"];
            this.termId = data["termId"];
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateIserFormDto {
        let result = new CreateOrUpdateIserFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["nameKey"] = this.nameKey;
        data["isEditor"] = this.isEditor;
        data["isActive"] = this.isActive;
        data["sequenceNo"] = this.sequenceNo;
        data["termId"] = this.termId;
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrUpdateIserFormDto {
    parentId: number;
    title: string;
    nameKey: string;
    isEditor: boolean;
    isActive: boolean;
    sequenceNo: number;
    termId: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    id: number;
}

export class PagedResultDtoOfIserFormDto implements IPagedResultDtoOfIserFormDto {
    totalCount: number;
    items: IserFormDto[];

    constructor(data?: IPagedResultDtoOfIserFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(IserFormDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfIserFormDto {
        let result = new PagedResultDtoOfIserFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfIserFormDto {
    totalCount: number;
    items: IserFormDto[];
}

export class IserFormDto implements IIserFormDto {
    parentId: number;
    grandParentId: number;
    title: string;
    isEditor: boolean;
    isActive: boolean;
    sequenceNo: number;
    termId: number;
    depth: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    id: number;

    constructor(data?: IIserFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.grandParentId = data["grandParentId"];
            this.title = data["title"];
            this.isEditor = data["isEditor"];
            this.isActive = data["isActive"];
            this.sequenceNo = data["sequenceNo"];
            this.termId = data["termId"];
            this.depth = data["depth"];
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IserFormDto {
        let result = new IserFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["grandParentId"] = this.grandParentId;
        data["title"] = this.title;
        data["isEditor"] = this.isEditor;
        data["isActive"] = this.isActive;
        data["sequenceNo"] = this.sequenceNo;
        data["termId"] = this.termId;
        data["depth"] = this.depth;
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        data["id"] = this.id;
        return data; 
    }
}

export interface IIserFormDto {
    parentId: number;
    grandParentId: number;
    title: string;
    isEditor: boolean;
    isActive: boolean;
    sequenceNo: number;
    termId: number;
    depth: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    id: number;
}

export class ListResultDtoOfIserFormDto implements IListResultDtoOfIserFormDto {
    items: IserFormDto[];

    constructor(data?: IListResultDtoOfIserFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(IserFormDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfIserFormDto {
        let result = new ListResultDtoOfIserFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfIserFormDto {
    items: IserFormDto[];
}

export class IserFeedbackFormCompletedAndAnswerDto implements IIserFeedbackFormCompletedAndAnswerDto {
    termId: number;
    tenantId: number;
    isCompleted: boolean;
    isPublished: boolean;
    iserFeedbackFormWithAnswer: IserFeedbackFormWithAnswerDto[];
    id: number;

    constructor(data?: IIserFeedbackFormCompletedAndAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.tenantId = data["tenantId"];
            this.isCompleted = data["isCompleted"];
            this.isPublished = data["isPublished"];
            if (data["iserFeedbackFormWithAnswer"] && data["iserFeedbackFormWithAnswer"].constructor === Array) {
                this.iserFeedbackFormWithAnswer = [];
                for (let item of data["iserFeedbackFormWithAnswer"])
                    this.iserFeedbackFormWithAnswer.push(IserFeedbackFormWithAnswerDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IserFeedbackFormCompletedAndAnswerDto {
        let result = new IserFeedbackFormCompletedAndAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["tenantId"] = this.tenantId;
        data["isCompleted"] = this.isCompleted;
        data["isPublished"] = this.isPublished;
        if (this.iserFeedbackFormWithAnswer && this.iserFeedbackFormWithAnswer.constructor === Array) {
            data["iserFeedbackFormWithAnswer"] = [];
            for (let item of this.iserFeedbackFormWithAnswer)
                data["iserFeedbackFormWithAnswer"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IIserFeedbackFormCompletedAndAnswerDto {
    termId: number;
    tenantId: number;
    isCompleted: boolean;
    isPublished: boolean;
    iserFeedbackFormWithAnswer: IserFeedbackFormWithAnswerDto[];
    id: number;
}

export class IserFeedbackFormWithAnswerDto implements IIserFeedbackFormWithAnswerDto {
    parentId: number;
    title: string;
    isEditor: boolean;
    isActive: boolean;
    sequenceNo: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    subIserFeedbackFormWithAnswer: IserFeedbackFormWithAnswerDto[];
    answer: IserFormAnswerDto;
    id: number;

    constructor(data?: IIserFeedbackFormWithAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.isEditor = data["isEditor"];
            this.isActive = data["isActive"];
            this.sequenceNo = data["sequenceNo"];
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            if (data["subIserFeedbackFormWithAnswer"] && data["subIserFeedbackFormWithAnswer"].constructor === Array) {
                this.subIserFeedbackFormWithAnswer = [];
                for (let item of data["subIserFeedbackFormWithAnswer"])
                    this.subIserFeedbackFormWithAnswer.push(IserFeedbackFormWithAnswerDto.fromJS(item));
            }
            this.answer = data["answer"] ? IserFormAnswerDto.fromJS(data["answer"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IserFeedbackFormWithAnswerDto {
        let result = new IserFeedbackFormWithAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["isEditor"] = this.isEditor;
        data["isActive"] = this.isActive;
        data["sequenceNo"] = this.sequenceNo;
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        if (this.subIserFeedbackFormWithAnswer && this.subIserFeedbackFormWithAnswer.constructor === Array) {
            data["subIserFeedbackFormWithAnswer"] = [];
            for (let item of this.subIserFeedbackFormWithAnswer)
                data["subIserFeedbackFormWithAnswer"].push(item.toJSON());
        }
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IIserFeedbackFormWithAnswerDto {
    parentId: number;
    title: string;
    isEditor: boolean;
    isActive: boolean;
    sequenceNo: number;
    isIntroduction: boolean;
    isConclusion: boolean;
    subIserFeedbackFormWithAnswer: IserFeedbackFormWithAnswerDto[];
    answer: IserFormAnswerDto;
    id: number;
}

export class IserFormAnswerDto implements IIserFormAnswerDto {
    tenantId: number;
    year: number;
    iserFeedbackFormId: number;
    body: string;
    id: number;

    constructor(data?: IIserFormAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.year = data["year"];
            this.iserFeedbackFormId = data["iserFeedbackFormId"];
            this.body = data["body"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IserFormAnswerDto {
        let result = new IserFormAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["year"] = this.year;
        data["iserFeedbackFormId"] = this.iserFeedbackFormId;
        data["body"] = this.body;
        data["id"] = this.id;
        return data; 
    }
}

export interface IIserFormAnswerDto {
    tenantId: number;
    year: number;
    iserFeedbackFormId: number;
    body: string;
    id: number;
}

export class IserFeedbackAnswerCreateOrEdit implements IIserFeedbackAnswerCreateOrEdit {
    tenantId: number;
    year: number;
    body: string;
    iserFeedbackFormId: number;
    id: number;

    constructor(data?: IIserFeedbackAnswerCreateOrEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.year = data["year"];
            this.body = data["body"];
            this.iserFeedbackFormId = data["iserFeedbackFormId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IserFeedbackAnswerCreateOrEdit {
        let result = new IserFeedbackAnswerCreateOrEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["year"] = this.year;
        data["body"] = this.body;
        data["iserFeedbackFormId"] = this.iserFeedbackFormId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IIserFeedbackAnswerCreateOrEdit {
    tenantId: number;
    year: number;
    body: string;
    iserFeedbackFormId: number;
    id: number;
}

export class GetIserFeedbackStatusOutputDto implements IGetIserFeedbackStatusOutputDto {
    id: number;
    termId: number;
    tenantId: number;
    isCompleted: boolean;
    isPublished: boolean;

    constructor(data?: IGetIserFeedbackStatusOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.termId = data["termId"];
            this.tenantId = data["tenantId"];
            this.isCompleted = data["isCompleted"];
            this.isPublished = data["isPublished"];
        }
    }

    static fromJS(data: any): GetIserFeedbackStatusOutputDto {
        let result = new GetIserFeedbackStatusOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["termId"] = this.termId;
        data["tenantId"] = this.tenantId;
        data["isCompleted"] = this.isCompleted;
        data["isPublished"] = this.isPublished;
        return data; 
    }
}

export interface IGetIserFeedbackStatusOutputDto {
    id: number;
    termId: number;
    tenantId: number;
    isCompleted: boolean;
    isPublished: boolean;
}

export class IserFeedbackFormCompletedDto implements IIserFeedbackFormCompletedDto {
    termId: number;
    tenantId: number;
    isCompleted: boolean;
    isPublished: boolean;

    constructor(data?: IIserFeedbackFormCompletedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.tenantId = data["tenantId"];
            this.isCompleted = data["isCompleted"];
            this.isPublished = data["isPublished"];
        }
    }

    static fromJS(data: any): IserFeedbackFormCompletedDto {
        let result = new IserFeedbackFormCompletedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["tenantId"] = this.tenantId;
        data["isCompleted"] = this.isCompleted;
        data["isPublished"] = this.isPublished;
        return data; 
    }
}

export interface IIserFeedbackFormCompletedDto {
    termId: number;
    tenantId: number;
    isCompleted: boolean;
    isPublished: boolean;
}

export class GetIserDataOutputDto implements IGetIserDataOutputDto {
    iserData: string;
    ifrData: string;
    iarData: string;

    constructor(data?: IGetIserDataOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.iserData = data["iserData"];
            this.ifrData = data["ifrData"];
            this.iarData = data["iarData"];
        }
    }

    static fromJS(data: any): GetIserDataOutputDto {
        let result = new GetIserDataOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iserData"] = this.iserData;
        data["ifrData"] = this.ifrData;
        data["iarData"] = this.iarData;
        return data; 
    }
}

export interface IGetIserDataOutputDto {
    iserData: string;
    ifrData: string;
    iarData: string;
}

export class ListResultDtoOfGetIserFeedbackCompletedOutputDto implements IListResultDtoOfGetIserFeedbackCompletedOutputDto {
    items: GetIserFeedbackCompletedOutputDto[];

    constructor(data?: IListResultDtoOfGetIserFeedbackCompletedOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetIserFeedbackCompletedOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetIserFeedbackCompletedOutputDto {
        let result = new ListResultDtoOfGetIserFeedbackCompletedOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetIserFeedbackCompletedOutputDto {
    items: GetIserFeedbackCompletedOutputDto[];
}

export class GetIserFeedbackCompletedOutputDto implements IGetIserFeedbackCompletedOutputDto {
    tenantId: number;
    tenantName: string;

    constructor(data?: IGetIserFeedbackCompletedOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
        }
    }

    static fromJS(data: any): GetIserFeedbackCompletedOutputDto {
        let result = new GetIserFeedbackCompletedOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        return data; 
    }
}

export interface IGetIserFeedbackCompletedOutputDto {
    tenantId: number;
    tenantName: string;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName: string;
    items: ApplicationLanguageListDto[];

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultLanguageName = data["defaultLanguageName"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string;
    items: ApplicationLanguageListDto[];
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId: number;
    name: string;
    displayName: string;
    icon: string;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.icon = data["icon"];
            this.isDisabled = data["isDisabled"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number;
    name: string;
    displayName: string;
    icon: string;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[];
    flags: ComboboxItemDto[];

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : <any>undefined;
            if (data["languageNames"] && data["languageNames"].constructor === Array) {
                this.languageNames = [];
                for (let item of data["languageNames"])
                    this.languageNames.push(ComboboxItemDto.fromJS(item));
            }
            if (data["flags"] && data["flags"].constructor === Array) {
                this.flags = [];
                for (let item of data["flags"])
                    this.flags.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (this.languageNames && this.languageNames.constructor === Array) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (this.flags && this.flags.constructor === Array) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[];
    flags: ComboboxItemDto[];
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id: number;
    name: string;
    icon: string;
    isEnabled: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.icon = data["icon"];
            this.isEnabled = data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data; 
    }
}

export interface IApplicationLanguageEditDto {
    id: number;
    name: string;
    icon: string;
    isEnabled: boolean;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value: string;
    displayText: string;
    isSelected: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data; 
    }
}

export interface IComboboxItemDto {
    value: string;
    displayText: string;
    isSelected: boolean;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto = new ApplicationLanguageEditDto();

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data; 
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[];

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[];
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key: string;
    baseValue: string;
    targetValue: string;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.baseValue = data["baseValue"];
            this.targetValue = data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data; 
    }
}

export interface ILanguageTextListDto {
    key: string;
    baseValue: string;
    targetValue: string;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
            this.sourceName = data["sourceName"];
            this.key = data["key"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data; 
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class CreateOrUpdateMachEvaluationFormDto implements ICreateOrUpdateMachEvaluationFormDto {
    machingEvaluationFormId: number;
    pairedEvaluationFormId: number;
    isMatch: boolean;
    id: number;

    constructor(data?: ICreateOrUpdateMachEvaluationFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.machingEvaluationFormId = data["machingEvaluationFormId"];
            this.pairedEvaluationFormId = data["pairedEvaluationFormId"];
            this.isMatch = data["isMatch"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMachEvaluationFormDto {
        let result = new CreateOrUpdateMachEvaluationFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machingEvaluationFormId"] = this.machingEvaluationFormId;
        data["pairedEvaluationFormId"] = this.pairedEvaluationFormId;
        data["isMatch"] = this.isMatch;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOrUpdateMachEvaluationFormDto {
    machingEvaluationFormId: number;
    pairedEvaluationFormId: number;
    isMatch: boolean;
    id: number;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[];

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.unreadCount = data["unreadCount"];
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[];
}

export class UserNotification implements IUserNotification {
    tenantId: number;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.state = data["state"];
            this.notification = data["notification"] ? TenantNotification.fromJS(data["notification"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserNotification {
    tenantId: number;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
    id: string;
}

export class TenantNotification implements ITenantNotification {
    tenantId: number;
    notificationName: string;
    data: NotificationData;
    entityType: string;
    entityTypeName: string;
    entityId: any;
    severity: TenantNotificationSeverity;
    creationTime: moment.Moment;
    id: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.notificationName = data["notificationName"];
            this.data = data["data"] ? NotificationData.fromJS(data["data"]) : <any>undefined;
            this.entityType = data["entityType"];
            this.entityTypeName = data["entityTypeName"];
            if (data["entityId"]) {
                this.entityId = {};
                for (let key in data["entityId"]) {
                    if (data["entityId"].hasOwnProperty(key))
                        this.entityId[key] = data["entityId"][key];
                }
            }
            this.severity = data["severity"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        if (this.entityId) {
            data["entityId"] = {};
            for (let key in this.entityId) {
                if (this.entityId.hasOwnProperty(key))
                    data["entityId"][key] = this.entityId[key];
            }
        }
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantNotification {
    tenantId: number;
    notificationName: string;
    data: NotificationData;
    entityType: string;
    entityTypeName: string;
    entityId: any;
    severity: TenantNotificationSeverity;
    creationTime: moment.Moment;
    id: string;
}

export class NotificationData implements INotificationData {
    type: string;
    properties: { [key: string] : any; };

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            if (data["properties"]) {
                this.properties = {};
                for (let key in data["properties"]) {
                    if (data["properties"].hasOwnProperty(key))
                        this.properties[key] = data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data; 
    }
}

export interface INotificationData {
    type: string;
    properties: { [key: string] : any; };
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[];

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                for (let item of data["notifications"])
                    this.notifications.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[];
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName: string;
    description: string;
    name: string;
    isSubscribed: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string;
    description: string;
    name: string;
    isSubscribed: boolean;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[];

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                for (let item of data["notifications"])
                    this.notifications.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[];
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data; 
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class CreateOpinionSuggestionInput implements ICreateOpinionSuggestionInput {
    processDateId: number;
    tenantId: number;
    userId: number;
    opinionSuggestionText: string;
    id: number;

    constructor(data?: ICreateOpinionSuggestionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processDateId = data["processDateId"];
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.opinionSuggestionText = data["opinionSuggestionText"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOpinionSuggestionInput {
        let result = new CreateOpinionSuggestionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processDateId"] = this.processDateId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["opinionSuggestionText"] = this.opinionSuggestionText;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateOpinionSuggestionInput {
    processDateId: number;
    tenantId: number;
    userId: number;
    opinionSuggestionText: string;
    id: number;
}

export class EditOpinionSuggestionInput implements IEditOpinionSuggestionInput {
    userId: number;
    opinionSuggestionText: string;
    id: number;

    constructor(data?: IEditOpinionSuggestionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.opinionSuggestionText = data["opinionSuggestionText"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditOpinionSuggestionInput {
        let result = new EditOpinionSuggestionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["opinionSuggestionText"] = this.opinionSuggestionText;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditOpinionSuggestionInput {
    userId: number;
    opinionSuggestionText: string;
    id: number;
}

export class OpinionSuggestionDto implements IOpinionSuggestionDto {
    processDateId: number;
    tenantId: number;
    userId: number;
    opinionSuggestionText: string;
    id: number;

    constructor(data?: IOpinionSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processDateId = data["processDateId"];
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.opinionSuggestionText = data["opinionSuggestionText"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OpinionSuggestionDto {
        let result = new OpinionSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processDateId"] = this.processDateId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["opinionSuggestionText"] = this.opinionSuggestionText;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOpinionSuggestionDto {
    processDateId: number;
    tenantId: number;
    userId: number;
    opinionSuggestionText: string;
    id: number;
}

export class ListResultDtoOfOpinionSuggestionListDto implements IListResultDtoOfOpinionSuggestionListDto {
    items: OpinionSuggestionListDto[];

    constructor(data?: IListResultDtoOfOpinionSuggestionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OpinionSuggestionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOpinionSuggestionListDto {
        let result = new ListResultDtoOfOpinionSuggestionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfOpinionSuggestionListDto {
    items: OpinionSuggestionListDto[];
}

export class OpinionSuggestionListDto implements IOpinionSuggestionListDto {
    processDate: ProcessDateDto;
    isActive: boolean;
    id: number;

    constructor(data?: IOpinionSuggestionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processDate = data["processDate"] ? ProcessDateDto.fromJS(data["processDate"]) : <any>undefined;
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OpinionSuggestionListDto {
        let result = new OpinionSuggestionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processDate"] = this.processDate ? this.processDate.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOpinionSuggestionListDto {
    processDate: ProcessDateDto;
    isActive: boolean;
    id: number;
}

export class ProcessDateDto implements IProcessDateDto {
    processId: number;
    expression: string;
    beginDate: moment.Moment;
    endDate: moment.Moment;
    process: ProcessDto;
    opinionsSuggestions: OpinionSuggestionDto[];
    id: number;

    constructor(data?: IProcessDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processId = data["processId"];
            this.expression = data["expression"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.process = data["process"] ? ProcessDto.fromJS(data["process"]) : <any>undefined;
            if (data["opinionsSuggestions"] && data["opinionsSuggestions"].constructor === Array) {
                this.opinionsSuggestions = [];
                for (let item of data["opinionsSuggestions"])
                    this.opinionsSuggestions.push(OpinionSuggestionDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProcessDateDto {
        let result = new ProcessDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processId"] = this.processId;
        data["expression"] = this.expression;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        if (this.opinionsSuggestions && this.opinionsSuggestions.constructor === Array) {
            data["opinionsSuggestions"] = [];
            for (let item of this.opinionsSuggestions)
                data["opinionsSuggestions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IProcessDateDto {
    processId: number;
    expression: string;
    beginDate: moment.Moment;
    endDate: moment.Moment;
    process: ProcessDto;
    opinionsSuggestions: OpinionSuggestionDto[];
    id: number;
}

export class ProcessDto implements IProcessDto {
    processName: string;
    processType: ProcessDtoProcessType;
    processDates: ProcessDateDto[];
    id: number;

    constructor(data?: IProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processName = data["processName"];
            this.processType = data["processType"];
            if (data["processDates"] && data["processDates"].constructor === Array) {
                this.processDates = [];
                for (let item of data["processDates"])
                    this.processDates.push(ProcessDateDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProcessDto {
        let result = new ProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processName"] = this.processName;
        data["processType"] = this.processType;
        if (this.processDates && this.processDates.constructor === Array) {
            data["processDates"] = [];
            for (let item of this.processDates)
                data["processDates"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IProcessDto {
    processName: string;
    processType: ProcessDtoProcessType;
    processDates: ProcessDateDto[];
    id: number;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[];

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[];
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId: number;
    code: string;
    displayName: string;
    memberCount: number;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.memberCount = data["memberCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitDto {
    parentId: number;
    code: string;
    displayName: string;
    memberCount: number;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[];

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[];
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    profilePictureId: string;
    addedTime: moment.Moment;
    id: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.addedTime = data["addedTime"] ? moment(data["addedTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IOrganizationUnitUserListDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    profilePictureId: string;
    addedTime: moment.Moment;
    id: number;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId: number;
    displayName: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number;
    displayName: string;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data; 
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id: number;
    newParentId: number;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.newParentId = data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data; 
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds: number[];
    organizationUnitId: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["userIds"] && data["userIds"].constructor === Array) {
                this.userIds = [];
                for (let item of data["userIds"])
                    this.userIds.push(item);
            }
            this.organizationUnitId = data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.userIds && this.userIds.constructor === Array) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data; 
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[];
    organizationUnitId: number;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.organizationUnitId = data["organizationUnitId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    edition: EditionSelectDto;
    additionalPrice: number;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            this.additionalPrice = data["additionalPrice"];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["additionalPrice"] = this.additionalPrice;
        return data; 
    }
}

export interface IPaymentInfoDto {
    edition: EditionSelectDto;
    additionalPrice: number;
}

export class EditionSelectDto implements IEditionSelectDto {
    id: number;
    name: string;
    displayName: string;
    expiringEditionId: number;
    monthlyPrice: number;
    annualPrice: number;
    trialDayCount: number;
    waitingDayAfterExpire: number;
    isFree: boolean;
    additionalData: AdditionalData;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.isFree = data["isFree"];
            this.additionalData = data["additionalData"] ? AdditionalData.fromJS(data["additionalData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditionSelectDto {
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string;
    displayName: string;
    expiringEditionId: number;
    monthlyPrice: number;
    annualPrice: number;
    trialDayCount: number;
    waitingDayAfterExpire: number;
    isFree: boolean;
    additionalData: AdditionalData;
}

export class CreatePaymentDto implements ICreatePaymentDto {
    editionId: number;
    editionPaymentType: CreatePaymentDtoEditionPaymentType;
    paymentPeriodType: CreatePaymentDtoPaymentPeriodType;
    subscriptionPaymentGatewayType: CreatePaymentDtoSubscriptionPaymentGatewayType;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.editionId = data["editionId"];
            this.editionPaymentType = data["editionPaymentType"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = data["subscriptionPaymentGatewayType"];
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        return data; 
    }
}

export interface ICreatePaymentDto {
    editionId: number;
    editionPaymentType: CreatePaymentDtoEditionPaymentType;
    paymentPeriodType: CreatePaymentDtoPaymentPeriodType;
    subscriptionPaymentGatewayType: CreatePaymentDtoSubscriptionPaymentGatewayType;
}

export class ExecutePaymentDto implements IExecutePaymentDto {
    gateway: ExecutePaymentDtoGateway;
    editionPaymentType: ExecutePaymentDtoEditionPaymentType;
    editionId: number;
    paymentPeriodType: ExecutePaymentDtoPaymentPeriodType;
    additionalData: { [key: string] : string; };

    constructor(data?: IExecutePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gateway = data["gateway"];
            this.editionPaymentType = data["editionPaymentType"];
            this.editionId = data["editionId"];
            this.paymentPeriodType = data["paymentPeriodType"];
            if (data["additionalData"]) {
                this.additionalData = {};
                for (let key in data["additionalData"]) {
                    if (data["additionalData"].hasOwnProperty(key))
                        this.additionalData[key] = data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExecutePaymentDto {
        let result = new ExecutePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["editionPaymentType"] = this.editionPaymentType;
        data["editionId"] = this.editionId;
        data["paymentPeriodType"] = this.paymentPeriodType;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    data["additionalData"][key] = this.additionalData[key];
            }
        }
        return data; 
    }
}

export interface IExecutePaymentDto {
    gateway: ExecutePaymentDtoGateway;
    editionPaymentType: ExecutePaymentDtoEditionPaymentType;
    editionId: number;
    paymentPeriodType: ExecutePaymentDtoPaymentPeriodType;
    additionalData: { [key: string] : string; };
}

export class PagedResultDtoOfSubscriptionPaymentListDto implements IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number;
    items: SubscriptionPaymentListDto[];

    constructor(data?: IPagedResultDtoOfSubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SubscriptionPaymentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubscriptionPaymentListDto {
        let result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number;
    items: SubscriptionPaymentListDto[];
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    gateway: string;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string;
    paymentId: string;
    payerId: string;
    status: string;
    editionDisplayName: string;
    tenantId: number;
    invoiceNo: string;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.paymentId = data["paymentId"];
            this.payerId = data["payerId"];
            this.status = data["status"];
            this.editionDisplayName = data["editionDisplayName"];
            this.tenantId = data["tenantId"];
            this.invoiceNo = data["invoiceNo"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDto {
        let result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISubscriptionPaymentListDto {
    gateway: string;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string;
    paymentId: string;
    payerId: string;
    status: string;
    editionDisplayName: string;
    tenantId: number;
    invoiceNo: string;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[];

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[];
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level: number;
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    isGrantedByDefault: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.level = data["level"];
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data; 
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    isGrantedByDefault: boolean;
}

export class PtQuestionOutputForEdit implements IPtQuestionOutputForEdit {
    description: string;
    isActive: boolean;
    questionAnswers: PtAnswerOutput[];
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPtQuestionOutputForEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            if (data["questionAnswers"] && data["questionAnswers"].constructor === Array) {
                this.questionAnswers = [];
                for (let item of data["questionAnswers"])
                    this.questionAnswers.push(PtAnswerOutput.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PtQuestionOutputForEdit {
        let result = new PtQuestionOutputForEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (this.questionAnswers && this.questionAnswers.constructor === Array) {
            data["questionAnswers"] = [];
            for (let item of this.questionAnswers)
                data["questionAnswers"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPtQuestionOutputForEdit {
    description: string;
    isActive: boolean;
    questionAnswers: PtAnswerOutput[];
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PtAnswerOutput implements IPtAnswerOutput {
    isCorrect: boolean;
    description: string;
    id: number;

    constructor(data?: IPtAnswerOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isCorrect = data["isCorrect"];
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PtAnswerOutput {
        let result = new PtAnswerOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCorrect"] = this.isCorrect;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPtAnswerOutput {
    isCorrect: boolean;
    description: string;
    id: number;
}

export class CreatePtQuestionInput implements ICreatePtQuestionInput {
    description: string;
    isActive: boolean;
    answers: PtAnswerInput[];

    constructor(data?: ICreatePtQuestionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            if (data["answers"] && data["answers"].constructor === Array) {
                this.answers = [];
                for (let item of data["answers"])
                    this.answers.push(PtAnswerInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePtQuestionInput {
        let result = new CreatePtQuestionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (this.answers && this.answers.constructor === Array) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreatePtQuestionInput {
    description: string;
    isActive: boolean;
    answers: PtAnswerInput[];
}

export class PtAnswerInput implements IPtAnswerInput {
    isCorrect: boolean;
    description: string;

    constructor(data?: IPtAnswerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isCorrect = data["isCorrect"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): PtAnswerInput {
        let result = new PtAnswerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCorrect"] = this.isCorrect;
        data["description"] = this.description;
        return data; 
    }
}

export interface IPtAnswerInput {
    isCorrect: boolean;
    description: string;
}

export class TestSectionOutput implements ITestSectionOutput {
    header: string;
    description: string;
    isActive: boolean;
    sequenceNo: number;
    testId: number;
    id: number;

    constructor(data?: ITestSectionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.header = data["header"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.sequenceNo = data["sequenceNo"];
            this.testId = data["testId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TestSectionOutput {
        let result = new TestSectionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["sequenceNo"] = this.sequenceNo;
        data["testId"] = this.testId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITestSectionOutput {
    header: string;
    description: string;
    isActive: boolean;
    sequenceNo: number;
    testId: number;
    id: number;
}

export class PagedResultDtoOfPtQuestionOutput implements IPagedResultDtoOfPtQuestionOutput {
    totalCount: number;
    items: PtQuestionOutput[];

    constructor(data?: IPagedResultDtoOfPtQuestionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PtQuestionOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPtQuestionOutput {
        let result = new PagedResultDtoOfPtQuestionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPtQuestionOutput {
    totalCount: number;
    items: PtQuestionOutput[];
}

export class PtQuestionOutput implements IPtQuestionOutput {
    description: string;
    isActive: boolean;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPtQuestionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PtQuestionOutput {
        let result = new PtQuestionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPtQuestionOutput {
    description: string;
    isActive: boolean;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CreatePreTrainingTestInput implements ICreatePreTrainingTestInput {
    preTestName: string;
    lastTestName: string;
    preTestDescription: string;
    lastTestDescription: string;
    isActive: boolean;
    termId: number;
    testTime: number;
    preQuestions: PreTestQuestionInput[];

    constructor(data?: ICreatePreTrainingTestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.preTestName = data["preTestName"];
            this.lastTestName = data["lastTestName"];
            this.preTestDescription = data["preTestDescription"];
            this.lastTestDescription = data["lastTestDescription"];
            this.isActive = data["isActive"];
            this.termId = data["termId"];
            this.testTime = data["testTime"];
            if (data["preQuestions"] && data["preQuestions"].constructor === Array) {
                this.preQuestions = [];
                for (let item of data["preQuestions"])
                    this.preQuestions.push(PreTestQuestionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePreTrainingTestInput {
        let result = new CreatePreTrainingTestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preTestName"] = this.preTestName;
        data["lastTestName"] = this.lastTestName;
        data["preTestDescription"] = this.preTestDescription;
        data["lastTestDescription"] = this.lastTestDescription;
        data["isActive"] = this.isActive;
        data["termId"] = this.termId;
        data["testTime"] = this.testTime;
        if (this.preQuestions && this.preQuestions.constructor === Array) {
            data["preQuestions"] = [];
            for (let item of this.preQuestions)
                data["preQuestions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreatePreTrainingTestInput {
    preTestName: string;
    lastTestName: string;
    preTestDescription: string;
    lastTestDescription: string;
    isActive: boolean;
    termId: number;
    testTime: number;
    preQuestions: PreTestQuestionInput[];
}

export class PreTestQuestionInput implements IPreTestQuestionInput {
    questionId: number;
    sectionId: number;
    point: number;
    sequenceNo: number;
    description: string;

    constructor(data?: IPreTestQuestionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questionId = data["questionId"];
            this.sectionId = data["sectionId"];
            this.point = data["point"];
            this.sequenceNo = data["sequenceNo"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): PreTestQuestionInput {
        let result = new PreTestQuestionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["sectionId"] = this.sectionId;
        data["point"] = this.point;
        data["sequenceNo"] = this.sequenceNo;
        data["description"] = this.description;
        return data; 
    }
}

export interface IPreTestQuestionInput {
    questionId: number;
    sectionId: number;
    point: number;
    sequenceNo: number;
    description: string;
}

export class PagedResultDtoOfPreQuestionsOutput implements IPagedResultDtoOfPreQuestionsOutput {
    totalCount: number;
    items: PreQuestionsOutput[];

    constructor(data?: IPagedResultDtoOfPreQuestionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PreQuestionsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPreQuestionsOutput {
        let result = new PagedResultDtoOfPreQuestionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPreQuestionsOutput {
    totalCount: number;
    items: PreQuestionsOutput[];
}

export class PreQuestionsOutput implements IPreQuestionsOutput {
    description: string;
    id: number;

    constructor(data?: IPreQuestionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PreQuestionsOutput {
        let result = new PreQuestionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPreQuestionsOutput {
    description: string;
    id: number;
}

export class PretestEditOutput implements IPretestEditOutput {
    termId: number;
    preTestName: string;
    lastTestName: string;
    preTestDescription: string;
    lastTestDescription: string;
    isActive: boolean;
    sectionId: number;
    testTime: number;
    preQuestions: PreTestQuestionInput[];
    id: number;

    constructor(data?: IPretestEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.preTestName = data["preTestName"];
            this.lastTestName = data["lastTestName"];
            this.preTestDescription = data["preTestDescription"];
            this.lastTestDescription = data["lastTestDescription"];
            this.isActive = data["isActive"];
            this.sectionId = data["sectionId"];
            this.testTime = data["testTime"];
            if (data["preQuestions"] && data["preQuestions"].constructor === Array) {
                this.preQuestions = [];
                for (let item of data["preQuestions"])
                    this.preQuestions.push(PreTestQuestionInput.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PretestEditOutput {
        let result = new PretestEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["preTestName"] = this.preTestName;
        data["lastTestName"] = this.lastTestName;
        data["preTestDescription"] = this.preTestDescription;
        data["lastTestDescription"] = this.lastTestDescription;
        data["isActive"] = this.isActive;
        data["sectionId"] = this.sectionId;
        data["testTime"] = this.testTime;
        if (this.preQuestions && this.preQuestions.constructor === Array) {
            data["preQuestions"] = [];
            for (let item of this.preQuestions)
                data["preQuestions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IPretestEditOutput {
    termId: number;
    preTestName: string;
    lastTestName: string;
    preTestDescription: string;
    lastTestDescription: string;
    isActive: boolean;
    sectionId: number;
    testTime: number;
    preQuestions: PreTestQuestionInput[];
    id: number;
}

export class PretestEditInput implements IPretestEditInput {
    termId: number;
    preTestName: string;
    lastTestName: string;
    preTestDescription: string;
    lastTestDescription: string;
    isActive: boolean;
    sectionId: number;
    testTime: number;
    preQuestions: PreTestQuestionInput[];
    id: number;

    constructor(data?: IPretestEditInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.preTestName = data["preTestName"];
            this.lastTestName = data["lastTestName"];
            this.preTestDescription = data["preTestDescription"];
            this.lastTestDescription = data["lastTestDescription"];
            this.isActive = data["isActive"];
            this.sectionId = data["sectionId"];
            this.testTime = data["testTime"];
            if (data["preQuestions"] && data["preQuestions"].constructor === Array) {
                this.preQuestions = [];
                for (let item of data["preQuestions"])
                    this.preQuestions.push(PreTestQuestionInput.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PretestEditInput {
        let result = new PretestEditInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["preTestName"] = this.preTestName;
        data["lastTestName"] = this.lastTestName;
        data["preTestDescription"] = this.preTestDescription;
        data["lastTestDescription"] = this.lastTestDescription;
        data["isActive"] = this.isActive;
        data["sectionId"] = this.sectionId;
        data["testTime"] = this.testTime;
        if (this.preQuestions && this.preQuestions.constructor === Array) {
            data["preQuestions"] = [];
            for (let item of this.preQuestions)
                data["preQuestions"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IPretestEditInput {
    termId: number;
    preTestName: string;
    lastTestName: string;
    preTestDescription: string;
    lastTestDescription: string;
    isActive: boolean;
    sectionId: number;
    testTime: number;
    preQuestions: PreTestQuestionInput[];
    id: number;
}

export class PagedResultDtoOfPreTrainingTestOutput implements IPagedResultDtoOfPreTrainingTestOutput {
    totalCount: number;
    items: PreTrainingTestOutput[];

    constructor(data?: IPagedResultDtoOfPreTrainingTestOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PreTrainingTestOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPreTrainingTestOutput {
        let result = new PagedResultDtoOfPreTrainingTestOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPreTrainingTestOutput {
    totalCount: number;
    items: PreTrainingTestOutput[];
}

export class PreTrainingTestOutput implements IPreTrainingTestOutput {
    name: string;
    isActive: boolean;
    testTime: number;
    termId: number;
    isEditable: boolean;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPreTrainingTestOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.testTime = data["testTime"];
            this.termId = data["termId"];
            this.isEditable = data["isEditable"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PreTrainingTestOutput {
        let result = new PreTrainingTestOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["testTime"] = this.testTime;
        data["termId"] = this.termId;
        data["isEditable"] = this.isEditable;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPreTrainingTestOutput {
    name: string;
    isActive: boolean;
    testTime: number;
    termId: number;
    isEditable: boolean;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PreviousExternalEvaluationAnswerInput implements IPreviousExternalEvaluationAnswerInput {
    universityId: number;
    year: number;
    mainEvaluationFormId: number;
    subEvaluationFormId: number;

    constructor(data?: IPreviousExternalEvaluationAnswerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.universityId = data["universityId"];
            this.year = data["year"];
            this.mainEvaluationFormId = data["mainEvaluationFormId"];
            this.subEvaluationFormId = data["subEvaluationFormId"];
        }
    }

    static fromJS(data: any): PreviousExternalEvaluationAnswerInput {
        let result = new PreviousExternalEvaluationAnswerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityId"] = this.universityId;
        data["year"] = this.year;
        data["mainEvaluationFormId"] = this.mainEvaluationFormId;
        data["subEvaluationFormId"] = this.subEvaluationFormId;
        return data; 
    }
}

export interface IPreviousExternalEvaluationAnswerInput {
    universityId: number;
    year: number;
    mainEvaluationFormId: number;
    subEvaluationFormId: number;
}

export class ListResultDtoOfPreviousExternalEvaluationAnswerOutput implements IListResultDtoOfPreviousExternalEvaluationAnswerOutput {
    items: PreviousExternalEvaluationAnswerOutput[];

    constructor(data?: IListResultDtoOfPreviousExternalEvaluationAnswerOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PreviousExternalEvaluationAnswerOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPreviousExternalEvaluationAnswerOutput {
        let result = new ListResultDtoOfPreviousExternalEvaluationAnswerOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPreviousExternalEvaluationAnswerOutput {
    items: PreviousExternalEvaluationAnswerOutput[];
}

export class PreviousExternalEvaluationAnswerOutput implements IPreviousExternalEvaluationAnswerOutput {
    parentId: number;
    title: string;
    sequenceNo: number;
    evlFormAnswerDto: EvlFormAnswerDto;
    id: number;

    constructor(data?: IPreviousExternalEvaluationAnswerOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentId = data["parentId"];
            this.title = data["title"];
            this.sequenceNo = data["sequenceNo"];
            this.evlFormAnswerDto = data["evlFormAnswerDto"] ? EvlFormAnswerDto.fromJS(data["evlFormAnswerDto"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PreviousExternalEvaluationAnswerOutput {
        let result = new PreviousExternalEvaluationAnswerOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["title"] = this.title;
        data["sequenceNo"] = this.sequenceNo;
        data["evlFormAnswerDto"] = this.evlFormAnswerDto ? this.evlFormAnswerDto.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPreviousExternalEvaluationAnswerOutput {
    parentId: number;
    title: string;
    sequenceNo: number;
    evlFormAnswerDto: EvlFormAnswerDto;
    id: number;
}

export class EvlFormAnswerDto implements IEvlFormAnswerDto {
    evaluationFormId: number;
    year: number;
    body: string;
    universityId: number;
    extAnswerDto: ExtAnswerDto;
    id: number;

    constructor(data?: IEvlFormAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evaluationFormId = data["evaluationFormId"];
            this.year = data["year"];
            this.body = data["body"];
            this.universityId = data["universityId"];
            this.extAnswerDto = data["extAnswerDto"] ? ExtAnswerDto.fromJS(data["extAnswerDto"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvlFormAnswerDto {
        let result = new EvlFormAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationFormId"] = this.evaluationFormId;
        data["year"] = this.year;
        data["body"] = this.body;
        data["universityId"] = this.universityId;
        data["extAnswerDto"] = this.extAnswerDto ? this.extAnswerDto.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvlFormAnswerDto {
    evaluationFormId: number;
    year: number;
    body: string;
    universityId: number;
    extAnswerDto: ExtAnswerDto;
    id: number;
}

export class ExtAnswerDto implements IExtAnswerDto {
    body: string;
    id: number;

    constructor(data?: IExtAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.body = data["body"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ExtAnswerDto {
        let result = new ExtAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        data["id"] = this.id;
        return data; 
    }
}

export interface IExtAnswerDto {
    body: string;
    id: number;
}

export class ListResultDtoOfPrgAccFeedbackOutput implements IListResultDtoOfPrgAccFeedbackOutput {
    items: PrgAccFeedbackOutput[];

    constructor(data?: IListResultDtoOfPrgAccFeedbackOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PrgAccFeedbackOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPrgAccFeedbackOutput {
        let result = new ListResultDtoOfPrgAccFeedbackOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPrgAccFeedbackOutput {
    items: PrgAccFeedbackOutput[];
}

export class PrgAccFeedbackOutput implements IPrgAccFeedbackOutput {
    name: string;
    description: string;
    isActive: boolean;
    termId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPrgAccFeedbackOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.termId = data["termId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PrgAccFeedbackOutput {
        let result = new PrgAccFeedbackOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["termId"] = this.termId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPrgAccFeedbackOutput {
    name: string;
    description: string;
    isActive: boolean;
    termId: number;
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PrgAccFeedbackCreateInput implements IPrgAccFeedbackCreateInput {
    name: string;
    description: string;
    isActive: boolean;
    termId: number;
    prgAccFeedbackQuestions: PrgAccFeedbackQuestionDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPrgAccFeedbackCreateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.termId = data["termId"];
            if (data["prgAccFeedbackQuestions"] && data["prgAccFeedbackQuestions"].constructor === Array) {
                this.prgAccFeedbackQuestions = [];
                for (let item of data["prgAccFeedbackQuestions"])
                    this.prgAccFeedbackQuestions.push(PrgAccFeedbackQuestionDto.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PrgAccFeedbackCreateInput {
        let result = new PrgAccFeedbackCreateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["termId"] = this.termId;
        if (this.prgAccFeedbackQuestions && this.prgAccFeedbackQuestions.constructor === Array) {
            data["prgAccFeedbackQuestions"] = [];
            for (let item of this.prgAccFeedbackQuestions)
                data["prgAccFeedbackQuestions"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPrgAccFeedbackCreateInput {
    name: string;
    description: string;
    isActive: boolean;
    termId: number;
    prgAccFeedbackQuestions: PrgAccFeedbackQuestionDto[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PrgAccFeedbackQuestionDto implements IPrgAccFeedbackQuestionDto {
    prgAccFeedbackId: number;
    prgAccQuestionId: number;
    prgAccQuestionName: string;
    prgAccQuestionGroupText: string;
    prgAccQuestionTypeText: string;

    constructor(data?: IPrgAccFeedbackQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.prgAccFeedbackId = data["prgAccFeedbackId"];
            this.prgAccQuestionId = data["prgAccQuestionId"];
            this.prgAccQuestionName = data["prgAccQuestionName"];
            this.prgAccQuestionGroupText = data["prgAccQuestionGroupText"];
            this.prgAccQuestionTypeText = data["prgAccQuestionTypeText"];
        }
    }

    static fromJS(data: any): PrgAccFeedbackQuestionDto {
        let result = new PrgAccFeedbackQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prgAccFeedbackId"] = this.prgAccFeedbackId;
        data["prgAccQuestionId"] = this.prgAccQuestionId;
        data["prgAccQuestionName"] = this.prgAccQuestionName;
        data["prgAccQuestionGroupText"] = this.prgAccQuestionGroupText;
        data["prgAccQuestionTypeText"] = this.prgAccQuestionTypeText;
        return data; 
    }
}

export interface IPrgAccFeedbackQuestionDto {
    prgAccFeedbackId: number;
    prgAccQuestionId: number;
    prgAccQuestionName: string;
    prgAccQuestionGroupText: string;
    prgAccQuestionTypeText: string;
}

export class PagedResultDtoOfPrgAccQuestionOutput implements IPagedResultDtoOfPrgAccQuestionOutput {
    totalCount: number;
    items: PrgAccQuestionOutput[];

    constructor(data?: IPagedResultDtoOfPrgAccQuestionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PrgAccQuestionOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPrgAccQuestionOutput {
        let result = new PagedResultDtoOfPrgAccQuestionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPrgAccQuestionOutput {
    totalCount: number;
    items: PrgAccQuestionOutput[];
}

export class PrgAccQuestionOutput implements IPrgAccQuestionOutput {
    name: string;
    prgAccQuestionTypeId: number;
    prgAccQuestionTypeText: string;
    prgAccQuestionGroupId: number;
    prgAccQuestionGroupText: string;
    termId: number;
    prgAccQuestionChoices: PrgAccQuestionChoiceDto[];
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IPrgAccQuestionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.prgAccQuestionTypeId = data["prgAccQuestionTypeId"];
            this.prgAccQuestionTypeText = data["prgAccQuestionTypeText"];
            this.prgAccQuestionGroupId = data["prgAccQuestionGroupId"];
            this.prgAccQuestionGroupText = data["prgAccQuestionGroupText"];
            this.termId = data["termId"];
            if (data["prgAccQuestionChoices"] && data["prgAccQuestionChoices"].constructor === Array) {
                this.prgAccQuestionChoices = [];
                for (let item of data["prgAccQuestionChoices"])
                    this.prgAccQuestionChoices.push(PrgAccQuestionChoiceDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PrgAccQuestionOutput {
        let result = new PrgAccQuestionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["prgAccQuestionTypeId"] = this.prgAccQuestionTypeId;
        data["prgAccQuestionTypeText"] = this.prgAccQuestionTypeText;
        data["prgAccQuestionGroupId"] = this.prgAccQuestionGroupId;
        data["prgAccQuestionGroupText"] = this.prgAccQuestionGroupText;
        data["termId"] = this.termId;
        if (this.prgAccQuestionChoices && this.prgAccQuestionChoices.constructor === Array) {
            data["prgAccQuestionChoices"] = [];
            for (let item of this.prgAccQuestionChoices)
                data["prgAccQuestionChoices"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPrgAccQuestionOutput {
    name: string;
    prgAccQuestionTypeId: number;
    prgAccQuestionTypeText: string;
    prgAccQuestionGroupId: number;
    prgAccQuestionGroupText: string;
    termId: number;
    prgAccQuestionChoices: PrgAccQuestionChoiceDto[];
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class PrgAccQuestionChoiceDto implements IPrgAccQuestionChoiceDto {
    name: string;
    value: number;
    id: number;

    constructor(data?: IPrgAccQuestionChoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PrgAccQuestionChoiceDto {
        let result = new PrgAccQuestionChoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPrgAccQuestionChoiceDto {
    name: string;
    value: number;
    id: number;
}

export class PrgAccResultProgramsInput implements IPrgAccResultProgramsInput {
    termId: number;
    tenantId: number;

    constructor(data?: IPrgAccResultProgramsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): PrgAccResultProgramsInput {
        let result = new PrgAccResultProgramsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["tenantId"] = this.tenantId;
        return data; 
    }
}

export interface IPrgAccResultProgramsInput {
    termId: number;
    tenantId: number;
}

export class ListResultDtoOfPrgAccResultProgramsOutput implements IListResultDtoOfPrgAccResultProgramsOutput {
    items: PrgAccResultProgramsOutput[];

    constructor(data?: IListResultDtoOfPrgAccResultProgramsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PrgAccResultProgramsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPrgAccResultProgramsOutput {
        let result = new ListResultDtoOfPrgAccResultProgramsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPrgAccResultProgramsOutput {
    items: PrgAccResultProgramsOutput[];
}

export class PrgAccResultProgramsOutput implements IPrgAccResultProgramsOutput {
    prgAccFeedbackId: number;
    yoksisUniversityId: number;
    tenantId: number;
    tenantName: string;
    facultyId: number;
    facultyName: string;
    programId: number;
    programName: string;
    accreditationAgenyId: number;
    accreditationAgenyName: string;
    visitBeginDate: moment.Moment;
    visitEndDate: moment.Moment;
    isAccredited: boolean;
    accreditedBeginDate: moment.Moment;
    accreditedEndDate: moment.Moment;
    isCompleted: boolean;

    constructor(data?: IPrgAccResultProgramsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.prgAccFeedbackId = data["prgAccFeedbackId"];
            this.yoksisUniversityId = data["yoksisUniversityId"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
            this.facultyId = data["facultyId"];
            this.facultyName = data["facultyName"];
            this.programId = data["programId"];
            this.programName = data["programName"];
            this.accreditationAgenyId = data["accreditationAgenyId"];
            this.accreditationAgenyName = data["accreditationAgenyName"];
            this.visitBeginDate = data["visitBeginDate"] ? moment(data["visitBeginDate"].toString()) : <any>undefined;
            this.visitEndDate = data["visitEndDate"] ? moment(data["visitEndDate"].toString()) : <any>undefined;
            this.isAccredited = data["isAccredited"];
            this.accreditedBeginDate = data["accreditedBeginDate"] ? moment(data["accreditedBeginDate"].toString()) : <any>undefined;
            this.accreditedEndDate = data["accreditedEndDate"] ? moment(data["accreditedEndDate"].toString()) : <any>undefined;
            this.isCompleted = data["isCompleted"];
        }
    }

    static fromJS(data: any): PrgAccResultProgramsOutput {
        let result = new PrgAccResultProgramsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prgAccFeedbackId"] = this.prgAccFeedbackId;
        data["yoksisUniversityId"] = this.yoksisUniversityId;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["facultyId"] = this.facultyId;
        data["facultyName"] = this.facultyName;
        data["programId"] = this.programId;
        data["programName"] = this.programName;
        data["accreditationAgenyId"] = this.accreditationAgenyId;
        data["accreditationAgenyName"] = this.accreditationAgenyName;
        data["visitBeginDate"] = this.visitBeginDate ? this.visitBeginDate.toISOString() : <any>undefined;
        data["visitEndDate"] = this.visitEndDate ? this.visitEndDate.toISOString() : <any>undefined;
        data["isAccredited"] = this.isAccredited;
        data["accreditedBeginDate"] = this.accreditedBeginDate ? this.accreditedBeginDate.toISOString() : <any>undefined;
        data["accreditedEndDate"] = this.accreditedEndDate ? this.accreditedEndDate.toISOString() : <any>undefined;
        data["isCompleted"] = this.isCompleted;
        return data; 
    }
}

export interface IPrgAccResultProgramsOutput {
    prgAccFeedbackId: number;
    yoksisUniversityId: number;
    tenantId: number;
    tenantName: string;
    facultyId: number;
    facultyName: string;
    programId: number;
    programName: string;
    accreditationAgenyId: number;
    accreditationAgenyName: string;
    visitBeginDate: moment.Moment;
    visitEndDate: moment.Moment;
    isAccredited: boolean;
    accreditedBeginDate: moment.Moment;
    accreditedEndDate: moment.Moment;
    isCompleted: boolean;
}

export class PrgAccProgramsDetailOutput implements IPrgAccProgramsDetailOutput {
    prgAccFeedbackId: number;
    prgAccAnswers: PrgAccAnswer[];
    prgAccTeam: PrgAccTeam[];

    constructor(data?: IPrgAccProgramsDetailOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.prgAccFeedbackId = data["prgAccFeedbackId"];
            if (data["prgAccAnswers"] && data["prgAccAnswers"].constructor === Array) {
                this.prgAccAnswers = [];
                for (let item of data["prgAccAnswers"])
                    this.prgAccAnswers.push(PrgAccAnswer.fromJS(item));
            }
            if (data["prgAccTeam"] && data["prgAccTeam"].constructor === Array) {
                this.prgAccTeam = [];
                for (let item of data["prgAccTeam"])
                    this.prgAccTeam.push(PrgAccTeam.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrgAccProgramsDetailOutput {
        let result = new PrgAccProgramsDetailOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prgAccFeedbackId"] = this.prgAccFeedbackId;
        if (this.prgAccAnswers && this.prgAccAnswers.constructor === Array) {
            data["prgAccAnswers"] = [];
            for (let item of this.prgAccAnswers)
                data["prgAccAnswers"].push(item.toJSON());
        }
        if (this.prgAccTeam && this.prgAccTeam.constructor === Array) {
            data["prgAccTeam"] = [];
            for (let item of this.prgAccTeam)
                data["prgAccTeam"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPrgAccProgramsDetailOutput {
    prgAccFeedbackId: number;
    prgAccAnswers: PrgAccAnswer[];
    prgAccTeam: PrgAccTeam[];
}

export class PrgAccAnswer implements IPrgAccAnswer {
    prgAccQuestionId: number;
    prgAccQuestionText: string;
    prgAccQuestionChoiceId: number;
    prgAccQuestionChoiceText: string;
    prgAccFeedbackAnswerText: string;

    constructor(data?: IPrgAccAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.prgAccQuestionId = data["prgAccQuestionId"];
            this.prgAccQuestionText = data["prgAccQuestionText"];
            this.prgAccQuestionChoiceId = data["prgAccQuestionChoiceId"];
            this.prgAccQuestionChoiceText = data["prgAccQuestionChoiceText"];
            this.prgAccFeedbackAnswerText = data["prgAccFeedbackAnswerText"];
        }
    }

    static fromJS(data: any): PrgAccAnswer {
        let result = new PrgAccAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prgAccQuestionId"] = this.prgAccQuestionId;
        data["prgAccQuestionText"] = this.prgAccQuestionText;
        data["prgAccQuestionChoiceId"] = this.prgAccQuestionChoiceId;
        data["prgAccQuestionChoiceText"] = this.prgAccQuestionChoiceText;
        data["prgAccFeedbackAnswerText"] = this.prgAccFeedbackAnswerText;
        return data; 
    }
}

export interface IPrgAccAnswer {
    prgAccQuestionId: number;
    prgAccQuestionText: string;
    prgAccQuestionChoiceId: number;
    prgAccQuestionChoiceText: string;
    prgAccFeedbackAnswerText: string;
}

export class PrgAccTeam implements IPrgAccTeam {
    name: string;
    lastName: string;
    isTeamLeader: boolean;

    constructor(data?: IPrgAccTeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.isTeamLeader = data["isTeamLeader"];
        }
    }

    static fromJS(data: any): PrgAccTeam {
        let result = new PrgAccTeam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["isTeamLeader"] = this.isTeamLeader;
        return data; 
    }
}

export interface IPrgAccTeam {
    name: string;
    lastName: string;
    isTeamLeader: boolean;
}

export class ListResultDtoOfPrgAccAllResultOutput implements IListResultDtoOfPrgAccAllResultOutput {
    items: PrgAccAllResultOutput[];

    constructor(data?: IListResultDtoOfPrgAccAllResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PrgAccAllResultOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPrgAccAllResultOutput {
        let result = new ListResultDtoOfPrgAccAllResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPrgAccAllResultOutput {
    items: PrgAccAllResultOutput[];
}

export class PrgAccAllResultOutput implements IPrgAccAllResultOutput {
    yoksisUniversityId: number;
    universityName: string;
    facultyId: number;
    facultyName: string;
    programId: number;
    programName: string;
    accreditationAgenyName: string;
    visitBeginDate: moment.Moment;
    visitEndDate: moment.Moment;
    accreditedBeginDate: moment.Moment;
    accreditedEndDate: moment.Moment;
    isAccredited: boolean;
    isCompleted: boolean;
    questionName: string;
    choiceName: string;
    choiceValue: number;
    prgAccFeedbackAnswerText: string;

    constructor(data?: IPrgAccAllResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.yoksisUniversityId = data["yoksisUniversityId"];
            this.universityName = data["universityName"];
            this.facultyId = data["facultyId"];
            this.facultyName = data["facultyName"];
            this.programId = data["programId"];
            this.programName = data["programName"];
            this.accreditationAgenyName = data["accreditationAgenyName"];
            this.visitBeginDate = data["visitBeginDate"] ? moment(data["visitBeginDate"].toString()) : <any>undefined;
            this.visitEndDate = data["visitEndDate"] ? moment(data["visitEndDate"].toString()) : <any>undefined;
            this.accreditedBeginDate = data["accreditedBeginDate"] ? moment(data["accreditedBeginDate"].toString()) : <any>undefined;
            this.accreditedEndDate = data["accreditedEndDate"] ? moment(data["accreditedEndDate"].toString()) : <any>undefined;
            this.isAccredited = data["isAccredited"];
            this.isCompleted = data["isCompleted"];
            this.questionName = data["questionName"];
            this.choiceName = data["choiceName"];
            this.choiceValue = data["choiceValue"];
            this.prgAccFeedbackAnswerText = data["prgAccFeedbackAnswerText"];
        }
    }

    static fromJS(data: any): PrgAccAllResultOutput {
        let result = new PrgAccAllResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yoksisUniversityId"] = this.yoksisUniversityId;
        data["universityName"] = this.universityName;
        data["facultyId"] = this.facultyId;
        data["facultyName"] = this.facultyName;
        data["programId"] = this.programId;
        data["programName"] = this.programName;
        data["accreditationAgenyName"] = this.accreditationAgenyName;
        data["visitBeginDate"] = this.visitBeginDate ? this.visitBeginDate.toISOString() : <any>undefined;
        data["visitEndDate"] = this.visitEndDate ? this.visitEndDate.toISOString() : <any>undefined;
        data["accreditedBeginDate"] = this.accreditedBeginDate ? this.accreditedBeginDate.toISOString() : <any>undefined;
        data["accreditedEndDate"] = this.accreditedEndDate ? this.accreditedEndDate.toISOString() : <any>undefined;
        data["isAccredited"] = this.isAccredited;
        data["isCompleted"] = this.isCompleted;
        data["questionName"] = this.questionName;
        data["choiceName"] = this.choiceName;
        data["choiceValue"] = this.choiceValue;
        data["prgAccFeedbackAnswerText"] = this.prgAccFeedbackAnswerText;
        return data; 
    }
}

export interface IPrgAccAllResultOutput {
    yoksisUniversityId: number;
    universityName: string;
    facultyId: number;
    facultyName: string;
    programId: number;
    programName: string;
    accreditationAgenyName: string;
    visitBeginDate: moment.Moment;
    visitEndDate: moment.Moment;
    accreditedBeginDate: moment.Moment;
    accreditedEndDate: moment.Moment;
    isAccredited: boolean;
    isCompleted: boolean;
    questionName: string;
    choiceName: string;
    choiceValue: number;
    prgAccFeedbackAnswerText: string;
}

export class CreateorUpdatePrgAccQuestionInput implements ICreateorUpdatePrgAccQuestionInput {
    name: string;
    prgAccQuestionTypeId: number;
    prgAccQuestionGroupId: number;
    termId: number;
    prgAccQuestionChoices: PrgAccQuestionChoiceDto[];
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ICreateorUpdatePrgAccQuestionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.prgAccQuestionTypeId = data["prgAccQuestionTypeId"];
            this.prgAccQuestionGroupId = data["prgAccQuestionGroupId"];
            this.termId = data["termId"];
            if (data["prgAccQuestionChoices"] && data["prgAccQuestionChoices"].constructor === Array) {
                this.prgAccQuestionChoices = [];
                for (let item of data["prgAccQuestionChoices"])
                    this.prgAccQuestionChoices.push(PrgAccQuestionChoiceDto.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateorUpdatePrgAccQuestionInput {
        let result = new CreateorUpdatePrgAccQuestionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["prgAccQuestionTypeId"] = this.prgAccQuestionTypeId;
        data["prgAccQuestionGroupId"] = this.prgAccQuestionGroupId;
        data["termId"] = this.termId;
        if (this.prgAccQuestionChoices && this.prgAccQuestionChoices.constructor === Array) {
            data["prgAccQuestionChoices"] = [];
            for (let item of this.prgAccQuestionChoices)
                data["prgAccQuestionChoices"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateorUpdatePrgAccQuestionInput {
    name: string;
    prgAccQuestionTypeId: number;
    prgAccQuestionGroupId: number;
    termId: number;
    prgAccQuestionChoices: PrgAccQuestionChoiceDto[];
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ListResultDtoOfPrgAccQuestionGroupOutput implements IListResultDtoOfPrgAccQuestionGroupOutput {
    items: PrgAccQuestionGroupOutput[];

    constructor(data?: IListResultDtoOfPrgAccQuestionGroupOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PrgAccQuestionGroupOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPrgAccQuestionGroupOutput {
        let result = new ListResultDtoOfPrgAccQuestionGroupOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPrgAccQuestionGroupOutput {
    items: PrgAccQuestionGroupOutput[];
}

export class PrgAccQuestionGroupOutput implements IPrgAccQuestionGroupOutput {
    name: string;
    id: number;

    constructor(data?: IPrgAccQuestionGroupOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PrgAccQuestionGroupOutput {
        let result = new PrgAccQuestionGroupOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPrgAccQuestionGroupOutput {
    name: string;
    id: number;
}

export class ListResultDtoOfPrgAccQuestionTypeOutput implements IListResultDtoOfPrgAccQuestionTypeOutput {
    items: PrgAccQuestionTypeOutput[];

    constructor(data?: IListResultDtoOfPrgAccQuestionTypeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PrgAccQuestionTypeOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPrgAccQuestionTypeOutput {
        let result = new ListResultDtoOfPrgAccQuestionTypeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfPrgAccQuestionTypeOutput {
    items: PrgAccQuestionTypeOutput[];
}

export class PrgAccQuestionTypeOutput implements IPrgAccQuestionTypeOutput {
    name: string;
    id: number;

    constructor(data?: IPrgAccQuestionTypeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PrgAccQuestionTypeOutput {
        let result = new PrgAccQuestionTypeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface IPrgAccQuestionTypeOutput {
    name: string;
    id: number;
}

export class EditProcessInput implements IEditProcessInput {
    processName: string;
    processTypeStr: string;
    id: number;

    constructor(data?: IEditProcessInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processName = data["processName"];
            this.processTypeStr = data["processTypeStr"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditProcessInput {
        let result = new EditProcessInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processName"] = this.processName;
        data["processTypeStr"] = this.processTypeStr;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditProcessInput {
    processName: string;
    processTypeStr: string;
    id: number;
}

export class ListResultDtoOfProcessListDto implements IListResultDtoOfProcessListDto {
    items: ProcessListDto[];

    constructor(data?: IListResultDtoOfProcessListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ProcessListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfProcessListDto {
        let result = new ListResultDtoOfProcessListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfProcessListDto {
    items: ProcessListDto[];
}

export class ProcessListDto implements IProcessListDto {
    processName: string;
    processTypeStr: string;
    id: number;

    constructor(data?: IProcessListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processName = data["processName"];
            this.processTypeStr = data["processTypeStr"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProcessListDto {
        let result = new ProcessListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processName"] = this.processName;
        data["processTypeStr"] = this.processTypeStr;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProcessListDto {
    processName: string;
    processTypeStr: string;
    id: number;
}

export class CreateProcessDateInput implements ICreateProcessDateInput {
    processId: number;
    expression: string;
    beginDate: moment.Moment;
    endDate: moment.Moment;
    id: number;

    constructor(data?: ICreateProcessDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processId = data["processId"];
            this.expression = data["expression"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateProcessDateInput {
        let result = new CreateProcessDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processId"] = this.processId;
        data["expression"] = this.expression;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateProcessDateInput {
    processId: number;
    expression: string;
    beginDate: moment.Moment;
    endDate: moment.Moment;
    id: number;
}

export class EditProcessDateDto implements IEditProcessDateDto {
    expression: string;
    beginDate: moment.Moment;
    endDate: moment.Moment;
    id: number;

    constructor(data?: IEditProcessDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.expression = data["expression"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditProcessDateDto {
        let result = new EditProcessDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditProcessDateDto {
    expression: string;
    beginDate: moment.Moment;
    endDate: moment.Moment;
    id: number;
}

export class ListResultDtoOfProcessDateListDto implements IListResultDtoOfProcessDateListDto {
    items: ProcessDateListDto[];

    constructor(data?: IListResultDtoOfProcessDateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ProcessDateListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfProcessDateListDto {
        let result = new ListResultDtoOfProcessDateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfProcessDateListDto {
    items: ProcessDateListDto[];
}

export class ProcessDateListDto implements IProcessDateListDto {
    processName: string;
    expression: string;
    beginDate: moment.Moment;
    endDate: moment.Moment;
    id: number;

    constructor(data?: IProcessDateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.processName = data["processName"];
            this.expression = data["expression"];
            this.beginDate = data["beginDate"] ? moment(data["beginDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProcessDateListDto {
        let result = new ProcessDateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processName"] = this.processName;
        data["expression"] = this.expression;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IProcessDateListDto {
    processName: string;
    expression: string;
    beginDate: moment.Moment;
    endDate: moment.Moment;
    id: number;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    isPhoneNumberConfirmed: boolean;
    timezone: string;
    qrCodeSetupImageUrl: string;
    isGoogleAuthenticatorEnabled: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.timezone = data["timezone"];
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data; 
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    isPhoneNumberConfirmed: boolean;
    timezone: string;
    qrCodeSetupImageUrl: string;
    isGoogleAuthenticatorEnabled: boolean;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data; 
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code: string;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data; 
    }
}

export interface IVerifySmsCodeInputDto {
    code: string;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPassword = data["currentPassword"];
            this.newPassword = data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileName: string;
    x: number;
    y: number;
    width: number;
    height: number;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data; 
    }
}

export interface IUpdateProfilePictureInput {
    fileName: string;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.setting = data["setting"] ? PasswordComplexitySetting.fromJS(data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture: string;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePicture = data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data; 
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class InternalEvaluationOutput implements IInternalEvaluationOutput {
    mainEvaluations: EvaluationsForInternalReport[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;

    constructor(data?: IInternalEvaluationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["mainEvaluations"] && data["mainEvaluations"].constructor === Array) {
                this.mainEvaluations = [];
                for (let item of data["mainEvaluations"])
                    this.mainEvaluations.push(EvaluationsForInternalReport.fromJS(item));
            }
            this.universityName = data["universityName"];
            this.universityAddress = data["universityAddress"];
            this.reportDate = data["reportDate"];
            this.reportHeader = data["reportHeader"];
            this.evidenceHeader = data["evidenceHeader"];
            this.criteriaHeader = data["criteriaHeader"];
            this.teamHeader = data["teamHeader"];
        }
    }

    static fromJS(data: any): InternalEvaluationOutput {
        let result = new InternalEvaluationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.mainEvaluations && this.mainEvaluations.constructor === Array) {
            data["mainEvaluations"] = [];
            for (let item of this.mainEvaluations)
                data["mainEvaluations"].push(item.toJSON());
        }
        data["universityName"] = this.universityName;
        data["universityAddress"] = this.universityAddress;
        data["reportDate"] = this.reportDate;
        data["reportHeader"] = this.reportHeader;
        data["evidenceHeader"] = this.evidenceHeader;
        data["criteriaHeader"] = this.criteriaHeader;
        data["teamHeader"] = this.teamHeader;
        return data; 
    }
}

export interface IInternalEvaluationOutput {
    mainEvaluations: EvaluationsForInternalReport[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;
}

export class EvaluationsForInternalReport implements IEvaluationsForInternalReport {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    proofFiles: string;
    subEvaluations: EvaluationsForInternalReport[];
    isIntroduction: boolean;
    isConclusion: boolean;
    maturityLevelHeader: string;
    evidenceHeader: string;
    maturityLevelDescription: string;

    constructor(data?: IEvaluationsForInternalReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.nameKey = data["nameKey"];
            this.description = data["description"];
            this.sequenceNo = data["sequenceNo"];
            this.proofFiles = data["proofFiles"];
            if (data["subEvaluations"] && data["subEvaluations"].constructor === Array) {
                this.subEvaluations = [];
                for (let item of data["subEvaluations"])
                    this.subEvaluations.push(EvaluationsForInternalReport.fromJS(item));
            }
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            this.maturityLevelHeader = data["maturityLevelHeader"];
            this.evidenceHeader = data["evidenceHeader"];
            this.maturityLevelDescription = data["maturityLevelDescription"];
        }
    }

    static fromJS(data: any): EvaluationsForInternalReport {
        let result = new EvaluationsForInternalReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameKey"] = this.nameKey;
        data["description"] = this.description;
        data["sequenceNo"] = this.sequenceNo;
        data["proofFiles"] = this.proofFiles;
        if (this.subEvaluations && this.subEvaluations.constructor === Array) {
            data["subEvaluations"] = [];
            for (let item of this.subEvaluations)
                data["subEvaluations"].push(item.toJSON());
        }
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        data["maturityLevelHeader"] = this.maturityLevelHeader;
        data["evidenceHeader"] = this.evidenceHeader;
        data["maturityLevelDescription"] = this.maturityLevelDescription;
        return data; 
    }
}

export interface IEvaluationsForInternalReport {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    proofFiles: string;
    subEvaluations: EvaluationsForInternalReport[];
    isIntroduction: boolean;
    isConclusion: boolean;
    maturityLevelHeader: string;
    evidenceHeader: string;
    maturityLevelDescription: string;
}

export class IndicatorReportOutput implements IIndicatorReportOutput {
    indicators: IndicatorsWithAnswersDto[];
    yearColumns: number[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;

    constructor(data?: IIndicatorReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["indicators"] && data["indicators"].constructor === Array) {
                this.indicators = [];
                for (let item of data["indicators"])
                    this.indicators.push(IndicatorsWithAnswersDto.fromJS(item));
            }
            if (data["yearColumns"] && data["yearColumns"].constructor === Array) {
                this.yearColumns = [];
                for (let item of data["yearColumns"])
                    this.yearColumns.push(item);
            }
            this.universityName = data["universityName"];
            this.universityAddress = data["universityAddress"];
            this.reportDate = data["reportDate"];
            this.reportHeader = data["reportHeader"];
            this.evidenceHeader = data["evidenceHeader"];
            this.criteriaHeader = data["criteriaHeader"];
            this.teamHeader = data["teamHeader"];
        }
    }

    static fromJS(data: any): IndicatorReportOutput {
        let result = new IndicatorReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.indicators && this.indicators.constructor === Array) {
            data["indicators"] = [];
            for (let item of this.indicators)
                data["indicators"].push(item.toJSON());
        }
        if (this.yearColumns && this.yearColumns.constructor === Array) {
            data["yearColumns"] = [];
            for (let item of this.yearColumns)
                data["yearColumns"].push(item);
        }
        data["universityName"] = this.universityName;
        data["universityAddress"] = this.universityAddress;
        data["reportDate"] = this.reportDate;
        data["reportHeader"] = this.reportHeader;
        data["evidenceHeader"] = this.evidenceHeader;
        data["criteriaHeader"] = this.criteriaHeader;
        data["teamHeader"] = this.teamHeader;
        return data; 
    }
}

export interface IIndicatorReportOutput {
    indicators: IndicatorsWithAnswersDto[];
    yearColumns: number[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;
}

export class ListResultDtoOfUniversityCriteriaListOutput implements IListResultDtoOfUniversityCriteriaListOutput {
    items: UniversityCriteriaListOutput[];

    constructor(data?: IListResultDtoOfUniversityCriteriaListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UniversityCriteriaListOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUniversityCriteriaListOutput {
        let result = new ListResultDtoOfUniversityCriteriaListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUniversityCriteriaListOutput {
    items: UniversityCriteriaListOutput[];
}

export class UniversityCriteriaListOutput implements IUniversityCriteriaListOutput {
    universityId: number;
    universityName: string;
    evaluationFormList: EvaluationFormList[];
    id: number;

    constructor(data?: IUniversityCriteriaListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.universityId = data["universityId"];
            this.universityName = data["universityName"];
            if (data["evaluationFormList"] && data["evaluationFormList"].constructor === Array) {
                this.evaluationFormList = [];
                for (let item of data["evaluationFormList"])
                    this.evaluationFormList.push(EvaluationFormList.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UniversityCriteriaListOutput {
        let result = new UniversityCriteriaListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityId"] = this.universityId;
        data["universityName"] = this.universityName;
        if (this.evaluationFormList && this.evaluationFormList.constructor === Array) {
            data["evaluationFormList"] = [];
            for (let item of this.evaluationFormList)
                data["evaluationFormList"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IUniversityCriteriaListOutput {
    universityId: number;
    universityName: string;
    evaluationFormList: EvaluationFormList[];
    id: number;
}

export class EvaluationFormList implements IEvaluationFormList {
    name: string;
    criteriaId: number;

    constructor(data?: IEvaluationFormList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.criteriaId = data["criteriaId"];
        }
    }

    static fromJS(data: any): EvaluationFormList {
        let result = new EvaluationFormList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["criteriaId"] = this.criteriaId;
        return data; 
    }
}

export interface IEvaluationFormList {
    name: string;
    criteriaId: number;
}

export class ListResultDtoOfEvlFormList implements IListResultDtoOfEvlFormList {
    items: EvlFormList[];

    constructor(data?: IListResultDtoOfEvlFormList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EvlFormList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEvlFormList {
        let result = new ListResultDtoOfEvlFormList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEvlFormList {
    items: EvlFormList[];
}

export class EvlFormList implements IEvlFormList {
    title: string;
    parentId: number;
    sequenceNo: number;
    selfCriteria: number;
    externalCriteria: number;
    subEvlFormList: EvlFormList[];
    id: number;

    constructor(data?: IEvlFormList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.parentId = data["parentId"];
            this.sequenceNo = data["sequenceNo"];
            this.selfCriteria = data["selfCriteria"];
            this.externalCriteria = data["externalCriteria"];
            if (data["subEvlFormList"] && data["subEvlFormList"].constructor === Array) {
                this.subEvlFormList = [];
                for (let item of data["subEvlFormList"])
                    this.subEvlFormList.push(EvlFormList.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvlFormList {
        let result = new EvlFormList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["parentId"] = this.parentId;
        data["sequenceNo"] = this.sequenceNo;
        data["selfCriteria"] = this.selfCriteria;
        data["externalCriteria"] = this.externalCriteria;
        if (this.subEvlFormList && this.subEvlFormList.constructor === Array) {
            data["subEvlFormList"] = [];
            for (let item of this.subEvlFormList)
                data["subEvlFormList"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvlFormList {
    title: string;
    parentId: number;
    sequenceNo: number;
    selfCriteria: number;
    externalCriteria: number;
    subEvlFormList: EvlFormList[];
    id: number;
}

export class ListResultDtoOfSelfAndExternalEvaluationCriteriaListOutput implements IListResultDtoOfSelfAndExternalEvaluationCriteriaListOutput {
    items: SelfAndExternalEvaluationCriteriaListOutput[];

    constructor(data?: IListResultDtoOfSelfAndExternalEvaluationCriteriaListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SelfAndExternalEvaluationCriteriaListOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSelfAndExternalEvaluationCriteriaListOutput {
        let result = new ListResultDtoOfSelfAndExternalEvaluationCriteriaListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSelfAndExternalEvaluationCriteriaListOutput {
    items: SelfAndExternalEvaluationCriteriaListOutput[];
}

export class SelfAndExternalEvaluationCriteriaListOutput implements ISelfAndExternalEvaluationCriteriaListOutput {
    universityId: number;
    universityName: string;
    evlFormList: EvlFormList[];

    constructor(data?: ISelfAndExternalEvaluationCriteriaListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.universityId = data["universityId"];
            this.universityName = data["universityName"];
            if (data["evlFormList"] && data["evlFormList"].constructor === Array) {
                this.evlFormList = [];
                for (let item of data["evlFormList"])
                    this.evlFormList.push(EvlFormList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelfAndExternalEvaluationCriteriaListOutput {
        let result = new SelfAndExternalEvaluationCriteriaListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityId"] = this.universityId;
        data["universityName"] = this.universityName;
        if (this.evlFormList && this.evlFormList.constructor === Array) {
            data["evlFormList"] = [];
            for (let item of this.evlFormList)
                data["evlFormList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISelfAndExternalEvaluationCriteriaListOutput {
    universityId: number;
    universityName: string;
    evlFormList: EvlFormList[];
}

export class ExternalEvaluationOutput implements IExternalEvaluationOutput {
    teamMember: UniversityTeamMember[];
    mainEvaluations: EvaluationsForExternalReport[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;

    constructor(data?: IExternalEvaluationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["teamMember"] && data["teamMember"].constructor === Array) {
                this.teamMember = [];
                for (let item of data["teamMember"])
                    this.teamMember.push(UniversityTeamMember.fromJS(item));
            }
            if (data["mainEvaluations"] && data["mainEvaluations"].constructor === Array) {
                this.mainEvaluations = [];
                for (let item of data["mainEvaluations"])
                    this.mainEvaluations.push(EvaluationsForExternalReport.fromJS(item));
            }
            this.universityName = data["universityName"];
            this.universityAddress = data["universityAddress"];
            this.reportDate = data["reportDate"];
            this.reportHeader = data["reportHeader"];
            this.evidenceHeader = data["evidenceHeader"];
            this.criteriaHeader = data["criteriaHeader"];
            this.teamHeader = data["teamHeader"];
        }
    }

    static fromJS(data: any): ExternalEvaluationOutput {
        let result = new ExternalEvaluationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.teamMember && this.teamMember.constructor === Array) {
            data["teamMember"] = [];
            for (let item of this.teamMember)
                data["teamMember"].push(item.toJSON());
        }
        if (this.mainEvaluations && this.mainEvaluations.constructor === Array) {
            data["mainEvaluations"] = [];
            for (let item of this.mainEvaluations)
                data["mainEvaluations"].push(item.toJSON());
        }
        data["universityName"] = this.universityName;
        data["universityAddress"] = this.universityAddress;
        data["reportDate"] = this.reportDate;
        data["reportHeader"] = this.reportHeader;
        data["evidenceHeader"] = this.evidenceHeader;
        data["criteriaHeader"] = this.criteriaHeader;
        data["teamHeader"] = this.teamHeader;
        return data; 
    }
}

export interface IExternalEvaluationOutput {
    teamMember: UniversityTeamMember[];
    mainEvaluations: EvaluationsForExternalReport[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;
}

export class UniversityTeamMember implements IUniversityTeamMember {
    memberTitle: string;
    memberName: string;
    memberSurname: string;
    memberTeamTask: string;

    constructor(data?: IUniversityTeamMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberTitle = data["memberTitle"];
            this.memberName = data["memberName"];
            this.memberSurname = data["memberSurname"];
            this.memberTeamTask = data["memberTeamTask"];
        }
    }

    static fromJS(data: any): UniversityTeamMember {
        let result = new UniversityTeamMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberTitle"] = this.memberTitle;
        data["memberName"] = this.memberName;
        data["memberSurname"] = this.memberSurname;
        data["memberTeamTask"] = this.memberTeamTask;
        return data; 
    }
}

export interface IUniversityTeamMember {
    memberTitle: string;
    memberName: string;
    memberSurname: string;
    memberTeamTask: string;
}

export class EvaluationsForExternalReport implements IEvaluationsForExternalReport {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    subEvaluations: EvaluationsForExternalReport[];
    isIntroduction: boolean;
    isConclusion: boolean;
    maturityLevelHeader: string;
    evidenceHeader: string;
    maturityLevelDescription: string;

    constructor(data?: IEvaluationsForExternalReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.nameKey = data["nameKey"];
            this.description = data["description"];
            this.sequenceNo = data["sequenceNo"];
            if (data["subEvaluations"] && data["subEvaluations"].constructor === Array) {
                this.subEvaluations = [];
                for (let item of data["subEvaluations"])
                    this.subEvaluations.push(EvaluationsForExternalReport.fromJS(item));
            }
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            this.maturityLevelHeader = data["maturityLevelHeader"];
            this.evidenceHeader = data["evidenceHeader"];
            this.maturityLevelDescription = data["maturityLevelDescription"];
        }
    }

    static fromJS(data: any): EvaluationsForExternalReport {
        let result = new EvaluationsForExternalReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameKey"] = this.nameKey;
        data["description"] = this.description;
        data["sequenceNo"] = this.sequenceNo;
        if (this.subEvaluations && this.subEvaluations.constructor === Array) {
            data["subEvaluations"] = [];
            for (let item of this.subEvaluations)
                data["subEvaluations"].push(item.toJSON());
        }
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        data["maturityLevelHeader"] = this.maturityLevelHeader;
        data["evidenceHeader"] = this.evidenceHeader;
        data["maturityLevelDescription"] = this.maturityLevelDescription;
        return data; 
    }
}

export interface IEvaluationsForExternalReport {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    subEvaluations: EvaluationsForExternalReport[];
    isIntroduction: boolean;
    isConclusion: boolean;
    maturityLevelHeader: string;
    evidenceHeader: string;
    maturityLevelDescription: string;
}

export class ListResultDtoOfExternalEvaluationFeedbackOutput implements IListResultDtoOfExternalEvaluationFeedbackOutput {
    items: ExternalEvaluationFeedbackOutput[];

    constructor(data?: IListResultDtoOfExternalEvaluationFeedbackOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ExternalEvaluationFeedbackOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfExternalEvaluationFeedbackOutput {
        let result = new ListResultDtoOfExternalEvaluationFeedbackOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfExternalEvaluationFeedbackOutput {
    items: ExternalEvaluationFeedbackOutput[];
}

export class ExternalEvaluationFeedbackOutput implements IExternalEvaluationFeedbackOutput {
    feedbackProofFiles: FeedbackProofFileDto[];
    termId: number;
    teamId: number;
    universityId: number;
    externalEvaluationReport: string;
    externalEvaluationReportUniAnswer: string;
    creationTime: moment.Moment;
    lastModifiedTime: moment.Moment;
    sendUniversityUserId: number;
    externalFeedbackProofFilesCount: number;
    isReportSent: boolean;
    id: number;

    constructor(data?: IExternalEvaluationFeedbackOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["feedbackProofFiles"] && data["feedbackProofFiles"].constructor === Array) {
                this.feedbackProofFiles = [];
                for (let item of data["feedbackProofFiles"])
                    this.feedbackProofFiles.push(FeedbackProofFileDto.fromJS(item));
            }
            this.termId = data["termId"];
            this.teamId = data["teamId"];
            this.universityId = data["universityId"];
            this.externalEvaluationReport = data["externalEvaluationReport"];
            this.externalEvaluationReportUniAnswer = data["externalEvaluationReportUniAnswer"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.lastModifiedTime = data["lastModifiedTime"] ? moment(data["lastModifiedTime"].toString()) : <any>undefined;
            this.sendUniversityUserId = data["sendUniversityUserId"];
            this.externalFeedbackProofFilesCount = data["externalFeedbackProofFilesCount"];
            this.isReportSent = data["isReportSent"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ExternalEvaluationFeedbackOutput {
        let result = new ExternalEvaluationFeedbackOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.feedbackProofFiles && this.feedbackProofFiles.constructor === Array) {
            data["feedbackProofFiles"] = [];
            for (let item of this.feedbackProofFiles)
                data["feedbackProofFiles"].push(item.toJSON());
        }
        data["termId"] = this.termId;
        data["teamId"] = this.teamId;
        data["universityId"] = this.universityId;
        data["externalEvaluationReport"] = this.externalEvaluationReport;
        data["externalEvaluationReportUniAnswer"] = this.externalEvaluationReportUniAnswer;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifiedTime"] = this.lastModifiedTime ? this.lastModifiedTime.toISOString() : <any>undefined;
        data["sendUniversityUserId"] = this.sendUniversityUserId;
        data["externalFeedbackProofFilesCount"] = this.externalFeedbackProofFilesCount;
        data["isReportSent"] = this.isReportSent;
        data["id"] = this.id;
        return data; 
    }
}

export interface IExternalEvaluationFeedbackOutput {
    feedbackProofFiles: FeedbackProofFileDto[];
    termId: number;
    teamId: number;
    universityId: number;
    externalEvaluationReport: string;
    externalEvaluationReportUniAnswer: string;
    creationTime: moment.Moment;
    lastModifiedTime: moment.Moment;
    sendUniversityUserId: number;
    externalFeedbackProofFilesCount: number;
    isReportSent: boolean;
    id: number;
}

export class FeedbackProofFileDto implements IFeedbackProofFileDto {
    externalDraftId: number;
    fileId: string;
    fileName: string;
    contentType: string;
    size: number;
    path: string;

    constructor(data?: IFeedbackProofFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.externalDraftId = data["externalDraftId"];
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.contentType = data["contentType"];
            this.size = data["size"];
            this.path = data["path"];
        }
    }

    static fromJS(data: any): FeedbackProofFileDto {
        let result = new FeedbackProofFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalDraftId"] = this.externalDraftId;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        data["path"] = this.path;
        return data; 
    }
}

export interface IFeedbackProofFileDto {
    externalDraftId: number;
    fileId: string;
    fileName: string;
    contentType: string;
    size: number;
    path: string;
}

export class ListResultDtoOfEvaluationFormProofFileOutput implements IListResultDtoOfEvaluationFormProofFileOutput {
    items: EvaluationFormProofFileOutput[];

    constructor(data?: IListResultDtoOfEvaluationFormProofFileOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EvaluationFormProofFileOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEvaluationFormProofFileOutput {
        let result = new ListResultDtoOfEvaluationFormProofFileOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEvaluationFormProofFileOutput {
    items: EvaluationFormProofFileOutput[];
}

export class EvaluationFormProofFileOutput implements IEvaluationFormProofFileOutput {
    id: number;
    evaluationForm: string;
    sequenceNo: number;
    proofs: string;
    subEvaluationForm: EvaluationFormProofFileOutput[];

    constructor(data?: IEvaluationFormProofFileOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.evaluationForm = data["evaluationForm"];
            this.sequenceNo = data["sequenceNo"];
            this.proofs = data["proofs"];
            if (data["subEvaluationForm"] && data["subEvaluationForm"].constructor === Array) {
                this.subEvaluationForm = [];
                for (let item of data["subEvaluationForm"])
                    this.subEvaluationForm.push(EvaluationFormProofFileOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EvaluationFormProofFileOutput {
        let result = new EvaluationFormProofFileOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["evaluationForm"] = this.evaluationForm;
        data["sequenceNo"] = this.sequenceNo;
        data["proofs"] = this.proofs;
        if (this.subEvaluationForm && this.subEvaluationForm.constructor === Array) {
            data["subEvaluationForm"] = [];
            for (let item of this.subEvaluationForm)
                data["subEvaluationForm"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEvaluationFormProofFileOutput {
    id: number;
    evaluationForm: string;
    sequenceNo: number;
    proofs: string;
    subEvaluationForm: EvaluationFormProofFileOutput[];
}

export class ListResultDtoOfEvaluationFormProofFileCountOutput implements IListResultDtoOfEvaluationFormProofFileCountOutput {
    items: EvaluationFormProofFileCountOutput[];

    constructor(data?: IListResultDtoOfEvaluationFormProofFileCountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EvaluationFormProofFileCountOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEvaluationFormProofFileCountOutput {
        let result = new ListResultDtoOfEvaluationFormProofFileCountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfEvaluationFormProofFileCountOutput {
    items: EvaluationFormProofFileCountOutput[];
}

export class EvaluationFormProofFileCountOutput implements IEvaluationFormProofFileCountOutput {
    universityId: number;
    universityName: string;
    proofFileCounts: ProofFileCount[];

    constructor(data?: IEvaluationFormProofFileCountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.universityId = data["universityId"];
            this.universityName = data["universityName"];
            if (data["proofFileCounts"] && data["proofFileCounts"].constructor === Array) {
                this.proofFileCounts = [];
                for (let item of data["proofFileCounts"])
                    this.proofFileCounts.push(ProofFileCount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EvaluationFormProofFileCountOutput {
        let result = new EvaluationFormProofFileCountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityId"] = this.universityId;
        data["universityName"] = this.universityName;
        if (this.proofFileCounts && this.proofFileCounts.constructor === Array) {
            data["proofFileCounts"] = [];
            for (let item of this.proofFileCounts)
                data["proofFileCounts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEvaluationFormProofFileCountOutput {
    universityId: number;
    universityName: string;
    proofFileCounts: ProofFileCount[];
}

export class ProofFileCount implements IProofFileCount {
    year: number;
    institutionsProofFilesCount: number;
    improvementProofFilesCount: number;

    constructor(data?: IProofFileCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.year = data["year"];
            this.institutionsProofFilesCount = data["institutionsProofFilesCount"];
            this.improvementProofFilesCount = data["improvementProofFilesCount"];
        }
    }

    static fromJS(data: any): ProofFileCount {
        let result = new ProofFileCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["institutionsProofFilesCount"] = this.institutionsProofFilesCount;
        data["improvementProofFilesCount"] = this.improvementProofFilesCount;
        return data; 
    }
}

export interface IProofFileCount {
    year: number;
    institutionsProofFilesCount: number;
    improvementProofFilesCount: number;
}

export class ListResultDtoOfInstAccUniversityListOutput implements IListResultDtoOfInstAccUniversityListOutput {
    items: InstAccUniversityListOutput[];

    constructor(data?: IListResultDtoOfInstAccUniversityListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(InstAccUniversityListOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfInstAccUniversityListOutput {
        let result = new ListResultDtoOfInstAccUniversityListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfInstAccUniversityListOutput {
    items: InstAccUniversityListOutput[];
}

export class InstAccUniversityListOutput implements IInstAccUniversityListOutput {
    termId: number;
    teamId: number;
    universityId: number;
    universityName: string;
    totalPoint: number;

    constructor(data?: IInstAccUniversityListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.termId = data["termId"];
            this.teamId = data["teamId"];
            this.universityId = data["universityId"];
            this.universityName = data["universityName"];
            this.totalPoint = data["totalPoint"];
        }
    }

    static fromJS(data: any): InstAccUniversityListOutput {
        let result = new InstAccUniversityListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termId"] = this.termId;
        data["teamId"] = this.teamId;
        data["universityId"] = this.universityId;
        data["universityName"] = this.universityName;
        data["totalPoint"] = this.totalPoint;
        return data; 
    }
}

export interface IInstAccUniversityListOutput {
    termId: number;
    teamId: number;
    universityId: number;
    universityName: string;
    totalPoint: number;
}

export class ListResultDtoOfInstAccMaturityLevelDetailOutput implements IListResultDtoOfInstAccMaturityLevelDetailOutput {
    items: InstAccMaturityLevelDetailOutput[];

    constructor(data?: IListResultDtoOfInstAccMaturityLevelDetailOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(InstAccMaturityLevelDetailOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfInstAccMaturityLevelDetailOutput {
        let result = new ListResultDtoOfInstAccMaturityLevelDetailOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfInstAccMaturityLevelDetailOutput {
    items: InstAccMaturityLevelDetailOutput[];
}

export class InstAccMaturityLevelDetailOutput implements IInstAccMaturityLevelDetailOutput {
    evaluationFormId: number;
    evaluationForm: string;
    deep: number;
    point: number;

    constructor(data?: IInstAccMaturityLevelDetailOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.evaluationFormId = data["evaluationFormId"];
            this.evaluationForm = data["evaluationForm"];
            this.deep = data["deep"];
            this.point = data["point"];
        }
    }

    static fromJS(data: any): InstAccMaturityLevelDetailOutput {
        let result = new InstAccMaturityLevelDetailOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["evaluationFormId"] = this.evaluationFormId;
        data["evaluationForm"] = this.evaluationForm;
        data["deep"] = this.deep;
        data["point"] = this.point;
        return data; 
    }
}

export interface IInstAccMaturityLevelDetailOutput {
    evaluationFormId: number;
    evaluationForm: string;
    deep: number;
    point: number;
}

export class ListResultDtoOfMatLevEvlFormList implements IListResultDtoOfMatLevEvlFormList {
    items: MatLevEvlFormList[];

    constructor(data?: IListResultDtoOfMatLevEvlFormList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(MatLevEvlFormList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfMatLevEvlFormList {
        let result = new ListResultDtoOfMatLevEvlFormList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfMatLevEvlFormList {
    items: MatLevEvlFormList[];
}

export class MatLevEvlFormList implements IMatLevEvlFormList {
    title: string;
    parentId: number;
    sequenceNo: number;
    selfMLSequenceNo: number;
    externalMLSequenceNo: number;
    selfMaturityLevel: number;
    externalMaturityLevel: number;
    subEvlFormList: MatLevEvlFormList[];
    id: number;

    constructor(data?: IMatLevEvlFormList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.parentId = data["parentId"];
            this.sequenceNo = data["sequenceNo"];
            this.selfMLSequenceNo = data["selfMLSequenceNo"];
            this.externalMLSequenceNo = data["externalMLSequenceNo"];
            this.selfMaturityLevel = data["selfMaturityLevel"];
            this.externalMaturityLevel = data["externalMaturityLevel"];
            if (data["subEvlFormList"] && data["subEvlFormList"].constructor === Array) {
                this.subEvlFormList = [];
                for (let item of data["subEvlFormList"])
                    this.subEvlFormList.push(MatLevEvlFormList.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MatLevEvlFormList {
        let result = new MatLevEvlFormList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["parentId"] = this.parentId;
        data["sequenceNo"] = this.sequenceNo;
        data["selfMLSequenceNo"] = this.selfMLSequenceNo;
        data["externalMLSequenceNo"] = this.externalMLSequenceNo;
        data["selfMaturityLevel"] = this.selfMaturityLevel;
        data["externalMaturityLevel"] = this.externalMaturityLevel;
        if (this.subEvlFormList && this.subEvlFormList.constructor === Array) {
            data["subEvlFormList"] = [];
            for (let item of this.subEvlFormList)
                data["subEvlFormList"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IMatLevEvlFormList {
    title: string;
    parentId: number;
    sequenceNo: number;
    selfMLSequenceNo: number;
    externalMLSequenceNo: number;
    selfMaturityLevel: number;
    externalMaturityLevel: number;
    subEvlFormList: MatLevEvlFormList[];
    id: number;
}

export class ListResultDtoOfUniversitySelfEvaluationMatLevOutput implements IListResultDtoOfUniversitySelfEvaluationMatLevOutput {
    items: UniversitySelfEvaluationMatLevOutput[];

    constructor(data?: IListResultDtoOfUniversitySelfEvaluationMatLevOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UniversitySelfEvaluationMatLevOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUniversitySelfEvaluationMatLevOutput {
        let result = new ListResultDtoOfUniversitySelfEvaluationMatLevOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUniversitySelfEvaluationMatLevOutput {
    items: UniversitySelfEvaluationMatLevOutput[];
}

export class UniversitySelfEvaluationMatLevOutput implements IUniversitySelfEvaluationMatLevOutput {
    universityId: number;
    universityName: string;
    evlFormList: MatLevEvlFormList[];

    constructor(data?: IUniversitySelfEvaluationMatLevOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.universityId = data["universityId"];
            this.universityName = data["universityName"];
            if (data["evlFormList"] && data["evlFormList"].constructor === Array) {
                this.evlFormList = [];
                for (let item of data["evlFormList"])
                    this.evlFormList.push(MatLevEvlFormList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UniversitySelfEvaluationMatLevOutput {
        let result = new UniversitySelfEvaluationMatLevOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityId"] = this.universityId;
        data["universityName"] = this.universityName;
        if (this.evlFormList && this.evlFormList.constructor === Array) {
            data["evlFormList"] = [];
            for (let item of this.evlFormList)
                data["evlFormList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUniversitySelfEvaluationMatLevOutput {
    universityId: number;
    universityName: string;
    evlFormList: MatLevEvlFormList[];
}

export class InstitutionalAccreditationReportOutput implements IInstitutionalAccreditationReportOutput {
    instAccTeamMember: InstAccUniversityTeamMember[];
    instAccMainEvaluations: InstAccEvaluationsForExternalReport[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;

    constructor(data?: IInstitutionalAccreditationReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["instAccTeamMember"] && data["instAccTeamMember"].constructor === Array) {
                this.instAccTeamMember = [];
                for (let item of data["instAccTeamMember"])
                    this.instAccTeamMember.push(InstAccUniversityTeamMember.fromJS(item));
            }
            if (data["instAccMainEvaluations"] && data["instAccMainEvaluations"].constructor === Array) {
                this.instAccMainEvaluations = [];
                for (let item of data["instAccMainEvaluations"])
                    this.instAccMainEvaluations.push(InstAccEvaluationsForExternalReport.fromJS(item));
            }
            this.universityName = data["universityName"];
            this.universityAddress = data["universityAddress"];
            this.reportDate = data["reportDate"];
            this.reportHeader = data["reportHeader"];
            this.evidenceHeader = data["evidenceHeader"];
            this.criteriaHeader = data["criteriaHeader"];
            this.teamHeader = data["teamHeader"];
        }
    }

    static fromJS(data: any): InstitutionalAccreditationReportOutput {
        let result = new InstitutionalAccreditationReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.instAccTeamMember && this.instAccTeamMember.constructor === Array) {
            data["instAccTeamMember"] = [];
            for (let item of this.instAccTeamMember)
                data["instAccTeamMember"].push(item.toJSON());
        }
        if (this.instAccMainEvaluations && this.instAccMainEvaluations.constructor === Array) {
            data["instAccMainEvaluations"] = [];
            for (let item of this.instAccMainEvaluations)
                data["instAccMainEvaluations"].push(item.toJSON());
        }
        data["universityName"] = this.universityName;
        data["universityAddress"] = this.universityAddress;
        data["reportDate"] = this.reportDate;
        data["reportHeader"] = this.reportHeader;
        data["evidenceHeader"] = this.evidenceHeader;
        data["criteriaHeader"] = this.criteriaHeader;
        data["teamHeader"] = this.teamHeader;
        return data; 
    }
}

export interface IInstitutionalAccreditationReportOutput {
    instAccTeamMember: InstAccUniversityTeamMember[];
    instAccMainEvaluations: InstAccEvaluationsForExternalReport[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;
}

export class InstAccUniversityTeamMember implements IInstAccUniversityTeamMember {
    memberTitle: string;
    memberName: string;
    memberSurname: string;
    memberTeamTask: string;

    constructor(data?: IInstAccUniversityTeamMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberTitle = data["memberTitle"];
            this.memberName = data["memberName"];
            this.memberSurname = data["memberSurname"];
            this.memberTeamTask = data["memberTeamTask"];
        }
    }

    static fromJS(data: any): InstAccUniversityTeamMember {
        let result = new InstAccUniversityTeamMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberTitle"] = this.memberTitle;
        data["memberName"] = this.memberName;
        data["memberSurname"] = this.memberSurname;
        data["memberTeamTask"] = this.memberTeamTask;
        return data; 
    }
}

export interface IInstAccUniversityTeamMember {
    memberTitle: string;
    memberName: string;
    memberSurname: string;
    memberTeamTask: string;
}

export class InstAccEvaluationsForExternalReport implements IInstAccEvaluationsForExternalReport {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    subEvaluations: InstAccEvaluationsForExternalReport[];
    isIntroduction: boolean;
    isConclusion: boolean;
    maturityLevelHeader: string;
    evidenceHeader: string;
    maturityLevelDescription: string;

    constructor(data?: IInstAccEvaluationsForExternalReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.nameKey = data["nameKey"];
            this.description = data["description"];
            this.sequenceNo = data["sequenceNo"];
            if (data["subEvaluations"] && data["subEvaluations"].constructor === Array) {
                this.subEvaluations = [];
                for (let item of data["subEvaluations"])
                    this.subEvaluations.push(InstAccEvaluationsForExternalReport.fromJS(item));
            }
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            this.maturityLevelHeader = data["maturityLevelHeader"];
            this.evidenceHeader = data["evidenceHeader"];
            this.maturityLevelDescription = data["maturityLevelDescription"];
        }
    }

    static fromJS(data: any): InstAccEvaluationsForExternalReport {
        let result = new InstAccEvaluationsForExternalReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameKey"] = this.nameKey;
        data["description"] = this.description;
        data["sequenceNo"] = this.sequenceNo;
        if (this.subEvaluations && this.subEvaluations.constructor === Array) {
            data["subEvaluations"] = [];
            for (let item of this.subEvaluations)
                data["subEvaluations"].push(item.toJSON());
        }
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        data["maturityLevelHeader"] = this.maturityLevelHeader;
        data["evidenceHeader"] = this.evidenceHeader;
        data["maturityLevelDescription"] = this.maturityLevelDescription;
        return data; 
    }
}

export interface IInstAccEvaluationsForExternalReport {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    subEvaluations: InstAccEvaluationsForExternalReport[];
    isIntroduction: boolean;
    isConclusion: boolean;
    maturityLevelHeader: string;
    evidenceHeader: string;
    maturityLevelDescription: string;
}

export class IserFeedbackReportOutput implements IIserFeedbackReportOutput {
    isCompleted: boolean;
    isPublished: boolean;
    iserFeedbackForms: IserFeedbackFormsForReport[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;

    constructor(data?: IIserFeedbackReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isCompleted = data["isCompleted"];
            this.isPublished = data["isPublished"];
            if (data["iserFeedbackForms"] && data["iserFeedbackForms"].constructor === Array) {
                this.iserFeedbackForms = [];
                for (let item of data["iserFeedbackForms"])
                    this.iserFeedbackForms.push(IserFeedbackFormsForReport.fromJS(item));
            }
            this.universityName = data["universityName"];
            this.universityAddress = data["universityAddress"];
            this.reportDate = data["reportDate"];
            this.reportHeader = data["reportHeader"];
            this.evidenceHeader = data["evidenceHeader"];
            this.criteriaHeader = data["criteriaHeader"];
            this.teamHeader = data["teamHeader"];
        }
    }

    static fromJS(data: any): IserFeedbackReportOutput {
        let result = new IserFeedbackReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCompleted"] = this.isCompleted;
        data["isPublished"] = this.isPublished;
        if (this.iserFeedbackForms && this.iserFeedbackForms.constructor === Array) {
            data["iserFeedbackForms"] = [];
            for (let item of this.iserFeedbackForms)
                data["iserFeedbackForms"].push(item.toJSON());
        }
        data["universityName"] = this.universityName;
        data["universityAddress"] = this.universityAddress;
        data["reportDate"] = this.reportDate;
        data["reportHeader"] = this.reportHeader;
        data["evidenceHeader"] = this.evidenceHeader;
        data["criteriaHeader"] = this.criteriaHeader;
        data["teamHeader"] = this.teamHeader;
        return data; 
    }
}

export interface IIserFeedbackReportOutput {
    isCompleted: boolean;
    isPublished: boolean;
    iserFeedbackForms: IserFeedbackFormsForReport[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;
}

export class IserFeedbackFormsForReport implements IIserFeedbackFormsForReport {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    subEvaluations: IserFeedbackFormsForReport[];
    isIntroduction: boolean;
    isConclusion: boolean;

    constructor(data?: IIserFeedbackFormsForReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.nameKey = data["nameKey"];
            this.description = data["description"];
            this.sequenceNo = data["sequenceNo"];
            if (data["subEvaluations"] && data["subEvaluations"].constructor === Array) {
                this.subEvaluations = [];
                for (let item of data["subEvaluations"])
                    this.subEvaluations.push(IserFeedbackFormsForReport.fromJS(item));
            }
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
        }
    }

    static fromJS(data: any): IserFeedbackFormsForReport {
        let result = new IserFeedbackFormsForReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameKey"] = this.nameKey;
        data["description"] = this.description;
        data["sequenceNo"] = this.sequenceNo;
        if (this.subEvaluations && this.subEvaluations.constructor === Array) {
            data["subEvaluations"] = [];
            for (let item of this.subEvaluations)
                data["subEvaluations"].push(item.toJSON());
        }
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        return data; 
    }
}

export interface IIserFeedbackFormsForReport {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    subEvaluations: IserFeedbackFormsForReport[];
    isIntroduction: boolean;
    isConclusion: boolean;
}

export class MentoringReportDataOutput implements IMentoringReportDataOutput {
    universityName: string;
    reportDate: string;
    reportHeader: string;
    applicantData: string;
    mentorReportData: string;

    constructor(data?: IMentoringReportDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.universityName = data["universityName"];
            this.reportDate = data["reportDate"];
            this.reportHeader = data["reportHeader"];
            this.applicantData = data["applicantData"];
            this.mentorReportData = data["mentorReportData"];
        }
    }

    static fromJS(data: any): MentoringReportDataOutput {
        let result = new MentoringReportDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityName"] = this.universityName;
        data["reportDate"] = this.reportDate;
        data["reportHeader"] = this.reportHeader;
        data["applicantData"] = this.applicantData;
        data["mentorReportData"] = this.mentorReportData;
        return data; 
    }
}

export interface IMentoringReportDataOutput {
    universityName: string;
    reportDate: string;
    reportHeader: string;
    applicantData: string;
    mentorReportData: string;
}

export class InstitutionalMonitoringReportDataOutput implements IInstitutionalMonitoringReportDataOutput {
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;
    teamMember: EvlSysUnivTeamMember[];
    mainEvaluations: EvlSysMonitoringMainForm[];

    constructor(data?: IInstitutionalMonitoringReportDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.universityName = data["universityName"];
            this.universityAddress = data["universityAddress"];
            this.reportDate = data["reportDate"];
            this.reportHeader = data["reportHeader"];
            this.evidenceHeader = data["evidenceHeader"];
            this.criteriaHeader = data["criteriaHeader"];
            this.teamHeader = data["teamHeader"];
            if (data["teamMember"] && data["teamMember"].constructor === Array) {
                this.teamMember = [];
                for (let item of data["teamMember"])
                    this.teamMember.push(EvlSysUnivTeamMember.fromJS(item));
            }
            if (data["mainEvaluations"] && data["mainEvaluations"].constructor === Array) {
                this.mainEvaluations = [];
                for (let item of data["mainEvaluations"])
                    this.mainEvaluations.push(EvlSysMonitoringMainForm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InstitutionalMonitoringReportDataOutput {
        let result = new InstitutionalMonitoringReportDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityName"] = this.universityName;
        data["universityAddress"] = this.universityAddress;
        data["reportDate"] = this.reportDate;
        data["reportHeader"] = this.reportHeader;
        data["evidenceHeader"] = this.evidenceHeader;
        data["criteriaHeader"] = this.criteriaHeader;
        data["teamHeader"] = this.teamHeader;
        if (this.teamMember && this.teamMember.constructor === Array) {
            data["teamMember"] = [];
            for (let item of this.teamMember)
                data["teamMember"].push(item.toJSON());
        }
        if (this.mainEvaluations && this.mainEvaluations.constructor === Array) {
            data["mainEvaluations"] = [];
            for (let item of this.mainEvaluations)
                data["mainEvaluations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IInstitutionalMonitoringReportDataOutput {
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;
    teamMember: EvlSysUnivTeamMember[];
    mainEvaluations: EvlSysMonitoringMainForm[];
}

export class EvlSysUnivTeamMember implements IEvlSysUnivTeamMember {
    memberTitle: string;
    memberName: string;
    memberSurname: string;
    memberTeamTask: string;

    constructor(data?: IEvlSysUnivTeamMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberTitle = data["memberTitle"];
            this.memberName = data["memberName"];
            this.memberSurname = data["memberSurname"];
            this.memberTeamTask = data["memberTeamTask"];
        }
    }

    static fromJS(data: any): EvlSysUnivTeamMember {
        let result = new EvlSysUnivTeamMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberTitle"] = this.memberTitle;
        data["memberName"] = this.memberName;
        data["memberSurname"] = this.memberSurname;
        data["memberTeamTask"] = this.memberTeamTask;
        return data; 
    }
}

export interface IEvlSysUnivTeamMember {
    memberTitle: string;
    memberName: string;
    memberSurname: string;
    memberTeamTask: string;
}

export class EvlSysMonitoringMainForm implements IEvlSysMonitoringMainForm {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    isIntoduction: boolean;
    isConclusion: boolean;

    constructor(data?: IEvlSysMonitoringMainForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.nameKey = data["nameKey"];
            this.description = data["description"];
            this.sequenceNo = data["sequenceNo"];
            this.isIntoduction = data["isIntoduction"];
            this.isConclusion = data["isConclusion"];
        }
    }

    static fromJS(data: any): EvlSysMonitoringMainForm {
        let result = new EvlSysMonitoringMainForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameKey"] = this.nameKey;
        data["description"] = this.description;
        data["sequenceNo"] = this.sequenceNo;
        data["isIntoduction"] = this.isIntoduction;
        data["isConclusion"] = this.isConclusion;
        return data; 
    }
}

export interface IEvlSysMonitoringMainForm {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    isIntoduction: boolean;
    isConclusion: boolean;
}

export class HSISelfEvaluationReportOutput implements IHSISelfEvaluationReportOutput {
    mainForms: HSISelfEvaluationMainForm[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;

    constructor(data?: IHSISelfEvaluationReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["mainForms"] && data["mainForms"].constructor === Array) {
                this.mainForms = [];
                for (let item of data["mainForms"])
                    this.mainForms.push(HSISelfEvaluationMainForm.fromJS(item));
            }
            this.universityName = data["universityName"];
            this.universityAddress = data["universityAddress"];
            this.reportDate = data["reportDate"];
            this.reportHeader = data["reportHeader"];
            this.evidenceHeader = data["evidenceHeader"];
            this.criteriaHeader = data["criteriaHeader"];
            this.teamHeader = data["teamHeader"];
        }
    }

    static fromJS(data: any): HSISelfEvaluationReportOutput {
        let result = new HSISelfEvaluationReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.mainForms && this.mainForms.constructor === Array) {
            data["mainForms"] = [];
            for (let item of this.mainForms)
                data["mainForms"].push(item.toJSON());
        }
        data["universityName"] = this.universityName;
        data["universityAddress"] = this.universityAddress;
        data["reportDate"] = this.reportDate;
        data["reportHeader"] = this.reportHeader;
        data["evidenceHeader"] = this.evidenceHeader;
        data["criteriaHeader"] = this.criteriaHeader;
        data["teamHeader"] = this.teamHeader;
        return data; 
    }
}

export interface IHSISelfEvaluationReportOutput {
    mainForms: HSISelfEvaluationMainForm[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;
}

export class HSISelfEvaluationMainForm implements IHSISelfEvaluationMainForm {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    proofFiles: string;
    subForms: HSISelfEvaluationMainForm[];
    isIntroduction: boolean;
    isConclusion: boolean;
    maturityLevelHeader: string;
    evidenceHeader: string;
    maturityLevelDescription: string;

    constructor(data?: IHSISelfEvaluationMainForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.nameKey = data["nameKey"];
            this.description = data["description"];
            this.sequenceNo = data["sequenceNo"];
            this.proofFiles = data["proofFiles"];
            if (data["subForms"] && data["subForms"].constructor === Array) {
                this.subForms = [];
                for (let item of data["subForms"])
                    this.subForms.push(HSISelfEvaluationMainForm.fromJS(item));
            }
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            this.maturityLevelHeader = data["maturityLevelHeader"];
            this.evidenceHeader = data["evidenceHeader"];
            this.maturityLevelDescription = data["maturityLevelDescription"];
        }
    }

    static fromJS(data: any): HSISelfEvaluationMainForm {
        let result = new HSISelfEvaluationMainForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameKey"] = this.nameKey;
        data["description"] = this.description;
        data["sequenceNo"] = this.sequenceNo;
        data["proofFiles"] = this.proofFiles;
        if (this.subForms && this.subForms.constructor === Array) {
            data["subForms"] = [];
            for (let item of this.subForms)
                data["subForms"].push(item.toJSON());
        }
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        data["maturityLevelHeader"] = this.maturityLevelHeader;
        data["evidenceHeader"] = this.evidenceHeader;
        data["maturityLevelDescription"] = this.maturityLevelDescription;
        return data; 
    }
}

export interface IHSISelfEvaluationMainForm {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    proofFiles: string;
    subForms: HSISelfEvaluationMainForm[];
    isIntroduction: boolean;
    isConclusion: boolean;
    maturityLevelHeader: string;
    evidenceHeader: string;
    maturityLevelDescription: string;
}

export class PagedResultDtoOfEvaluatorsListDto implements IPagedResultDtoOfEvaluatorsListDto {
    totalCount: number;
    items: EvaluatorsListDto[];

    constructor(data?: IPagedResultDtoOfEvaluatorsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(EvaluatorsListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEvaluatorsListDto {
        let result = new PagedResultDtoOfEvaluatorsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfEvaluatorsListDto {
    totalCount: number;
    items: EvaluatorsListDto[];
}

export class EvaluatorsListDto implements IEvaluatorsListDto {
    name: string;
    lastName: string;
    activeEmail: string;
    institutionName: string;
    title: string;
    applicantid: number;
    applicationStatus: EvaluatorsListDtoApplicationStatus;
    isAttendMeeting: boolean;
    id: number;

    constructor(data?: IEvaluatorsListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.activeEmail = data["activeEmail"];
            this.institutionName = data["institutionName"];
            this.title = data["title"];
            this.applicantid = data["applicantid"];
            this.applicationStatus = data["applicationStatus"];
            this.isAttendMeeting = data["isAttendMeeting"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvaluatorsListDto {
        let result = new EvaluatorsListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["activeEmail"] = this.activeEmail;
        data["institutionName"] = this.institutionName;
        data["title"] = this.title;
        data["applicantid"] = this.applicantid;
        data["applicationStatus"] = this.applicationStatus;
        data["isAttendMeeting"] = this.isAttendMeeting;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvaluatorsListDto {
    name: string;
    lastName: string;
    activeEmail: string;
    institutionName: string;
    title: string;
    applicantid: number;
    applicationStatus: EvaluatorsListDtoApplicationStatus;
    isAttendMeeting: boolean;
    id: number;
}

export class UpdateEvalutarosInput implements IUpdateEvalutarosInput {
    applicationStatus: UpdateEvalutarosInputApplicationStatus;
    isAttendMeeting: boolean;
    id: number;

    constructor(data?: IUpdateEvalutarosInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicationStatus = data["applicationStatus"];
            this.isAttendMeeting = data["isAttendMeeting"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateEvalutarosInput {
        let result = new UpdateEvalutarosInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationStatus"] = this.applicationStatus;
        data["isAttendMeeting"] = this.isAttendMeeting;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUpdateEvalutarosInput {
    applicationStatus: UpdateEvalutarosInputApplicationStatus;
    isAttendMeeting: boolean;
    id: number;
}

export class EvaluatorsDetailDto implements IEvaluatorsDetailDto {
    name: string;
    lastName: string;
    activeEmail: string;
    institutionName: string;
    workStatus: string;
    administrativePosition: string;
    unit: string;
    academicFaculty: string;
    academicDepartmentOf: string;
    isEulaSigned: string;
    applicationStatus: string;
    lastModificationTime: moment.Moment;
    formerApplicantInstitutions: string;
    formerAdministrativePositions: string;
    formerAdditionalExperiences: string;
    extra: string;
    title: string;
    tcNo: number;
    gender: string;
    phone: string;
    formerAdditionalExperience: FormerAdditionalExperienceDto[];
    id: number;

    constructor(data?: IEvaluatorsDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.activeEmail = data["activeEmail"];
            this.institutionName = data["institutionName"];
            this.workStatus = data["workStatus"];
            this.administrativePosition = data["administrativePosition"];
            this.unit = data["unit"];
            this.academicFaculty = data["academicFaculty"];
            this.academicDepartmentOf = data["academicDepartmentOf"];
            this.isEulaSigned = data["isEulaSigned"];
            this.applicationStatus = data["applicationStatus"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.formerApplicantInstitutions = data["formerApplicantInstitutions"];
            this.formerAdministrativePositions = data["formerAdministrativePositions"];
            this.formerAdditionalExperiences = data["formerAdditionalExperiences"];
            this.extra = data["extra"];
            this.title = data["title"];
            this.tcNo = data["tcNo"];
            this.gender = data["gender"];
            this.phone = data["phone"];
            if (data["formerAdditionalExperience"] && data["formerAdditionalExperience"].constructor === Array) {
                this.formerAdditionalExperience = [];
                for (let item of data["formerAdditionalExperience"])
                    this.formerAdditionalExperience.push(FormerAdditionalExperienceDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EvaluatorsDetailDto {
        let result = new EvaluatorsDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["activeEmail"] = this.activeEmail;
        data["institutionName"] = this.institutionName;
        data["workStatus"] = this.workStatus;
        data["administrativePosition"] = this.administrativePosition;
        data["unit"] = this.unit;
        data["academicFaculty"] = this.academicFaculty;
        data["academicDepartmentOf"] = this.academicDepartmentOf;
        data["isEulaSigned"] = this.isEulaSigned;
        data["applicationStatus"] = this.applicationStatus;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["formerApplicantInstitutions"] = this.formerApplicantInstitutions;
        data["formerAdministrativePositions"] = this.formerAdministrativePositions;
        data["formerAdditionalExperiences"] = this.formerAdditionalExperiences;
        data["extra"] = this.extra;
        data["title"] = this.title;
        data["tcNo"] = this.tcNo;
        data["gender"] = this.gender;
        data["phone"] = this.phone;
        if (this.formerAdditionalExperience && this.formerAdditionalExperience.constructor === Array) {
            data["formerAdditionalExperience"] = [];
            for (let item of this.formerAdditionalExperience)
                data["formerAdditionalExperience"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface IEvaluatorsDetailDto {
    name: string;
    lastName: string;
    activeEmail: string;
    institutionName: string;
    workStatus: string;
    administrativePosition: string;
    unit: string;
    academicFaculty: string;
    academicDepartmentOf: string;
    isEulaSigned: string;
    applicationStatus: string;
    lastModificationTime: moment.Moment;
    formerApplicantInstitutions: string;
    formerAdministrativePositions: string;
    formerAdditionalExperiences: string;
    extra: string;
    title: string;
    tcNo: number;
    gender: string;
    phone: string;
    formerAdditionalExperience: FormerAdditionalExperienceDto[];
    id: number;
}

export class FormerAdditionalExperienceDto implements IFormerAdditionalExperienceDto {
    experienceType: string;
    description: string;

    constructor(data?: IFormerAdditionalExperienceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.experienceType = data["experienceType"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): FormerAdditionalExperienceDto {
        let result = new FormerAdditionalExperienceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experienceType"] = this.experienceType;
        data["description"] = this.description;
        return data; 
    }
}

export interface IFormerAdditionalExperienceDto {
    experienceType: string;
    description: string;
}

export class ListResultDtoOfApplicantListDto implements IListResultDtoOfApplicantListDto {
    items: ApplicantListDto[];

    constructor(data?: IListResultDtoOfApplicantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(ApplicantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfApplicantListDto {
        let result = new ListResultDtoOfApplicantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfApplicantListDto {
    items: ApplicantListDto[];
}

export class ApplicantListDto implements IApplicantListDto {
    tcNo: number;
    name: string;
    lastName: string;
    activeEmail: string;
    institutionName: string;
    title: string;
    applicantid: number;
    applicationStatus: ApplicantListDtoApplicationStatus;
    phone: string;
    id: number;

    constructor(data?: IApplicantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tcNo = data["tcNo"];
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.activeEmail = data["activeEmail"];
            this.institutionName = data["institutionName"];
            this.title = data["title"];
            this.applicantid = data["applicantid"];
            this.applicationStatus = data["applicationStatus"];
            this.phone = data["phone"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ApplicantListDto {
        let result = new ApplicantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tcNo"] = this.tcNo;
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["activeEmail"] = this.activeEmail;
        data["institutionName"] = this.institutionName;
        data["title"] = this.title;
        data["applicantid"] = this.applicantid;
        data["applicationStatus"] = this.applicationStatus;
        data["phone"] = this.phone;
        data["id"] = this.id;
        return data; 
    }
}

export interface IApplicantListDto {
    tcNo: number;
    name: string;
    lastName: string;
    activeEmail: string;
    institutionName: string;
    title: string;
    applicantid: number;
    applicationStatus: ApplicantListDtoApplicationStatus;
    phone: string;
    id: number;
}

export class GetEvaluatorsListForTransferInput implements IGetEvaluatorsListForTransferInput {
    status: Status3[];
    titleId: number;
    filter: string;

    constructor(data?: IGetEvaluatorsListForTransferInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["status"] && data["status"].constructor === Array) {
                this.status = [];
                for (let item of data["status"])
                    this.status.push(item);
            }
            this.titleId = data["titleId"];
            this.filter = data["filter"];
        }
    }

    static fromJS(data: any): GetEvaluatorsListForTransferInput {
        let result = new GetEvaluatorsListForTransferInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.status && this.status.constructor === Array) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["titleId"] = this.titleId;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IGetEvaluatorsListForTransferInput {
    status: Status3[];
    titleId: number;
    filter: string;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items: RoleListDto[];

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[];
}

export class RoleListDto implements IRoleListDto {
    name: string;
    displayName: string;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRoleListDto {
    name: string;
    displayName: string;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[];
    grantedPermissionNames: string[];

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : <any>undefined;
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[];
    grantedPermissionNames: string[];
}

export class RoleEditDto implements IRoleEditDto {
    id: number;
    displayName: string;
    isDefault: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isDefault = data["isDefault"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data; 
    }
}

export interface IRoleEditDto {
    id: number;
    displayName: string;
    isDefault: boolean;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    isGrantedByDefault: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data; 
    }
}

export interface IFlatPermissionDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    isGrantedByDefault: boolean;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role: RoleEditDto = new RoleEditDto();
    grantedPermissionNames: string[] = [];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : new RoleEditDto();
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserLoginInfoDto.fromJS(data["user"]) : <any>undefined;
            this.tenant = data["tenant"] ? TenantLoginInfoDto.fromJS(data["tenant"]) : <any>undefined;
            this.application = data["application"] ? ApplicationInfoDto.fromJS(data["application"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    profilePictureId: string;
    id: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserLoginInfoDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    profilePictureId: string;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string;
    name: string;
    logoId: string;
    logoFileType: string;
    customCssId: string;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    paymentPeriodType: TenantLoginInfoDtoPaymentPeriodType;
    subscriptionDateString: string;
    creationTimeString: string;
    id: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.logoId = data["logoId"];
            this.logoFileType = data["logoFileType"];
            this.customCssId = data["customCssId"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.edition = data["edition"] ? EditionInfoDto.fromJS(data["edition"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionDateString = data["subscriptionDateString"];
            this.creationTimeString = data["creationTimeString"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string;
    name: string;
    logoId: string;
    logoFileType: string;
    customCssId: string;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    paymentPeriodType: TenantLoginInfoDtoPaymentPeriodType;
    subscriptionDateString: string;
    creationTimeString: string;
    id: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string;
    releaseDate: moment.Moment;
    features: { [key: string] : boolean; };

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.version = data["version"];
            this.releaseDate = data["releaseDate"] ? moment(data["releaseDate"].toString()) : <any>undefined;
            if (data["features"]) {
                this.features = {};
                for (let key in data["features"]) {
                    if (data["features"].hasOwnProperty(key))
                        this.features[key] = data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data; 
    }
}

export interface IApplicationInfoDto {
    version: string;
    releaseDate: moment.Moment;
    features: { [key: string] : boolean; };
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName: string;
    trialDayCount: number;
    monthlyPrice: number;
    annualPrice: number;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.displayName = data["displayName"];
            this.trialDayCount = data["trialDayCount"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.isHighestEdition = data["isHighestEdition"];
            this.isFree = data["isFree"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data; 
    }
}

export interface IEditionInfoDto {
    displayName: string;
    trialDayCount: number;
    monthlyPrice: number;
    annualPrice: number;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken: string;
    encodedUserId: string;
    encodedTenantId: string;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.signInToken = data["signInToken"];
            this.encodedUserId = data["encodedUserId"];
            this.encodedTenantId = data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data; 
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string;
    encodedUserId: string;
    encodedTenantId: string;
}

export class ListResultDtoOfSourceDto implements IListResultDtoOfSourceDto {
    items: SourceDto[];

    constructor(data?: IListResultDtoOfSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SourceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSourceDto {
        let result = new ListResultDtoOfSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSourceDto {
    items: SourceDto[];
}

export class CreateSourceInput implements ICreateSourceInput {
    nameKey: string;
    sequenceNo: number;
    isActive: boolean;

    constructor(data?: ICreateSourceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nameKey = data["nameKey"];
            this.sequenceNo = data["sequenceNo"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateSourceInput {
        let result = new CreateSourceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameKey"] = this.nameKey;
        data["sequenceNo"] = this.sequenceNo;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface ICreateSourceInput {
    nameKey: string;
    sequenceNo: number;
    isActive: boolean;
}

export class GetSourceForEditModel implements IGetSourceForEditModel {
    nameKey: string;
    sequenceNo: number;
    isActive: boolean;
    id: number;

    constructor(data?: IGetSourceForEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.nameKey = data["nameKey"];
            this.sequenceNo = data["sequenceNo"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetSourceForEditModel {
        let result = new GetSourceForEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameKey"] = this.nameKey;
        data["sequenceNo"] = this.sequenceNo;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGetSourceForEditModel {
    nameKey: string;
    sequenceNo: number;
    isActive: boolean;
    id: number;
}

export class AssignUniversityInput implements IAssignUniversityInput {
    universityId: number;
    teamId: number;
    termId: number;
    evaluationBeginDate: moment.Moment;
    evaluationEndDate: moment.Moment;

    constructor(data?: IAssignUniversityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.universityId = data["universityId"];
            this.teamId = data["teamId"];
            this.termId = data["termId"];
            this.evaluationBeginDate = data["evaluationBeginDate"] ? moment(data["evaluationBeginDate"].toString()) : <any>undefined;
            this.evaluationEndDate = data["evaluationEndDate"] ? moment(data["evaluationEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssignUniversityInput {
        let result = new AssignUniversityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityId"] = this.universityId;
        data["teamId"] = this.teamId;
        data["termId"] = this.termId;
        data["evaluationBeginDate"] = this.evaluationBeginDate ? this.evaluationBeginDate.toISOString() : <any>undefined;
        data["evaluationEndDate"] = this.evaluationEndDate ? this.evaluationEndDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IAssignUniversityInput {
    universityId: number;
    teamId: number;
    termId: number;
    evaluationBeginDate: moment.Moment;
    evaluationEndDate: moment.Moment;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[];

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[];
}

export class TenantListDto implements ITenantListDto {
    tenancyName: string;
    name: string;
    editionDisplayName: string;
    connectionString: string;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndDateUtc: moment.Moment;
    editionId: number;
    isInTrialPeriod: boolean;
    id: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.editionDisplayName = data["editionDisplayName"];
            this.connectionString = data["connectionString"];
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = data["editionId"];
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantListDto {
    tenancyName: string;
    name: string;
    editionDisplayName: string;
    connectionString: string;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndDateUtc: moment.Moment;
    editionId: number;
    isInTrialPeriod: boolean;
    id: number;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    connectionString: string;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.connectionString = data["connectionString"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = data["sendActivationEmail"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data; 
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    connectionString: string;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string;
    editionId: number;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    id: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.connectionString = data["connectionString"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string;
    editionId: number;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment;
    isInTrialPeriod: boolean;
    id: number;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[];
    features: FlatFeatureDto[];

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                for (let item of data["features"])
                    this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[];
    features: FlatFeatureDto[];
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[] = [];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export class EntityDto implements IEntityDto {
    id: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDto {
    id: number;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities: MemberActivity[];

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["memberActivities"] && data["memberActivities"].constructor === Array) {
                this.memberActivities = [];
                for (let item of data["memberActivities"])
                    this.memberActivities.push(MemberActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.memberActivities && this.memberActivities.constructor === Array) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[];
}

export class MemberActivity implements IMemberActivity {
    name: string;
    earnings: string;
    cases: number;
    closed: number;
    rate: string;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.earnings = data["earnings"];
            this.cases = data["cases"];
            this.closed = data["closed"];
            this.rate = data["rate"];
        }
    }

    static fromJS(data: any): MemberActivity {
        let result = new MemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data; 
    }
}

export interface IMemberActivity {
    name: string;
    earnings: string;
    cases: number;
    closed: number;
    rate: string;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
    salesSummary: SalesSummaryData[];
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
    dailySales: number[];
    profitShares: number[];

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalProfit = data["totalProfit"];
            this.newFeedbacks = data["newFeedbacks"];
            this.newOrders = data["newOrders"];
            this.newUsers = data["newUsers"];
            if (data["salesSummary"] && data["salesSummary"].constructor === Array) {
                this.salesSummary = [];
                for (let item of data["salesSummary"])
                    this.salesSummary.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = data["totalSales"];
            this.revenue = data["revenue"];
            this.expenses = data["expenses"];
            this.growth = data["growth"];
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
            if (data["dailySales"] && data["dailySales"].constructor === Array) {
                this.dailySales = [];
                for (let item of data["dailySales"])
                    this.dailySales.push(item);
            }
            if (data["profitShares"] && data["profitShares"].constructor === Array) {
                this.profitShares = [];
                for (let item of data["profitShares"])
                    this.profitShares.push(item);
            }
        }
    }

    static fromJS(data: any): GetDashboardDataOutput {
        let result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (this.salesSummary && this.salesSummary.constructor === Array) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (this.dailySales && this.dailySales.constructor === Array) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        if (this.profitShares && this.profitShares.constructor === Array) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data; 
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
    salesSummary: SalesSummaryData[];
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
    dailySales: number[];
    profitShares: number[];
}

export class SalesSummaryData implements ISalesSummaryData {
    period: string;
    sales: number;
    profit: number;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.period = data["period"];
            this.sales = data["sales"];
            this.profit = data["profit"];
        }
    }

    static fromJS(data: any): SalesSummaryData {
        let result = new SalesSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data; 
    }
}

export interface ISalesSummaryData {
    period: string;
    sales: number;
    profit: number;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    salesSummary: SalesSummaryData[];

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["salesSummary"] && data["salesSummary"].constructor === Array) {
                this.salesSummary = [];
                for (let item of data["salesSummary"])
                    this.salesSummary.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSalesSummaryOutput {
        let result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.salesSummary && this.salesSummary.constructor === Array) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetSalesSummaryOutput {
    salesSummary: SalesSummaryData[];
}

export class GetWorldMapOutput implements IGetWorldMapOutput {
    countries: WorldMapCountry[];

    constructor(data?: IGetWorldMapOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["countries"] && data["countries"].constructor === Array) {
                this.countries = [];
                for (let item of data["countries"])
                    this.countries.push(WorldMapCountry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetWorldMapOutput {
        let result = new GetWorldMapOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.countries && this.countries.constructor === Array) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetWorldMapOutput {
    countries: WorldMapCountry[];
}

export class WorldMapCountry implements IWorldMapCountry {
    countryName: string;
    color: number;

    constructor(data?: IWorldMapCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.countryName = data["countryName"];
            this.color = data["color"];
        }
    }

    static fromJS(data: any): WorldMapCountry {
        let result = new WorldMapCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["color"] = this.color;
        return data; 
    }
}

export interface IWorldMapCountry {
    countryName: string;
    color: number;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetGeneralStatsOutput {
        let result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data; 
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    captchaResponse: string;
    subscriptionStartType: RegisterTenantInputSubscriptionStartType;
    gateway: RegisterTenantInputGateway;
    editionId: number;
    paymentId: string;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.captchaResponse = data["captchaResponse"];
            this.subscriptionStartType = data["subscriptionStartType"];
            this.gateway = data["gateway"];
            this.editionId = data["editionId"];
            this.paymentId = data["paymentId"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["gateway"] = this.gateway;
        data["editionId"] = this.editionId;
        data["paymentId"] = this.paymentId;
        return data; 
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string;
    captchaResponse: string;
    subscriptionStartType: RegisterTenantInputSubscriptionStartType;
    gateway: RegisterTenantInputGateway;
    editionId: number;
    paymentId: string;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string;
    name: string;
    userName: string;
    emailAddress: string;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.isTenantActive = data["isTenantActive"];
            this.isActive = data["isActive"];
            this.isEmailConfirmationRequired = data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data; 
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string;
    name: string;
    userName: string;
    emailAddress: string;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[];
    editionsWithFeatures: EditionWithFeaturesDto[];
    tenantEditionId: number;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["allFeatures"] && data["allFeatures"].constructor === Array) {
                this.allFeatures = [];
                for (let item of data["allFeatures"])
                    this.allFeatures.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (data["editionsWithFeatures"] && data["editionsWithFeatures"].constructor === Array) {
                this.editionsWithFeatures = [];
                for (let item of data["editionsWithFeatures"])
                    this.editionsWithFeatures.push(EditionWithFeaturesDto.fromJS(item));
            }
            this.tenantEditionId = data["tenantEditionId"];
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.allFeatures && this.allFeatures.constructor === Array) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (this.editionsWithFeatures && this.editionsWithFeatures.constructor === Array) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        data["tenantEditionId"] = this.tenantEditionId;
        return data; 
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[];
    editionsWithFeatures: EditionWithFeaturesDto[];
    tenantEditionId: number;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    defaultValue: string;
    inputType: IInputType;
    textHtmlColor: string;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? IInputType.fromJS(data["inputType"]) : <any>undefined;
            this.textHtmlColor = data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data; 
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string;
    name: string;
    displayName: string;
    description: string;
    defaultValue: string;
    inputType: IInputType;
    textHtmlColor: string;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[];

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : <any>undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                for (let item of data["featureValues"])
                    this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[];
}

export class IInputType implements IIInputType {
    name: string;
    attributes: { [key: string] : any; };
    validator: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (let key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IIInputType {
    name: string;
    attributes: { [key: string] : any; };
    validator: IValueValidator;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto = new TenantUserManagementSettingsEditDto();
    email: EmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto = new SecuritySettingsEditDto();
    billing: TenantBillingSettingsEditDto;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : <any>undefined;
            this.userManagement = data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : <any>undefined;
            this.ldap = data["ldap"] ? LdapSettingsEditDto.fromJS(data["ldap"]) : <any>undefined;
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? TenantBillingSettingsEditDto.fromJS(data["billing"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        return data; 
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string;
    userName: string;
    password: string;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isModuleEnabled = data["isModuleEnabled"];
            this.isEnabled = data["isEnabled"];
            this.domain = data["domain"];
            this.userName = data["userName"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string;
    userName: string;
    password: string;
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName: string;
    address: string;
    taxVatNo: string;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
            this.taxVatNo = data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data; 
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string;
    address: string;
    taxVatNo: string;
}

export class CreateTermInput implements ICreateTermInput {
    announcementBeginDate: moment.Moment;
    announcementEndDate: moment.Moment;
    assignmentBeginDate: moment.Moment;
    assignmentEndDate: moment.Moment;
    trainingBeginDate: moment.Moment;
    trainingEndDate: moment.Moment;
    name: string;
    isActive: boolean;
    isEvaluationTerm: boolean;
    id: number;

    constructor(data?: ICreateTermInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.announcementBeginDate = data["announcementBeginDate"] ? moment(data["announcementBeginDate"].toString()) : <any>undefined;
            this.announcementEndDate = data["announcementEndDate"] ? moment(data["announcementEndDate"].toString()) : <any>undefined;
            this.assignmentBeginDate = data["assignmentBeginDate"] ? moment(data["assignmentBeginDate"].toString()) : <any>undefined;
            this.assignmentEndDate = data["assignmentEndDate"] ? moment(data["assignmentEndDate"].toString()) : <any>undefined;
            this.trainingBeginDate = data["trainingBeginDate"] ? moment(data["trainingBeginDate"].toString()) : <any>undefined;
            this.trainingEndDate = data["trainingEndDate"] ? moment(data["trainingEndDate"].toString()) : <any>undefined;
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.isEvaluationTerm = data["isEvaluationTerm"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateTermInput {
        let result = new CreateTermInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["announcementBeginDate"] = this.announcementBeginDate ? this.announcementBeginDate.toISOString() : <any>undefined;
        data["announcementEndDate"] = this.announcementEndDate ? this.announcementEndDate.toISOString() : <any>undefined;
        data["assignmentBeginDate"] = this.assignmentBeginDate ? this.assignmentBeginDate.toISOString() : <any>undefined;
        data["assignmentEndDate"] = this.assignmentEndDate ? this.assignmentEndDate.toISOString() : <any>undefined;
        data["trainingBeginDate"] = this.trainingBeginDate ? this.trainingBeginDate.toISOString() : <any>undefined;
        data["trainingEndDate"] = this.trainingEndDate ? this.trainingEndDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["isEvaluationTerm"] = this.isEvaluationTerm;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateTermInput {
    announcementBeginDate: moment.Moment;
    announcementEndDate: moment.Moment;
    assignmentBeginDate: moment.Moment;
    assignmentEndDate: moment.Moment;
    trainingBeginDate: moment.Moment;
    trainingEndDate: moment.Moment;
    name: string;
    isActive: boolean;
    isEvaluationTerm: boolean;
    id: number;
}

export class UpdateTermInput implements IUpdateTermInput {
    announcementBeginDate: moment.Moment;
    announcementEndDate: moment.Moment;
    assignmentBeginDate: moment.Moment;
    assignmentEndDate: moment.Moment;
    trainingBeginDate: moment.Moment;
    trainingEndDate: moment.Moment;
    name: string;
    isActive: boolean;
    isEvaluationTerm: boolean;
    id: number;

    constructor(data?: IUpdateTermInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.announcementBeginDate = data["announcementBeginDate"] ? moment(data["announcementBeginDate"].toString()) : <any>undefined;
            this.announcementEndDate = data["announcementEndDate"] ? moment(data["announcementEndDate"].toString()) : <any>undefined;
            this.assignmentBeginDate = data["assignmentBeginDate"] ? moment(data["assignmentBeginDate"].toString()) : <any>undefined;
            this.assignmentEndDate = data["assignmentEndDate"] ? moment(data["assignmentEndDate"].toString()) : <any>undefined;
            this.trainingBeginDate = data["trainingBeginDate"] ? moment(data["trainingBeginDate"].toString()) : <any>undefined;
            this.trainingEndDate = data["trainingEndDate"] ? moment(data["trainingEndDate"].toString()) : <any>undefined;
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.isEvaluationTerm = data["isEvaluationTerm"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateTermInput {
        let result = new UpdateTermInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["announcementBeginDate"] = this.announcementBeginDate ? this.announcementBeginDate.toISOString() : <any>undefined;
        data["announcementEndDate"] = this.announcementEndDate ? this.announcementEndDate.toISOString() : <any>undefined;
        data["assignmentBeginDate"] = this.assignmentBeginDate ? this.assignmentBeginDate.toISOString() : <any>undefined;
        data["assignmentEndDate"] = this.assignmentEndDate ? this.assignmentEndDate.toISOString() : <any>undefined;
        data["trainingBeginDate"] = this.trainingBeginDate ? this.trainingBeginDate.toISOString() : <any>undefined;
        data["trainingEndDate"] = this.trainingEndDate ? this.trainingEndDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["isEvaluationTerm"] = this.isEvaluationTerm;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUpdateTermInput {
    announcementBeginDate: moment.Moment;
    announcementEndDate: moment.Moment;
    assignmentBeginDate: moment.Moment;
    assignmentEndDate: moment.Moment;
    trainingBeginDate: moment.Moment;
    trainingEndDate: moment.Moment;
    name: string;
    isActive: boolean;
    isEvaluationTerm: boolean;
    id: number;
}

export class CreateUnivPermInput implements ICreateUnivPermInput {
    tenantId: number;
    year: number;
    permissionBeginDate: moment.Moment;
    permissionEndDate: moment.Moment;
    id: number;

    constructor(data?: ICreateUnivPermInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.year = data["year"];
            this.permissionBeginDate = data["permissionBeginDate"] ? moment(data["permissionBeginDate"].toString()) : <any>undefined;
            this.permissionEndDate = data["permissionEndDate"] ? moment(data["permissionEndDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateUnivPermInput {
        let result = new CreateUnivPermInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["year"] = this.year;
        data["permissionBeginDate"] = this.permissionBeginDate ? this.permissionBeginDate.toISOString() : <any>undefined;
        data["permissionEndDate"] = this.permissionEndDate ? this.permissionEndDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateUnivPermInput {
    tenantId: number;
    year: number;
    permissionBeginDate: moment.Moment;
    permissionEndDate: moment.Moment;
    id: number;
}

export class UpdateUnivPermInput implements IUpdateUnivPermInput {
    permissionBeginDate: moment.Moment;
    permissionEndDate: moment.Moment;
    id: number;

    constructor(data?: IUpdateUnivPermInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.permissionBeginDate = data["permissionBeginDate"] ? moment(data["permissionBeginDate"].toString()) : <any>undefined;
            this.permissionEndDate = data["permissionEndDate"] ? moment(data["permissionEndDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateUnivPermInput {
        let result = new UpdateUnivPermInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionBeginDate"] = this.permissionBeginDate ? this.permissionBeginDate.toISOString() : <any>undefined;
        data["permissionEndDate"] = this.permissionEndDate ? this.permissionEndDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUpdateUnivPermInput {
    permissionBeginDate: moment.Moment;
    permissionEndDate: moment.Moment;
    id: number;
}

export class ListResultDtoOfUnivPermOutput implements IListResultDtoOfUnivPermOutput {
    items: UnivPermOutput[];

    constructor(data?: IListResultDtoOfUnivPermOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UnivPermOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUnivPermOutput {
        let result = new ListResultDtoOfUnivPermOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUnivPermOutput {
    items: UnivPermOutput[];
}

export class UnivPermOutput implements IUnivPermOutput {
    tenantId: number;
    year: number;
    tenantName: string;
    permissionBeginDate: moment.Moment;
    permissionEndDate: moment.Moment;
    id: number;

    constructor(data?: IUnivPermOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.year = data["year"];
            this.tenantName = data["tenantName"];
            this.permissionBeginDate = data["permissionBeginDate"] ? moment(data["permissionBeginDate"].toString()) : <any>undefined;
            this.permissionEndDate = data["permissionEndDate"] ? moment(data["permissionEndDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UnivPermOutput {
        let result = new UnivPermOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["year"] = this.year;
        data["tenantName"] = this.tenantName;
        data["permissionBeginDate"] = this.permissionBeginDate ? this.permissionBeginDate.toISOString() : <any>undefined;
        data["permissionEndDate"] = this.permissionEndDate ? this.permissionEndDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUnivPermOutput {
    tenantId: number;
    year: number;
    tenantName: string;
    permissionBeginDate: moment.Moment;
    permissionEndDate: moment.Moment;
    id: number;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items: NameValueDto[];

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[];
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string;
    rememberClient: boolean;
    twoFactorRememberClientToken: string;
    singleSignIn: boolean;
    returnUrl: string;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.twoFactorVerificationCode = data["twoFactorVerificationCode"];
            this.rememberClient = data["rememberClient"];
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.singleSignIn = data["singleSignIn"];
            this.returnUrl = data["returnUrl"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        return data; 
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string;
    rememberClient: boolean;
    twoFactorRememberClientToken: string;
    singleSignIn: boolean;
    returnUrl: string;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[];
    twoFactorRememberClientToken: string;
    returnUrl: string;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.shouldResetPassword = data["shouldResetPassword"];
            this.passwordResetCode = data["passwordResetCode"];
            this.userId = data["userId"];
            this.requiresTwoFactorVerification = data["requiresTwoFactorVerification"];
            if (data["twoFactorAuthProviders"] && data["twoFactorAuthProviders"].constructor === Array) {
                this.twoFactorAuthProviders = [];
                for (let item of data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders.push(item);
            }
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.returnUrl = data["returnUrl"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (this.twoFactorAuthProviders && this.twoFactorAuthProviders.constructor === Array) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        return data; 
    }
}

export interface IAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[];
    twoFactorRememberClientToken: string;
    returnUrl: string;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.provider = data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data; 
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data; 
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string;
    clientId: string;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.clientId = data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data; 
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string;
    clientId: string;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string;
    singleSignIn: boolean;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authProvider = data["authProvider"];
            this.providerKey = data["providerKey"];
            this.providerAccessCode = data["providerAccessCode"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data; 
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string;
    singleSignIn: boolean;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.waitingForActivation = data["waitingForActivation"];
            this.returnUrl = data["returnUrl"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        return data; 
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string;
}

export class TrainingFileDto implements ITrainingFileDto {
    fileName: string;
    contentType: string;
    size: number;
    binaryObjectId: string;
    id: string;

    constructor(data?: ITrainingFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.contentType = data["contentType"];
            this.size = data["size"];
            this.binaryObjectId = data["binaryObjectId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TrainingFileDto {
        let result = new TrainingFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        data["binaryObjectId"] = this.binaryObjectId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITrainingFileDto {
    fileName: string;
    contentType: string;
    size: number;
    binaryObjectId: string;
    id: string;
}

export class TQuestionOutputForEdit implements ITQuestionOutputForEdit {
    description: string;
    isActive: boolean;
    questionAnswers: TAnswerOutput[];
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITQuestionOutputForEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            if (data["questionAnswers"] && data["questionAnswers"].constructor === Array) {
                this.questionAnswers = [];
                for (let item of data["questionAnswers"])
                    this.questionAnswers.push(TAnswerOutput.fromJS(item));
            }
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TQuestionOutputForEdit {
        let result = new TQuestionOutputForEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (this.questionAnswers && this.questionAnswers.constructor === Array) {
            data["questionAnswers"] = [];
            for (let item of this.questionAnswers)
                data["questionAnswers"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITQuestionOutputForEdit {
    description: string;
    isActive: boolean;
    questionAnswers: TAnswerOutput[];
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class TAnswerOutput implements ITAnswerOutput {
    isCorrect: boolean;
    description: string;
    id: number;

    constructor(data?: ITAnswerOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isCorrect = data["isCorrect"];
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TAnswerOutput {
        let result = new TAnswerOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCorrect"] = this.isCorrect;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITAnswerOutput {
    isCorrect: boolean;
    description: string;
    id: number;
}

export class CreateTQuestionInput implements ICreateTQuestionInput {
    description: string;
    isActive: boolean;
    answers: TAnswerInput[];

    constructor(data?: ICreateTQuestionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            if (data["answers"] && data["answers"].constructor === Array) {
                this.answers = [];
                for (let item of data["answers"])
                    this.answers.push(TAnswerInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTQuestionInput {
        let result = new CreateTQuestionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        if (this.answers && this.answers.constructor === Array) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateTQuestionInput {
    description: string;
    isActive: boolean;
    answers: TAnswerInput[];
}

export class TAnswerInput implements ITAnswerInput {
    isCorrect: boolean;
    description: string;

    constructor(data?: ITAnswerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isCorrect = data["isCorrect"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): TAnswerInput {
        let result = new TAnswerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCorrect"] = this.isCorrect;
        data["description"] = this.description;
        return data; 
    }
}

export interface ITAnswerInput {
    isCorrect: boolean;
    description: string;
}

export class PagedResultDtoOfTQuestionOutput implements IPagedResultDtoOfTQuestionOutput {
    totalCount: number;
    items: TQuestionOutput[];

    constructor(data?: IPagedResultDtoOfTQuestionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TQuestionOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTQuestionOutput {
        let result = new PagedResultDtoOfTQuestionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfTQuestionOutput {
    totalCount: number;
    items: TQuestionOutput[];
}

export class TQuestionOutput implements ITQuestionOutput {
    description: string;
    isActive: boolean;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITQuestionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TQuestionOutput {
        let result = new TQuestionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITQuestionOutput {
    description: string;
    isActive: boolean;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class ListResultDtoOfSectionQuestionsInput implements IListResultDtoOfSectionQuestionsInput {
    items: SectionQuestionsInput[];

    constructor(data?: IListResultDtoOfSectionQuestionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(SectionQuestionsInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSectionQuestionsInput {
        let result = new ListResultDtoOfSectionQuestionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfSectionQuestionsInput {
    items: SectionQuestionsInput[];
}

export class SectionQuestionsInput implements ISectionQuestionsInput {
    description: string;
    questionId: number;
    sectionId: number;
    point: number;
    sequenceNo: number;
    questionAnswersVm: QuestionAnswerVm[];

    constructor(data?: ISectionQuestionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.questionId = data["questionId"];
            this.sectionId = data["sectionId"];
            this.point = data["point"];
            this.sequenceNo = data["sequenceNo"];
            if (data["questionAnswersVm"] && data["questionAnswersVm"].constructor === Array) {
                this.questionAnswersVm = [];
                for (let item of data["questionAnswersVm"])
                    this.questionAnswersVm.push(QuestionAnswerVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SectionQuestionsInput {
        let result = new SectionQuestionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["questionId"] = this.questionId;
        data["sectionId"] = this.sectionId;
        data["point"] = this.point;
        data["sequenceNo"] = this.sequenceNo;
        if (this.questionAnswersVm && this.questionAnswersVm.constructor === Array) {
            data["questionAnswersVm"] = [];
            for (let item of this.questionAnswersVm)
                data["questionAnswersVm"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISectionQuestionsInput {
    description: string;
    questionId: number;
    sectionId: number;
    point: number;
    sequenceNo: number;
    questionAnswersVm: QuestionAnswerVm[];
}

export class QuestionAnswerVm implements IQuestionAnswerVm {
    description: string;
    isSelectedByApplicant: boolean;
    isCorrectAnswer: boolean;
    trainingEndDate: moment.Moment;
    id: number;

    constructor(data?: IQuestionAnswerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.isSelectedByApplicant = data["isSelectedByApplicant"];
            this.isCorrectAnswer = data["isCorrectAnswer"];
            this.trainingEndDate = data["trainingEndDate"] ? moment(data["trainingEndDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): QuestionAnswerVm {
        let result = new QuestionAnswerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isSelectedByApplicant"] = this.isSelectedByApplicant;
        data["isCorrectAnswer"] = this.isCorrectAnswer;
        data["trainingEndDate"] = this.trainingEndDate ? this.trainingEndDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IQuestionAnswerVm {
    description: string;
    isSelectedByApplicant: boolean;
    isCorrectAnswer: boolean;
    trainingEndDate: moment.Moment;
    id: number;
}

export class ListResultDtoOfTestListOutput implements IListResultDtoOfTestListOutput {
    items: TestListOutput[];

    constructor(data?: IListResultDtoOfTestListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TestListOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTestListOutput {
        let result = new ListResultDtoOfTestListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfTestListOutput {
    items: TestListOutput[];
}

export class TestListOutput implements ITestListOutput {
    id: number;
    testName: string;

    constructor(data?: ITestListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.testName = data["testName"];
        }
    }

    static fromJS(data: any): TestListOutput {
        let result = new TestListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["testName"] = this.testName;
        return data; 
    }
}

export interface ITestListOutput {
    id: number;
    testName: string;
}

export class PagedResultDtoOfTestResultOutput implements IPagedResultDtoOfTestResultOutput {
    totalCount: number;
    items: TestResultOutput[];

    constructor(data?: IPagedResultDtoOfTestResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TestResultOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTestResultOutput {
        let result = new PagedResultDtoOfTestResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfTestResultOutput {
    totalCount: number;
    items: TestResultOutput[];
}

export class TestResultOutput implements ITestResultOutput {
    applicantId: number;
    applicantTitle: string;
    applicantName: string;
    applicantLastName: string;
    testId: number;
    testName: string;
    totalQuestionCount: number;
    testSectionResult: TestSectionResult[];

    constructor(data?: ITestResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicantId = data["applicantId"];
            this.applicantTitle = data["applicantTitle"];
            this.applicantName = data["applicantName"];
            this.applicantLastName = data["applicantLastName"];
            this.testId = data["testId"];
            this.testName = data["testName"];
            this.totalQuestionCount = data["totalQuestionCount"];
            if (data["testSectionResult"] && data["testSectionResult"].constructor === Array) {
                this.testSectionResult = [];
                for (let item of data["testSectionResult"])
                    this.testSectionResult.push(TestSectionResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TestResultOutput {
        let result = new TestResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["applicantTitle"] = this.applicantTitle;
        data["applicantName"] = this.applicantName;
        data["applicantLastName"] = this.applicantLastName;
        data["testId"] = this.testId;
        data["testName"] = this.testName;
        data["totalQuestionCount"] = this.totalQuestionCount;
        if (this.testSectionResult && this.testSectionResult.constructor === Array) {
            data["testSectionResult"] = [];
            for (let item of this.testSectionResult)
                data["testSectionResult"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITestResultOutput {
    applicantId: number;
    applicantTitle: string;
    applicantName: string;
    applicantLastName: string;
    testId: number;
    testName: string;
    totalQuestionCount: number;
    testSectionResult: TestSectionResult[];
}

export class TestSectionResult implements ITestSectionResult {
    sectionId: number;
    sectionName: string;
    sectionScore: number;
    testBeginDate: moment.Moment;
    testEndDate: moment.Moment;
    testCompletionDate: moment.Moment;
    numberOfCorrectAnswers: number;
    numberOfWrongAnswers: number;
    isCompleted: boolean;
    sectionQuestionCount: number;

    constructor(data?: ITestSectionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sectionId = data["sectionId"];
            this.sectionName = data["sectionName"];
            this.sectionScore = data["sectionScore"];
            this.testBeginDate = data["testBeginDate"] ? moment(data["testBeginDate"].toString()) : <any>undefined;
            this.testEndDate = data["testEndDate"] ? moment(data["testEndDate"].toString()) : <any>undefined;
            this.testCompletionDate = data["testCompletionDate"] ? moment(data["testCompletionDate"].toString()) : <any>undefined;
            this.numberOfCorrectAnswers = data["numberOfCorrectAnswers"];
            this.numberOfWrongAnswers = data["numberOfWrongAnswers"];
            this.isCompleted = data["isCompleted"];
            this.sectionQuestionCount = data["sectionQuestionCount"];
        }
    }

    static fromJS(data: any): TestSectionResult {
        let result = new TestSectionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["sectionScore"] = this.sectionScore;
        data["testBeginDate"] = this.testBeginDate ? this.testBeginDate.toISOString() : <any>undefined;
        data["testEndDate"] = this.testEndDate ? this.testEndDate.toISOString() : <any>undefined;
        data["testCompletionDate"] = this.testCompletionDate ? this.testCompletionDate.toISOString() : <any>undefined;
        data["numberOfCorrectAnswers"] = this.numberOfCorrectAnswers;
        data["numberOfWrongAnswers"] = this.numberOfWrongAnswers;
        data["isCompleted"] = this.isCompleted;
        data["sectionQuestionCount"] = this.sectionQuestionCount;
        return data; 
    }
}

export interface ITestSectionResult {
    sectionId: number;
    sectionName: string;
    sectionScore: number;
    testBeginDate: moment.Moment;
    testEndDate: moment.Moment;
    testCompletionDate: moment.Moment;
    numberOfCorrectAnswers: number;
    numberOfWrongAnswers: number;
    isCompleted: boolean;
    sectionQuestionCount: number;
}

export class PagedResultDtoOfPreAndLastTestResultOutput implements IPagedResultDtoOfPreAndLastTestResultOutput {
    totalCount: number;
    items: PreAndLastTestResultOutput[];

    constructor(data?: IPagedResultDtoOfPreAndLastTestResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PreAndLastTestResultOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPreAndLastTestResultOutput {
        let result = new PagedResultDtoOfPreAndLastTestResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfPreAndLastTestResultOutput {
    totalCount: number;
    items: PreAndLastTestResultOutput[];
}

export class PreAndLastTestResultOutput implements IPreAndLastTestResultOutput {
    applicantId: number;
    applicantTitle: string;
    applicantName: string;
    applicantLastName: string;
    preScore: number;
    preBeginDate: moment.Moment;
    preEndDate: moment.Moment;
    preCompletionDate: moment.Moment;
    preCorrect: number;
    preWrong: number;
    preIsCompleted: boolean;
    lastScore: number;
    lastBeginDate: moment.Moment;
    lastEndDate: moment.Moment;
    lastCompletionDate: moment.Moment;
    lastCorrect: number;
    lastWrong: number;
    lastIsCompleted: boolean;

    constructor(data?: IPreAndLastTestResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicantId = data["applicantId"];
            this.applicantTitle = data["applicantTitle"];
            this.applicantName = data["applicantName"];
            this.applicantLastName = data["applicantLastName"];
            this.preScore = data["preScore"];
            this.preBeginDate = data["preBeginDate"] ? moment(data["preBeginDate"].toString()) : <any>undefined;
            this.preEndDate = data["preEndDate"] ? moment(data["preEndDate"].toString()) : <any>undefined;
            this.preCompletionDate = data["preCompletionDate"] ? moment(data["preCompletionDate"].toString()) : <any>undefined;
            this.preCorrect = data["preCorrect"];
            this.preWrong = data["preWrong"];
            this.preIsCompleted = data["preIsCompleted"];
            this.lastScore = data["lastScore"];
            this.lastBeginDate = data["lastBeginDate"] ? moment(data["lastBeginDate"].toString()) : <any>undefined;
            this.lastEndDate = data["lastEndDate"] ? moment(data["lastEndDate"].toString()) : <any>undefined;
            this.lastCompletionDate = data["lastCompletionDate"] ? moment(data["lastCompletionDate"].toString()) : <any>undefined;
            this.lastCorrect = data["lastCorrect"];
            this.lastWrong = data["lastWrong"];
            this.lastIsCompleted = data["lastIsCompleted"];
        }
    }

    static fromJS(data: any): PreAndLastTestResultOutput {
        let result = new PreAndLastTestResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["applicantTitle"] = this.applicantTitle;
        data["applicantName"] = this.applicantName;
        data["applicantLastName"] = this.applicantLastName;
        data["preScore"] = this.preScore;
        data["preBeginDate"] = this.preBeginDate ? this.preBeginDate.toISOString() : <any>undefined;
        data["preEndDate"] = this.preEndDate ? this.preEndDate.toISOString() : <any>undefined;
        data["preCompletionDate"] = this.preCompletionDate ? this.preCompletionDate.toISOString() : <any>undefined;
        data["preCorrect"] = this.preCorrect;
        data["preWrong"] = this.preWrong;
        data["preIsCompleted"] = this.preIsCompleted;
        data["lastScore"] = this.lastScore;
        data["lastBeginDate"] = this.lastBeginDate ? this.lastBeginDate.toISOString() : <any>undefined;
        data["lastEndDate"] = this.lastEndDate ? this.lastEndDate.toISOString() : <any>undefined;
        data["lastCompletionDate"] = this.lastCompletionDate ? this.lastCompletionDate.toISOString() : <any>undefined;
        data["lastCorrect"] = this.lastCorrect;
        data["lastWrong"] = this.lastWrong;
        data["lastIsCompleted"] = this.lastIsCompleted;
        return data; 
    }
}

export interface IPreAndLastTestResultOutput {
    applicantId: number;
    applicantTitle: string;
    applicantName: string;
    applicantLastName: string;
    preScore: number;
    preBeginDate: moment.Moment;
    preEndDate: moment.Moment;
    preCompletionDate: moment.Moment;
    preCorrect: number;
    preWrong: number;
    preIsCompleted: boolean;
    lastScore: number;
    lastBeginDate: moment.Moment;
    lastEndDate: moment.Moment;
    lastCompletionDate: moment.Moment;
    lastCorrect: number;
    lastWrong: number;
    lastIsCompleted: boolean;
}

export class ListResultDtoOfQuestionBaseTestResultOutput implements IListResultDtoOfQuestionBaseTestResultOutput {
    items: QuestionBaseTestResultOutput[];

    constructor(data?: IListResultDtoOfQuestionBaseTestResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(QuestionBaseTestResultOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfQuestionBaseTestResultOutput {
        let result = new ListResultDtoOfQuestionBaseTestResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfQuestionBaseTestResultOutput {
    items: QuestionBaseTestResultOutput[];
}

export class QuestionBaseTestResultOutput implements IQuestionBaseTestResultOutput {
    sectionName: string;
    questionid: number;
    question: string;
    correctAnswer: string;
    correctCount: number;
    wrongCount: number;

    constructor(data?: IQuestionBaseTestResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sectionName = data["sectionName"];
            this.questionid = data["questionid"];
            this.question = data["question"];
            this.correctAnswer = data["correctAnswer"];
            this.correctCount = data["correctCount"];
            this.wrongCount = data["wrongCount"];
        }
    }

    static fromJS(data: any): QuestionBaseTestResultOutput {
        let result = new QuestionBaseTestResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionName"] = this.sectionName;
        data["questionid"] = this.questionid;
        data["question"] = this.question;
        data["correctAnswer"] = this.correctAnswer;
        data["correctCount"] = this.correctCount;
        data["wrongCount"] = this.wrongCount;
        return data; 
    }
}

export interface IQuestionBaseTestResultOutput {
    sectionName: string;
    questionid: number;
    question: string;
    correctAnswer: string;
    correctCount: number;
    wrongCount: number;
}

export class PagedResultDtoOfTrainingTestListOutput implements IPagedResultDtoOfTrainingTestListOutput {
    totalCount: number;
    items: TrainingTestListOutput[];

    constructor(data?: IPagedResultDtoOfTrainingTestListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TrainingTestListOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTrainingTestListOutput {
        let result = new PagedResultDtoOfTrainingTestListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfTrainingTestListOutput {
    totalCount: number;
    items: TrainingTestListOutput[];
}

export class TrainingTestListOutput implements ITrainingTestListOutput {
    name: string;
    isActive: boolean;
    termId: number;
    isEditable: boolean;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: ITrainingTestListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.termId = data["termId"];
            this.isEditable = data["isEditable"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TrainingTestListOutput {
        let result = new TrainingTestListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["termId"] = this.termId;
        data["isEditable"] = this.isEditable;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITrainingTestListOutput {
    name: string;
    isActive: boolean;
    termId: number;
    isEditable: boolean;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class CreateTrainingTestInput implements ICreateTrainingTestInput {
    name: string;
    description: string;
    termId: number;
    isActive: boolean;
    testSections: CreateSectionInput[];
    id: number;

    constructor(data?: ICreateTrainingTestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.termId = data["termId"];
            this.isActive = data["isActive"];
            if (data["testSections"] && data["testSections"].constructor === Array) {
                this.testSections = [];
                for (let item of data["testSections"])
                    this.testSections.push(CreateSectionInput.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateTrainingTestInput {
        let result = new CreateTrainingTestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["termId"] = this.termId;
        data["isActive"] = this.isActive;
        if (this.testSections && this.testSections.constructor === Array) {
            data["testSections"] = [];
            for (let item of this.testSections)
                data["testSections"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateTrainingTestInput {
    name: string;
    description: string;
    termId: number;
    isActive: boolean;
    testSections: CreateSectionInput[];
    id: number;
}

export class CreateSectionInput implements ICreateSectionInput {
    testId: number;
    header: string;
    description: string;
    isActive: boolean;
    sequenceNo: number;
    isSectionStarted: boolean;
    isCompletedByUser: boolean;
    isTrainingEnded: boolean;
    sectionFiles: SectionFileInput[];
    sectionQuestions: SectionQuestionsInput[];
    sectionEmbedFiles: SectionEmbedFileInput[];
    id: number;

    constructor(data?: ICreateSectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.testId = data["testId"];
            this.header = data["header"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.sequenceNo = data["sequenceNo"];
            this.isSectionStarted = data["isSectionStarted"];
            this.isCompletedByUser = data["isCompletedByUser"];
            this.isTrainingEnded = data["isTrainingEnded"];
            if (data["sectionFiles"] && data["sectionFiles"].constructor === Array) {
                this.sectionFiles = [];
                for (let item of data["sectionFiles"])
                    this.sectionFiles.push(SectionFileInput.fromJS(item));
            }
            if (data["sectionQuestions"] && data["sectionQuestions"].constructor === Array) {
                this.sectionQuestions = [];
                for (let item of data["sectionQuestions"])
                    this.sectionQuestions.push(SectionQuestionsInput.fromJS(item));
            }
            if (data["sectionEmbedFiles"] && data["sectionEmbedFiles"].constructor === Array) {
                this.sectionEmbedFiles = [];
                for (let item of data["sectionEmbedFiles"])
                    this.sectionEmbedFiles.push(SectionEmbedFileInput.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateSectionInput {
        let result = new CreateSectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["testId"] = this.testId;
        data["header"] = this.header;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["sequenceNo"] = this.sequenceNo;
        data["isSectionStarted"] = this.isSectionStarted;
        data["isCompletedByUser"] = this.isCompletedByUser;
        data["isTrainingEnded"] = this.isTrainingEnded;
        if (this.sectionFiles && this.sectionFiles.constructor === Array) {
            data["sectionFiles"] = [];
            for (let item of this.sectionFiles)
                data["sectionFiles"].push(item.toJSON());
        }
        if (this.sectionQuestions && this.sectionQuestions.constructor === Array) {
            data["sectionQuestions"] = [];
            for (let item of this.sectionQuestions)
                data["sectionQuestions"].push(item.toJSON());
        }
        if (this.sectionEmbedFiles && this.sectionEmbedFiles.constructor === Array) {
            data["sectionEmbedFiles"] = [];
            for (let item of this.sectionEmbedFiles)
                data["sectionEmbedFiles"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ICreateSectionInput {
    testId: number;
    header: string;
    description: string;
    isActive: boolean;
    sequenceNo: number;
    isSectionStarted: boolean;
    isCompletedByUser: boolean;
    isTrainingEnded: boolean;
    sectionFiles: SectionFileInput[];
    sectionQuestions: SectionQuestionsInput[];
    sectionEmbedFiles: SectionEmbedFileInput[];
    id: number;
}

export class SectionFileInput implements ISectionFileInput {
    fileId: string;
    fileName: string;
    contentType: string;

    constructor(data?: ISectionFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileId = data["fileId"];
            this.fileName = data["fileName"];
            this.contentType = data["contentType"];
        }
    }

    static fromJS(data: any): SectionFileInput {
        let result = new SectionFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        return data; 
    }
}

export interface ISectionFileInput {
    fileId: string;
    fileName: string;
    contentType: string;
}

export class SectionEmbedFileInput implements ISectionEmbedFileInput {
    embedFileCode: string;
    sectionId: number;
    id: number;

    constructor(data?: ISectionEmbedFileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.embedFileCode = data["embedFileCode"];
            this.sectionId = data["sectionId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SectionEmbedFileInput {
        let result = new SectionEmbedFileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["embedFileCode"] = this.embedFileCode;
        data["sectionId"] = this.sectionId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ISectionEmbedFileInput {
    embedFileCode: string;
    sectionId: number;
    id: number;
}

export class TrainingTestEditOutput implements ITrainingTestEditOutput {
    name: string;
    description: string;
    isActive: boolean;
    termId: number;
    testSections: CreateSectionInput[];
    id: number;

    constructor(data?: ITrainingTestEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.isActive = data["isActive"];
            this.termId = data["termId"];
            if (data["testSections"] && data["testSections"].constructor === Array) {
                this.testSections = [];
                for (let item of data["testSections"])
                    this.testSections.push(CreateSectionInput.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TrainingTestEditOutput {
        let result = new TrainingTestEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["termId"] = this.termId;
        if (this.testSections && this.testSections.constructor === Array) {
            data["testSections"] = [];
            for (let item of this.testSections)
                data["testSections"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }
}

export interface ITrainingTestEditOutput {
    name: string;
    description: string;
    isActive: boolean;
    termId: number;
    testSections: CreateSectionInput[];
    id: number;
}

export class ListResultDtoOfTransferTypeDto implements IListResultDtoOfTransferTypeDto {
    items: TransferTypeDto[];

    constructor(data?: IListResultDtoOfTransferTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(TransferTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfTransferTypeDto {
        let result = new ListResultDtoOfTransferTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfTransferTypeDto {
    items: TransferTypeDto[];
}

export class TransferTypeOutput implements ITransferTypeOutput {
    isActive: boolean;
    nameKey: string;
    sequenceNo: number;
    nameValue: string;
    id: number;

    constructor(data?: ITransferTypeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.nameKey = data["nameKey"];
            this.sequenceNo = data["sequenceNo"];
            this.nameValue = data["nameValue"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransferTypeOutput {
        let result = new TransferTypeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["nameKey"] = this.nameKey;
        data["sequenceNo"] = this.sequenceNo;
        data["nameValue"] = this.nameValue;
        data["id"] = this.id;
        return data; 
    }
}

export interface ITransferTypeOutput {
    isActive: boolean;
    nameKey: string;
    sequenceNo: number;
    nameValue: string;
    id: number;
}

export class CreateTransferTypeInput implements ICreateTransferTypeInput {
    sequenceNo: number;
    isActive: boolean;
    nameKey: string;

    constructor(data?: ICreateTransferTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sequenceNo = data["sequenceNo"];
            this.isActive = data["isActive"];
            this.nameKey = data["nameKey"];
        }
    }

    static fromJS(data: any): CreateTransferTypeInput {
        let result = new CreateTransferTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequenceNo"] = this.sequenceNo;
        data["isActive"] = this.isActive;
        data["nameKey"] = this.nameKey;
        return data; 
    }
}

export interface ICreateTransferTypeInput {
    sequenceNo: number;
    isActive: boolean;
    nameKey: string;
}

export class UpdateTransferTypeInput implements IUpdateTransferTypeInput {
    isActive: boolean;
    nameKey: string;
    sequenceNo: number;
    id: number;

    constructor(data?: IUpdateTransferTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.nameKey = data["nameKey"];
            this.sequenceNo = data["sequenceNo"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateTransferTypeInput {
        let result = new UpdateTransferTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["nameKey"] = this.nameKey;
        data["sequenceNo"] = this.sequenceNo;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUpdateTransferTypeInput {
    isActive: boolean;
    nameKey: string;
    sequenceNo: number;
    id: number;
}

export class UiCustomizationSettingsEditDto implements IUiCustomizationSettingsEditDto {
    layout: UiCustomizationLayoutSettingsEditDto;
    header: UiCustomizationHeaderSettingsEditDto;
    menu: UiCustomizationMenuSettingsEditDto;
    footer: UiCustomizationFooterSettingsEditDto;

    constructor(data?: IUiCustomizationSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layout = data["layout"] ? UiCustomizationLayoutSettingsEditDto.fromJS(data["layout"]) : <any>undefined;
            this.header = data["header"] ? UiCustomizationHeaderSettingsEditDto.fromJS(data["header"]) : <any>undefined;
            this.menu = data["menu"] ? UiCustomizationMenuSettingsEditDto.fromJS(data["menu"]) : <any>undefined;
            this.footer = data["footer"] ? UiCustomizationFooterSettingsEditDto.fromJS(data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiCustomizationSettingsEditDto {
        let result = new UiCustomizationSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUiCustomizationSettingsEditDto {
    layout: UiCustomizationLayoutSettingsEditDto;
    header: UiCustomizationHeaderSettingsEditDto;
    menu: UiCustomizationMenuSettingsEditDto;
    footer: UiCustomizationFooterSettingsEditDto;
}

export class UiCustomizationLayoutSettingsEditDto implements IUiCustomizationLayoutSettingsEditDto {
    layoutType: string;
    contentSkin: string;

    constructor(data?: IUiCustomizationLayoutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.layoutType = data["layoutType"];
            this.contentSkin = data["contentSkin"];
        }
    }

    static fromJS(data: any): UiCustomizationLayoutSettingsEditDto {
        let result = new UiCustomizationLayoutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        data["contentSkin"] = this.contentSkin;
        return data; 
    }
}

export interface IUiCustomizationLayoutSettingsEditDto {
    layoutType: string;
    contentSkin: string;
}

export class UiCustomizationHeaderSettingsEditDto implements IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader: boolean;
    desktopMinimizeMode: string;
    mobileFixedHeader: boolean;
    dropdownSkinDesktop: string;
    displaySubmenuArrowDesktop: boolean;
    dropdownSkin: string;

    constructor(data?: IUiCustomizationHeaderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.desktopFixedHeader = data["desktopFixedHeader"];
            this.desktopMinimizeMode = data["desktopMinimizeMode"];
            this.mobileFixedHeader = data["mobileFixedHeader"];
            this.dropdownSkinDesktop = data["dropdownSkinDesktop"];
            this.displaySubmenuArrowDesktop = data["displaySubmenuArrowDesktop"];
            this.dropdownSkin = data["dropdownSkin"];
        }
    }

    static fromJS(data: any): UiCustomizationHeaderSettingsEditDto {
        let result = new UiCustomizationHeaderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["desktopMinimizeMode"] = this.desktopMinimizeMode;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["dropdownSkinDesktop"] = this.dropdownSkinDesktop;
        data["displaySubmenuArrowDesktop"] = this.displaySubmenuArrowDesktop;
        data["dropdownSkin"] = this.dropdownSkin;
        return data; 
    }
}

export interface IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader: boolean;
    desktopMinimizeMode: string;
    mobileFixedHeader: boolean;
    dropdownSkinDesktop: string;
    displaySubmenuArrowDesktop: boolean;
    dropdownSkin: string;
}

export class UiCustomizationMenuSettingsEditDto implements IUiCustomizationMenuSettingsEditDto {
    position: string;
    asideSkin: string;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    allowAsideHiding: boolean;
    defaultHiddenAside: boolean;
    submenuToggle: string;
    dropdownSubmenuSkin: string;
    dropdownSubmenuArrow: boolean;

    constructor(data?: IUiCustomizationMenuSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.position = data["position"];
            this.asideSkin = data["asideSkin"];
            this.fixedAside = data["fixedAside"];
            this.allowAsideMinimizing = data["allowAsideMinimizing"];
            this.defaultMinimizedAside = data["defaultMinimizedAside"];
            this.allowAsideHiding = data["allowAsideHiding"];
            this.defaultHiddenAside = data["defaultHiddenAside"];
            this.submenuToggle = data["submenuToggle"];
            this.dropdownSubmenuSkin = data["dropdownSubmenuSkin"];
            this.dropdownSubmenuArrow = data["dropdownSubmenuArrow"];
        }
    }

    static fromJS(data: any): UiCustomizationMenuSettingsEditDto {
        let result = new UiCustomizationMenuSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["allowAsideHiding"] = this.allowAsideHiding;
        data["defaultHiddenAside"] = this.defaultHiddenAside;
        data["submenuToggle"] = this.submenuToggle;
        data["dropdownSubmenuSkin"] = this.dropdownSubmenuSkin;
        data["dropdownSubmenuArrow"] = this.dropdownSubmenuArrow;
        return data; 
    }
}

export interface IUiCustomizationMenuSettingsEditDto {
    position: string;
    asideSkin: string;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    allowAsideHiding: boolean;
    defaultHiddenAside: boolean;
    submenuToggle: string;
    dropdownSubmenuSkin: string;
    dropdownSubmenuArrow: boolean;
}

export class UiCustomizationFooterSettingsEditDto implements IUiCustomizationFooterSettingsEditDto {
    fixedFooter: boolean;

    constructor(data?: IUiCustomizationFooterSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fixedFooter = data["fixedFooter"];
        }
    }

    static fromJS(data: any): UiCustomizationFooterSettingsEditDto {
        let result = new UiCustomizationFooterSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data; 
    }
}

export interface IUiCustomizationFooterSettingsEditDto {
    fixedFooter: boolean;
}

export class ListResultDtoOfRegionAndCountryOutput implements IListResultDtoOfRegionAndCountryOutput {
    items: RegionAndCountryOutput[];

    constructor(data?: IListResultDtoOfRegionAndCountryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(RegionAndCountryOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRegionAndCountryOutput {
        let result = new ListResultDtoOfRegionAndCountryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfRegionAndCountryOutput {
    items: RegionAndCountryOutput[];
}

export class RegionAndCountryOutput implements IRegionAndCountryOutput {
    regionId: string;
    regionName: string;
    countryId: string;
    countryName: string;
    id: number;

    constructor(data?: IRegionAndCountryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.regionId = data["regionId"];
            this.regionName = data["regionName"];
            this.countryId = data["countryId"];
            this.countryName = data["countryName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegionAndCountryOutput {
        let result = new RegionAndCountryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["id"] = this.id;
        return data; 
    }
}

export interface IRegionAndCountryOutput {
    regionId: string;
    regionName: string;
    countryId: string;
    countryName: string;
    id: number;
}

export class UniversityInfoOutput implements IUniversityInfoOutput {
    univWebSite: string;
    univPhone: string;
    univFax: string;
    univType: UniversityInfoOutputUnivType;
    missionOriented: UniversityInfoOutputMissionOriented;
    establishmentYear: number;
    isTecnicalUniversity: boolean;
    isHaveMedicalSchool: boolean;
    rectorName: string;
    rectorSurname: string;
    rectorGsm: string;
    rectorPhone: string;
    rectorEmail: string;
    rectorEmailSecond: string;
    privateSecretaryName: string;
    privateSecretarySurname: string;
    privateSecretaryGsm: string;
    privateSecretaryPhone: string;
    privateSecretaryEmail: string;
    regionAndCountryId: number;
    qualityCoordinatorName: string;
    qualityCoordinatorSurname: string;
    qualityCoordinatorGsm: string;
    qualityCoordinatorPhone: string;
    qualityCoordinatorEmail: string;
    qualityComStudentName: string;
    qualityComStudentSurname: string;
    qualityComStudentGsm: string;
    qualityComStudentEmail: string;
    qualityComStudentProgram: string;
    qualityComStudentDepartman: string;
    qualityComStudentClass: string;
    senateMemStudentName: string;
    senateMemStudentSurname: string;
    senateMemStudentGsm: string;
    senateMemStudentEmail: string;
    senateMemStudentProgram: string;
    senateMemStudentDepartman: string;
    senateMemStudentClass: string;
    stuQuaComName: string;
    stuQuaComAdmName: string;
    stuQuaComAdmSurname: string;
    stuQuaComAdmEmail: string;
    stuQuaComAdmGsm: string;
    stuQuaComMentorName: string;
    stuQuaComMentorSurname: string;
    stuQuaComMentorEmail: string;
    stuQuaComSocialMedia: string;
    quaViceChancellorName: string;
    quaViceChancellorSurname: string;
    quaViceChancellorGsm: string;
    quaViceChancellorPhone: string;
    quaViceChancellorEmail: string;
    kvkk: boolean;
    id: number;

    constructor(data?: IUniversityInfoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.univWebSite = data["univWebSite"];
            this.univPhone = data["univPhone"];
            this.univFax = data["univFax"];
            this.univType = data["univType"];
            this.missionOriented = data["missionOriented"];
            this.establishmentYear = data["establishmentYear"];
            this.isTecnicalUniversity = data["isTecnicalUniversity"];
            this.isHaveMedicalSchool = data["isHaveMedicalSchool"];
            this.rectorName = data["rectorName"];
            this.rectorSurname = data["rectorSurname"];
            this.rectorGsm = data["rectorGsm"];
            this.rectorPhone = data["rectorPhone"];
            this.rectorEmail = data["rectorEmail"];
            this.rectorEmailSecond = data["rectorEmailSecond"];
            this.privateSecretaryName = data["privateSecretaryName"];
            this.privateSecretarySurname = data["privateSecretarySurname"];
            this.privateSecretaryGsm = data["privateSecretaryGsm"];
            this.privateSecretaryPhone = data["privateSecretaryPhone"];
            this.privateSecretaryEmail = data["privateSecretaryEmail"];
            this.regionAndCountryId = data["regionAndCountryId"];
            this.qualityCoordinatorName = data["qualityCoordinatorName"];
            this.qualityCoordinatorSurname = data["qualityCoordinatorSurname"];
            this.qualityCoordinatorGsm = data["qualityCoordinatorGsm"];
            this.qualityCoordinatorPhone = data["qualityCoordinatorPhone"];
            this.qualityCoordinatorEmail = data["qualityCoordinatorEmail"];
            this.qualityComStudentName = data["qualityComStudentName"];
            this.qualityComStudentSurname = data["qualityComStudentSurname"];
            this.qualityComStudentGsm = data["qualityComStudentGsm"];
            this.qualityComStudentEmail = data["qualityComStudentEmail"];
            this.qualityComStudentProgram = data["qualityComStudentProgram"];
            this.qualityComStudentDepartman = data["qualityComStudentDepartman"];
            this.qualityComStudentClass = data["qualityComStudentClass"];
            this.senateMemStudentName = data["senateMemStudentName"];
            this.senateMemStudentSurname = data["senateMemStudentSurname"];
            this.senateMemStudentGsm = data["senateMemStudentGsm"];
            this.senateMemStudentEmail = data["senateMemStudentEmail"];
            this.senateMemStudentProgram = data["senateMemStudentProgram"];
            this.senateMemStudentDepartman = data["senateMemStudentDepartman"];
            this.senateMemStudentClass = data["senateMemStudentClass"];
            this.stuQuaComName = data["stuQuaComName"];
            this.stuQuaComAdmName = data["stuQuaComAdmName"];
            this.stuQuaComAdmSurname = data["stuQuaComAdmSurname"];
            this.stuQuaComAdmEmail = data["stuQuaComAdmEmail"];
            this.stuQuaComAdmGsm = data["stuQuaComAdmGsm"];
            this.stuQuaComMentorName = data["stuQuaComMentorName"];
            this.stuQuaComMentorSurname = data["stuQuaComMentorSurname"];
            this.stuQuaComMentorEmail = data["stuQuaComMentorEmail"];
            this.stuQuaComSocialMedia = data["stuQuaComSocialMedia"];
            this.quaViceChancellorName = data["quaViceChancellorName"];
            this.quaViceChancellorSurname = data["quaViceChancellorSurname"];
            this.quaViceChancellorGsm = data["quaViceChancellorGsm"];
            this.quaViceChancellorPhone = data["quaViceChancellorPhone"];
            this.quaViceChancellorEmail = data["quaViceChancellorEmail"];
            this.kvkk = data["kvkk"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UniversityInfoOutput {
        let result = new UniversityInfoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["univWebSite"] = this.univWebSite;
        data["univPhone"] = this.univPhone;
        data["univFax"] = this.univFax;
        data["univType"] = this.univType;
        data["missionOriented"] = this.missionOriented;
        data["establishmentYear"] = this.establishmentYear;
        data["isTecnicalUniversity"] = this.isTecnicalUniversity;
        data["isHaveMedicalSchool"] = this.isHaveMedicalSchool;
        data["rectorName"] = this.rectorName;
        data["rectorSurname"] = this.rectorSurname;
        data["rectorGsm"] = this.rectorGsm;
        data["rectorPhone"] = this.rectorPhone;
        data["rectorEmail"] = this.rectorEmail;
        data["rectorEmailSecond"] = this.rectorEmailSecond;
        data["privateSecretaryName"] = this.privateSecretaryName;
        data["privateSecretarySurname"] = this.privateSecretarySurname;
        data["privateSecretaryGsm"] = this.privateSecretaryGsm;
        data["privateSecretaryPhone"] = this.privateSecretaryPhone;
        data["privateSecretaryEmail"] = this.privateSecretaryEmail;
        data["regionAndCountryId"] = this.regionAndCountryId;
        data["qualityCoordinatorName"] = this.qualityCoordinatorName;
        data["qualityCoordinatorSurname"] = this.qualityCoordinatorSurname;
        data["qualityCoordinatorGsm"] = this.qualityCoordinatorGsm;
        data["qualityCoordinatorPhone"] = this.qualityCoordinatorPhone;
        data["qualityCoordinatorEmail"] = this.qualityCoordinatorEmail;
        data["qualityComStudentName"] = this.qualityComStudentName;
        data["qualityComStudentSurname"] = this.qualityComStudentSurname;
        data["qualityComStudentGsm"] = this.qualityComStudentGsm;
        data["qualityComStudentEmail"] = this.qualityComStudentEmail;
        data["qualityComStudentProgram"] = this.qualityComStudentProgram;
        data["qualityComStudentDepartman"] = this.qualityComStudentDepartman;
        data["qualityComStudentClass"] = this.qualityComStudentClass;
        data["senateMemStudentName"] = this.senateMemStudentName;
        data["senateMemStudentSurname"] = this.senateMemStudentSurname;
        data["senateMemStudentGsm"] = this.senateMemStudentGsm;
        data["senateMemStudentEmail"] = this.senateMemStudentEmail;
        data["senateMemStudentProgram"] = this.senateMemStudentProgram;
        data["senateMemStudentDepartman"] = this.senateMemStudentDepartman;
        data["senateMemStudentClass"] = this.senateMemStudentClass;
        data["stuQuaComName"] = this.stuQuaComName;
        data["stuQuaComAdmName"] = this.stuQuaComAdmName;
        data["stuQuaComAdmSurname"] = this.stuQuaComAdmSurname;
        data["stuQuaComAdmEmail"] = this.stuQuaComAdmEmail;
        data["stuQuaComAdmGsm"] = this.stuQuaComAdmGsm;
        data["stuQuaComMentorName"] = this.stuQuaComMentorName;
        data["stuQuaComMentorSurname"] = this.stuQuaComMentorSurname;
        data["stuQuaComMentorEmail"] = this.stuQuaComMentorEmail;
        data["stuQuaComSocialMedia"] = this.stuQuaComSocialMedia;
        data["quaViceChancellorName"] = this.quaViceChancellorName;
        data["quaViceChancellorSurname"] = this.quaViceChancellorSurname;
        data["quaViceChancellorGsm"] = this.quaViceChancellorGsm;
        data["quaViceChancellorPhone"] = this.quaViceChancellorPhone;
        data["quaViceChancellorEmail"] = this.quaViceChancellorEmail;
        data["kvkk"] = this.kvkk;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUniversityInfoOutput {
    univWebSite: string;
    univPhone: string;
    univFax: string;
    univType: UniversityInfoOutputUnivType;
    missionOriented: UniversityInfoOutputMissionOriented;
    establishmentYear: number;
    isTecnicalUniversity: boolean;
    isHaveMedicalSchool: boolean;
    rectorName: string;
    rectorSurname: string;
    rectorGsm: string;
    rectorPhone: string;
    rectorEmail: string;
    rectorEmailSecond: string;
    privateSecretaryName: string;
    privateSecretarySurname: string;
    privateSecretaryGsm: string;
    privateSecretaryPhone: string;
    privateSecretaryEmail: string;
    regionAndCountryId: number;
    qualityCoordinatorName: string;
    qualityCoordinatorSurname: string;
    qualityCoordinatorGsm: string;
    qualityCoordinatorPhone: string;
    qualityCoordinatorEmail: string;
    qualityComStudentName: string;
    qualityComStudentSurname: string;
    qualityComStudentGsm: string;
    qualityComStudentEmail: string;
    qualityComStudentProgram: string;
    qualityComStudentDepartman: string;
    qualityComStudentClass: string;
    senateMemStudentName: string;
    senateMemStudentSurname: string;
    senateMemStudentGsm: string;
    senateMemStudentEmail: string;
    senateMemStudentProgram: string;
    senateMemStudentDepartman: string;
    senateMemStudentClass: string;
    stuQuaComName: string;
    stuQuaComAdmName: string;
    stuQuaComAdmSurname: string;
    stuQuaComAdmEmail: string;
    stuQuaComAdmGsm: string;
    stuQuaComMentorName: string;
    stuQuaComMentorSurname: string;
    stuQuaComMentorEmail: string;
    stuQuaComSocialMedia: string;
    quaViceChancellorName: string;
    quaViceChancellorSurname: string;
    quaViceChancellorGsm: string;
    quaViceChancellorPhone: string;
    quaViceChancellorEmail: string;
    kvkk: boolean;
    id: number;
}

export class ListResultDtoOfGetAccreditationOutput implements IListResultDtoOfGetAccreditationOutput {
    items: GetAccreditationOutput[];

    constructor(data?: IListResultDtoOfGetAccreditationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetAccreditationOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetAccreditationOutput {
        let result = new ListResultDtoOfGetAccreditationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetAccreditationOutput {
    items: GetAccreditationOutput[];
}

export class GetAccreditationOutput implements IGetAccreditationOutput {
    name: string;
    tenancyName: string;
    agencyType: number;
    agencyTypeStr: string;
    creationTime: string;
    id: number;

    constructor(data?: IGetAccreditationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.tenancyName = data["tenancyName"];
            this.agencyType = data["agencyType"];
            this.agencyTypeStr = data["agencyTypeStr"];
            this.creationTime = data["creationTime"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetAccreditationOutput {
        let result = new GetAccreditationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["tenancyName"] = this.tenancyName;
        data["agencyType"] = this.agencyType;
        data["agencyTypeStr"] = this.agencyTypeStr;
        data["creationTime"] = this.creationTime;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGetAccreditationOutput {
    name: string;
    tenancyName: string;
    agencyType: number;
    agencyTypeStr: string;
    creationTime: string;
    id: number;
}

export class GetFacultyOutput implements IGetFacultyOutput {
    yoksisUniversityId: number;
    fakultyList: FakultyList[];

    constructor(data?: IGetFacultyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.yoksisUniversityId = data["yoksisUniversityId"];
            if (data["fakultyList"] && data["fakultyList"].constructor === Array) {
                this.fakultyList = [];
                for (let item of data["fakultyList"])
                    this.fakultyList.push(FakultyList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFacultyOutput {
        let result = new GetFacultyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yoksisUniversityId"] = this.yoksisUniversityId;
        if (this.fakultyList && this.fakultyList.constructor === Array) {
            data["fakultyList"] = [];
            for (let item of this.fakultyList)
                data["fakultyList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetFacultyOutput {
    yoksisUniversityId: number;
    fakultyList: FakultyList[];
}

export class FakultyList implements IFakultyList {
    biriM_ID: number;
    biriM_ADI: string;
    biriM_UZUN_ADI: string;
    biriM_TURU_ID: number;
    biriM_TURU_ADI: string;
    aktif: number;
    baglI_OLDUGU_BIRIM_ID: number;
    ogreniM_DILI: string;
    ogreniM_TURU: string;
    ogreniM_SURESI: string;
    biriM_ADI_INGILIZCE: string;
    kilavuZ_KODU: number;
    koD_BID: number;
    aktiF_TEXT: string;

    constructor(data?: IFakultyList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.biriM_ID = data["biriM_ID"];
            this.biriM_ADI = data["biriM_ADI"];
            this.biriM_UZUN_ADI = data["biriM_UZUN_ADI"];
            this.biriM_TURU_ID = data["biriM_TURU_ID"];
            this.biriM_TURU_ADI = data["biriM_TURU_ADI"];
            this.aktif = data["aktif"];
            this.baglI_OLDUGU_BIRIM_ID = data["baglI_OLDUGU_BIRIM_ID"];
            this.ogreniM_DILI = data["ogreniM_DILI"];
            this.ogreniM_TURU = data["ogreniM_TURU"];
            this.ogreniM_SURESI = data["ogreniM_SURESI"];
            this.biriM_ADI_INGILIZCE = data["biriM_ADI_INGILIZCE"];
            this.kilavuZ_KODU = data["kilavuZ_KODU"];
            this.koD_BID = data["koD_BID"];
            this.aktiF_TEXT = data["aktiF_TEXT"];
        }
    }

    static fromJS(data: any): FakultyList {
        let result = new FakultyList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biriM_ID"] = this.biriM_ID;
        data["biriM_ADI"] = this.biriM_ADI;
        data["biriM_UZUN_ADI"] = this.biriM_UZUN_ADI;
        data["biriM_TURU_ID"] = this.biriM_TURU_ID;
        data["biriM_TURU_ADI"] = this.biriM_TURU_ADI;
        data["aktif"] = this.aktif;
        data["baglI_OLDUGU_BIRIM_ID"] = this.baglI_OLDUGU_BIRIM_ID;
        data["ogreniM_DILI"] = this.ogreniM_DILI;
        data["ogreniM_TURU"] = this.ogreniM_TURU;
        data["ogreniM_SURESI"] = this.ogreniM_SURESI;
        data["biriM_ADI_INGILIZCE"] = this.biriM_ADI_INGILIZCE;
        data["kilavuZ_KODU"] = this.kilavuZ_KODU;
        data["koD_BID"] = this.koD_BID;
        data["aktiF_TEXT"] = this.aktiF_TEXT;
        return data; 
    }
}

export interface IFakultyList {
    biriM_ID: number;
    biriM_ADI: string;
    biriM_UZUN_ADI: string;
    biriM_TURU_ID: number;
    biriM_TURU_ADI: string;
    aktif: number;
    baglI_OLDUGU_BIRIM_ID: number;
    ogreniM_DILI: string;
    ogreniM_TURU: string;
    ogreniM_SURESI: string;
    biriM_ADI_INGILIZCE: string;
    kilavuZ_KODU: number;
    koD_BID: number;
    aktiF_TEXT: string;
}

export class ListResultDtoOfGetProgramOutput implements IListResultDtoOfGetProgramOutput {
    items: GetProgramOutput[];

    constructor(data?: IListResultDtoOfGetProgramOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(GetProgramOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfGetProgramOutput {
        let result = new ListResultDtoOfGetProgramOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfGetProgramOutput {
    items: GetProgramOutput[];
}

export class GetProgramOutput implements IGetProgramOutput {
    biriM_ID: number;
    biriM_ADI: string;
    biriM_UZUN_ADI: string;
    biriM_TURU_ID: number;
    biriM_TURU_ADI: string;
    aktif: number;
    baglI_OLDUGU_BIRIM_ID: number;
    ogreniM_DILI: string;
    ogreniM_TURU: string;
    ogreniM_SURESI: string;
    biriM_ADI_INGILIZCE: string;
    kilavuZ_KODU: number;
    koD_BID: number;
    aktiF_TEXT: string;

    constructor(data?: IGetProgramOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.biriM_ID = data["biriM_ID"];
            this.biriM_ADI = data["biriM_ADI"];
            this.biriM_UZUN_ADI = data["biriM_UZUN_ADI"];
            this.biriM_TURU_ID = data["biriM_TURU_ID"];
            this.biriM_TURU_ADI = data["biriM_TURU_ADI"];
            this.aktif = data["aktif"];
            this.baglI_OLDUGU_BIRIM_ID = data["baglI_OLDUGU_BIRIM_ID"];
            this.ogreniM_DILI = data["ogreniM_DILI"];
            this.ogreniM_TURU = data["ogreniM_TURU"];
            this.ogreniM_SURESI = data["ogreniM_SURESI"];
            this.biriM_ADI_INGILIZCE = data["biriM_ADI_INGILIZCE"];
            this.kilavuZ_KODU = data["kilavuZ_KODU"];
            this.koD_BID = data["koD_BID"];
            this.aktiF_TEXT = data["aktiF_TEXT"];
        }
    }

    static fromJS(data: any): GetProgramOutput {
        let result = new GetProgramOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["biriM_ID"] = this.biriM_ID;
        data["biriM_ADI"] = this.biriM_ADI;
        data["biriM_UZUN_ADI"] = this.biriM_UZUN_ADI;
        data["biriM_TURU_ID"] = this.biriM_TURU_ID;
        data["biriM_TURU_ADI"] = this.biriM_TURU_ADI;
        data["aktif"] = this.aktif;
        data["baglI_OLDUGU_BIRIM_ID"] = this.baglI_OLDUGU_BIRIM_ID;
        data["ogreniM_DILI"] = this.ogreniM_DILI;
        data["ogreniM_TURU"] = this.ogreniM_TURU;
        data["ogreniM_SURESI"] = this.ogreniM_SURESI;
        data["biriM_ADI_INGILIZCE"] = this.biriM_ADI_INGILIZCE;
        data["kilavuZ_KODU"] = this.kilavuZ_KODU;
        data["koD_BID"] = this.koD_BID;
        data["aktiF_TEXT"] = this.aktiF_TEXT;
        return data; 
    }
}

export interface IGetProgramOutput {
    biriM_ID: number;
    biriM_ADI: string;
    biriM_UZUN_ADI: string;
    biriM_TURU_ID: number;
    biriM_TURU_ADI: string;
    aktif: number;
    baglI_OLDUGU_BIRIM_ID: number;
    ogreniM_DILI: string;
    ogreniM_TURU: string;
    ogreniM_SURESI: string;
    biriM_ADI_INGILIZCE: string;
    kilavuZ_KODU: number;
    koD_BID: number;
    aktiF_TEXT: string;
}

export class GetFeedbackQuestionsOutput implements IGetFeedbackQuestionsOutput {
    name: string;
    description: string;
    prgAccFeedbackInfoId: number;
    visitBeginDate: moment.Moment;
    visitEndDate: moment.Moment;
    accreditedBeginDate: moment.Moment;
    accreditedEndDate: moment.Moment;
    isAccredited: boolean;
    isCompleted: boolean;
    feedbackQuestions: FeedbackQuestion[];
    feedbackTeams: FeedbackTeam[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IGetFeedbackQuestionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.description = data["description"];
            this.prgAccFeedbackInfoId = data["prgAccFeedbackInfoId"];
            this.visitBeginDate = data["visitBeginDate"] ? moment(data["visitBeginDate"].toString()) : <any>undefined;
            this.visitEndDate = data["visitEndDate"] ? moment(data["visitEndDate"].toString()) : <any>undefined;
            this.accreditedBeginDate = data["accreditedBeginDate"] ? moment(data["accreditedBeginDate"].toString()) : <any>undefined;
            this.accreditedEndDate = data["accreditedEndDate"] ? moment(data["accreditedEndDate"].toString()) : <any>undefined;
            this.isAccredited = data["isAccredited"];
            this.isCompleted = data["isCompleted"];
            if (data["feedbackQuestions"] && data["feedbackQuestions"].constructor === Array) {
                this.feedbackQuestions = [];
                for (let item of data["feedbackQuestions"])
                    this.feedbackQuestions.push(FeedbackQuestion.fromJS(item));
            }
            if (data["feedbackTeams"] && data["feedbackTeams"].constructor === Array) {
                this.feedbackTeams = [];
                for (let item of data["feedbackTeams"])
                    this.feedbackTeams.push(FeedbackTeam.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetFeedbackQuestionsOutput {
        let result = new GetFeedbackQuestionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["prgAccFeedbackInfoId"] = this.prgAccFeedbackInfoId;
        data["visitBeginDate"] = this.visitBeginDate ? this.visitBeginDate.toISOString() : <any>undefined;
        data["visitEndDate"] = this.visitEndDate ? this.visitEndDate.toISOString() : <any>undefined;
        data["accreditedBeginDate"] = this.accreditedBeginDate ? this.accreditedBeginDate.toISOString() : <any>undefined;
        data["accreditedEndDate"] = this.accreditedEndDate ? this.accreditedEndDate.toISOString() : <any>undefined;
        data["isAccredited"] = this.isAccredited;
        data["isCompleted"] = this.isCompleted;
        if (this.feedbackQuestions && this.feedbackQuestions.constructor === Array) {
            data["feedbackQuestions"] = [];
            for (let item of this.feedbackQuestions)
                data["feedbackQuestions"].push(item.toJSON());
        }
        if (this.feedbackTeams && this.feedbackTeams.constructor === Array) {
            data["feedbackTeams"] = [];
            for (let item of this.feedbackTeams)
                data["feedbackTeams"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IGetFeedbackQuestionsOutput {
    name: string;
    description: string;
    prgAccFeedbackInfoId: number;
    visitBeginDate: moment.Moment;
    visitEndDate: moment.Moment;
    accreditedBeginDate: moment.Moment;
    accreditedEndDate: moment.Moment;
    isAccredited: boolean;
    isCompleted: boolean;
    feedbackQuestions: FeedbackQuestion[];
    feedbackTeams: FeedbackTeam[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class FeedbackQuestion implements IFeedbackQuestion {
    name: string;
    prgAccQuestionTypeId: number;
    prgAccQuestionTypeText: string;
    prgAccQuestionGroupId: number;
    prgAccQuestionGroupText: string;
    prgAccQuestionAnswerText: string;
    feedbackQuestionChoices: FeedbackQuestionChoice[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;

    constructor(data?: IFeedbackQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.prgAccQuestionTypeId = data["prgAccQuestionTypeId"];
            this.prgAccQuestionTypeText = data["prgAccQuestionTypeText"];
            this.prgAccQuestionGroupId = data["prgAccQuestionGroupId"];
            this.prgAccQuestionGroupText = data["prgAccQuestionGroupText"];
            this.prgAccQuestionAnswerText = data["prgAccQuestionAnswerText"];
            if (data["feedbackQuestionChoices"] && data["feedbackQuestionChoices"].constructor === Array) {
                this.feedbackQuestionChoices = [];
                for (let item of data["feedbackQuestionChoices"])
                    this.feedbackQuestionChoices.push(FeedbackQuestionChoice.fromJS(item));
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FeedbackQuestion {
        let result = new FeedbackQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["prgAccQuestionTypeId"] = this.prgAccQuestionTypeId;
        data["prgAccQuestionTypeText"] = this.prgAccQuestionTypeText;
        data["prgAccQuestionGroupId"] = this.prgAccQuestionGroupId;
        data["prgAccQuestionGroupText"] = this.prgAccQuestionGroupText;
        data["prgAccQuestionAnswerText"] = this.prgAccQuestionAnswerText;
        if (this.feedbackQuestionChoices && this.feedbackQuestionChoices.constructor === Array) {
            data["feedbackQuestionChoices"] = [];
            for (let item of this.feedbackQuestionChoices)
                data["feedbackQuestionChoices"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFeedbackQuestion {
    name: string;
    prgAccQuestionTypeId: number;
    prgAccQuestionTypeText: string;
    prgAccQuestionGroupId: number;
    prgAccQuestionGroupText: string;
    prgAccQuestionAnswerText: string;
    feedbackQuestionChoices: FeedbackQuestionChoice[];
    isDeleted: boolean;
    deleterUserId: number;
    deletionTime: moment.Moment;
    lastModificationTime: moment.Moment;
    lastModifierUserId: number;
    creationTime: moment.Moment;
    creatorUserId: number;
    id: number;
}

export class FeedbackTeam implements IFeedbackTeam {
    name: string;
    lastName: string;
    isTeamLeader: boolean;
    prgAccFeedbackInfoId: number;
    id: number;

    constructor(data?: IFeedbackTeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.isTeamLeader = data["isTeamLeader"];
            this.prgAccFeedbackInfoId = data["prgAccFeedbackInfoId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FeedbackTeam {
        let result = new FeedbackTeam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["isTeamLeader"] = this.isTeamLeader;
        data["prgAccFeedbackInfoId"] = this.prgAccFeedbackInfoId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFeedbackTeam {
    name: string;
    lastName: string;
    isTeamLeader: boolean;
    prgAccFeedbackInfoId: number;
    id: number;
}

export class FeedbackQuestionChoice implements IFeedbackQuestionChoice {
    name: string;
    value: number;
    isSelected: boolean;
    id: number;

    constructor(data?: IFeedbackQuestionChoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
            this.isSelected = data["isSelected"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FeedbackQuestionChoice {
        let result = new FeedbackQuestionChoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["isSelected"] = this.isSelected;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFeedbackQuestionChoice {
    name: string;
    value: number;
    isSelected: boolean;
    id: number;
}

export class FeedbackQuestionAnswerInput implements IFeedbackQuestionAnswerInput {
    prgAccFeedbackInfoId: number;
    formQuestionId: number;
    formQuestionChoiceId: number;
    formQuestionAnswerText: string;
    id: number;

    constructor(data?: IFeedbackQuestionAnswerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.prgAccFeedbackInfoId = data["prgAccFeedbackInfoId"];
            this.formQuestionId = data["formQuestionId"];
            this.formQuestionChoiceId = data["formQuestionChoiceId"];
            this.formQuestionAnswerText = data["formQuestionAnswerText"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FeedbackQuestionAnswerInput {
        let result = new FeedbackQuestionAnswerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prgAccFeedbackInfoId"] = this.prgAccFeedbackInfoId;
        data["formQuestionId"] = this.formQuestionId;
        data["formQuestionChoiceId"] = this.formQuestionChoiceId;
        data["formQuestionAnswerText"] = this.formQuestionAnswerText;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFeedbackQuestionAnswerInput {
    prgAccFeedbackInfoId: number;
    formQuestionId: number;
    formQuestionChoiceId: number;
    formQuestionAnswerText: string;
    id: number;
}

export class VisitDateInput implements IVisitDateInput {
    visitBeginDate: moment.Moment;
    visitEndDate: moment.Moment;
    prgAccFeedbackInfoId: number;

    constructor(data?: IVisitDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.visitBeginDate = data["visitBeginDate"] ? moment(data["visitBeginDate"].toString()) : <any>undefined;
            this.visitEndDate = data["visitEndDate"] ? moment(data["visitEndDate"].toString()) : <any>undefined;
            this.prgAccFeedbackInfoId = data["prgAccFeedbackInfoId"];
        }
    }

    static fromJS(data: any): VisitDateInput {
        let result = new VisitDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["visitBeginDate"] = this.visitBeginDate ? this.visitBeginDate.toISOString() : <any>undefined;
        data["visitEndDate"] = this.visitEndDate ? this.visitEndDate.toISOString() : <any>undefined;
        data["prgAccFeedbackInfoId"] = this.prgAccFeedbackInfoId;
        return data; 
    }
}

export interface IVisitDateInput {
    visitBeginDate: moment.Moment;
    visitEndDate: moment.Moment;
    prgAccFeedbackInfoId: number;
}

export class AccreditedDateInput implements IAccreditedDateInput {
    accreditedBeginDate: moment.Moment;
    accreditedEndDate: moment.Moment;
    isAccredited: boolean;
    prgAccFeedbackInfoId: number;
    id: number;

    constructor(data?: IAccreditedDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accreditedBeginDate = data["accreditedBeginDate"] ? moment(data["accreditedBeginDate"].toString()) : <any>undefined;
            this.accreditedEndDate = data["accreditedEndDate"] ? moment(data["accreditedEndDate"].toString()) : <any>undefined;
            this.isAccredited = data["isAccredited"];
            this.prgAccFeedbackInfoId = data["prgAccFeedbackInfoId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AccreditedDateInput {
        let result = new AccreditedDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accreditedBeginDate"] = this.accreditedBeginDate ? this.accreditedBeginDate.toISOString() : <any>undefined;
        data["accreditedEndDate"] = this.accreditedEndDate ? this.accreditedEndDate.toISOString() : <any>undefined;
        data["isAccredited"] = this.isAccredited;
        data["prgAccFeedbackInfoId"] = this.prgAccFeedbackInfoId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IAccreditedDateInput {
    accreditedBeginDate: moment.Moment;
    accreditedEndDate: moment.Moment;
    isAccredited: boolean;
    prgAccFeedbackInfoId: number;
    id: number;
}

export class FeedbackTeamInput implements IFeedbackTeamInput {
    name: string;
    lastName: string;
    isTeamLeader: boolean;
    prgAccFeedbackInfoId: number;
    id: number;

    constructor(data?: IFeedbackTeamInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.lastName = data["lastName"];
            this.isTeamLeader = data["isTeamLeader"];
            this.prgAccFeedbackInfoId = data["prgAccFeedbackInfoId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FeedbackTeamInput {
        let result = new FeedbackTeamInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["lastName"] = this.lastName;
        data["isTeamLeader"] = this.isTeamLeader;
        data["prgAccFeedbackInfoId"] = this.prgAccFeedbackInfoId;
        data["id"] = this.id;
        return data; 
    }
}

export interface IFeedbackTeamInput {
    name: string;
    lastName: string;
    isTeamLeader: boolean;
    prgAccFeedbackInfoId: number;
    id: number;
}

export class CompleteFeedBackFormInput implements ICompleteFeedBackFormInput {
    isCompleted: boolean;
    prgAccFeedbackInfoId: number;
    id: number;

    constructor(data?: ICompleteFeedBackFormInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isCompleted = data["isCompleted"];
            this.prgAccFeedbackInfoId = data["prgAccFeedbackInfoId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CompleteFeedBackFormInput {
        let result = new CompleteFeedBackFormInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isCompleted"] = this.isCompleted;
        data["prgAccFeedbackInfoId"] = this.prgAccFeedbackInfoId;
        data["id"] = this.id;
        return data; 
    }
}

export interface ICompleteFeedBackFormInput {
    isCompleted: boolean;
    prgAccFeedbackInfoId: number;
    id: number;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[];

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[];
}

export class UserListDto implements IUserListDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    profilePictureId: string;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[];
    lastLoginTime: moment.Moment;
    isActive: boolean;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserListRoleDto.fromJS(item));
            }
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface IUserListDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    profilePictureId: string;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[];
    lastLoginTime: moment.Moment;
    isActive: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId: number;
    roleName: string;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data; 
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId: string;
    user: UserEditDto;
    roles: UserRoleDto[];
    allOrganizationUnits: OrganizationUnitDto[];
    memberedOrganizationUnits: string[];

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.profilePictureId = data["profilePictureId"];
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : <any>undefined;
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (let item of data["roles"])
                    this.roles.push(UserRoleDto.fromJS(item));
            }
            if (data["allOrganizationUnits"] && data["allOrganizationUnits"].constructor === Array) {
                this.allOrganizationUnits = [];
                for (let item of data["allOrganizationUnits"])
                    this.allOrganizationUnits.push(OrganizationUnitDto.fromJS(item));
            }
            if (data["memberedOrganizationUnits"] && data["memberedOrganizationUnits"].constructor === Array) {
                this.memberedOrganizationUnits = [];
                for (let item of data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (this.allOrganizationUnits && this.allOrganizationUnits.constructor === Array) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (this.memberedOrganizationUnits && this.memberedOrganizationUnits.constructor === Array) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        return data; 
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string;
    user: UserEditDto;
    roles: UserRoleDto[];
    allOrganizationUnits: OrganizationUnitDto[];
    memberedOrganizationUnits: string[];
}

export class UserEditDto implements IUserEditDto {
    id: number;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    password: string;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.password = data["password"];
            this.isActive = data["isActive"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
        }
    }

    static fromJS(data: any): UserEditDto {
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data; 
    }
}

export interface IUserEditDto {
    id: number;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string;
    password: string;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
}

export class UserRoleDto implements IUserRoleDto {
    roleId: number;
    roleName: string;
    roleDisplayName: string;
    isAssigned: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
            this.roleDisplayName = data["roleDisplayName"];
            this.isAssigned = data["isAssigned"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        return data; 
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string;
    roleDisplayName: string;
    isAssigned: boolean;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[];
    grantedPermissionNames: string[];

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[];
    grantedPermissionNames: string[];
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[] = [];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user: UserEditDto = new UserEditDto();
    assignedRoleNames: string[] = [];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[];

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : new UserEditDto();
            if (data["assignedRoleNames"] && data["assignedRoleNames"].constructor === Array) {
                this.assignedRoleNames = [];
                for (let item of data["assignedRoleNames"])
                    this.assignedRoleNames.push(item);
            }
            this.sendActivationEmail = data["sendActivationEmail"];
            this.setRandomPassword = data["setRandomPassword"];
            if (data["organizationUnits"] && data["organizationUnits"].constructor === Array) {
                this.organizationUnits = [];
                for (let item of data["organizationUnits"])
                    this.organizationUnits.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (this.assignedRoleNames && this.assignedRoleNames.constructor === Array) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (this.organizationUnits && this.organizationUnits.constructor === Array) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data; 
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[];
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName: string;
    usernameOrEmailAddress: string;
    password: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.usernameOrEmailAddress = data["usernameOrEmailAddress"];
            this.password = data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILinkToUserInput {
    tenancyName: string;
    usernameOrEmailAddress: string;
    password: string;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[];

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[];
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId: number;
    tenancyName: string;
    username: string;
    lastLoginTime: moment.Moment;
    id: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.username = data["username"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }
}

export interface ILinkedUserDto {
    tenantId: number;
    tenancyName: string;
    username: string;
    lastLoginTime: moment.Moment;
    id: number;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[];

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[];
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId: number;
    userId: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IUnlinkUserInput {
    tenantId: number;
    userId: number;
}

export class ListResultDtoOfUserLoginAttemptDto implements IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[];

    constructor(data?: IListResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserLoginAttemptDto {
        let result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[];
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName: string;
    userNameOrEmail: string;
    clientIpAddress: string;
    clientName: string;
    browserInfo: string;
    result: string;
    creationTime: moment.Moment;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userNameOrEmail = data["userNameOrEmail"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.result = data["result"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string;
    userNameOrEmail: string;
    clientIpAddress: string;
    clientName: string;
    browserInfo: string;
    result: string;
    creationTime: moment.Moment;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines: string[];

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["latestWebLogLines"] && data["latestWebLogLines"].constructor === Array) {
                this.latestWebLogLines = [];
                for (let item of data["latestWebLogLines"])
                    this.latestWebLogLines.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.latestWebLogLines && this.latestWebLogLines.constructor === Array) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data; 
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[];
}

export enum EvlFormHelpAndProofType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum EvlFormHelpAndProofType2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum EvaluatorTask {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7,

}

export enum From {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum To {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum From2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum To2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum From3 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum To3 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum From4 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum To4 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum IncomeStatisticsDateInterval {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum IncomeStatisticsDateInterval2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum State {
    _0 = 0, 
    _1 = 1, 
}

export enum Status {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum Status2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum SalesSummaryDatePeriod {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum SalesSummaryDatePeriod2 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum ProcessType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum DefaultTimezoneScope {
    _1 = 1, 
    _2 = 2, 
    _4 = 4, 
    _7 = 7, 
}

export enum IsTenantAvailableOutputState {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum GetAcceptedTitleDtoType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum CreateAnnAnnouncementInputAnnType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum AnnAnnouncementEditAnnType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum ReviewApplicationDtoApplicationStatus {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum FriendDtoState {
    _1 = 1, 
    _2 = 2, 
}

export enum ChatMessageDtoSide {
    _1 = 1, 
    _2 = 2, 
}

export enum ChatMessageDtoReadState {
    _1 = 1, 
    _2 = 2, 
}

export enum ChatMessageDtoReceiverReadState {
    _1 = 1, 
    _2 = 2, 
}

export enum DataTextListDtoCategoryType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
    _8 = 8, 
    _9 = 9, 
    _10 = 10, 
    _11 = 11, 
}

export enum HelpAndProofDtoEvlFormHelpAndProofType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum UploadProofFileDtoEvlFormHelpAndProofType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum EvaluationTeamOutputEvaluationType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6,
    _7 = 7
}

export enum TeamMemberOutputTeamTask {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
}

export enum TeamMemberOutputIsDutyAccepted {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum TeamMemberOutputIsUnivConfirm {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum TeamMemberAuthOutputTeamTask {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
}

export enum CreateTeamInputEvaluationType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum TeamMemberInputTask {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7,
    _8 = 8,
}

export enum UpdateTeamInputEvaluationType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6,
    _7 = 7,
}

export enum EvaluationUniversityAccDataOutputAccType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3,
    _4= 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum EvlSysMeetingcoeDataMeetingType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum CreateEESurveyInputFrom {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum CreateEESurveyInputTo {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum EESurveyForEditFrom {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum EESurveyForEditTo {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum UniversityTeamMemberOutputMemberTeamTaskId {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
    _7 = 7, 
}

export enum UnivTeamMemerConfirmOutputIsUnivConfirm {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum HSIHelpDtoEvlFormHelpAndProofType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum HSIEvaluationFormHelpAndProofDtoEvlFormHelpAndProofType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum HSIMaturityLevelDtoType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum CreateOrUpdateHSIMaturityLevelDtoType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum CalculationMessageType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum IndicatorFilterInputUnivType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum IndicatorFilterInputMissionOriented {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum UserNotificationState {
    _0 = 0, 
    _1 = 1, 
}

export enum TenantNotificationSeverity {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
}

export enum ProcessDtoProcessType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6,
    _7 = 7,
}

export class AdditionalData implements IAdditionalData {
    paypal: { [key: string] : string; };

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["Paypal"]) {
                this.paypal = {};
                for (let key in data["Paypal"]) {
                    if (data["Paypal"].hasOwnProperty(key))
                        this.paypal[key] = data["Paypal"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalData {
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (let key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    data["Paypal"][key] = this.paypal[key];
            }
        }
        return data; 
    }
}

export interface IAdditionalData {
    paypal: { [key: string] : string; };
}

export enum CreatePaymentDtoEditionPaymentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum CreatePaymentDtoPaymentPeriodType {
    _30 = 30, 
    _365 = 365, 
}

export enum CreatePaymentDtoSubscriptionPaymentGatewayType {
    _1 = 1, 
}

export enum ExecutePaymentDtoGateway {
    _1 = 1, 
}

export enum ExecutePaymentDtoEditionPaymentType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum ExecutePaymentDtoPaymentPeriodType {
    _30 = 30, 
    _365 = 365, 
}

export enum EvaluatorsListDtoApplicationStatus {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum UpdateEvalutarosInputApplicationStatus {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum ApplicantListDtoApplicationStatus {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum Status3 {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
}

export enum TenantLoginInfoDtoPaymentPeriodType {
    _30 = 30, 
    _365 = 365, 
}

export enum RegisterTenantInputSubscriptionStartType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum RegisterTenantInputGateway {
    _1 = 1, 
}

export enum UniversityInfoOutputUnivType {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum UniversityInfoOutputMissionOriented {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return Observable.throw(result);
    else
        return Observable.throw(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = function() { 
                observer.next(this.result);
                observer.complete();
            }
            reader.readAsText(blob); 
        }
    });
}
//ARA DEĞERLENDİRME
export class AraReportOutput implements IAraReportOutput {
    AraTeamMember: AraUniversityTeamMember[];
    AraMainEvaluations: AraEvaluationsForExternalReport[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;

    constructor(data?: IAraReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["AraTeamMember"] && data["AraTeamMember"].constructor === Array) {
                this.AraTeamMember = [];
                for (let item of data["AraTeamMember"])
                    this.AraTeamMember.push(AraUniversityTeamMember.fromJS(item));
            }
            if (data["AraMainEvaluations"] && data["AraMainEvaluations"].constructor === Array) {
                this.AraMainEvaluations = [];
                for (let item of data["AraMainEvaluations"])
                    this.AraMainEvaluations.push(AraEvaluationsForExternalReport.fromJS(item));
            }
            this.universityName = data["universityName"];
            this.universityAddress = data["universityAddress"];
            this.reportDate = data["reportDate"];
            this.reportHeader = data["reportHeader"];
            this.evidenceHeader = data["evidenceHeader"];
            this.criteriaHeader = data["criteriaHeader"];
            this.teamHeader = data["teamHeader"];
        }
    }

    static fromJS(data: any): AraReportOutput {
        let result = new AraReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.AraTeamMember && this.AraTeamMember.constructor === Array) {
            data["AraTeamMember"] = [];
            for (let item of this.AraTeamMember)
                data["AraTeamMember"].push(item.toJSON());
        }
        if (this.AraMainEvaluations && this.AraMainEvaluations.constructor === Array) {
            data["AraMainEvaluations"] = [];
            for (let item of this.AraMainEvaluations)
                data["AraMainEvaluations"].push(item.toJSON());
        }
        data["universityName"] = this.universityName;
        data["universityAddress"] = this.universityAddress;
        data["reportDate"] = this.reportDate;
        data["reportHeader"] = this.reportHeader;
        data["evidenceHeader"] = this.evidenceHeader;
        data["criteriaHeader"] = this.criteriaHeader;
        data["teamHeader"] = this.teamHeader;
        return data;
    }
}

export interface IAraReportOutput {
    AraTeamMember: AraUniversityTeamMember[];
    AraMainEvaluations: AraEvaluationsForExternalReport[];
    universityName: string;
    universityAddress: string;
    reportDate: string;
    reportHeader: string;
    evidenceHeader: string;
    criteriaHeader: string;
    teamHeader: string;
}

export class AraUniversityTeamMember implements IAraUniversityTeamMember {
    memberTitle: string;
    memberName: string;
    memberSurname: string;
    memberTeamTask: string;

    constructor(data?: IAraUniversityTeamMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.memberTitle = data["memberTitle"];
            this.memberName = data["memberName"];
            this.memberSurname = data["memberSurname"];
            this.memberTeamTask = data["memberTeamTask"];
        }
    }

    static fromJS(data: any): AraUniversityTeamMember {
        let result = new AraUniversityTeamMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberTitle"] = this.memberTitle;
        data["memberName"] = this.memberName;
        data["memberSurname"] = this.memberSurname;
        data["memberTeamTask"] = this.memberTeamTask;
        return data;
    }
}

export interface IAraUniversityTeamMember {
    memberTitle: string;
    memberName: string;
    memberSurname: string;
    memberTeamTask: string;
}

export class AraEvaluationsForExternalReport implements IAraEvaluationsForExternalReport {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    subEvaluations: AraEvaluationsForExternalReport[];
    isIntroduction: boolean;
    isConclusion: boolean;
    maturityLevelHeader: string;
    evidenceHeader: string;
    maturityLevelDescription: string;

    constructor(data?: IAraEvaluationsForExternalReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.nameKey = data["nameKey"];
            this.description = data["description"];
            this.sequenceNo = data["sequenceNo"];
            if (data["subEvaluations"] && data["subEvaluations"].constructor === Array) {
                this.subEvaluations = [];
                for (let item of data["subEvaluations"])
                    this.subEvaluations.push(AraEvaluationsForExternalReport.fromJS(item));
            }
            this.isIntroduction = data["isIntroduction"];
            this.isConclusion = data["isConclusion"];
            this.maturityLevelHeader = data["maturityLevelHeader"];
            this.evidenceHeader = data["evidenceHeader"];
            this.maturityLevelDescription = data["maturityLevelDescription"];
        }
    }

    static fromJS(data: any): AraEvaluationsForExternalReport {
        let result = new AraEvaluationsForExternalReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameKey"] = this.nameKey;
        data["description"] = this.description;
        data["sequenceNo"] = this.sequenceNo;
        if (this.subEvaluations && this.subEvaluations.constructor === Array) {
            data["subEvaluations"] = [];
            for (let item of this.subEvaluations)
                data["subEvaluations"].push(item.toJSON());
        }
        data["isIntroduction"] = this.isIntroduction;
        data["isConclusion"] = this.isConclusion;
        data["maturityLevelHeader"] = this.maturityLevelHeader;
        data["evidenceHeader"] = this.evidenceHeader;
        data["maturityLevelDescription"] = this.maturityLevelDescription;
        return data;
    }
}

export interface IAraEvaluationsForExternalReport {
    id: number;
    name: string;
    nameKey: string;
    description: string;
    sequenceNo: string;
    subEvaluations: AraEvaluationsForExternalReport[];
    isIntroduction: boolean;
    isConclusion: boolean;
    maturityLevelHeader: string;
    evidenceHeader: string;
    maturityLevelDescription: string;
}


//ARA DEĞERLENDİRME



// WEBPACK FOOTER //
// ./src/shared/service-proxies/service-proxies.ts